import { r as registerInstance, h, g as getElement, H as Host, c as createEvent, F as Fragment, f as forceUpdate } from './index-5faac9d7.js';
import { y as getDataAttributes, g as getLocaleFromBody, _ as getBrandName, am as indexDBBreadcrumbs, aj as filterBreadcrumbsForSaving, t as tryParse, b as isIndexDBEnabled, a2 as getConsumerSpecificData, a as isPBS, x as deepMerge, U as comparator, q as parseJSONString, aN as SprykerProductCardMain, K as arrayToMap, T as MAX_COMPARATOR_ITEMS, Q as getComparisonSessionId, i as isV3, O as sleep, ah as fetchers, c as isPublicEnvironment, V as getComparatorUrl, n as isEmpty, s as scrollToComponent, an as store, ar as setLinearProductData, ao as ACTION_TYPES, aS as ConfiguratorHandler, v as validateHost, aZ as SPRYKER_PRODUCT_CARD_SECONDARY_PATH, a_ as SPRYKER_PRODUCT_CARD_MAIN_PATH } from './index-e29b327a.js';
import { d as getQdsIconLibrary, i as isAnalyticsEnabled, a as setPaginationParams, N as NAVIGATION_STATE_PARAM_NAME } from './helpers-e12aa36b.js';
import { c as classnames } from './index-5d9a618b.js';
import { ai as DOCUMENTS, aj as pesIconSizes, ak as pesIconMirrorDirection, P as PageNames, b as productCtas, j as EEvent, t as CircularProductTypes, d as EQdsButtonSize, c as EQdsButtonImportance, al as DEFAULT_LINE_HEIGHT, am as DEBOUNCED_HANDLER_DELAY, an as HMC_CLOSE_EVENT, ao as HMCPlatform, ap as MY_SCHNEIDER_CLICK_EVENT, aq as ICON_FONT_NAME, ar as LOAD_TIMEOUT, m as myProductsResponseStatus, as as EStatus, at as ENotificationType, au as ENotificationPageType, av as DESKTOP_MAX_CONTENT_WIDTH, a3 as PRODUCT, Q as QdsSize, R as REVIEW_SECTION_ANCHOR, aw as ExtraBadgesCharId, n as BAZAAR_VOICE_URL } from './currency-7be6806c.js';
import { P as PesProductLink } from './pes-product-link-74e48119.js';
import { s as send, j as downloadDocumentEvent, x as productSelectorVirtualPageEvent, w as hmcEvent, b as productSelectorAddToCartEvent, q as paginationClickEvent, B as filtersVirtualPageEvent } from './analytics-b6a65ffa.js';
import { h as hammer, N as NotificationBannerController, i as isZipCodeValid, s as saveZipCodeToStorage, g as getNotificationMessage, a as getCommerceConnectorSettings, n as normalizeZipCodePattern, c as categorizeAndLinkProductsWithRelations, b as getFilteredProductIds, d as getZipCode, e as getBuyOnlineAvailability, f as getCircularProductsStockAvailability, j as getPrices, k as startSearch, l as getAllDistributors, m as setStickyBarTab, o as observeIntersectionWithHeader, p as setTabActive, q as isWebkitLineClampSupports, r as addToCart, t as getApcCta, u as availabilityUrl, v as getAvailabilityInfo, w as getAPCDistributor, x as getSingleDistributor, y as formCtaUrl } from './utils-63a7bdb5.js';
import { c as createCommonjsModule, a as commonjsGlobal, b as getDefaultExportFromCjs } from './_commonjsHelpers-11ca3be1.js';
import { I as IconCopy } from './copy-d62b8b74.js';
import { a as isBrowser, i as isMobile } from './utils-6c8f178b.js';
import { g as generateMedia, b as generateSrcSet } from './index-e233ecdd.js';
import { n as navigateWithRouter, i as isAppRoutingEnabled } from './utils-e0387569.js';
import { P as PesRoute } from './pes-route-5a1043d8.js';
import { g as getProductInfoFromBreadcrumbs, s as storeBreadcrumbs } from './utils-5c7c3926.js';
import { p as parseCommonURLToRouterParts } from './url-parser-bc0c129e.js';
import { u as updateProductCtasSelectorSettings, s as scConfigurationToPostData, a as switchProductSelector } from './product-selector-utils-94175aab.js';
import { g as getMyProductsFromConnector, t as timeLimitedRequest } from './utils-77dd4675.js';
import { D as DEFAULT_CATEGORY_PRODUCT_CTAS, r as parseRichText, x as getSprykerBaseQueryParams, y as getSiteTypeByURL, s as scrollToTop, z as html2plain, A as getCategoryOrSubCatFilterUrl, l as filterReset, m as setNavigationFilterPath, b as getQueryParam, t as getBaseUrl, u as pageParam, B as listingTypes, n as getPaginationParams, q as getFilterProductsUrl, o as getPbsFilterProductsUrl, C as getCategoryRangesFilterUrl, E as getPbsRangesfiltersUrl, M as MAX_RANGES_BEFORE_SDL_PROMO_BANNER, F as MAX_VISIBLE_CARDS_WHILE_COLLAPSED, e as getCountry, f as getLanguage, v as url, G as getBrandName$1, H as qs } from './helpers-c4d5ad02.js';
import { h as http, g as getData } from './http-0a1631f3.js';
import { l as lodash } from './lodash-bd96d09c.js';
import { d as debounce_1 } from './debounce-0324bad5.js';
import { i as isEmpty_1 } from './isEmpty-51908328.js';
import { p as productsParamsToPostData, g as getSingleProductList } from './utils-ba4359e5.js';
import { g as getBaseNavigationUrl } from './navigation-d0912565.js';
import { a as getStickyBarMapping } from './cta-list-298471fe.js';
import { G as GLOBAL_ANALYTICS_EVENT_NAME, F as FILTER_STATE_CHANGED_EVENT_NAME } from './analytics-205f1857.js';
import { s as store$1 } from './pes-router-store-0c1092be.js';
import { i as isViewOnline, c as columnTypes } from './utils-5735b62e.js';
import { t as trackFilterAnalytics, f as fetchSprykerFilters } from './normalizeFiltersData-55e65203.js';
import { a as ProductCommercialLabel, I as IconPlus } from './product-card-c5e7a62c.js';
export { P as product_card } from './product-card-c5e7a62c.js';
import { _ as __rest } from './tslib.es6-613ce1cd.js';
import { j as join } from './path-384d1457.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';
import './number-57a50dcb.js';
import './ResizeObserver-65f84d09.js';
import './toString-10b0f228.js';
import './isSymbol-bae590b5.js';
import './constants-7d3b1dc0.js';
import './__node-resolve_empty-7dfe5913.js';
import './_isIndex-3036d479.js';
import './toNumber-6e3a0b09.js';
import './flatMap-f62e8c63.js';
import './_baseFlatten-65704796.js';
import './_arrayLikeKeys-728b0edd.js';
import './_baseIteratee-285d44d0.js';
import './_getAllKeys-407edbf9.js';
import './hasIn-53d8ae96.js';
import './_baseFor-a28737de.js';
import './checkoutEventEmitter.service-41cc6ce1.js';
import './_basePickBy-e4f30088.js';
import './keysIn-6ff99c07.js';
import './_flatRest-cb1a737b.js';
import './_copyObject-8b49fce6.js';
import './index-54dd34b7.js';

const HttpStatusCodes = {
    ACCEPTED: 202,
    BAD_GATEWAY: 502,
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    GATEWAY_TIMEOUT: 504,
    METHOD_NOT_ALLOWED: 405,
    NETWORK_AUTHENTICATION_REQUIRED: 511,
    NOT_FOUND: 404,
    NOT_IMPLEMENTED: 501,
    OK: 200,
    PROCESSING: 102,
    REQUEST_TIMEOUT: 408,
    SERVICE_UNAVAILABLE: 503,
    UNAUTHORIZED: 401,
    TEMPORARY_REDIRECT: 307,
    SERVER_ERROR: 500,
};

// Used in pes-comparison-bar button to navigate to comparator page
const REPLATFORMED_COMPARATOR_URL = '/v3/product-comparator';

const LineCount = {
    DESKTOP_LINE_COUNT: 5,
    MOBILE_LINE_COUNT: 4,
};

const addToCartButtonCss = ".add-to-cart-button{display:block;width:100%}";

const AddToCartButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isInList = false;
    this.labels = {};
    this.button = undefined;
    this.size = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderIcon() {
    var _a;
    if ((_a = this.button) === null || _a === void 0 ? void 0 : _a.icons) {
      const { icons } = this.button;
      return icons.addIcon;
    }
    return "shopping-cart";
  }
  render() {
    var _a, _b, _c, _d, _e;
    const icon = this.renderIcon();
    let buttonProps = {
      'data-da-element-id': 'add_p',
      'data-autotests-id': 'uiaas-product-card-cta-add-to-cart',
    };
    if ((_a = this.button) === null || _a === void 0 ? void 0 : _a.isShown) {
      const { dataset = {} } = this.button;
      const dataProps = getDataAttributes(dataset);
      buttonProps = Object.assign(Object.assign({}, buttonProps), dataProps);
    }
    const label = this.isInList
      ? ((_c = (_b = this.button) === null || _b === void 0 ? void 0 : _b.labels) === null || _c === void 0 ? void 0 : _c.removeLabel) || this.labels.removeFromCartLabel
      : ((_e = (_d = this.button) === null || _d === void 0 ? void 0 : _d.labels) === null || _e === void 0 ? void 0 : _e.addLabel) || this.labels.addToCartLabel;
    return (h("qds-button", Object.assign({ class: "add-to-cart-button" }, buttonProps, { size: this.size, variant: "hero", importance: "standard", text: label, iconName: icon, iconLibrary: getQdsIconLibrary(icon) })));
  }
  get el() { return getElement(this); }
};
AddToCartButton.style = addToCartButtonCss;

const addToFavoriteButtonCss = ".icon-add pes-icon{opacity:0.7}pes-icon{color:#333333}";

const AddToFavoriteButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isInList = false;
    this.button = { isShown: false };
  }
  render() {
    let buttonProps = {
      'data-da-element-id': 'add_p',
      'data-autotests-id': 'uiaas-product-card-cta-add-to-my-products',
    };
    if (this.button.dataset) {
      const { dataset = {} } = this.button;
      const dataProps = getDataAttributes(dataset);
      buttonProps = Object.assign(Object.assign({}, buttonProps), dataProps);
    }
    return (h(Host, Object.assign({ role: "button", class: this.isInList
        ? 'btn-link button--add-to-favorite is-added'
        : 'btn-link button--add-to-favorite' }, buttonProps), this.isInList ? (h("div", { class: "icon-remove" }, h("pes-icon", { customStyle: { fontSize: '22px' } }, "star_plain"))) : (h("div", { class: "icon-add" }, h("pes-icon", { customStyle: { fontSize: '22px' } }, "star_stroke")))));
  }
};
AddToFavoriteButton.style = addToFavoriteButtonCss;

const documentsListCss = "a{text-decoration:none}.button{width:auto;font-size:16px}.hidden{display:none}.document{position:absolute;left:1px ;right:0 ;bottom:0;max-height:59px;transition:max-height 0.3s linear;overflow:hidden}.document.open{max-height:100%;z-index:3}.button-document{display:flex;justify-content:center;width:100%;cursor:pointer;background-color:#ffffff}.button-document:active{background-color:#cbcbcb}.button-document.open:hover{background-color:#e6e6e6}.grid-view .button-document{padding:12px 10px 16px}.grid-view.open .button-document{padding:12px 10px 6px}.document-list{background-color:#ffffff}.document-item{display:flex;align-items:center;margin:0;padding:10px 20px 10px 20px;font-size:14px;line-height:20px;color:#333333;cursor:pointer}.document-item:hover,.document-item:focus{background-color:#e6e6e6}.icon-file{top:-2px;width:20px;height:20px;background-size:100%;background-repeat:no-repeat;flex-shrink:0}:host(:not([dir=\"rtl\"])) .icon-file{margin-right:5px}:host([dir=\"rtl\"]) .icon-file{margin-left:5px}.icon-doc,.icon-cad{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='60px' height='60px' viewBox='0 0 60 60' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 63.1 (92452) - https://sketch.com --%3E%3Ctitle%3EIcon/Documents/Filled/CAD%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Icon/Documents/Filled/CAD' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Crect id='bound' x='0' y='0' width='60' height='60'%3E%3C/rect%3E%3Cg id='bg' transform='translate(10.000000, 0.000000)' fill-rule='nonzero'%3E%3Cpolygon id='Rectangle-15' fill='%23404040' points='0 1.56437363e-14 26 0 40 14 40 60 0 60'%3E%3C/polygon%3E%3Cpolygon id='Rectangle-16' fill='%23000000' points='26 0 40 14 26 14'%3E%3C/polygon%3E%3C/g%3E%3Cpath d='M29,42 L22.0285645,42 L22.0285645,35 L16,35 L16,31.9875488 L22.0285645,31.9875488 L22.0285645,25 L28.9902344,25 L28.9902344,19 L32.0454102,19 L32,25 L39,25 L39,32 L44.9958496,31.9875488 L44.9958496,35 L39,35 L39,42 L32,42 L32,48 L29,48 L29,42 Z M25,39 L36,39 L36,28 L25,28 L25,39 Z' id='img' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\")}.icon-pdf{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='60px' height='60px' viewBox='0 0 60 60' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 63.1 (92452) - https://sketch.com --%3E%3Ctitle%3EIcon/Documents/Filled/pdf%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Icon/Documents/Filled/pdf' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Crect id='bound' x='0' y='0' width='60' height='60'%3E%3C/rect%3E%3Cg id='bg' transform='translate(10.000000, 0.000000)' fill-rule='nonzero'%3E%3Cpolygon id='Rectangle-15' fill='%23C22827' points='0 1.56437363e-14 26 0 40 14 40 60 0 60'%3E%3C/polygon%3E%3Cpolygon id='Rectangle-16' fill='%23680F11' points='26 0 40 14 26 14'%3E%3C/polygon%3E%3C/g%3E%3Cpath d='M46.4496479,36.9428356 C46.6915555,37.1843563 46.9152007,37.5380396 46.951152,37.8240149 C47.071819,38.7879483 46.9816534,39.72941 46.5372319,40.4128392 C46.3114831,40.7602696 45.9411636,41.016348 45.5018098,41.1352522 C45.2168749,41.2122418 44.8662522,41.2519089 44.4595031,41.2519089 C42.1686474,41.2519089 38.5390763,40.0726389 35.5879943,38.3746664 C31.7155593,38.9665486 27.2970634,40.0396158 23.4162143,41.330657 C20.0549409,47.3247088 17.6149245,50 15.5131964,50 C15.1209809,50 14.7381357,49.905815 14.375083,49.7199846 L13.538159,49.2896048 C13.0131333,48.9829166 12.9362583,48.3206888 13.0395233,47.8031581 C13.3639473,46.1812959 15.3193834,44.1374563 18.2702744,42.3370913 C18.6181242,42.1220478 20.1011233,41.3205937 20.164134,41.2865933 L21.0294559,40.8190865 C21.8675273,39.3538415 22.7920352,37.6242129 23.8109158,35.5867241 L23.9368417,35.3345536 C24.9053329,33.3959396 26.0030008,31.1985114 26.878936,29.0166182 L27.1920773,28.238808 C25.9687704,23.4633026 25.2937237,19.7762037 25.9479262,17.3115591 C26.1631571,16.5257374 26.9830615,16 27.989034,16 L28.0035676,16 L28.5326091,16.0174888 C29.434743,15.9775284 30.0101581,16.7103953 30.3036026,17.4020317 L30.397306,17.6480467 C30.4737029,17.8737396 30.4978937,17.9579592 30.5371917,18.2483312 C30.8227957,20.3655455 29.7438685,26.6275953 29.7438685,26.6275953 C29.6924272,26.8612997 29.6371614,27.0903145 29.5722383,27.3508871 C30.5685537,30.1405882 32.167439,32.6775328 34.0829078,34.5052545 C34.7950534,35.1852644 35.7020636,35.749985 36.5822059,36.2688832 C38.5477772,35.9876953 40.41649,35.8479805 41.9690973,35.8654694 C44.2627261,35.8962459 45.7700117,36.2586243 46.4496479,36.9428356 Z M15.1035448,48.301832 C16.136959,47.8239688 17.707829,46.3002976 20.0535683,42.477392 C19.735455,42.7862296 19.3880832,43.118907 19.2470501,43.2357593 C17.0039064,45.114091 15.4867724,47.2310119 15.1035448,48.301832 Z M28.3898199,17.0747281 C28.0797383,17.0747281 28.1079449,19.5457234 28.1079449,19.5457234 C28.1079449,20.8384258 28.2933437,22.815437 28.6769538,24.0697423 C29.1401161,23.2225636 29.5134953,22.0775873 29.4816553,20.4461501 C29.4497196,18.8148106 29.0654403,17.0747281 28.3898199,17.0747281 Z M24.3782653,39.2992256 C26.9631394,38.2839986 29.8990187,37.4487393 33.2958612,36.7619879 C33.0639932,36.581336 32.8432166,36.4001956 32.63487,36.220032 C30.9644642,34.7752067 29.5435196,32.9719106 28.4025378,30.850788 C27.8288438,32.3666433 27.0585639,34.2108767 25.8388903,36.5677554 C25.3385335,37.5305164 24.8488856,38.4383684 24.3782653,39.2992256 Z M45.8395859,39.182184 C46.0464025,39.0499927 46.0311997,38.4112133 44.8245298,38.0967089 C43.61786,37.7822041 43.2523212,37.7876696 42.0183055,37.7876696 C41.3441195,37.7876696 40.5922935,37.8191359 39.7723889,37.8811771 C41.9063394,38.8159949 43.4285412,39.3907791 44.6588281,39.3907791 C45.0400477,39.3907791 45.6326735,39.3143757 45.8395859,39.182184 Z' id='img' stroke='%23FFFFFF' stroke-width='0.100000001' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\")}:host(:not([dir=\"rtl\"])) .link-all{padding:10px 20px 10px 24px}:host([dir=\"rtl\"]) .link-all{padding:10px 24px 10px 20px}.document-backdrop{position:absolute;top:1px;height:0;width:calc(100% - 1px);z-index:3;transition:height 0s linear 0.3s, background-color 0.3s linear;background-color:unset}:host(:not([dir=\"rtl\"])) .document-backdrop{left:1px}:host([dir=\"rtl\"]) .document-backdrop{right:1px}.document-backdrop.open{height:calc(100% - 1px);background-color:rgba(51, 51, 51, 0.2);transition:background-color 0.3s linear}@media screen and (min-width: 980px){.document.list-view{position:relative;background-color:#ffffff;border-top:none;overflow:visible}.document.list-view .button-document{background-color:#ffffff}.document.list-view .button-document:hover,.document.list-view .button-document:active{border-color:#626469;background-color:#ffffff}.document.list-view .button-document.open{box-shadow:none}:host(:not([dir=\"rtl\"])) .document.list-view .icon-documents{margin-right:3px}:host([dir=\"rtl\"]) .document.list-view .icon-documents{margin-left:3px}.document.list-view .document-list{display:none;position:absolute;z-index:5;top:calc(100% + 5px);width:300px;background-color:#ffffff}:host(:not([dir=\"rtl\"])) .document.list-view .document-list{right:0}:host([dir=\"rtl\"]) .document.list-view .document-list{left:0}.document.list-view .open .icon-arrow-up{display:block}.document.list-view .open .icon-arrow-down{display:none}.document.list-view .open+.document-list{display:block;box-shadow:0 2px 4px 0 rgba(0, 0, 0, 0.2)}.document-backdrop.list-view{display:none}}";

const DocumentsList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.toggleDocumentView = createEvent(this, "toggleDocumentView", 7);
    this.onDocumentLinkClick = (document) => {
      const { documentReference, documentName, documentType } = document;
      send(downloadDocumentEvent, { documentReference, documentName, documentType });
    };
    this.renderLink = (document) => {
      const { iconClass, title, url, cadProvider } = document;
      const isCadDocumentPopUp = cadProvider && cadProvider !== 'EDMS';
      return isCadDocumentPopUp ? (h("div", { "data-da-element-id": "doc_item", onClick: () => DocumentsList.openPopUp(url) }, DocumentsList.renderLinkContent(iconClass, title))) : (h("a", { href: url, "data-da-element-id": "doc_item", target: "_blank", onClick: () => this.onDocumentLinkClick(document) }, DocumentsList.renderLinkContent(iconClass, title)));
    };
    this.open = undefined;
    this.documentsLabel = undefined;
    this.documents = undefined;
    this.viewAllDocumentsUrl = undefined;
    this.isGridView = undefined;
    this.pdpViewAllLabel = undefined;
    this.productId = undefined;
    this.enableAppRouting = undefined;
    this.tabId = DOCUMENTS;
    this.handleProductClick = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  static openPopUp(url) {
    const leftWindowBoundary = window.screenLeft || window.screenX || 0;
    const topWindowBoundary = window.screenTop || window.screenY || 0;
    const x = (window.screen.width - DocumentsList.POP_UP_WIDTH) / 2 + leftWindowBoundary;
    const y = (window.screen.height - DocumentsList.POP_UP_HEIGHT) / 2 + topWindowBoundary;
    window.open(url, DocumentsList.POP_UP_NAME, `height=${DocumentsList.POP_UP_VIEWPORT_HEIGHT},width=${DocumentsList.POP_UP_WIDTH},left=${x},top=${y}`);
  }
  static renderLinkContent(iconClass, title) {
    return (h("p", { class: "document-item" }, h("div", { class: `icon-file ${iconClass}` }), title));
  }
  getDropdownIconType() {
    if (this.open !== this.isGridView)
      return 'dropdown-close';
    return 'dropdown';
  }
  render() {
    return (h(Host, { class: this.isGridView ? 'grid-view' : 'list-view' }, h("div", { class: `document-backdrop
            ${this.isGridView ? 'grid-view' : 'list-view'}
            ${this.open ? 'open' : ''}` }), h("div", { class: `document
            ${this.isGridView ? 'grid-view' : 'list-view'}
            ${this.open ? 'open' : ''}` }, h("div", { class: classnames('button-container', 'button-document', { open: this.open }), onClick: this.toggleDocumentView.emit }, h("qds-button", { size: "standard", importance: this.isGridView ? 'subdued' : 'standard', class: "button", "data-da-element-id": 'b_doc', iconName: "page-lines", iconLibrary: getQdsIconLibrary("page-lines"), text: this.documentsLabel, action: this.getDropdownIconType() })), h("div", { class: 'document-list' }, this.documents.map(this.renderLink), this.viewAllDocumentsUrl && (h(PesProductLink, { className: '', url: this.viewAllDocumentsUrl, id: this.productId, tabId: this.tabId, enableAppRouting: this.enableAppRouting }, h("qds-standalone-link", { class: 'link-all', href: this.viewAllDocumentsUrl, "data-da-element-id": 'doc_all', onClick: this.handleProductClick }, this.pdpViewAllLabel)))))));
  }
  get el() { return getElement(this); }
};
DocumentsList.POP_UP_WIDTH = 580;
DocumentsList.POP_UP_HEIGHT = 800;
DocumentsList.POP_UP_VIEWPORT_HEIGHT = 670;
DocumentsList.POP_UP_NAME = 'CAD Publisher';
DocumentsList.style = documentsListCss;

const tooltipCss$1 = ".icon-color-blue{color:#219bfd}.icon-color-blue:hover,.icon-color-blue:focus{color:#219bfd}.icon-color-grey{color:#9fa0a4}.icon-color-grey:hover,.icon-color-grey:focus{color:#9fa0a4}.icon-color-grey:hover+.tooltip-text{color:#626469}.tooltip-icon{display:block;width:18px;height:18px;cursor:pointer;color:#9fa0a4}.tooltip-icon.active{color:#626469}.tooltip-label-container{display:flex;align-items:center}:host(:not([dir=\"rtl\"])) .tooltip-text{padding-left:5px}:host([dir=\"rtl\"]) .tooltip-text{padding-right:5px}";

const IconTooltipComponent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didOpen = createEvent(this, "didOpen", 7);
    this.didClose = createEvent(this, "didClose", 7);
    this.handleTooltipOpen = () => {
      this.active = true;
      this.didOpen.emit();
    };
    this.handleTooltipClose = () => {
      this.active = false;
      this.didClose.emit();
    };
    this.icon = 'information_circle';
    this.iconColor = 'blue';
    this.iconSize = pesIconSizes.SMALL;
    this.position = 'bottom';
    this.text = undefined;
    this.active = false;
    this.host.dir = document.documentElement.dir || 'auto';
  }
  render() {
    const iconClass = classnames('tooltip-icon', `icon-color-${this.iconColor}`, { active: this.active });
    return (h("pes-tooltip-wrapper", { onDidOpen: this.handleTooltipOpen, onDidClose: this.handleTooltipClose, position: this.position }, h("div", { slot: "tooltip-activator", class: "tooltip-label-container" }, h("pes-icon", { class: iconClass, size: this.iconSize }, this.icon), this.text && h("span", { class: "tooltip-text" }, this.text)), h("div", { slot: "tooltip-content" }, h("slot", null))));
  }
  get host() { return getElement(this); }
};
IconTooltipComponent.style = tooltipCss$1;

const modalSymplyCss = ".icon-info-container{display:inline-flex;align-items:center}.icon-info{color:#9fa0a4;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E%3Cpath fill='%239FA0A4' d='M512 128c212 0 384 172 384 384S724 896 512 896 128 724 128 512s172-384 384-384zm0 43c-189 0-341 152-341 341s152 341 341 341 341-152 341-341-152-341-341-341zm65 225h2c34 0 61-28 61-62 0-33-27-60-60-61-34-1-62 26-63 60s26 62 60 63zm0 265v-1c1-8-4-15-12-17-21 20-45 37-71 48-6 0-7-5-3-11l78-185c5-10 8-21 10-33-2-18-17-32-35-33-59 9-113 39-151 86-1 0-1 0-1 1-1 8 4 15 12 17 20-18 43-33 67-43v11l-78 187c-5 10-8 21-9 33 4 16 18 28 35 30 62-7 120-39 158-90z'/%3E%3C/svg%3E\");display:inline-block;height:24px;width:24px}.icon-info_small{width:18px;height:18px}.icon-close{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg viewBox='0 0 19 19' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath fill='%239FA0A4' fill-rule='evenodd' d='M13.1 13.1c-.28.28-.74.28-1.02 0l-2.7-2.68-2.8 2.8c-.28.3-.74.3-1.02 0a.7.7 0 0 1 0-1l2.8-2.83L5.7 6.7c-.3-.27-.3-.73 0-1 .27-.3.73-.3 1 0l2.7 2.67 2.55-2.55c.28-.3.74-.3 1.02 0 .28.28.28.73 0 1.02L10.42 9.4l2.68 2.68c.28.28.28.74 0 1.02m2.94-10.35c-3.66-3.67-9.63-3.67-13.3 0-3.66 3.66-3.66 9.62 0 13.3 3.67 3.65 9.63 3.65 13.3 0 3.66-3.68 3.66-9.64 0-13.3'%3E%3C/path%3E%3C/svg%3E\");height:20px;width:20px}.modal-overlay{box-sizing:border-box;position:fixed;z-index:10000;top:0;left:0;bottom:0;right:0;display:flex;justify-content:center;align-items:center;background-color:rgba(51, 51, 51, 0.6)}.modal-overlay *,.modal-overlay *::before,.modal-overlay *::after{box-sizing:inherit}.modal-overlay.hidden{display:none}.modal-wrapper{display:flex;flex-direction:column;position:relative;width:100%;min-height:100px;margin:15px;padding:15px;background-color:#ffffff}.button-close{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;align-self:flex-end}:host(:not([dir=\"rtl\"])) .modal-icon-text{padding-left:5px}:host([dir=\"rtl\"]) .modal-icon-text{padding-right:5px}.modal-icon-text:active{color:#626469}";

const ModalSymply = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.toggleOpenState = () => {
      this.open = !this.open;
    };
    this.text = undefined;
    this.open = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, null, h("div", { class: "icon-info-container", onClick: this.toggleOpenState }, h("div", { class: this.text ? 'icon-info icon-info_small' : 'icon-info' }), this.text && h("span", { class: "modal-icon-text" }, this.text)), h("div", { class: this.open ? 'modal-overlay' : 'modal-overlay hidden' }, h("div", { class: "modal-wrapper" }, h("button", { type: "button", class: "button-close", onClick: this.toggleOpenState }, h("div", { class: "icon-close" })), h("slot", null)))));
  }
  get el() { return getElement(this); }
};
ModalSymply.style = modalSymplyCss;

const skeletonCss = "span{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#DDDBDD}span::after{position:absolute;top:0;right:0;bottom:0;left:0;animation:shimmer 2s infinite;content:\"\"}:host(:not([dir=\"rtl\"])) span::after{transform:translateX(-100%);background-image:linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0))}:host([dir=\"rtl\"]) span::after{transform:translateX(100%);background-image:linear-gradient(-90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0))}@keyframes shimmer{100%{transform:translateX(100%)}}h3{font-size:1.25em;font-weight:bold}.meta{font-size:0.85em;color:#6b6b6b}.o-media{display:flex}.o-media__body{flex-grow:1}:host(:not([dir=\"rtl\"])) .o-media__body{margin-left:1em}:host([dir=\"rtl\"]) .o-media__body{margin-right:1em}.o-vertical-spacing>*+*{margin-top:0.75em}.o-vertical-spacing--l>*+*{margin-top:2em}*{box-sizing:border-box}";

const SkeletonComponent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    const arr = [1, 2, 3, 4];
    return (h("ul", { class: "o-vertical-spacing o-vertical-spacing--l" }, arr.map(() => (h("li", { class: "blog-post o-media" }, h("div", { class: "o-media__figure" }, h("span", { style: { width: '100px', height: '80px' } })), h("div", { class: "o-media__body" }, h("div", { class: "o-vertical-spacing" }, h("h3", null, h("span", { style: { width: '55%' } })), h("p", null, h("span", { style: { width: '80%' } }), h("span", { style: { width: '90%' } }), h("span", { style: { width: '83%' } }), h("span", { style: { width: '80%' } })), h("div", { class: "meta" }, h("span", { style: { width: '70px' } })))))))));
  }
};
SkeletonComponent.style = skeletonCss;

const sliderCss = ":host{position:relative;display:flex}.slim-slider-wrapper{overflow:hidden;text-align:center;height:100%;min-width:100%}.slim-slider-wrapper>div,.slim-slider-wrapper>img,.slim-slider-wrapper>p{width:100%;height:100%;display:flex}.slim-slider-wrapper>div.vertical,.slim-slider-wrapper>img.vertical,.slim-slider-wrapper>p.vertical{flex-direction:column}.slim-slider-wrapper>div.is-animating,.slim-slider-wrapper>img.is-animating,.slim-slider-wrapper>p.is-animating{transition:transform 400ms}.carousel-pagination{display:flex;justify-content:center;align-items:center;position:absolute;bottom:-36px;width:100%;height:35px;z-index:100}:host(:not([dir=\"rtl\"])) .carousel-pagination{left:0}:host([dir=\"rtl\"]) .carousel-pagination{right:0}.carousel-pagination a{width:7px;height:7px;padding:0;margin:0 3px;border-radius:50%;background:#cbcbcb;border:0;outline:none;cursor:pointer}.carousel-pagination a.pointer{cursor:none}.carousel-pagination a:first-child,.carousel-pagination a:last-child{width:12px;height:12px}.carousel-pagination a.active{background:#3dcd58}.carousel-pagination .carousel-pagination__above{bottom:85px}.small-point a{width:6px;height:6px}.small-point a:first-child,.small-point a:last-child{width:4px;height:4px}.small-point a.active{width:6px;height:6px}.carousel-buttons{display:flex;justify-content:center;align-items:center;position:absolute;bottom:50%;width:100%;height:0;z-index:100}:host(:not([dir=\"rtl\"])) .carousel-buttons{left:0}:host([dir=\"rtl\"]) .carousel-buttons{right:0}.carousel-buttons.vertical{bottom:0;width:0;height:100%;z-index:100}:host(:not([dir=\"rtl\"])) .carousel-buttons.vertical{left:28px}:host([dir=\"rtl\"]) .carousel-buttons.vertical{right:28px}.carousel-buttons.vertical button{background:none;border:none;padding:0;outline:inherit;cursor:pointer;position:absolute;-webkit-user-select:none;user-select:none;text-decoration:none;color:rgba(51, 51, 51, 0.5)}.carousel-buttons.vertical button.next,.carousel-buttons.vertical button.prev{cursor:pointer}:host(:not([dir=\"rtl\"])) .carousel-buttons.vertical button.next,:host(:not([dir=\"rtl\"])) .carousel-buttons.vertical button.prev{left:-20px}:host([dir=\"rtl\"]) .carousel-buttons.vertical button.next,:host([dir=\"rtl\"]) .carousel-buttons.vertical button.prev{right:-20px}.carousel-buttons.vertical button.next.disabled,.carousel-buttons.vertical button.prev.disabled{color:rgba(51, 51, 51, 0.3)}.carousel-buttons.vertical button.prev{top:-35px}.carousel-buttons.vertical button.next{bottom:-27px}.carousel-buttons:not(.vertical) button{background:none;border:none;padding:0;outline:inherit;cursor:pointer;font-size:22px;position:absolute;-webkit-user-select:none;user-select:none;text-decoration:none}.carousel-buttons:not(.vertical) button.next,.carousel-buttons:not(.vertical) button.prev{cursor:pointer}.carousel-buttons:not(.vertical) button.next.disabled,.carousel-buttons:not(.vertical) button.prev.disabled{color:rgba(51, 51, 51, 0.3)}.carousel-buttons:not(.vertical) button.next{font-size:56px;color:#626469}:host(:not([dir=\"rtl\"])) .carousel-buttons:not(.vertical) button.next{right:-40px}:host([dir=\"rtl\"]) .carousel-buttons:not(.vertical) button.next{left:-40px}.carousel-buttons:not(.vertical) button.prev{font-size:56px;color:#626469}:host(:not([dir=\"rtl\"])) .carousel-buttons:not(.vertical) button.prev{left:-50px}:host([dir=\"rtl\"]) .carousel-buttons:not(.vertical) button.prev{right:-50px}.small-card a{flex-flow:row-reverse}";

const Slider = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.afterSlimInit = createEvent(this, "afterSlimInit", 7);
    this.afterSlimSlide = createEvent(this, "afterSlimSlide", 7);
    this.pos = 0;
    this.handleSwipe = (e) => {
      const shiftY = (e.deltaY / this.slideWidth) * 100 > -20;
      const shiftX = (e.deltaX / this.slideHeight) * 100 > -20;
      if (this.panEnabled && (shiftY || shiftX)) {
        !this.verticalPan && this.translateY(this.pos + e.deltaY);
        this.verticalPan && this.translateX(this.pos + e.deltaX);
        if (e.isFinal) {
          if (e.type === 'panleft' || e.type === 'panup') {
            this.goToNext();
          }
          else if (e.type === 'panright' || e.type === 'pandown') {
            this.goToPrevious();
          }
          else {
            this.slideTo(this.current);
          }
        }
        else if (e.type === 'panend' || e.type === 'pancancel') {
          this.slideTo(this.current);
        }
      }
      else {
        this.slideTo(this.current);
      }
    };
    this.timing = 400;
    this.childrenClassName = 'pdp-slider > div, pdp-slider > pdp-product-card';
    this.verticalPan = false;
    this.showButtons = true;
    this.infinite = false;
    this.showPointers = false;
    this.showThumbnails = false;
    this.itemsPerSlide = 1;
    this.differentWidthOfItems = false;
    this.sliderWidth = null;
    this.sliderHeight = null;
    this.activeSlide = 0;
    this.panEnabled = true;
    this.direction = document.documentElement.dir || 'auto';
    this.smallPoint = false;
    this.smallCard = false;
    this.shortCarouselPagination = undefined;
    this.goToNext = (e) => {
      e && e.preventDefault();
      if (this.direction === 'rtl') {
        this.slideTo(Math.ceil(this.current + this.operator));
      }
      else {
        this.slideTo(Math.ceil(this.current - this.operator));
      }
    };
    this.goToPrevious = (e) => {
      e && e.preventDefault();
      if (this.direction === 'rtl') {
        this.slideTo(Math.ceil(this.current - this.operator));
      }
      else {
        this.slideTo(this.current + this.operator);
      }
    };
    this.slideCount = 0;
    this.current = this.activeSlide;
  }
  optionDidChange(activeSlide) {
    this.slideTo(activeSlide);
  }
  setPan(enabled) {
    this.panEnabled = enabled;
    this.initGesture();
  }
  slideTo(n) {
    let last;
    if (this.differentWidthOfItems) {
      last = Array.from(this.slides)
        .slice(0 - (this.slideCount - this.current))
        .reduce((sum, i) => sum + i.offsetWidth, 0) >= this.slider.offsetWidth
        ? this.slideCount
        : n - 1;
      this.current = n < 0 ? 0 : n >= last ? last : n;
      this.pos = this.current === 0
        ? 0
        : this.operator
          * Array.from(this.slides)
            .slice(0, this.current)
            .reduce((sum, i) => sum + i.offsetWidth, 0);
    }
    else {
      last = this.infinite ? 0 : Math.ceil(this.slideCount - this.itemsPerSlide);
      this.current = n < 0 ? 0 : n >= last ? last : n;
      this.pos = (this.operator * this.current * (!this.verticalPan
        ? this.slideWidth
        : this.slideHeight))
        / this.itemsPerSlide;
    }
    this.slider.classList.add('is-animating');
    const prevSlide = this.parent.querySelector(`${this.childrenClassName}.active`);
    prevSlide && prevSlide.classList.remove('active');
    this.slides[this.current] && this.slides[this.current].classList.add('active');
    if (this.showButtons) {
      this.current === last
        ? this.nextBtn && this.nextBtn.classList.add('disabled')
        : this.nextBtn && this.nextBtn.classList.remove('disabled');
      this.current === 0
        ? this.prevBtn && this.prevBtn.classList.add('disabled')
        : this.prevBtn && this.prevBtn.classList.remove('disabled');
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.slider && this.slider.classList.remove('is-animating');
      this.afterSlimSlide.emit({ current: this.current });
    }, this.timing);
    !this.verticalPan ? this.translateY(this.pos) : this.translateX(this.pos);
  }
  init() {
    var _a, _b, _c, _d;
    this.operator = -1;
    this.slides = this.parent.querySelectorAll(this.childrenClassName);
    this.slideCount = this.slides.length;
    this.slideWidth = (_a = this.sliderWidth) !== null && _a !== void 0 ? _a : this.parent.offsetWidth;
    this.slideHeight = (_b = this.sliderHeight) !== null && _b !== void 0 ? _b : this.parent.offsetHeight;
    this.itemWidth = this.slideWidth / this.itemsPerSlide;
    this.itemHeight = this.slideHeight / this.itemsPerSlide;
    this.parent.style.direction = this.direction;
    (_d = (_c = this.slides) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.classList.add('active');
    if (this.slideCount > 4 && this.verticalPan) {
      this.parent.style.marginTop = '23px';
    }
    Array.from(this.slides).forEach((el, k) => {
      el.dataset.item = k.toString();
      if (!this.differentWidthOfItems && this.slideCount > this.itemsPerSlide) {
        this.verticalPan
          ? (el.style.minHeight = `${this.itemHeight}px`)
          : (el.style.minWidth = `${this.itemWidth}px`);
      }
      Array.from(el.querySelectorAll('img')).map((i) => (i.draggable = false));
    });
    this.afterSlimInit.emit({ current: this.current });
  }
  resizeWindow() {
    this.init();
    this.slideTo(0);
  }
  initGesture() {
    if (this.sliderManager) {
      this.sliderManager.destroy();
      this.sliderManager = null;
    }
    if (this.slideCount <= this.itemsPerSlide)
      return;
    const touchAction = !this.panEnabled
      ? { touchAction: 'none' }
      : this.verticalPan
        ? { touchAction: 'pan-x' }
        : { touchAction: 'pan-y' };
    this.sliderManager = new hammer.Manager(this.slider, Object.assign(Object.assign({}, touchAction), { recognizers: [[hammer.Pan, { direction: hammer.DIRECTION_ALL }]] }));
    this.sliderManager.on('panstart panmove panend pancancel panleft panright panup pandown', this.handleSwipe);
    window.addEventListener('resize', () => this.resizeWindow);
  }
  translateY(to) {
    const pos = this.direction === 'rtl' ? to * -1 : to;
    requestAnimationFrame(() => {
      this.slider.style.transform = `translateX(${pos}px)`;
      this.slider.style.webkitTransform = `translateX(${pos}px)`;
    });
  }
  translateX(to) {
    requestAnimationFrame(() => {
      this.slider.style.transform = `translateY(${to}px)`;
      this.slider.style.webkitTransform = `translateY(${to}px)`;
    });
  }
  getCarouselPointers(count) {
    let pointers = [];
    if (this.shortCarouselPagination && count >= 4) {
      pointers = [
        h("a", { class: classnames('pointer', { active: this.current === 0 }) }),
        h("a", { class: classnames('pointer', { active: this.current === 1 }) }),
        h("a", { class: classnames('pointer', { active: this.current > 1 && this.current < count - 1 }) }),
        h("a", { class: classnames('pointer', { active: this.current === count - 1 }) }),
      ];
    }
    else {
      for (let k = 0; k < count - this.itemsPerSlide + 1; k++) {
        pointers.push(h("a", { class: classnames(`pointer_${k}`, { active: this.current === k }), onClick: () => this.slideTo(k) }));
      }
    }
    return pointers;
  }
  updateCurrentPosition(event) {
    this.current = event.detail.current;
  }
  recalculateSlides() {
    this.init();
  }
  recalculateSlidePosition() {
    var _a;
    this.slideWidth = this.parent.offsetWidth;
    this.itemWidth = this.slideWidth / this.itemsPerSlide;
    if ((_a = this.slides) === null || _a === void 0 ? void 0 : _a.length) {
      Array.from(this.slides).forEach((el) => {
        if (!this.differentWidthOfItems && this.slideCount > this.itemsPerSlide) {
          el.style.minWidth = `${this.itemWidth}px`;
        }
      });
    }
    this.pos = (this.operator * this.current * this.slideWidth) / this.itemsPerSlide;
    this.translateY(this.pos);
  }
  componentDidLoad() {
    this.init();
    this.initGesture();
    if (this.current > 0)
      this.slideTo(this.current);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeWindow);
  }
  handleSlotChange() {
    this.init();
    this.slideTo(0);
  }
  render() {
    return [
      h("div", { class: "slim-slider-wrapper" }, h("div", { class: classnames('slim-slides', {
          'small-height': this.smallCard,
          vertical: this.verticalPan,
        }), ref: (el) => (this.slider = el) }, h("slot", { onSlotchange: () => this.handleSlotChange() }))),
      this.showPointers && this.slideCount > this.itemsPerSlide && (h("div", { class: classnames('carousel-pagination', {
          'carousel-pagination__above': this.showThumbnails,
          'small-point': this.smallPoint,
        }) }, this.getCarouselPointers(this.slideCount))),
      this.showButtons && this.slideCount > this.itemsPerSlide && (h("div", { class: classnames({ vertical: this.verticalPan }, 'carousel-buttons') }, h("button", { class: "btn-link prev disabled", onClick: this.goToPrevious, ref: (el) => (this.prevBtn = el) }, this.verticalPan ? (h("pes-icon", { mirror: pesIconMirrorDirection.VERTICAL, size: pesIconSizes.MICRO }, "arrow2_down")) : (h("pes-icon", { size: pesIconSizes.LARGE, customStyle: { fontSize: '56px' } }, "arrow2_left"))), h("button", { class: "btn-link next", onClick: this.goToNext, ref: (el) => (this.nextBtn = el) }, this.verticalPan ? (h("pes-icon", { size: pesIconSizes.MICRO, customStyle: { fontSize: '40px' } }, "arrow2_down")) : (h("pes-icon", { size: pesIconSizes.LARGE, customStyle: { fontSize: '56px' }, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left"))))),
    ];
  }
  get parent() { return getElement(this); }
  static get watchers() { return {
    "activeSlide": ["optionDidChange"],
    "itemsPerSlide": ["recalculateSlides"],
    "sliderWidth": ["recalculateSlidePosition"]
  }; }
};
Slider.style = sliderCss;

const productOfProductsTranslations = {
  FROM: '#from what element the product is displayed#',
  TO: '#to what element the product is displayed#',
  ALL: '#all the products#',
};
const PRODUCTS_LABEL_TRANSLATION = '#number of products#';
const MAX_DISPLAYED_NUMBER_OF_RECORDS = 10;

const switchCardViewCss = ".button{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;position:relative;min-width:1px;min-height:20px;font-size:14px;line-height:20px;color:#626469}:host(:not([dir=\"rtl\"])) .button{padding-left:30px}:host([dir=\"rtl\"]) .button{padding-right:30px}.button:hover,.button:focus,.button.active{color:#3dcd58}.button::before{content:\"\";position:absolute;top:50%;width:20px;height:20px;background-repeat:no-repeat;background-position:center center;transform:translateY(-50%)}:host(:not([dir=\"rtl\"])) .button::before{left:0}:host([dir=\"rtl\"]) .button::before{right:0}:host(:not([dir=\"rtl\"])) .button+.button{margin-left:13px}:host([dir=\"rtl\"]) .button+.button{margin-right:13px}:host(:not([dir=\"rtl\"])) .button--without-labels{padding-left:28px}:host([dir=\"rtl\"]) .button--without-labels{padding-right:28px}:host(:not([dir=\"rtl\"])) .button--without-labels+.button{margin-left:0}:host([dir=\"rtl\"]) .button--without-labels+.button{margin-right:0}.button-grid::before{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 63.1 (92452) - https://sketch.com --%3E%3Ctitle%3Eic_grid-view/inactive%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='ic_grid-view/inactive' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Crect id='bound' x='0' y='0' width='20' height='20'%3E%3C/rect%3E%3Cpath d='M17.5,16.5 C17.5,17.0128358 17.1139598,17.4355072 16.6166211,17.4932723 L16.5,17.5 L3.5,17.5 C2.98716416,17.5 2.56449284,17.1139598 2.50672773,16.6166211 L2.5,16.5 L2.5,3.5 C2.5,2.98716416 2.88604019,2.56449284 3.38337887,2.50672773 L3.5,2.5 L16.5,2.5 C17.0128358,2.5 17.4355072,2.88604019 17.4932723,3.38337887 L17.5,3.5 L17.5,16.5 Z M9.5,10.5 L3.5,10.5 L3.5,16.5 L9.5,16.5 L9.5,10.5 Z M16.5,10.5 L10.5,10.5 L10.5,16.5 L16.5,16.5 L16.5,10.5 Z M9.5,3.5 L3.5,3.5 L3.5,9.5 L9.5,9.5 L9.5,3.5 Z M16.5,3.5 L10.5,3.5 L10.5,9.5 L16.5,9.5 L16.5,3.5 Z' id='ic_grid-view' fill='%23626469' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\")}:host(:not([dir=\"rtl\"])) .button-grid::before{left:-2px}:host([dir=\"rtl\"]) .button-grid::before{right:-2px}.button-grid:hover::before,.button-grid:focus::before,.button-grid.active::before{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 63.1 (92452) - https://sketch.com --%3E%3Ctitle%3Eic_grid-view/active%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='ic_grid-view/active' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Crect id='bound' x='0' y='0' width='20' height='20'%3E%3C/rect%3E%3Cpath d='M17.5,16.5 C17.5,17.0128358 17.1139598,17.4355072 16.6166211,17.4932723 L16.5,17.5 L3.5,17.5 C2.98716416,17.5 2.56449284,17.1139598 2.50672773,16.6166211 L2.5,16.5 L2.5,3.5 C2.5,2.98716416 2.88604019,2.56449284 3.38337887,2.50672773 L3.5,2.5 L16.5,2.5 C17.0128358,2.5 17.4355072,2.88604019 17.4932723,3.38337887 L17.5,3.5 L17.5,16.5 Z M9.5,10.5 L3.5,10.5 L3.5,16.5 L9.5,16.5 L9.5,10.5 Z M16.5,10.5 L10.5,10.5 L10.5,16.5 L16.5,16.5 L16.5,10.5 Z M9.5,3.5 L3.5,3.5 L3.5,9.5 L9.5,9.5 L9.5,3.5 Z M16.5,3.5 L10.5,3.5 L10.5,9.5 L16.5,9.5 L16.5,3.5 Z' id='ic_grid-view' fill='%233DCD58' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\")}.button-list::before{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 63.1 (92452) - https://sketch.com --%3E%3Ctitle%3Eic_list-view/inactive%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3Cpath d='M1.19836957,0 C0.538043478,0 0,0.538043478 0,1.17391304 C0,1.83423913 0.538043478,2.37228261 1.19836957,2.37228261 C1.85869565,2.37228261 2.37228261,1.83423913 2.37228261,1.17391304 C2.37228261,0.538043478 1.85869565,0 1.19836957,0 Z M17.486413,1.6875 C17.7798913,1.6875 18,1.4673913 18,1.17391304 C18,0.904891304 17.7798913,0.684782609 17.486413,0.684782609 L5.79619565,0.684782609 C5.50271739,0.684782609 5.2826087,0.904891304 5.2826087,1.17391304 C5.2826087,1.4673913 5.50271739,1.6875 5.79619565,1.6875 L17.486413,1.6875 Z M1.19836957,5.74728261 C0.538043478,5.74728261 0,6.28532609 0,6.94565217 C0,7.60597826 0.538043478,8.14402174 1.19836957,8.14402174 C1.85869565,8.14402174 2.37228261,7.60597826 2.37228261,6.94565217 C2.37228261,6.28532609 1.85869565,5.74728261 1.19836957,5.74728261 Z M17.486413,7.45923913 C17.7798913,7.45923913 18,7.21467391 18,6.94565217 C18,6.65217391 17.7798913,6.43206522 17.486413,6.43206522 L5.79619565,6.43206522 C5.50271739,6.43206522 5.2826087,6.65217391 5.2826087,6.94565217 C5.2826087,7.21467391 5.50271739,7.45923913 5.79619565,7.45923913 L17.486413,7.45923913 Z M1.19836957,11.4945652 C0.538043478,11.4945652 0,12.0326087 0,12.6929348 C0,13.3532609 0.538043478,13.8913043 1.19836957,13.8913043 C1.85869565,13.8913043 2.37228261,13.3532609 2.37228261,12.6929348 C2.37228261,12.0326087 1.85869565,11.4945652 1.19836957,11.4945652 Z M17.486413,13.2065217 C17.7798913,13.2065217 18,12.986413 18,12.6929348 C18,12.423913 17.7798913,12.1793478 17.486413,12.1793478 L5.79619565,12.1793478 C5.50271739,12.1793478 5.2826087,12.423913 5.2826087,12.6929348 C5.2826087,12.986413 5.50271739,13.2065217 5.79619565,13.2065217 L17.486413,13.2065217 Z' id='path-1'%3E%3C/path%3E%3C/defs%3E%3Cg id='ic_list-view/inactive' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Crect id='bound' x='0' y='0' width='20' height='20'%3E%3C/rect%3E%3Cg id='ic_list-view' transform='translate(1.000000, 3.000000)'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cg id='Mask' fill-rule='nonzero'%3E%3C/g%3E%3Cg id='Color/Dark_Gray_%23626469' mask='url(%23mask-2)' fill='%23626469'%3E%3Cg transform='translate(-1.000000, -3.000000)' id='color'%3E%3Crect x='0' y='0' width='20' height='20'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.button-list:hover::before,.button-list:focus::before,.button-list.active::before{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 63.1 (92452) - https://sketch.com --%3E%3Ctitle%3Eic_list-view/active%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3Cpath d='M1.19836957,0 C0.538043478,0 0,0.538043478 0,1.17391304 C0,1.83423913 0.538043478,2.37228261 1.19836957,2.37228261 C1.85869565,2.37228261 2.37228261,1.83423913 2.37228261,1.17391304 C2.37228261,0.538043478 1.85869565,0 1.19836957,0 Z M17.486413,1.6875 C17.7798913,1.6875 18,1.4673913 18,1.17391304 C18,0.904891304 17.7798913,0.684782609 17.486413,0.684782609 L5.79619565,0.684782609 C5.50271739,0.684782609 5.2826087,0.904891304 5.2826087,1.17391304 C5.2826087,1.4673913 5.50271739,1.6875 5.79619565,1.6875 L17.486413,1.6875 Z M1.19836957,5.74728261 C0.538043478,5.74728261 0,6.28532609 0,6.94565217 C0,7.60597826 0.538043478,8.14402174 1.19836957,8.14402174 C1.85869565,8.14402174 2.37228261,7.60597826 2.37228261,6.94565217 C2.37228261,6.28532609 1.85869565,5.74728261 1.19836957,5.74728261 Z M17.486413,7.45923913 C17.7798913,7.45923913 18,7.21467391 18,6.94565217 C18,6.65217391 17.7798913,6.43206522 17.486413,6.43206522 L5.79619565,6.43206522 C5.50271739,6.43206522 5.2826087,6.65217391 5.2826087,6.94565217 C5.2826087,7.21467391 5.50271739,7.45923913 5.79619565,7.45923913 L17.486413,7.45923913 Z M1.19836957,11.4945652 C0.538043478,11.4945652 0,12.0326087 0,12.6929348 C0,13.3532609 0.538043478,13.8913043 1.19836957,13.8913043 C1.85869565,13.8913043 2.37228261,13.3532609 2.37228261,12.6929348 C2.37228261,12.0326087 1.85869565,11.4945652 1.19836957,11.4945652 Z M17.486413,13.2065217 C17.7798913,13.2065217 18,12.986413 18,12.6929348 C18,12.423913 17.7798913,12.1793478 17.486413,12.1793478 L5.79619565,12.1793478 C5.50271739,12.1793478 5.2826087,12.423913 5.2826087,12.6929348 C5.2826087,12.986413 5.50271739,13.2065217 5.79619565,13.2065217 L17.486413,13.2065217 Z' id='path-1'%3E%3C/path%3E%3C/defs%3E%3Cg id='ic_list-view/active' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Crect id='bound' x='0' y='0' width='20' height='20'%3E%3C/rect%3E%3Cg id='ic_list-view' transform='translate(1.000000, 3.000000)'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cg id='Mask' fill-rule='nonzero'%3E%3C/g%3E%3Cg id='Color/Life_Green_%233DCD58' mask='url(%23mask-2)' fill='%233DCD58'%3E%3Cg transform='translate(-1.000000, -3.000000)' id='color'%3E%3Crect x='0' y='0' width='20' height='20'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.product-of-products{font-size:12px;font-weight:normal;line-height:15px;color:#626469}:host(:not([dir=\"rtl\"])) .product-of-products{padding:3px 0 2px 15px;margin-left:15px;border-left:1px solid #9fa0a4}:host([dir=\"rtl\"]) .product-of-products{padding:3px 15px 2px 0;margin-right:15px;border-right:1px solid #9fa0a4}:host(:not([dir=\"rtl\"])) .product-of-products--without-button-labels{margin-left:4px}:host([dir=\"rtl\"]) .product-of-products--without-button-labels{margin-right:4px}";

const SwitchCardView = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.toggleCardView = createEvent(this, "toggleCardView", 7);
    this.listViewLabel = undefined;
    this.gridViewLabel = undefined;
    this.areLabelsShown = true;
    this.isGridView = undefined;
    this.productOfProductsLabel = undefined;
    this.productsLabel = undefined;
    this.firstRecNum = undefined;
    this.lastRecNum = undefined;
    this.totalNumRecs = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  get productOfProductsText() {
    if (this.totalNumRecs > MAX_DISPLAYED_NUMBER_OF_RECORDS) {
      return this.productOfProductsLabel
        .replace(productOfProductsTranslations.FROM, this.firstRecNum.toString())
        .replace(productOfProductsTranslations.TO, this.lastRecNum.toString())
        .replace(productOfProductsTranslations.ALL, this.totalNumRecs.toString());
    }
    if (this.productsLabel.includes(PRODUCTS_LABEL_TRANSLATION)) {
      return this.productsLabel.replace(PRODUCTS_LABEL_TRANSLATION, this.totalNumRecs.toString());
    }
    return `${this.totalNumRecs} ${this.productsLabel}`;
  }
  clickButtonHandler(isGrid) {
    this.toggleCardView.emit(isGrid);
  }
  render() {
    const gridClass = classnames({
      button: true,
      'button-grid': true,
      active: this.isGridView,
      'button--without-labels': !this.areLabelsShown,
    });
    const listClass = classnames({
      button: true,
      'button-list': true,
      active: !this.isGridView,
      'button--without-labels': !this.areLabelsShown,
    });
    return (h(Host, { class: "switch-view" }, h("button", { type: "button", class: listClass, onClick: () => this.clickButtonHandler(false), innerHTML: this.areLabelsShown ? this.listViewLabel : '&nbsp;', title: this.areLabelsShown ? null : this.listViewLabel }), h("button", { type: "button", class: gridClass, onClick: () => this.clickButtonHandler(true), innerHTML: this.areLabelsShown ? this.gridViewLabel : '&nbsp;', title: this.areLabelsShown ? null : this.gridViewLabel }), this.productOfProductsLabel && (h("span", { class: classnames('product-of-products', {
        'product-of-products--without-button-labels': !this.areLabelsShown,
      }) }, this.productOfProductsText))));
  }
  get el() { return getElement(this); }
};
SwitchCardView.style = switchCardViewCss;

var clipboard = createCommonjsModule(function (module, exports) {
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory();
})(commonjsGlobal, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ clipboard; }
});

// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(279);
var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
// EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
var listen = __webpack_require__(370);
var listen_default = /*#__PURE__*/__webpack_require__.n(listen);
// EXTERNAL MODULE: ./node_modules/select/src/select.js
var src_select = __webpack_require__(817);
var select_default = /*#__PURE__*/__webpack_require__.n(src_select);
/**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */
function command(type) {
  try {
    return document.execCommand(type);
  } catch (err) {
    return false;
  }
}


/**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */

var ClipboardActionCut = function ClipboardActionCut(target) {
  var selectedText = select_default()(target);
  command('cut');
  return selectedText;
};

/* harmony default export */ var actions_cut = (ClipboardActionCut);
/**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */
function createFakeElement(value) {
  var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
  var fakeElement = document.createElement('textarea'); // Prevent zooming on iOS

  fakeElement.style.fontSize = '12pt'; // Reset box model

  fakeElement.style.border = '0';
  fakeElement.style.padding = '0';
  fakeElement.style.margin = '0'; // Move element out of screen horizontally

  fakeElement.style.position = 'absolute';
  fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

  var yPosition = window.pageYOffset || document.documentElement.scrollTop;
  fakeElement.style.top = "".concat(yPosition, "px");
  fakeElement.setAttribute('readonly', '');
  fakeElement.value = value;
  return fakeElement;
}



/**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */

var fakeCopyAction = function fakeCopyAction(value, options) {
  var fakeElement = createFakeElement(value);
  options.container.appendChild(fakeElement);
  var selectedText = select_default()(fakeElement);
  command('copy');
  fakeElement.remove();
  return selectedText;
};
/**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */


var ClipboardActionCopy = function ClipboardActionCopy(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    container: document.body
  };
  var selectedText = '';

  if (typeof target === 'string') {
    selectedText = fakeCopyAction(target, options);
  } else if (target instanceof HTMLInputElement && !['text', 'search', 'url', 'tel', 'password'].includes(target === null || target === void 0 ? void 0 : target.type)) {
    // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
    selectedText = fakeCopyAction(target.value, options);
  } else {
    selectedText = select_default()(target);
    command('copy');
  }

  return selectedText;
};

/* harmony default export */ var actions_copy = (ClipboardActionCopy);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



/**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */

var ClipboardActionDefault = function ClipboardActionDefault() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Defines base properties passed from constructor.
  var _options$action = options.action,
      action = _options$action === void 0 ? 'copy' : _options$action,
      container = options.container,
      target = options.target,
      text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.

  if (action !== 'copy' && action !== 'cut') {
    throw new Error('Invalid "action" value, use either "copy" or "cut"');
  } // Sets the `target` property using an element that will be have its content copied.


  if (target !== undefined) {
    if (target && _typeof(target) === 'object' && target.nodeType === 1) {
      if (action === 'copy' && target.hasAttribute('disabled')) {
        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
      }

      if (action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
      }
    } else {
      throw new Error('Invalid "target" value, use a valid Element');
    }
  } // Define selection strategy based on `text` property.


  if (text) {
    return actions_copy(text, {
      container: container
    });
  } // Defines which selection strategy based on `target` property.


  if (target) {
    return action === 'cut' ? actions_cut(target) : actions_copy(target, {
      container: container
    });
  }
};

/* harmony default export */ var actions_default = (ClipboardActionDefault);
function clipboard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clipboard_typeof = function _typeof(obj) { return typeof obj; }; } else { clipboard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clipboard_typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }






/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */

function getAttributeValue(suffix, element) {
  var attribute = "data-clipboard-".concat(suffix);

  if (!element.hasAttribute(attribute)) {
    return;
  }

  return element.getAttribute(attribute);
}
/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */


var Clipboard = /*#__PURE__*/function (_Emitter) {
  _inherits(Clipboard, _Emitter);

  var _super = _createSuper(Clipboard);

  /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */
  function Clipboard(trigger, options) {
    var _this;

    _classCallCheck(this, Clipboard);

    _this = _super.call(this);

    _this.resolveOptions(options);

    _this.listenClick(trigger);

    return _this;
  }
  /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */


  _createClass(Clipboard, [{
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
      this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
      this.text = typeof options.text === 'function' ? options.text : this.defaultText;
      this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
    }
    /**
     * Adds a click event listener to the passed trigger.
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     */

  }, {
    key: "listenClick",
    value: function listenClick(trigger) {
      var _this2 = this;

      this.listener = listen_default()(trigger, 'click', function (e) {
        return _this2.onClick(e);
      });
    }
    /**
     * Defines a new `ClipboardAction` on each click event.
     * @param {Event} e
     */

  }, {
    key: "onClick",
    value: function onClick(e) {
      var trigger = e.delegateTarget || e.currentTarget;
      var action = this.action(trigger) || 'copy';
      var text = actions_default({
        action: action,
        container: this.container,
        target: this.target(trigger),
        text: this.text(trigger)
      }); // Fires an event based on the copy operation result.

      this.emit(text ? 'success' : 'error', {
        action: action,
        text: text,
        trigger: trigger,
        clearSelection: function clearSelection() {
          if (trigger) {
            trigger.focus();
          }

          window.getSelection().removeAllRanges();
        }
      });
    }
    /**
     * Default `action` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultAction",
    value: function defaultAction(trigger) {
      return getAttributeValue('action', trigger);
    }
    /**
     * Default `target` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultTarget",
    value: function defaultTarget(trigger) {
      var selector = getAttributeValue('target', trigger);

      if (selector) {
        return document.querySelector(selector);
      }
    }
    /**
     * Allow fire programmatically a copy action
     * @param {String|HTMLElement} target
     * @param {Object} options
     * @returns Text copied.
     */

  }, {
    key: "defaultText",

    /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */
    value: function defaultText(trigger) {
      return getAttributeValue('text', trigger);
    }
    /**
     * Destroy lifecycle.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.listener.destroy();
    }
  }], [{
    key: "copy",
    value: function copy(target) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        container: document.body
      };
      return actions_copy(target, options);
    }
    /**
     * Allow fire programmatically a cut action
     * @param {String|HTMLElement} target
     * @returns Text cutted.
     */

  }, {
    key: "cut",
    value: function cut(target) {
      return actions_cut(target);
    }
    /**
     * Returns the support of the given action, or all actions if no action is
     * given.
     * @param {String} [action]
     */

  }, {
    key: "isSupported",
    value: function isSupported() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
      var actions = typeof action === 'string' ? [action] : action;
      var support = !!document.queryCommandSupported;
      actions.forEach(function (action) {
        support = support && !!document.queryCommandSupported(action);
      });
      return support;
    }
  }]);

  return Clipboard;
}((tiny_emitter_default()));

/* harmony default export */ var clipboard = (Clipboard);

/***/ }),

/***/ 828:
/***/ (function(module) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ 438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var closest = __webpack_require__(828);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ 879:
/***/ (function(__unused_webpack_module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ 370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var is = __webpack_require__(879);
var delegate = __webpack_require__(438);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ 817:
/***/ (function(module) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ 279:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    }
    listener._ = callback;
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); };
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(686);
/******/ })()
.default;
});
});

const ClipboardJS = /*@__PURE__*/getDefaultExportFromCjs(clipboard);

const COPY_LINK_DISABLED_PAGES = [
  /\/shop\/\w{2}\/\w{2}\/payment\/CheckoutOrderReview\.jsp/gi,
  /\/shop\/\w{2}\/\w{2}\/order\/orderConfirmation\.jsp/gi,
];
const API_COPY_LINK_CONFIG_URL = '/rest/model/schneider/chatlink/rest/CopyLinkActor/copyLink';
const COPY_LINK_BTN = 'copyBtn';
const CSC_ID = 'Chat_CSC_ID';

const agentLinkCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}@media screen and (min-width: 720px){:host(:not([dir=\"rtl\"])){padding-right:24px}:host([dir=\"rtl\"]){padding-left:24px}}.copy-link-button-wrapper{position:relative}.copy-link-button-wrapper__no-bar{margin-bottom:12px}.copy-link-button-wrapper .copy-link-button{width:48px;height:48px;border:none;background-color:#42b4e6;display:flex;justify-content:center;align-items:center;padding:0;box-shadow:0 0 2px 0 rgba(51, 51, 51, 0.14), 0 3px 5px 0 rgba(51, 51, 51, 0.1)}.copy-link-button-wrapper .copy-link-button:focus,.copy-link-button-wrapper .copy-link-button:hover{outline:0;padding:0}:host(:not([dir=\"rtl\"])) .copy-link-button-wrapper .copy-link-button:focus,:host(:not([dir=\"rtl\"])) .copy-link-button-wrapper .copy-link-button:hover{background:linear-gradient(180deg, #55d1fe 0%, #42b4e6 100%)}:host([dir=\"rtl\"]) .copy-link-button-wrapper .copy-link-button:focus,:host([dir=\"rtl\"]) .copy-link-button-wrapper .copy-link-button:hover{background:linear-gradient(-180deg, #55d1fe 0%, #42b4e6 100%)}.copy-link-button-wrapper.online .copy-link-button{background:#3dcd58}@media screen and (min-width: 720px){:host(:not([dir=\"rtl\"])) .copy-link-button-wrapper.online .copy-link-button:hover{background:linear-gradient(180deg, #55d1fe 0%, #42b4e6 100%)}:host([dir=\"rtl\"]) .copy-link-button-wrapper.online .copy-link-button:hover{background:linear-gradient(-180deg, #55d1fe 0%, #42b4e6 100%)}}.copy-link-button-wrapper .copy-link-button:hover+.tooltip{display:block}.copy-link-button-wrapper.online .tooltip .availability span{color:#3dcd58}.copy-link-button-wrapper .tooltip{display:none;position:absolute;bottom:-4px;width:204px;padding:20px;background-color:#ffffff;box-shadow:0 0 5px 0 rgba(51, 51, 51, 0.05), 0 5px 5px 0 rgba(51, 51, 51, 0.15);font-family:\"ArialRoundedMTforSE_Latin\", Arial, \"Helvetica Neue\", Helvetica, sans-serif;font-display:swap;text-transform:none;color:#626469;font-size:0.75rem;line-height:1.125rem;border-radius:4px}:host(:not([dir=\"rtl\"])) .copy-link-button-wrapper .tooltip{right:65px;text-align:left}:host([dir=\"rtl\"]) .copy-link-button-wrapper .tooltip{left:65px;text-align:right}.copy-link-button-wrapper .tooltip:after{content:\"\";position:absolute;bottom:24px;width:9px;height:9px;background-color:#ffffff}:host(:not([dir=\"rtl\"])) .copy-link-button-wrapper .tooltip:after{right:-5px;transform:rotate(225deg);box-shadow:-9px 2px 8px 0 rgba(0, 0, 0, 0.08)}:host([dir=\"rtl\"]) .copy-link-button-wrapper .tooltip:after{left:-5px;transform:rotate(-225deg);box-shadow:9px 2px 8px 0 rgba(0, 0, 0, 0.08)}@media screen and (max-width: 719px){.copy-link-button-wrapper{display:none}}";

function isBtnEnabledForPage() {
  return !COPY_LINK_DISABLED_PAGES.find((urlRx) => !!window.location.pathname.match(urlRx));
}
const CopyLinkButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.handleCloseTopBar = () => {
      this.state = Object.assign(Object.assign({}, this.state), { showTopBar: false });
    };
    this.getCSCID = () => {
      var _a;
      const queryString = (_a = this.state.config) === null || _a === void 0 ? void 0 : _a.linkToShare.split('?')[1];
      const queries = queryString ? queryString.split('&') : null;
      if (queries) {
        for (let i = 0; i < queries.length; i++) {
          const query = queries[i].split('=');
          if (query[0] === CSC_ID) {
            return query[1];
          }
        }
      }
    };
    this.updateLinkToShare = () => {
      const CSCValue = this.getCSCID();
      return window.location.search
        ? `${window.location.href}&${CSC_ID}=${CSCValue}`
        : `${window.location.href}?${CSC_ID}=${CSCValue}`;
    };
    this.handleBtnClick = (e) => {
      e.preventDefault();
      let linkToShare;
      if (this.state.config.linkToShare
        && this.state.config.linkToShare.split('?')[0]
          !== `${window.location.origin}+${window.location.pathname}`) {
        linkToShare = this.updateLinkToShare();
      }
      document.addEventListener('mousedown', this.handleClickOutside);
      const updatedState = linkToShare
        ? {
          showTopBar: true,
          config: Object.assign(Object.assign({}, this.state.config), { linkToShare }),
          isLinkUpdated: true,
        }
        : {
          showTopBar: true,
          isLinkUpdated: true,
        };
      this.state = Object.assign(Object.assign({}, this.state), updatedState);
      const { prepareQuoteRest } = this.state.config;
      if (prepareQuoteRest) {
        this.prepareQuoteRestRequest(prepareQuoteRest);
      }
    };
    this.handlePDPHeaderChangeEvent = (e) => {
      this.state = Object.assign(Object.assign({}, this.state), { stickyAreaHeight: e.detail.stickyAreaHeight });
    };
    this.setButtonRef = (node) => {
      this.buttonRef = node;
    };
    this.setHostRef = (node) => {
      this.hostRef = node;
    };
    this.hideTopBar = () => {
      this.state = Object.assign(Object.assign({}, this.state), { showTopBar: false });
      document.removeEventListener('mousedown', this.handleClickOutside);
    };
    this.handleClickOutside = (event) => {
      if (this.notificationController.getBannerElement().contains(event.target)) {
        return;
      }
      if (this.hostRef !== event.target) {
        this.hideTopBar();
      }
    };
    this.host = undefined;
    this.compareBar = false;
    this.state = {
      isDesktop: true,
      showTopBar: false,
      stickyAreaHeight: null,
      btnEnabled: isBtnEnabledForPage(),
      isLinkUpdated: false,
      config: {},
      labels: {},
    };
  }
  handleStateUpdate(_, oldState) {
    var _a, _b, _c, _d;
    if (this.state.showTopBar !== oldState.showTopBar) {
      if (this.state.showTopBar) {
        this.notificationController = new NotificationBannerController();
        this.notificationController.show({
          target: ((_a = this.state.config) === null || _a === void 0 ? void 0 : _a.noHeader) ? 'body' : 'header',
          componentProps: {
            active: true,
            status: "informational",
            innerHTML: `
              <div>
                ${IconCopy}
                &nbsp;${(_b = this.state.labels) === null || _b === void 0 ? void 0 : _b.message}
                <a
                  href="${(_c = this.state.config) === null || _c === void 0 ? void 0 : _c.linkToShare}"
                  target="_blank"
                  style="color: #ffffff; text-decoration: underline"
                >${(_d = this.state.labels) === null || _d === void 0 ? void 0 : _d.target}</a>
              </div>`,
          },
        });
        document.addEventListener('closeDidClick', this.hideTopBar);
      }
      else {
        const bannerEl = this.notificationController.getBannerElement();
        bannerEl.dispatchEvent(new CustomEvent('closeDidClick'));
        document.removeEventListener('closeDidClick', this.hideTopBar);
      }
    }
  }
  prepareQuoteRestRequest(prepareQuoteRest) {
    fetch(prepareQuoteRest)
      .then(() => {
      console.log('success');
    })
      .catch((error) => {
      console.log(error);
    });
  }
  request(url) {
    return fetch(url, {
      credentials: 'include',
    }).then((response) => {
      if (response.status === 200)
        return response.json();
      throw response.status;
    });
  }
  loadConfig(host) {
    this.request(`${host}${API_COPY_LINK_CONFIG_URL}`)
      .then((config) => {
      if (config) {
        this.state = Object.assign(Object.assign({}, this.state), { config });
      }
    })
      .catch((error) => {
      console.error(error);
    });
  }
  componentDidLoad() {
    const { languageCode, countryCode } = getLocaleFromBody(isBrowser) || {};
    const brand = getBrandName();
    const url = `/agent/link?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}`;
    if (this.state.btnEnabled) {
      this.request(url)
        .then(({ labels, urls }) => {
        this.state = Object.assign(Object.assign({}, this.state), { labels });
        this.loadConfig(urls.apcHost);
      })
        .catch((error) => {
        console.error(error);
      });
    }
    if (this.buttonRef) {
      new ClipboardJS(this.buttonRef);
    }
  }
  disconnectedCallback() {
    const clipboard = new ClipboardJS(this.buttonRef);
    clipboard.destroy();
  }
  componentDidUpdate() {
    if (this.state.isLinkUpdated) {
      new ClipboardJS(this.buttonRef);
      this.state = Object.assign(Object.assign({}, this.state), { isLinkUpdated: false });
    }
  }
  render() {
    var _a;
    const { config } = this.state;
    if (!config.linkToShare) {
      return null;
    }
    return (h(Host, { ref: this.setHostRef }, h("div", { class: classnames('copy-link-button-wrapper', {
        'copy-link-button-wrapper__no-bar': !this.compareBar,
      }) }, h("button", { class: "copy-link-button", "aria-label": "", onClick: this.handleBtnClick, "data-clipboard-text": config.linkToShare, "data-clipboard-action": "copy", id: COPY_LINK_BTN, ref: this.setButtonRef }, h("div", { innerHTML: IconCopy })), h("div", { class: "tooltip" }, (_a = this.state.labels) === null || _a === void 0 ? void 0 : _a.tooltip))));
  }
  static get watchers() { return {
    "state": ["handleStateUpdate"]
  }; }
};
CopyLinkButton.style = agentLinkCss;

var smoothscroll = createCommonjsModule(function (module, exports) {
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  {
    // commonjs
    module.exports = { polyfill: polyfill };
  }

}());
});

const backToTopCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}@media screen and (min-width: 720px){:host(:not([dir=\"rtl\"])){padding-right:24px}:host([dir=\"rtl\"]){padding-left:24px}}.back-to-top{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;display:block;width:48px;height:48px;background-color:rgba(51, 51, 51, 0.5);color:#ffffff;border-radius:4px;overflow:hidden;transition:all 0.25s ease-out}.back-to-top:hover{background-color:rgba(51, 51, 51, 0.7)}.back-to-top:active{background-color:#333333}.back-to-top--shown{animation:show 0.25s ease-out;opacity:1}.back-to-top--hidden{animation:hide 0.25s ease-out;opacity:0}@keyframes show{from{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes hide{from{transform:translateY(0)}to{transform:translateY(100%)}}.back-to-top__wrapper{display:flex;align-items:center;justify-content:center;width:48px;height:48px}";

smoothscroll.polyfill();
const SCREENS_NUMBER_THRESHOLD = 4;
const BackToTop = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.handleClick = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };
    this.isShown = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  onWindowScroll() {
    const { innerHeight, scrollY } = window || {};
    const scrolledScreens = Math.floor(scrollY / innerHeight) + 1;
    if (scrolledScreens >= SCREENS_NUMBER_THRESHOLD) {
      this.isShown = true;
    }
    else {
      this.isShown = false;
    }
  }
  render() {
    return (h("button", { onClick: this.handleClick, class: classnames('back-to-top', this.isShown ? 'back-to-top--shown' : 'back-to-top--hidden') }, h("div", { class: "back-to-top__wrapper" }, h("pes-icon", { size: pesIconSizes.SMALL, mirror: pesIconMirrorDirection.VERTICAL }, "arrow2_down"))));
  }
  get el() { return getElement(this); }
};
BackToTop.style = backToTopCss;

const badgeCss = ":host{display:inline-flex}.badge{box-sizing:border-box;display:flex;align-items:center;align-self:center;max-width:100%;color:#ffffff;background-color:#3dcd58}.badge *,.badge *::before,.badge *::after{box-sizing:inherit}.badge--small{min-height:20px;max-height:34px;border-radius:2px;padding:1px 5px;line-height:16px;font-size:12px}.badge--large{max-height:60px;line-height:30px;border-radius:4px;padding:0 12px;font-size:14px;font-weight:700}.badge--new{background-color:#3dcd58}.badge--featured{background-color:#42b4e6}.badge--best-value{background-color:#ffd100;color:#0f0f0f}.badge--best-performance{background-color:#e47f00}.badge--best-seller{background-color:#b10043}";

const Badge$1 = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.type = undefined;
    this.color = undefined;
    this.textColor = undefined;
    this.label = undefined;
    this.size = 'small';
    this.lineHeight = undefined;
  }
  getStyles() {
    const styles = {};
    if (this.color) {
      styles.backgroundColor = this.color;
    }
    if (this.textColor) {
      styles.color = this.textColor;
    }
    if (this.lineHeight) {
      styles.lineHeight = this.lineHeight;
    }
    return styles;
  }
  render() {
    const hasType = !this.color && !this.textColor && this.type;
    const maxHeight = this.size === 'large' ? "60px" : "34px";
    return (h("div", { class: classnames('badge', `badge--${this.size}`, hasType && `badge--${this.type}`), style: this.getStyles() }, h("pes-ellipsis", { maxHeight: maxHeight, content: this.label })));
  }
};
Badge$1.style = badgeCss;

const BADGE_TYPE_MAP = {
  productLine: 'new',
  productsAdded: 'new',
  badgeNew: 'new',
  badgeFeatured: 'featured',
  badgeBestSeller: 'best-seller',
  badgeBestValue: 'best-value',
  badgeBestPerformance: 'best-performance',
};

const badgeWrapperCss = ":host{display:flex}";

const Badge = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.type = undefined;
    this.color = undefined;
    this.label = undefined;
    this.size = 'small';
    this.lineHeight = undefined;
  }
  getBadgeType(type) {
    if (type in BADGE_TYPE_MAP) {
      return BADGE_TYPE_MAP[type];
    }
    return '';
  }
  render() {
    return (h("pes-badge", { type: this.getBadgeType(this.type), label: this.label, size: this.size, color: this.color, lineHeight: this.lineHeight }));
  }
};
Badge.style = badgeWrapperCss;

const bannerCss = ".banner{cursor:pointer;display:flex;flex-direction:column;border:1px solid #42b4e6;width:100%;height:100%;position:relative;overflow:hidden;text-decoration:none;background-color:#ffffff;box-sizing:border-box}.banner *,.banner *::before,.banner *::after{box-sizing:inherit}.banner::before{content:\"\";position:absolute;top:0;width:40px;height:40px;background-color:#42b4e6}:host(:not([dir=\"rtl\"])) .banner::before{left:0;border-bottom-right-radius:100%}:host([dir=\"rtl\"]) .banner::before{right:0;border-bottom-left-radius:100%}.banner__corner-icon{position:absolute;top:8px}:host(:not([dir=\"rtl\"])) .banner__corner-icon{left:8px}:host([dir=\"rtl\"]) .banner__corner-icon{right:8px}";

const Banner = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.url = '';
    this.target = '_self';
    this.icon = 'segment_retail';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    const anchorProps = this.url ? { href: this.url, target: this.target } : {};
    return (h("a", Object.assign({ class: "banner" }, anchorProps), h("pes-icon", { class: "banner__corner-icon", color: "alternative", size: pesIconSizes.MICRO }, this.icon), h("slot", null)));
  }
  get el() { return getElement(this); }
};
Banner.style = bannerCss;

const bannerPromoBlockCss = ".banner-promo-block{height:270px;margin:0;padding:0;border:0;font:inherit;color:#ffffff;position:relative;margin-bottom:20px}.banner-promo-block :hover{background-color:rgba(51, 51, 51, 0.4)}.banner-promo-block :hover h4{transform:translateY(-15px);transition:transform 0.15s}.banner-promo-block__context-link{text-decoration:none}.banner-promo-block__context-link_underline{text-decoration:underline}@media screen and (max-width: 979px){.banner-promo-block{height:160px}}.banner-promo-block__image-wrap{height:270px;position:relative}@media screen and (max-width: 979px){.banner-promo-block__image-wrap{height:160px}}.banner-promo-block__image-wrap ::after{position:absolute;content:\"\";top:0;right:0;bottom:0;left:0;background:linear-gradient(0deg, rgba(51, 51, 51, 0.95), rgba(51, 51, 51, 0.4))}.banner-promo-block__wrapper{position:relative;margin:0;padding:0;border:0;font:inherit;vertical-align:baseline}.banner-promo-block__picture{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;overflow:hidden}@media screen and (max-width: 979px){.banner-promo-block__picture{height:160px}}.banner-promo-block__picture source{width:100%;height:100%}.banner-promo-block__picture img{min-width:100%;min-height:100%;max-width:100%;max-height:100%;object-fit:cover;position:absolute}:host(:not([dir=\"rtl\"])) .banner-promo-block__picture img{right:0}:host([dir=\"rtl\"]) .banner-promo-block__picture img{left:0}.banner-promo-block__context{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;justify-content:flex-end;align-items:flex-start;padding:20px 20px 5px;color:#fff}.banner-promo-block__context :hover{background-color:rgba(51, 51, 51, 0)}.banner-promo-block__context-description{margin:0;margin-bottom:10px;font-size:1rem;line-height:25px;max-width:506px;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden}.banner-promo-block__context h4{margin:0;font-size:1.375rem;line-height:2.5rem;margin-bottom:15px;max-width:100%;transition:transform 0.15s;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}@media screen and (max-width: 979px){.banner-promo-block__context h4{display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden}}.banner-promo-block__context-panel{display:flex;width:auto;justify-content:flex-start;font-size:0.8125rem;cursor:pointer}.banner-promo-block__context-panel-link{display:flex;align-items:center}:host(:not([dir=\"rtl\"])) .banner-promo-block__context-panel-link{margin-right:6px}:host([dir=\"rtl\"]) .banner-promo-block__context-panel-link{margin-left:6px}.banner-promo-block__context-link{font-size:0.8125rem;line-height:25px;color:#fff;text-decoration:none}.banner-promo-block__context-link_underline{text-decoration:underline}.banner-promo-block__context-link:visited,.banner-promo-block__context-link:active{text-decoration:none}.banner-promo-block__context-link-icon{position:relative}:host(:not([dir=\"rtl\"])) .banner-promo-block__context-link-icon{left:2px}:host([dir=\"rtl\"]) .banner-promo-block__context-link-icon{right:2px;transform:scaleX(-1)}.banner-promo-block__context-button-block{display:flex;align-items:center}.banner-promo-block__context-button{margin:0;padding:0;border:none;color:#fff;background:transparent;z-index:10;cursor:pointer}.banner-promo-block__context-button:hover{text-decoration:underline}.banner-promo-block__context-icon-play{height:15px;width:15px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40' id='play-hover-40x40'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle stroke='%23fff' stroke-width='2' cx='20' cy='20' r='19'%3E%3C/circle%3E%3Cpath d='M18.453 14.25l6.467 5.022a1 1 0 010 1.58l-6.467 5.022a1 1 0 01-1.613-.79V15.04a1 1 0 011.613-.79z' fill='%23fff'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\")}:host(:not([dir=\"rtl\"])) .banner-promo-block__context-icon-play{margin-left:5px}:host([dir=\"rtl\"]) .banner-promo-block__context-icon-play{margin-right:5px}.banner-promo-block__modal-window{position:fixed;top:0px;right:0px;bottom:0px;left:0px;display:flex;justify-content:center;align-items:center;z-index:60;background:rgba(51, 51, 51, 0.6)}.banner-promo-block__modal-window-content{max-width:1140px}";

const BannerPromoBlock = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.handleWatchClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.isShown = !this.isShown;
    };
    this.sdlCategoryPromo = undefined;
    this.isShown = false;
    this.isHover = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return (h("div", { class: "banner-promo-block", onMouseLeave: () => (this.isHover = false), onMouseEnter: () => (this.isHover = true), onClick: () => {
        var _a, _b, _c, _d;
        return window.open((_b = (_a = this.sdlCategoryPromo) === null || _a === void 0 ? void 0 : _a.callToAction[0]) === null || _b === void 0 ? void 0 : _b.externalUrl, ((_d = (_c = this.sdlCategoryPromo) === null || _c === void 0 ? void 0 : _c.callToAction[0]) === null || _d === void 0 ? void 0 : _d.openInNewWindow) ? '_blank' : '_self');
      } }, h("div", { class: "banner-promo-block__wrapper" }, h("div", { class: "banner-promo-block__image-wrap" }, h("picture", { class: "banner-promo-block__picture" }, (_c = (_b = (_a = this.sdlCategoryPromo) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.imageSourceSets) === null || _c === void 0 ? void 0 :
      _c.map(({ minWidth, maxWidth, urls }) => (h("source", { media: generateMedia(minWidth, maxWidth), srcSet: generateSrcSet(urls) }))), h("img", { src: (_e = (_d = this.sdlCategoryPromo) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.Url, alt: (_g = (_f = this.sdlCategoryPromo) === null || _f === void 0 ? void 0 : _f.image) === null || _g === void 0 ? void 0 : _g.altText }))), h("div", { class: "banner-promo-block__context" }, h("h4", null, (_h = this.sdlCategoryPromo) === null || _h === void 0 ? void 0 : _h.title), ((_j = this.sdlCategoryPromo) === null || _j === void 0 ? void 0 : _j.description) && (h("p", { class: "banner-promo-block__context-description" }, (_k = this.sdlCategoryPromo) === null || _k === void 0 ? void 0 : _k.description)), h("div", { class: "banner-promo-block__context-panel" }, (_l = this.sdlCategoryPromo) === null || _l === void 0 ? void 0 : _l.callToAction.map((action) => {
      return (action === null || action === void 0 ? void 0 : action.externalUrl) ? (h("div", { class: "banner-promo-block__context-panel-link" }, h("a", { class: classnames('banner-promo-block__context-link', this.isHover && 'banner-promo-block__context-link_underline'), href: (action === null || action === void 0 ? void 0 : action.externalUrl) && (action === null || action === void 0 ? void 0 : action.externalUrl), target: (action === null || action === void 0 ? void 0 : action.openInNewWindow) ? '_blank' : '_self' }, action === null || action === void 0 ? void 0 : action.text), h("pes-icon", { class: "banner-promo-block__context-link-icon", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left"))) : (h("div", { class: "banner-promo-block__context-button-block" }, h("button", { onMouseLeave: () => (this.isHover = true), onMouseEnter: () => (this.isHover = false), onClick: this.handleWatchClick, class: "banner-promo-block__context-button" }, action === null || action === void 0 ? void 0 : action.text), h("span", { class: "banner-promo-block__context-icon-play" })));
    })))), this.isShown && (h("div", { class: "banner-promo-block__modal-window", onClick: this.handleWatchClick }, h("iframe", { class: "banner-promo-block__modal-window-content-video", width: "540", height: "360", src: (_m = this.sdlCategoryPromo) === null || _m === void 0 ? void 0 : _m.callToAction[1].youTubeEmbedUrl, title: "YouTube video player", frameborder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowfullScreen: "1" })))));
  }
  get el() { return getElement(this); }
};
BannerPromoBlock.style = bannerPromoBlockCss;

const breadcrumbsCss = ":host{display:block}.breadcrumbs{box-sizing:border-box;padding:14px 16px 10px}.breadcrumbs--hide-mobile{display:none}@media screen and (min-width: 980px){.breadcrumbs{display:block;max-width:1200px;margin-left:auto;margin-right:auto;padding:8px 10px;background-color:transparent}}.highlight-naming .accent{font-weight:bold}";

const Breadcrumbs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.handleNavigate = (route, breadcrumb) => {
      return async (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        await this.handleClickBreadcrumb(event, breadcrumb);
        navigateWithRouter(route, target);
      };
    };
    this.saveBreadcrumbsInIndexDB = async (storageKey, breadcrumbsToStore, clickedBreadcrumb) => {
      try {
        await indexDBBreadcrumbs.createOrUpdate({
          storageName: this.storageName,
          storageKey,
          updatedBreadCrumbs: breadcrumbsToStore,
        });
        this.breadcrumbsFromStorage = breadcrumbsToStore;
      }
      catch (e) {
        console.error(`[PES]: Breadcrumbs can not be saved or updated in indexDB ${this.storageName} with ${storageKey} key`, e);
      }
      if (!isAppRoutingEnabled()) {
        window.location.href = clickedBreadcrumb.url;
      }
    };
    this.handleClickBreadcrumb = async (event, clickedBreadcrumb) => {
      var _a;
      event.preventDefault();
      const storageKey = `${clickedBreadcrumb.itemType}/${clickedBreadcrumb.id}`;
      const currentBreadcrumbs = ((_a = this.breadcrumbsFromStorage) === null || _a === void 0 ? void 0 : _a.length)
        ? this.breadcrumbsFromStorage
        : this.breadcrumbs;
      const breadcrumbsToStore = filterBreadcrumbsForSaving(currentBreadcrumbs, clickedBreadcrumb.itemType);
      await this.saveBreadcrumbsInIndexDB(storageKey, breadcrumbsToStore, clickedBreadcrumb);
    };
    this.getBreadcrumb = (breadcrumb) => {
      let breadcrumbProps = {};
      if (breadcrumb.url && breadcrumb.url !== '#') {
        if (isAppRoutingEnabled()) {
          const { pageType, pageId } = parseCommonURLToRouterParts(breadcrumb.url);
          const route = new PesRoute({ page: pageType, pageId });
          breadcrumbProps = {
            href: route.url,
            onDidNavigate: this.handleNavigate(route, breadcrumb),
          };
        }
        else {
          breadcrumbProps = {
            href: breadcrumb.url,
            onClick: isIndexDBEnabled() ? (e) => this.handleClickBreadcrumb(e, breadcrumb) : undefined,
          };
        }
      }
      return (h("se-breadcrumb-item", Object.assign({}, breadcrumbProps), h("span", { innerHTML: breadcrumb.name })));
    };
    this.breadcrumbs = undefined;
    this._breadcrumbs = undefined;
    this.hideOnMobile = false;
    this._hideOnMobile = undefined;
    this.hostWithLocale = undefined;
    this.tail = [];
    this.breadcrumbsFromStorage = [];
    this.storageName = '';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleTailDidAppend(event) {
    this.setTailState(event.detail);
  }
  setTailState(data) {
    this.tail = (data === null || data === void 0 ? void 0 : data.length) ? [...data] : [];
  }
  async componentWillLoad() {
    var _a, _b, _c;
    this.breadcrumbs = (_a = tryParse(this._breadcrumbs)) !== null && _a !== void 0 ? _a : this.breadcrumbs;
    this.hideOnMobile = (_b = tryParse(this._hideOnMobile)) !== null && _b !== void 0 ? _b : this.hideOnMobile;
    if (!isIndexDBEnabled())
      return;
    const { consumer, storageName } = getConsumerSpecificData(isPBS(), this.hostWithLocale);
    this.storageName = storageName;
    const lastBreadcrumb = ((_c = this.breadcrumbs) === null || _c === void 0 ? void 0 : _c.length)
      ? this.breadcrumbs[this.breadcrumbs.length - 1]
      : {};
    const pageType = lastBreadcrumb.itemType;
    const pageId = lastBreadcrumb.id;
    const pageKey = `${pageType}/${pageId}`;
    indexDBBreadcrumbs.setChannel(consumer);
    try {
      const fetchedBreadcrumbs = await indexDBBreadcrumbs.setupStorage({
        breadcrumbs: this.breadcrumbs,
        storageName,
        pageKey,
      });
      if (!(fetchedBreadcrumbs === null || fetchedBreadcrumbs === void 0 ? void 0 : fetchedBreadcrumbs.length)) {
        this.breadcrumbsFromStorage = this.breadcrumbs;
      }
      this.breadcrumbsFromStorage = fetchedBreadcrumbs;
    }
    catch (e) {
      console.error(`[PES]: Breadcrumbs can not be updated in indexDB ${storageName} storage`, e);
    }
  }
  render() {
    var _a, _b;
    if (!((_a = this.breadcrumbs) === null || _a === void 0 ? void 0 : _a.length)) {
      return null;
    }
    const breadcrumbsList = ((_b = this.breadcrumbsFromStorage) === null || _b === void 0 ? void 0 : _b.length)
      ? this.breadcrumbsFromStorage
      : this.breadcrumbs;
    const breadcrumbs = breadcrumbsList.concat(this.tail);
    const { productCategory, productSubCategory, productRange, productName, } = getProductInfoFromBreadcrumbs(this.breadcrumbs);
    return (h(Fragment, null, h("se-breadcrumb", { class: classnames('breadcrumbs', 'js-pes-sticky', {
        'breadcrumbs--hide-mobile': this.hideOnMobile,
      }), breakpoint: "desktop", withMicrodata: "true" }, breadcrumbs.map(this.getBreadcrumb)), h("pes-product-info-chat-event", { productCategory: productCategory, productSubCategory: productSubCategory, productRange: productRange, productName: productName, sendProductInfoUsingInterval: true })));
  }
  get el() { return getElement(this); }
};
Breadcrumbs.style = breadcrumbsCss;

const categoryDescriptionCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}:host{display:block;margin:0 auto;padding:0 16px 20px;box-sizing:border-box;max-width:1200px;overflow:visible;color:#626469;padding-bottom:0;margin-top:14px;margin-bottom:24px}:host *,:host *::before,:host *::after{box-sizing:inherit}@media screen and (min-width: 980px){:host{padding:0 10px}}@media screen and (min-width: 980px){:host{margin-top:32px}}.category-description__header{padding:0}.category-description__badge{margin-top:16px}@media screen and (min-width: 980px){.category-description__badge{display:inline-block;margin-top:0;margin-bottom:2px;vertical-align:text-bottom}:host(:not([dir=\"rtl\"])) .category-description__badge{margin-left:24px}:host([dir=\"rtl\"]) .category-description__badge{margin-right:24px}}.category-description__header-title{display:block;margin:0;font-size:1.875rem;line-height:2.5rem;font-weight:normal;color:#3dcd58}@media screen and (min-width: 980px){.category-description__header-title{display:inline;font-size:2.625rem;line-height:3rem}}";

const CategoryDescription = class {
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f;
    this.name = (_a = tryParse(this._name)) !== null && _a !== void 0 ? _a : this.name;
    this.description = (_b = tryParse(this._description)) !== null && _b !== void 0 ? _b : this.description;
    this.readMoreLabel = (_c = tryParse(this._readMoreLabel)) !== null && _c !== void 0 ? _c : this.readMoreLabel;
    this.readLessLabel = (_d = tryParse(this._readLessLabel)) !== null && _d !== void 0 ? _d : this.readLessLabel;
    this.badge = (_e = tryParse(this._badge)) !== null && _e !== void 0 ? _e : this.badge;
    this.isCategory = (_f = tryParse(this._isCategory)) !== null && _f !== void 0 ? _f : this.isCategory;
  }
  getWrapped(text) {
    if (this.isCategory)
      return `<!--L1-NAME_BEGIN-->${text} <!--L1-NAME_END-->`;
    return `<!--L2-NAME_BEGIN-->${text}<!--L2-NAME_END-->`;
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.name = undefined;
    this.description = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.badge = undefined;
    this.isCategory = false;
    this._name = undefined;
    this._description = undefined;
    this._readMoreLabel = undefined;
    this._readLessLabel = undefined;
    this._badge = undefined;
    this._isCategory = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, null, h("div", { class: "category-description__header" }, h("h1", { class: "category-description__header-title", innerHTML: this.getWrapped(this.name) }), this.badge && (h("pes-badge-wrapper", { class: "category-description__badge", type: this.badge.type, label: this.badge.label, size: "large" }))), this.description && (h("pes-description", { class: "category", text: this.description, expandLabel: this.readMoreLabel, collapseLabel: this.readLessLabel, numLinesToShow: {
        desktop: LineCount.DESKTOP_LINE_COUNT,
        mobile: LineCount.MOBILE_LINE_COUNT,
      } }))));
  }
  get el() { return getElement(this); }
};
CategoryDescription.style = categoryDescriptionCss;

const categoryRangeCardCss = ":host{padding:20px 5px;width:100%;font-size:0.875rem}@media screen and (min-width: 980px){:host{width:33.33%}}.range-card__image-wrapper{position:relative;margin-bottom:12px;height:60px;width:60px}:host(:not([dir=\"rtl\"])) .range-card__image-wrapper{margin-right:15px}:host([dir=\"rtl\"]) .range-card__image-wrapper{margin-left:15px}@media screen and (min-width: 980px){.range-card__image-wrapper{width:100px;height:100px}}.range-card__brand-logo{position:absolute;bottom:0;width:60px}.range-card__image{width:60px;min-width:60px;height:60px;min-height:60px;display:block}@media screen and (min-width: 980px){.range-card__image{width:100px;height:100px}}.range-card{width:100%;display:flex;text-decoration:none}.range-card .highlight-naming{font-weight:normal}.range-card .highlight-naming .accent{font-weight:bold}.range-card .range-card__name.avoid-accents .highlight-naming{font-weight:bold}.range-card .range-card__description.avoid-accents .accent{font-weight:normal}@media screen and (min-width: 980px){.range-card{max-width:250px;flex-direction:column}}.range-card:hover{cursor:pointer}@media screen and (min-width: 980px){.range-card__wrapper{width:100%}}.range-card__badge{margin-bottom:8px}@media screen and (min-width: 980px){.range-card__badge:last-of-type{margin-bottom:12px}}.range-card__view:hover .range-card__name{text-decoration:underline}.range-card__name{padding:0;margin-top:15px;font-size:1rem;font-weight:bold;color:#333333}.range-card__description{position:relative;margin:0;margin-top:5px;color:#626469;line-height:1.25rem;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}@media screen and (min-width: 980px){.range-card__description{display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden}}.range-card__description a{display:inline-block;border-radius:var(--qds-focus-border-radius);box-sizing:border-box;text-decoration:underline;color:var(--qds-theme-link-standard-default)}.range-card__description a:visited{color:var(--qds-theme-link-standard-visited)}.range-card__description a:hover{color:var(--qds-theme-link-standard-hover)}.range-card__description a:active{color:var(--qds-theme-link-standard-pressed)}.range-card__description a:visited:hover{color:var(--qds-theme-link-standard-visited-hover)}.range-card__description a:visited:active{color:var(--qds-theme-link-standard-visited-pressed)}.range-card__description a[rel~=external]>.qds-external{display:inline-block}.range-card__description a:focus-visible{outline:var(--qds-theme-focus-border) solid var(--qds-focus-border-width)}.range-card__description a[aria-disabled=true]{opacity:var(--qds-theme-disabled);pointer-events:none}.range-card__master-range-name{color:#626469;display:block;margin-top:5px}.range-card__view-prod-label{max-width:200px}@media screen and (min-width: 980px){.range-card__view-prod-label{margin-top:12px}}.range-card__product-selector-link{margin-bottom:8px;cursor:pointer}@media screen and (min-width: 980px){.range-card__product-selector-link{margin-top:12px}}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .range-card__product-selector-link{margin-left:75px}:host([dir=\"rtl\"]) .range-card__product-selector-link{margin-right:75px}}:host([dir=\"rtl\"]) .range-card__icon-link,:host([dir=\"rtl\"]) .product-selector-icon{transform:scaleX(-1)}*{box-sizing:border-box}:host(.sub){border:1px solid #e7e6e6;display:flex;flex-direction:column;padding:24px;width:100%;background-color:#ffffff}:host(.sub) .range-card{flex-direction:column;padding:0;overflow:hidden;max-width:none}:host(:not([dir=\"rtl\"]).sub) .product-selector-link{margin-left:0}:host([dir=\"rtl\"].sub) .product-selector-link{margin-right:0}:host(.sub) .range-card__image{width:140px;height:140px}:host(.sub) .range-card__image-wrapper{display:flex;width:100%;height:140px;justify-content:center}:host(:not([dir=\"rtl\"]).sub) .range-card__brand-logo{left:0}:host([dir=\"rtl\"].sub) .range-card__brand-logo{right:0}:host(:not([dir=\"rtl\"]).sub) .range-card__product-selector-link{margin-left:0}:host([dir=\"rtl\"].sub) .range-card__product-selector-link{margin-right:0}:host(.sub:hover){box-shadow:0 0 2px 0 rgba(51, 51, 51, 0.05), 0 2px 10px 0 rgba(51, 51, 51, 0.15);border-color:transparent}";

const CategoryRangeCard = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    var _a, _b;
    this.rangeUrl = ((_a = this.data) === null || _a === void 0 ? void 0 : _a.redirectUrl) || ((_b = this.data) === null || _b === void 0 ? void 0 : _b.url);
    this.onClickHandler = async (event) => {
      if (!isAppRoutingEnabled())
        return;
      event.preventDefault();
      const target = event.currentTarget;
      if (!isIndexDBEnabled()) {
        navigateWithRouter(this.route, target);
        return;
      }
      const { consumer, storageName } = getConsumerSpecificData(true, this.storageName);
      indexDBBreadcrumbs.setChannel(consumer);
      try {
        const breadcrumbs = await indexDBBreadcrumbs.getValidatedBreadcrumbs({
          storageName,
          key: this.currentPageStorageKey,
        });
        await storeBreadcrumbs({
          id: this.data.id,
          name: this.data.name,
          url: this.rangeUrl,
          subcategory: this.subCategory,
          breadcrumbs,
          pageName: PageNames.RANGE,
          storageName: this.storageName,
        });
      }
      catch (e) {
        console.error(`[PES]: Breadcrumbs can not be fetched from indexDB storage ${this.currentPageStorageKey}`, e);
      }
      navigateWithRouter(this.route, target);
    };
    this.openProductSelector = (selector, config) => (event) => {
      event.preventDefault();
      if (config.type === 'sc') {
        const host = document.createElement('pdp-sc-selector-modal');
        const frame = document.createElement('div');
        frame.id = 'widgetFrame';
        host.headerLabel = config.scLabel || 'Select your product';
        host.appendChild(frame);
        host.open = true;
        host.addEventListener('didClose', () => {
          document.body.removeChild(host);
        });
        document.body.appendChild(host);
      }
      selector.open(config, true);
      if (isAnalyticsEnabled()) {
        send(productSelectorVirtualPageEvent, { pageRangeId: this.data.id });
      }
    };
    this.getDescriptionText = (description, longDescription) => {
      if (description && longDescription) {
        return [
          this.getRangeWrapped(description, 's'),
          this.getRangeWrapped(longDescription, 'l'),
        ].join(' ');
      }
      if (description)
        return this.getRangeWrapped(description, 's');
      if (longDescription)
        return this.getRangeWrapped(longDescription, 'l');
    };
    this.getRangeCardContent = () => {
      if (!this.data)
        return null;
      const { name, badge, image, brandLogo, description, longDescription, masterRangeName, redirectUrl, domainName, commercialStatus, } = this.data;
      return [
        h("div", { class: "range-card__image-wrapper" }, image && (h("img", { loading: this.withImageLazy ? 'lazy' : 'eager', class: "range-card__image", src: image.url, alt: image.title })), brandLogo && (h("img", { loading: this.withImageLazy ? 'lazy' : 'eager', class: "range-card__brand-logo", src: brandLogo.url, alt: brandLogo.alt }))),
        h("div", { class: "range-card__wrapper" }, (commercialStatus === null || commercialStatus === void 0 ? void 0 : commercialStatus.label) && (h("pes-badge-wrapper", { class: "range-card__badge", type: commercialStatus.status, label: commercialStatus.label, color: commercialStatus.color })), badge && (h("pes-badge-wrapper", { class: "range-card__badge", type: badge.type, label: badge.label })), h("div", { class: "range-card__view" }, h("h3", null, h("span", { class: classnames('range-card__name', { 'avoid-accents': this.avoidAccents }), innerHTML: this.getWrapped(name) })), this.getDescription(description, longDescription), masterRangeName && (h("span", { class: "range-card__master-range-name", innerHTML: this.rangePartofLabel.replace('#MasterRangeName#', masterRangeName) })), redirectUrl ? (h("qds-standalone-link", { size: "standard", importance: "standard", class: "range-card__view-prod-label", iconName: "arrow-top-right-on-square" }, `${this.viewOnLabel.replace('#domain_name#', '')} ${domainName}`)) : (h("qds-standalone-link", { size: "standard", importance: "standard", class: "range-card__view-prod-label" }, this.getLinkText())))),
      ];
    };
    this.data = undefined;
    this.rangePartofLabel = undefined;
    this.viewOnLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.rangeProductsViewDetailsLabel = undefined;
    this.subcategoryView = false;
    this.avoidAccents = undefined;
    this.withImageLazy = true;
    this.currentPageStorageKey = undefined;
    this.storageName = undefined;
    this.subCategory = undefined;
    this.selectorExtraOptions = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.rangeUrl);
      this.route = new PesRoute({ page: pageType, pageId });
      this.rangeUrl = this.route.url;
    }
    this.selectorExtraOptions = updateProductCtasSelectorSettings(this.data.selectorConfig, productCtas.buttons);
  }
  updatedSelectorConfig(config) {
    return deepMerge(config, { scOptions: this.selectorExtraOptions });
  }
  getLinkText() {
    return this.data.productsCount > 0
      ? this.productRelationsViewProdLabel
      : this.rangeProductsViewDetailsLabel;
  }
  getRangeWrapped(text, type) {
    if (type === 's')
      return `<!--RANGE-SHORTDESC_BEGIN-->${text}<!--RANGE-SCHORTDESC_END-->`;
    if (type === 'l')
      return `<!--RANGE-LONGDESC_BEGIN-->${text}<!--RANGE-LONGDESC_END-->`;
    return text;
  }
  getDescription(description, longDescription) {
    const descriptionText = this.getDescriptionText(description, longDescription);
    if (!descriptionText) {
      return null;
    }
    return (h("div", { class: classnames('range-card__description', { 'avoid-accents': this.avoidAccents }), innerHTML: descriptionText }));
  }
  getWrapped(text) {
    return `<!--RANGE-NAME_BEGIN-->${text}<!--RANGE-NAME_END-->`;
  }
  getProductSelector() {
    if (this.data.selectorConfig && this.data.selectorConfig.config) {
      return (h("pes-product-selector", { config: this.updatedSelectorConfig(this.data.selectorConfig.config), renderFunction: (selector) => (h("qds-standalone-link", { size: "standard", importance: "standard", class: "range-card__product-selector-link", onClick: this.openProductSelector(selector, this.updatedSelectorConfig(this.data.selectorConfig.config)) }, this.data.selectorConfig.categoryLabel)) }));
    }
  }
  render() {
    if (!this.data) {
      return null;
    }
    const { id, redirectUrl, url } = this.data;
    const shouldRefresh = url || redirectUrl;
    return (h(Host, { class: classnames({ sub: this.subcategoryView }) }, shouldRefresh ? (h(Fragment, null, h("a", { class: "range-card", href: this.rangeUrl, target: redirectUrl ? '_blank' : '_self', onClick: this.onClickHandler }, this.getRangeCardContent()), this.getProductSelector())) : (h("pes-router-link", { page: "range", pageId: id }, h(Fragment, null, h("a", { class: "range-card", id: id, href: "#" }, this.getRangeCardContent()), this.getProductSelector())))));
  }
  get el() { return getElement(this); }
};
CategoryRangeCard.style = categoryRangeCardCss;

const pesCategorySubcategoryProductsListCss = ":host{display:block}@media screen and (min-width: 980px){.products-list__list{display:block}}.products-list__title{color:#333333;margin:0;font-weight:normal;font-size:1.125rem;line-height:1.5625rem}@media screen and (min-width: 980px){.products-list__title{font-size:1.375rem;line-height:1.875rem}}.products-list__count{color:#9fa0a4}";

const PesCategorySubcategoryProductsList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.handleComparatorChange = (e) => {
      this.comparatorValue = e.detail;
    };
    this.handleProductCtasChange = (event) => {
      if (!this.productCtas)
        return;
      if (this.isPBS) {
        this.productCtas = Object.assign({}, this.productCtas);
        return;
      }
      this.productCtas = Object.assign(Object.assign({}, this.productCtas), { buttons: event.detail });
    };
    this.hostWithLocale = undefined;
    this.navigationState = undefined;
    this.pills = undefined;
    this.showDocuments = undefined;
    this.showBuyOnline = undefined;
    this.enableCommerceConnector = undefined;
    this.productCtas = DEFAULT_CATEGORY_PRODUCT_CTAS;
    this.isMobileCategorySelected = undefined;
    this.isMobileView = undefined;
    this.numberProductsOfAllProductsLabel = undefined;
    this.appProductsLabel = undefined;
    this.loadMoreLabel = undefined;
    this.loadPreviousLabel = undefined;
    this.previousLabel = undefined;
    this.nextLabel = undefined;
    this.labelValue = undefined;
    this.productsCountLabel = undefined;
    this.productsSectionTitleLabel = undefined;
    this.noResultsClearLinkLabel = undefined;
    this.noResultsHeaderLabel = undefined;
    this.noResultsMessageLabel = undefined;
    this.isProductsLoading = false;
    this.parsedProducts = null;
    this.selectedPage = undefined;
    this.productsPerPage = undefined;
    this.localeCode = undefined;
    this.showCompare = true;
    this.storageName = undefined;
    this.isPBS = false;
    this.currentPageStorageKey = undefined;
    this.enableAppRouting = false;
    this.analyticsPageData = undefined;
    this.comparatorValue = comparator.value;
    this.productsIds = [];
    this.richText = undefined;
    this.scrollToProduct = undefined;
    this.productsCount = 0;
    this.resultsCount = undefined;
    this.lastLoadedRecNum = undefined;
    this.firstLoadedRecNum = undefined;
    this.el.dir = (document === null || document === void 0 ? void 0 : document.documentElement.dir) || 'auto';
  }
  componentWillLoad() {
    this.setProductsInfo(this.parsedProducts);
  }
  connectedCallback() {
    window === null || window === void 0 ? void 0 : window.addEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  disconnectedCallback() {
    window === null || window === void 0 ? void 0 : window.removeEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  onParsedProductsChange(newProducts) {
    this.setProductsInfo(newProducts);
  }
  setScrollToProduct(event) {
    this.scrollToProduct = event.detail;
  }
  setProductsInfo(productsInfo) {
    if (!productsInfo)
      return;
    const { totalNumRecs, firstRecNum, recsPerPage, productIds, richText } = productsInfo;
    const productsCount = productIds.length;
    this.richText = parseRichText(richText);
    const lastRecNum = firstRecNum + productsCount - 1;
    this.productsCount = productsInfo.totalNumRecs;
    this.resultsCount = {
      firstRecNum,
      lastRecNum,
      recsPerPage,
      totalNumRecs,
    };
    if (!isMobile()) {
      this.firstLoadedRecNum = undefined;
      this.lastLoadedRecNum = undefined;
      this.productsIds = [];
    }
    this.firstLoadedRecNum = this.firstLoadedRecNum === undefined
      ? firstRecNum
      : Math.min(firstRecNum, this.firstLoadedRecNum);
    this.lastLoadedRecNum = this.lastLoadedRecNum === undefined
      ? lastRecNum
      : Math.max(lastRecNum, this.lastLoadedRecNum);
    this.productsIds = productIds;
  }
  getAdditionalMainQueryParams() {
    return { nodeOrSubCatId: this.navigationState, isCategoryListing: true };
  }
  renderProductCards() {
    var _a, _b, _c;
    if (this.isProductsLoading || this.productsIds.length) {
      return (h("product-cards-wrapper", { class: "products-list__list", currentPageStorageKey: this.currentPageStorageKey, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, comparator: this.comparatorValue, enableCommerceConnector: this.enableCommerceConnector, "product-ids": this.productsIds.join(), host: this.hostWithLocale, hostWithLocale: this.storageName, additionalMainQueryParams: this.getAdditionalMainQueryParams(), productCtas: this.productCtas, productOfProductsLabel: this.numberProductsOfAllProductsLabel, productsLabel: this.appProductsLabel, firstRecNum: (_a = this.resultsCount) === null || _a === void 0 ? void 0 : _a.firstRecNum, lastRecNum: (_b = this.resultsCount) === null || _b === void 0 ? void 0 : _b.lastRecNum, totalNumRecs: (_c = this.resultsCount) === null || _c === void 0 ? void 0 : _c.totalNumRecs, areListGridLabelsShown: false, scrollToProduct: this.scrollToProduct, enableAppRouting: this.enableAppRouting, localeCode: this.localeCode, isProductListing: true, analyticsPageData: this.analyticsPageData }, this.productsSectionTitleLabel && (h("div", { slot: "title" }, h("h3", { class: "products-list__title" }, this.productsSectionTitleLabel, h("span", { class: "products-list__count" }, " (", this.productsCount, ") ")))), h("div", { slot: "pills" }, h("pes-range-filter-pills", { pills: this.pills }))));
    }
  }
  renderNoResults() {
    return (h(Fragment, null, h("pes-range-filter-pills", { pills: this.pills }), h("pes-filters-no-results", { noResultsClearLink: this.noResultsClearLinkLabel, noResultsHeader: this.noResultsHeaderLabel, noResultsMessage: this.noResultsMessageLabel })));
  }
  render() {
    var _a, _b;
    if (!this.isProductsLoading && !this.productsIds.length && !((_a = this.richText) === null || _a === void 0 ? void 0 : _a.length)) {
      return this.renderNoResults();
    }
    return (h(Fragment, null, h("pes-range-product-ctas-updater", { buttons: (_b = this.productCtas) === null || _b === void 0 ? void 0 : _b.buttons, myProductsGetter: getMyProductsFromConnector, onButtonsChange: this.handleProductCtasChange }), h("pes-products-pagination", { firstLoadedRecNum: this.firstLoadedRecNum, lastLoadedRecNum: this.lastLoadedRecNum, totalNumRecs: this.productsCount, productsPerPage: this.productsPerPage, showMobilePagination: this.isMobileView && this.isMobileCategorySelected, showDesktopPagination: !this.isMobileView, selectedPage: this.selectedPage, loadMoreLabel: this.loadMoreLabel, loadPreviousLabel: this.loadPreviousLabel, previousLabel: this.previousLabel, nextLabel: this.nextLabel, labelValue: this.labelValue, productsCountLabel: this.productsCountLabel }, this.richText && h("pes-rich-text-information", { richText: this.richText }), this.renderProductCards())));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "parsedProducts": ["onParsedProductsChange"]
  }; }
};
PesCategorySubcategoryProductsList.style = pesCategorySubcategoryProductsListCss;

const itemsCss = "@media screen and (min-width: 720px){.cc-items-wrapper{display:flex;flex-direction:row;flex-wrap:wrap}}@media screen and (min-width: 980px){.cc-items-wrapper{margin:-6px}}.cc-item{box-sizing:border-box;display:flex;align-items:center;min-height:91px;text-decoration:none}.cc-item *,.cc-item *::before,.cc-item *::after{box-sizing:inherit}@media screen and (max-width: 719px){.cc-item{border-bottom:1px solid #e7e6e6}:host(:not([dir=\"rtl\"])) .cc-item{padding:8px 0 8px 8px}:host([dir=\"rtl\"]) .cc-item{padding:8px 8px 8px 0}.cc-item:first-child{border-top:1px solid #e7e6e6}}@media screen and (min-width: 720px){.cc-item{display:block;position:relative;height:auto;padding:8px 8px 12px}}@media screen and (min-width: 720px) and (max-width: 980px){.cc-item{flex-grow:0;flex-shrink:0;flex-basis:33.3333333333%;max-width:33.3333333333%;border-bottom:1px solid #e7e6e6}:host(:not([dir=\"rtl\"])) .cc-item{border-right:1px solid #e7e6e6}:host([dir=\"rtl\"]) .cc-item{border-left:1px solid #e7e6e6}.cc-item:nth-child(-n+3){border-top:1px solid #e7e6e6}:host(:not([dir=\"rtl\"])) .cc-item:nth-child(3n+1){border-left:1px solid #e7e6e6}:host([dir=\"rtl\"]) .cc-item:nth-child(3n+1){border-right:1px solid #e7e6e6}}@media screen and (min-width: 720px){.cc-item{display:block;position:relative;height:auto;padding:8px 8px 12px}.cc-item--favorite.cc-item--disable{background-color:#fafafa}.cc-item--favorite:not(.cc-item--disable){border-color:#3dcd58}.cc-item--favorite:not(.cc-item--disable) .cc-item__icon--favorite{color:#3dcd58}.cc-item--favorite .cc-item__icon--favorite{display:block}}@media screen and (min-width: 980px){.cc-item{flex-basis:calc(25% - 12px);max-width:calc(25% - 12px);margin:6px;border:1px solid #e7e6e6}.cc-item:hover{box-shadow:0 7px 15px 0 rgba(51, 51, 51, 0.2)}}.cc-item:focus{outline:2px solid #e7e6e6}.cc-item__icon{color:rgba(51, 51, 51, 0.5)}@media screen and (min-width: 720px){.cc-item__icon{position:absolute;height:16px}}@media screen and (min-width: 980px){.cc-item__icon{display:none}.cc-item:hover .cc-item__icon{display:block}}.cc-item__icon--favorite{align-self:center;background:none;border:none;cursor:pointer}.cc-item__icon--favorite:focus{outline:2px solid #e7e6e6}@media screen and (max-width: 719px){.cc-item__icon--favorite{width:32px;height:32px;padding:8px}.cc-item__icon--favorite:focus{outline:0}}@media screen and (min-width: 720px){.cc-item__icon--favorite{width:16px;height:16px;padding:0;top:10px}:host(:not([dir=\"rtl\"])) .cc-item__icon--favorite{right:11px}:host([dir=\"rtl\"]) .cc-item__icon--favorite{left:11px}}.cc-item__icon--new-window{height:16px;align-self:flex-end}@media screen and (min-width: 720px){.cc-item__icon--new-window{bottom:6px}:host(:not([dir=\"rtl\"])) .cc-item__icon--new-window{left:7px}:host([dir=\"rtl\"]) .cc-item__icon--new-window{right:7px}}.cc-item__logo{width:114px;margin-left:10px;margin-right:10px}@media screen and (min-width: 720px){.cc-item__logo{margin:0 auto;height:70px;text-align:center}}.cc-item__logo img{max-width:114px;max-height:70px;vertical-align:top}.cc-item--favorite.cc-item--disable .cc-item__logo img{opacity:0.5}.cc-item__info{display:flex;flex-direction:column;justify-content:center;align-items:flex-end;font-size:12px;line-height:20px}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .cc-item__info{margin-left:auto}:host([dir=\"rtl\"]) .cc-item__info{margin-right:auto}}@media screen and (min-width: 720px){.cc-item__info{margin-top:8px;align-items:center}}.cc-item__stock{line-height:20px;padding-left:5px;padding-right:5px;color:#626469;background-color:rgba(98, 100, 105, 0.1)}@media screen and (min-width: 720px){.cc-item__stock{text-align:center}}.cc-item__stock--in{color:#3dcd58;background-color:rgba(61, 205, 88, 0.1)}.cc-item__price{margin-top:8px;color:#626469;font-weight:bold}@media screen and (min-width: 980px){.cc-item__price{flex-grow:1}:host(:not([dir=\"rtl\"])) .cc-item__price{text-align:right}:host([dir=\"rtl\"]) .cc-item__price{text-align:left}}";

const CommerceConnectorItems = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.favoriteRetailIconClick = createEvent(this, "favoriteRetailIconClick", 7);
    this.favoriteRetailerIconClick = (e, distributor) => {
      e.preventDefault();
      this.favoriteRetailIconClick.emit(distributor);
    };
    this.renderItem = (distributor) => {
      const { isAvailable, priceFormatted, price } = distributor;
      return (h("a", { class: {
          'cc-item': true,
          'cc-item--disable': !isAvailable,
          'cc-item--favorite': this.isFavoriteBlock,
        }, href: distributor.buyUrl, target: "_blank" }, h("div", { class: "cc-item__icon cc-item__icon--new-window" }, h("pes-icon", { size: pesIconSizes.MICRO }, "action_new_window")), h("div", { class: "cc-item__logo" }, h("img", { src: distributor.logoUrl, alt: distributor.name, title: distributor.name })), h("div", { class: "cc-item__info" }, h("div", { class: {
          'cc-item__stock': true,
          'cc-item__stock--in': isAvailable,
        } }, distributor.stockLabel), distributor.showPrice && (h("div", { class: "cc-item__price" }, price ? priceFormatted : this.priceUnavailableLabel))), h("button", { type: "button", class: "cc-item__icon cc-item__icon--favorite", onClick: (e) => {
          this.favoriteRetailerIconClick(e, distributor);
        } }, h("pes-icon", { size: pesIconSizes.MICRO, class: "favorite-icon" }, distributor.isFavorite ? 'star_plain' : 'star_stroke'))));
    };
    this.distributors = undefined;
    this.priceUnavailableLabel = undefined;
    this.isFavoriteBlock = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: { 'cc-items-wrapper': true, 'cc-items-wrapper--favorite': this.isFavoriteBlock } }, this.distributors.map(this.renderItem)));
  }
  get el() { return getElement(this); }
};
CommerceConnectorItems.style = itemsCss;

const FAVORITE_RETAILERS_STORAGE_KEY = 'favorite-retailers';
const getKey = (countryLanguageCode) => `${FAVORITE_RETAILERS_STORAGE_KEY}-${countryLanguageCode}`;
const getFavoritesFromStorage = (countryLanguageCode) => {
  const key = getKey(countryLanguageCode);
  const favorites = parseJSONString(window.localStorage.getItem(key), null);
  return favorites || [];
};
const addFavoritesToStorage = (favorites, countryLanguageCode) => {
  const key = getKey(countryLanguageCode);
  window.localStorage.setItem(key, JSON.stringify(favorites));
};
const getLabelNumber = (label, labels) => {
  const { inStock, outOfStock, notAvailable } = labels;
  switch (label) {
    case inStock:
      return -1;
    case outOfStock:
      return 0;
    case notAvailable:
      return 1;
    default:
      return -2;
  }
};
const sortFavorites = (favorites, labels) => {
  return favorites.sort((a, b) => {
    const aNumber = getLabelNumber(a.stockLabel, labels);
    const bNumber = getLabelNumber(b.stockLabel, labels);
    return aNumber - bNumber;
  });
};
const updateFavoritesInStorage = (distributor, countryLanguageCode) => {
  const storageFavorites = getFavoritesFromStorage(countryLanguageCode);
  const index = storageFavorites.findIndex((favorite) => favorite.id === distributor.id);
  if (index === -1) {
    storageFavorites.push(distributor);
    addFavoritesToStorage(storageFavorites, countryLanguageCode);
  }
  else {
    storageFavorites.splice(index, 1);
    addFavoritesToStorage(storageFavorites, countryLanguageCode);
  }
};
const getFavoritesList = (storageFavorites, distributors, notAvailableLabel) => storageFavorites.map((favorite) => {
  let item = distributors.find((distributor) => distributor.id === favorite.id);
  if (!item) {
    favorite.isAvailable = false;
    favorite.stockLabel = notAvailableLabel;
    favorite.buyUrl = favorite.retailerSite;
    favorite.price = null;
    item = favorite;
  }
  item.isFavorite = true;
  return item;
});
const getSortedFavoritesList = (distributors, countryLanguageCode, labels) => {
  const storageFavorites = getFavoritesFromStorage(countryLanguageCode);
  const favoritesList = getFavoritesList(storageFavorites, distributors, labels.notAvailable);
  return sortFavorites(favoritesList, labels);
};
const getFavoritesIds = (favoritesList) => (favoritesList
  ? favoritesList.map((favorite) => favorite.id)
  : []);
const updateFavoriteStatus = (distributors, favoritesIds) => {
  distributors.forEach((distributor) => {
    distributor.isFavorite = favoritesIds.includes(distributor.id);
  });
};

const CommerceConnectorMain = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.ccDialogClosed = createEvent(this, "ccDialogClosed", 7);
    this.channelSightResponse = createEvent(this, "channelSightResponse", 7);
    this.ccBroadcastPrices = createEvent(this, "ccBroadcastPrices", 7);
    this.ccBtnBuyOnlineAvailability = createEvent(this, "ccBtnBuyOnlineAvailability", 7);
    this.ccGetOptionsSucceeded = createEvent(this, "ccGetOptionsSucceeded", 7);
    this.isLinkedCircularProductAvaliableInStock = false;
    this.productTabLabelsMap = {};
    this.ccActiveProductType = CircularProductTypes.LINEAR;
    this.ccActiveProductTabLabel = '';
    this.ccStandardProductTabLabel = '';
    this.ccCircularProductTabLabel = '';
    this.hasEnabledLinkedCircularProduct = false;
    this.productsAvailability = {};
    this.productMap = null;
    this.host = undefined;
    this.products = undefined;
    this.productIdToShow = undefined;
    this.additionalDistributors = undefined;
    this.siteType = undefined;
    this.localeCode = undefined;
    this.isPdp = false;
    this.circularEconomy = null;
    this.countryCode = undefined;
    this.settings = undefined;
    this.productsDistributorsInfo = {};
    this.notification = undefined;
    this.isZipCodeValid = true;
    this.zipCode = undefined;
    this.showLoader = undefined;
    this.showValidateMessage = undefined;
    this.showContent = undefined;
    this.isSearchInputPristine = true;
    this.favoriteDistributors = undefined;
    this.isOpen = false;
    this.retailersByProduct = {};
  }
  onItemSelect(event) {
    this.ccActiveProductTabLabel = event.detail;
    const selectedProductTab = this.productTabLabelsMap[this.ccActiveProductTabLabel];
    this.ccActiveProductType = selectedProductTab.type;
    this.productIdToShow = selectedProductTab.commercialReference;
  }
  dialogCloseHandler() {
    const { useZipCode, searchOnOpen } = this.settings.options;
    this.showValidateMessage = false;
    this.isSearchInputPristine = true;
    this.ccDialogClosed.emit();
    if (useZipCode && !searchOnOpen) {
      this.showContent = false;
    }
    if (this.hasEnabledLinkedCircularProduct && this.isLinkedCircularProductAvaliableInStock) {
      this.ccActiveProductType = CircularProductTypes.LINEAR;
      this.ccActiveProductTabLabel = this.ccStandardProductTabLabel;
    }
    this.isOpen = false;
  }
  favoriteRetailIconClickHandler(e) {
    const { options: { countryLanguageCode }, } = this.settings;
    updateFavoritesInStorage(e.detail, countryLanguageCode);
    this.initUpdateFavoritesList();
  }
  buyOnlineSearchClickHandler(event) {
    const { options: { zipCodePattern, countryLanguageCode, feedUrl, circularFeedUrl, useZipCode, searchOnOpen, enableEmptyZipCode, }, labels: { inStock, outOfStock }, } = this.settings;
    const value = event.detail;
    this.isZipCodeValid = (value === '') || isZipCodeValid(zipCodePattern, value);
    this.showValidateMessage = !this.isZipCodeValid;
    if (!this.isZipCodeValid)
      return;
    if (value !== this.zipCode) {
      this.zipCode = value;
      saveZipCodeToStorage(countryLanguageCode, this.zipCode);
    }
    this.productInfo
      && this.initSearch({
        standardProductCommercialReference: this.isccActiveProductTypeStandard
          ? this.productIdToShow : null,
        circularProductCommercialReference: this.isccActiveProductTypeStandard
          ? null : this.productIdToShow,
        zipCode: this.zipCode,
        standardProductFeedUrl: feedUrl,
        circularFeedUrl,
        inStock,
        outOfStock,
        useZipCode,
        searchOnOpen,
        enableEmptyZipCode,
        showContent: true,
        showPrice: this.settings.options.enablePrice,
      });
  }
  buyOnlineSearchInputChangedHandler() {
    this.isSearchInputPristine = false;
  }
  onCircularProductStockAvailabilityEvent(e) {
    this.productsAvailability = Object.assign(this.productsAvailability, e.detail);
    this.ccBtnBuyOnlineAvailability.emit(this.productsAvailability);
  }
  onProductsChange() {
    if (!this.productMap)
      return;
    this.products.forEach((newProduct) => {
      const product = this.productMap.get(newProduct.commercialReference);
      if (!product)
        return;
      Object.assign(product, newProduct);
    });
  }
  async onProductToShowIdChange() {
    var _a, _b, _c;
    if (!this.productIdToShow) {
      return;
    }
    if (this.isOpen) {
      this.updateDistributors();
      return;
    }
    this.ccActiveProductType = this.productInfo.circularType || CircularProductTypes.LINEAR;
    this.hasEnabledLinkedCircularProduct = this.productInfo.circularType === CircularProductTypes.LINEAR
      && this.circularEconomy
      && this.productInfo.circularProductRelationships
      && !!((_a = this.productInfo.circularProductRelationships[0]) === null || _a === void 0 ? void 0 : _a.productId);
    if (!this.hasEnabledLinkedCircularProduct) {
      this.updateDistributors();
      this.isOpen = true;
      return;
    }
    const { productId } = this.productInfo.circularProductRelationships[0];
    this.isLinkedCircularProductAvaliableInStock = !!this.productsAvailability[productId];
    if (!this.isLinkedCircularProductAvaliableInStock) {
      this.updateDistributors();
      this.isOpen = true;
      return;
    }
    const { circularType: productCircularType } = this.productInfo.circularProductRelationships[0];
    this.ccStandardProductTabLabel = this.productInfo.circularNatureLabel;
    this.ccCircularProductTabLabel = (_b = this.circularEconomy) === null || _b === void 0 ? void 0 : _b.circularNatureLabels[productCircularType];
    this.productTabLabelsMap = {
      [this.ccStandardProductTabLabel]: {
        type: CircularProductTypes.LINEAR,
        commercialReference: this.productInfo.commercialReference,
      },
      [this.ccCircularProductTabLabel]: {
        type: productCircularType,
        commercialReference: productId,
      },
    };
    this.ccActiveProductTabLabel = this.ccStandardProductTabLabel;
    const linkedCircularProduct = this.productMap.get(productId);
    const isLinkedCircularProductInfoAvailable = (linkedCircularProduct === null || linkedCircularProduct === void 0 ? void 0 : linkedCircularProduct.description)
      && (linkedCircularProduct === null || linkedCircularProduct === void 0 ? void 0 : linkedCircularProduct.imgUrl)
      && (linkedCircularProduct === null || linkedCircularProduct === void 0 ? void 0 : linkedCircularProduct.imgAlt);
    if (linkedCircularProduct && isLinkedCircularProductInfoAvailable) {
      this.updateDistributors();
      this.isOpen = true;
      return;
    }
    const { countryCode, languageCode } = getSprykerBaseQueryParams(this.host);
    const { result, error } = await SprykerProductCardMain.getProductCardMain({
      countryCode,
      languageCode,
      productIdList: productId,
    });
    if (error) {
      console.error('[PES]: Could not fetch products', error);
      this.updateDistributors();
      this.isOpen = true;
      return;
    }
    if ((_c = result.products) === null || _c === void 0 ? void 0 : _c.length) {
      const { description, pictureUrl, pictureAltText } = result.products[0];
      Object.assign(linkedCircularProduct, { description, imgUrl: pictureUrl, imgAlt: pictureAltText });
    }
    this.updateDistributors();
    this.isOpen = true;
  }
  distributorsChangeHandler() {
    this.notification = getNotificationMessage(this.zipCode, Object.keys(this.productsDistributorsInfo).length, this.settings);
  }
  async componentWillLoad() {
    var _a, _b, _c;
    (_a = this.siteType) !== null && _a !== void 0 ? _a : (this.siteType = getSiteTypeByURL(this.host));
    const response = await getCommerceConnectorSettings(this.host, this.localeCode);
    if (!response)
      return;
    this.ccGetOptionsSucceeded.emit(response.options);
    if (!response.options.enableChannelSight)
      return;
    this.settings = response;
    this.showContent = this.settings.options.useZipCode
      ? this.settings.options.searchOnOpen
      : true;
    this.settings.options.zipCodePattern = normalizeZipCodePattern(this.settings.options.zipCodePattern);
    const { standardProducts, circularProducts, } = categorizeAndLinkProductsWithRelations(this.products);
    this.productMap = arrayToMap(standardProducts.concat(circularProducts), 'commercialReference');
    const { standardProductIds, circularProductIds } = getFilteredProductIds(Array.from(this.productMap.values()));
    const { options: { zipCodePattern, countryLanguageCode, useZipCode, detectZipCode, zipCodeLength, feedUrl, circularFeedUrl, searchOnOpen, enablePrice, priceTemplate, enableEmptyZipCode, }, labels: { inStock, outOfStock, priceFrom: priceFromLabel }, } = this.settings;
    if (useZipCode) {
      this.zipCode = getZipCode({
        countryLanguageCode,
        detect: detectZipCode,
        length: zipCodeLength,
        pattern: zipCodePattern,
      });
    }
    await this.initSearch({
      standardProductCommercialReference: standardProductIds || null,
      circularProductCommercialReference: circularProductIds || null,
      zipCode: this.zipCode,
      standardProductFeedUrl: feedUrl,
      circularFeedUrl,
      inStock,
      outOfStock,
      useZipCode,
      searchOnOpen,
      enableEmptyZipCode,
      showContent: false,
      showPrice: enablePrice,
    });
    const standardProductButtonsBuyOnlineAvailability = getBuyOnlineAvailability(standardProducts, this.productsDistributorsInfo);
    let circularProductStockAvailability = {};
    if (!this.isPdp) {
      circularProductStockAvailability = await getCircularProductsStockAvailability(circularProducts, this.countryCode, (_b = this.circularEconomy) === null || _b === void 0 ? void 0 : _b.apiEndPointUrl, (_c = this.circularEconomy) === null || _c === void 0 ? void 0 : _c.apiKey);
    }
    this.productsAvailability = Object.assign(this.productsAvailability, standardProductButtonsBuyOnlineAvailability, circularProductStockAvailability);
    this.ccBtnBuyOnlineAvailability.emit(this.productsAvailability);
    if (!enablePrice)
      return;
    const prices = getPrices(this.productsDistributorsInfo, {
      template: priceTemplate,
      locale: countryLanguageCode,
    });
    this.ccBroadcastPrices.emit({ priceFromLabel, prices });
  }
  get productInfo() {
    if (!this.productIdToShow) {
      return;
    }
    return this.productMap.get(this.productIdToShow);
  }
  get isccActiveProductTypeStandard() {
    return this.ccActiveProductType === CircularProductTypes.LINEAR;
  }
  async initSearch({ standardProductCommercialReference, circularProductCommercialReference, zipCode, standardProductFeedUrl, circularFeedUrl, inStock, outOfStock, useZipCode, searchOnOpen, enableEmptyZipCode, showContent, showPrice, }) {
    var _a, _b;
    const stockLabels = { inStock, outOfStock };
    this.showLoader = true;
    if (!this.zipCode && !enableEmptyZipCode) {
      this.showContent = false;
    }
    else if (useZipCode && !searchOnOpen) {
      this.showContent = showContent;
    }
    else {
      this.showContent = true;
    }
    try {
      let standardProductData = Promise.resolve({
        productsDataFeed: [],
        distributorProductsInfo: {},
      });
      let circularProductData = Promise.resolve({
        productsDataFeed: [], distributorProductsInfo: {},
      });
      if (standardProductCommercialReference) {
        standardProductData = startSearch({
          feedUrl: standardProductFeedUrl,
          commercialReference: standardProductCommercialReference,
          zipCode,
          stockLabels,
          showPrice,
          siteType: this.siteType,
          isCircularProduct: false,
        });
      }
      if (circularProductCommercialReference) {
        circularProductData = startSearch({
          feedUrl: circularFeedUrl,
          commercialReference: circularProductCommercialReference,
          zipCode,
          stockLabels,
          showPrice,
          siteType: this.siteType,
          isCircularProduct: true,
        });
      }
      const [standardProductDataResult, circularProductDataResult] = await Promise.all([standardProductData, circularProductData]);
      const { productsDataFeed: standardProductsFeed, distributorProductsInfo: standardDistributorInfo, } = standardProductDataResult;
      const { productsDataFeed: circularProductsFeed, distributorProductsInfo: circularDistributorInfo, } = circularProductDataResult;
      this.channelSightResponse.emit(standardProductsFeed.concat(circularProductsFeed));
      const linearRetailers = standardProductsFeed
        .filter(({ RetailerProducts }) => RetailerProducts === null || RetailerProducts === void 0 ? void 0 : RetailerProducts.length)
        .map(({ RetailerProducts }) => RetailerProducts);
      const circularRetailers = circularProductsFeed
        .filter(({ RetailerProducts }) => RetailerProducts === null || RetailerProducts === void 0 ? void 0 : RetailerProducts.length)
        .map(({ RetailerProducts }) => RetailerProducts);
      this.retailersByProduct = {
        linear: standardProductCommercialReference ? linearRetailers : (_a = this.retailersByProduct) === null || _a === void 0 ? void 0 : _a.linear,
        circular: circularProductCommercialReference ? circularRetailers : (_b = this.retailersByProduct) === null || _b === void 0 ? void 0 : _b.circular,
      };
      this.productsDistributorsInfo = Object.assign(Object.assign({}, standardDistributorInfo), circularDistributorInfo);
    }
    catch (error) {
      this.productsDistributorsInfo = {};
      console.error(error);
    }
    finally {
      this.showLoader = false;
    }
  }
  initUpdateFavoritesList() {
    var _a;
    const { options: { countryLanguageCode, priceTemplate }, labels: { notAvailable, inStock, outOfStock }, } = this.settings;
    const distributors = getAllDistributors((_a = this.productInfo) === null || _a === void 0 ? void 0 : _a.commercialReference, this.productsDistributorsInfo, this.additionalDistributors, { priceLocale: countryLanguageCode, priceTemplate });
    this.favoriteDistributors = getSortedFavoritesList(distributors, countryLanguageCode, {
      notAvailable,
      inStock,
      outOfStock,
    });
  }
  async updateDistributors() {
    const { options: { zipCodePattern, feedUrl, circularFeedUrl, useZipCode, searchOnOpen, enableEmptyZipCode, }, labels: { inStock, outOfStock }, } = this.settings;
    this.isZipCodeValid = isZipCodeValid(zipCodePattern, this.zipCode);
    this.showValidateMessage = !this.isZipCodeValid && !this.isSearchInputPristine;
    await this.initSearch({
      standardProductCommercialReference: this.isccActiveProductTypeStandard ? this.productIdToShow
        : null,
      circularProductCommercialReference: this.isccActiveProductTypeStandard ? null
        : this.productIdToShow,
      zipCode: this.zipCode,
      standardProductFeedUrl: feedUrl,
      circularFeedUrl,
      inStock,
      outOfStock,
      useZipCode,
      searchOnOpen,
      enableEmptyZipCode,
      showContent: this.settings.options.useZipCode ? this.settings.options.searchOnOpen : true,
      showPrice: this.settings.options.enablePrice,
    });
    this.initUpdateFavoritesList();
  }
  render() {
    var _a, _b, _c, _d, _e;
    if (!this.settings || !isBrowser()) {
      return null;
    }
    const { priceTemplate, countryLanguageCode: priceLocale } = this.settings.options;
    const favoritesIds = getFavoritesIds(this.favoriteDistributors);
    const distributors = getAllDistributors((_a = this.productInfo) === null || _a === void 0 ? void 0 : _a.commercialReference, this.productsDistributorsInfo, this.additionalDistributors, { priceTemplate, priceLocale });
    updateFavoriteStatus(distributors, favoritesIds);
    return (h("pes-cc-main-view", { isOpen: !!this.productIdToShow && this.isOpen, header: this.settings.labels.modalHeader, product: this.productInfo, isContentVisible: this.showContent, labels: this.settings.labels, distributors: distributors, favorites: this.favoriteDistributors, showLoader: this.showLoader, showSearch: !!this.productIdToShow && this.settings.options.useZipCode, searchHeading: this.settings.labels.searchTitle, searchPlaceholder: this.settings.labels.searchPlaceholder, searchMaxLength: this.settings.options.zipCodeLength, searchButtonLabel: this.settings.labels.searchButton, searchMessage: this.settings.messages.invalidZipCode, searchShowValidateMessage: this.settings.options.useZipCode && this.showValidateMessage, searchValue: this.settings.options.useZipCode ? this.zipCode : undefined, notification: this.notification, ccStandardProductTabLabel: this.ccStandardProductTabLabel, ccCircularProductTabLabel: this.ccCircularProductTabLabel, hasLinearRetailers: !!((_c = (_b = this.retailersByProduct) === null || _b === void 0 ? void 0 : _b.linear) === null || _c === void 0 ? void 0 : _c.length), hasCircularRetailers: !!((_e = (_d = this.retailersByProduct) === null || _d === void 0 ? void 0 : _d.circular) === null || _e === void 0 ? void 0 : _e.length), shouldChipsBeVisible: this.hasEnabledLinkedCircularProduct
        && this.isLinkedCircularProductAvaliableInStock, ccActiveProductTabLabel: this.ccActiveProductTabLabel }));
  }
  static get watchers() { return {
    "products": ["onProductsChange"],
    "productIdToShow": ["onProductToShowIdChange"],
    "productsDistributorsInfo": ["distributorsChangeHandler"]
  }; }
};

const ChipsBlock = ({ data, selected, title }) => {
  return (h("div", { class: 'cc-header__chips' },
    h("div", { class: 'cc-header__chips-title' }, title),
    h("pes-chips-list", { data: data, selected: selected })));
};

const SearchBlock = ({ notification, searchPlaceholder, searchMaxLength, searchButtonLabel, searchShowValidateMessage, searchMessage, searchValue, }) => {
  return (h("div", { class: 'cc-header__search-block' },
    h("div", { class: "cc-content__search-info-message-wrapper" }, notification),
    h("div", { class: "cc-header__search-slot" },
      h("pes-cc-search", { heading: '', placeholder: searchPlaceholder, maxLength: searchMaxLength, buttonLabel: searchButtonLabel, showValidateMessage: searchShowValidateMessage, message: searchMessage, value: searchValue }))));
};

const mainCss = ".cc-wrapper{text-align:initial}.cc-body{height:calc(100vh - 115px);overflow:auto;position:relative}.cc-header{position:sticky;display:flex;flex-direction:column;padding:24px 16px}@media screen and (min-width: 980px){.cc-header--content-scrollable::after{content:\"\";position:absolute;right:0;left:0;bottom:-10px;height:10px;background:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));opacity:0;pointer-events:none}}@media screen and (min-width: 980px){.cc-header--content-scrolled::after{opacity:1}}@media screen and (min-width: 980px){.cc-header{position:sticky;padding:24px 36px;top:0;flex-direction:column;z-index:1000;background-color:#ffffff}}.cc-header__info-wrapper{display:flex;color:#333333}@media screen and (min-width: 980px){.cc-header__info-wrapper{border-bottom:1px solid var(--qds-theme-divider-standard);padding-bottom:24px}}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .cc-header__info-wrapper [dir=rtl]{margin-left:24px;margin-right:0px}:host([dir=\"rtl\"]) .cc-header__info-wrapper [dir=rtl]{margin-right:24px;margin-left:0px}}.cc-header__info{display:flex;flex-direction:column;align-items:flex-start}.cc-header__info-divider{height:1px;padding:0 36px;border-bottom:1px solid black}.cc-header__info-title{margin-bottom:4px;font-size:14px;line-height:24px;font-weight:bold}@media screen and (min-width: 980px){.cc-header__info-title{font-size:24px}}.cc-header__info-description{font-size:12px;line-height:16px;max-width:415px}@media screen and (min-width: 980px){.cc-header__info-description{font-size:14px;line-height:20px}}:host(:not([dir=\"rtl\"])) .cc-header__img{margin-right:16px}:host([dir=\"rtl\"]) .cc-header__img{margin-left:16px}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .cc-header__img{margin-right:36px}:host([dir=\"rtl\"]) .cc-header__img{margin-left:36px}}.cc-header__img img{width:100px;height:100px}@media screen and (min-width: 980px){.cc-header__img img{width:115px;height:115px}}.cc-header__chips{margin-top:24px}.cc-header__chips-title{font-weight:bold;font-size:16px;line-height:24px}:host(:not([dir=\"rtl\"])) .cc-header__chips-title{margin-left:4px}:host([dir=\"rtl\"]) .cc-header__chips-title{margin-right:4px}.cc-header__search-slot{width:100%}@media screen and (min-width: 980px){.cc-header__search-slot{width:50%;flex-basis:50%}:host(:not([dir=\"rtl\"])) .cc-header__search-slot{margin-left:6px}:host([dir=\"rtl\"]) .cc-header__search-slot{margin-right:6px}}.cc-header__search-block{display:flex;margin-top:8px;align-items:flex-start;justify-content:space-between;flex-direction:column}@media screen and (min-width: 980px){.cc-header__search-block{flex-direction:row}}.cc-header .cc-content__search-info-message-wrapper{width:100%}@media screen and (min-width: 980px){.cc-header .cc-content__search-info-message-wrapper{width:50%}}.cc-header__result-title{font-weight:bold;font-size:16px;line-height:24px;margin-top:24px}.cc-content__notification-wrapper{width:100%;font-size:14px}@media screen and (min-width: 980px){.cc-content__notification-wrapper{width:50%}}.cc-content__result-title{padding:8px 16px;font-size:16px;line-height:24px;font-weight:bold;color:#333333}@media screen and (min-width: 980px){.cc-content__result-title{padding:8px 0}}.cc-content__result-title:not(:first-child){padding-top:36px}@media screen and (min-width: 980px){.cc-content__result-title:not(:first-child){padding-top:24px}}@media screen and (min-width: 980px){.cc-content__result-wrapper{padding:0 36px 24px}}.cc-content__result--no-result{padding:24px 36px 48px}.cc-content__loading-wrapper{position:absolute;bottom:35%}:host(:not([dir=\"rtl\"])) .cc-content__loading-wrapper{left:50%}:host([dir=\"rtl\"]) .cc-content__loading-wrapper{right:50%}@media screen and (min-width: 980px){.cc-content__loading-wrapper{bottom:15%}}";

const CommerceConnectorView = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onDialogContentScroll = () => {
      this.contentScrolled = this.dialogContent.scrollTop > 0;
    };
    this.renderContent = (distributors, favorites, labels) => {
      const { noSearchResults, allRetailers, favoriteRetailers, priceUnavailable } = labels;
      const isFavorites = favorites && !!favorites.length;
      if (!distributors.length) {
        return h("pes-cc-no-result", { label: noSearchResults });
      }
      return (h("div", null, isFavorites && h("div", { class: "cc-content__result-title" }, favoriteRetailers), isFavorites && (h("pes-cc-items", { isFavoriteBlock: true, distributors: favorites, priceUnavailableLabel: priceUnavailable })), isFavorites && h("div", { class: "cc-content__result-title" }, allRetailers), h("pes-cc-items", { distributors: distributors, priceUnavailableLabel: priceUnavailable })));
    };
    this.isOpen = undefined;
    this.header = undefined;
    this.product = undefined;
    this.notification = undefined;
    this.isContentVisible = undefined;
    this.labels = undefined;
    this.distributors = undefined;
    this.favorites = undefined;
    this.showLoader = undefined;
    this.showSearch = undefined;
    this.searchHeading = undefined;
    this.searchPlaceholder = undefined;
    this.searchMaxLength = undefined;
    this.searchButtonLabel = undefined;
    this.searchMessage = undefined;
    this.searchShowValidateMessage = undefined;
    this.searchValue = undefined;
    this.shouldChipsBeVisible = false;
    this.ccStandardProductTabLabel = undefined;
    this.ccCircularProductTabLabel = undefined;
    this.ccActiveProductTabLabel = undefined;
    this.hasLinearRetailers = undefined;
    this.hasCircularRetailers = undefined;
    this.contentScrolled = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    this.dialogContent.addEventListener('scroll', this.onDialogContentScroll);
  }
  render() {
    const chipsData = [];
    this.hasLinearRetailers !== false && chipsData.push(this.ccStandardProductTabLabel);
    this.hasCircularRetailers !== false && chipsData.push(this.ccCircularProductTabLabel);
    return (h("div", { class: "cc-wrapper" }, h("se-dialog", { size: "xlarge", color: "primary", open: this.isOpen, "page-scroll": "false" }, h("se-dialog-header", { "close-icon": "true", option: "indent" }, this.header), h("div", { class: "cc-body" }, h("se-dialog-content", { option: "fill", ref: (el) => (this.dialogContent = el) }, this.product && (h("div", { class: {
        'cc-header': true,
        'cc-header--content-scrollable': this.isContentVisible,
        'cc-header--content-scrolled': this.contentScrolled,
      } }, h("div", { class: "cc-header__info-wrapper" }, h("div", { class: "cc-header__img", dir: document.documentElement.dir }, h("img", { src: this.product.imgUrl, alt: this.product.imgAlt })), h("div", { class: "cc-header__info" }, h("div", { class: "cc-header__info-title" }, this.product.commercialReference), h("div", { class: "cc-header__info-description" }, this.product.description), this.shouldChipsBeVisible && (h(ChipsBlock, { data: chipsData, title: this.labels.chipsLabel, selected: this.ccActiveProductTabLabel })))), h("div", null, h("div", { class: "cc-header__result-title" }, this.labels.availableDistributors), this.showSearch
      && h(SearchBlock, { notification: this.notification, searchPlaceholder: this.searchPlaceholder, searchMaxLength: this.searchMaxLength, searchButtonLabel: this.searchButtonLabel, searchShowValidateMessage: this.searchShowValidateMessage, searchMessage: this.searchMessage, searchValue: this.searchValue })))), (!this.showLoader && this.isContentVisible) && (h("div", { class: "cc-content" }, h("div", { class: {
        'cc-content__result-wrapper': true,
        'cc-content__result-wrapper--no-result': !this.distributors.length,
      } }, this.renderContent(this.distributors, this.favorites, this.labels))))), this.showLoader && (h("div", { class: "cc-content__loading-wrapper" }, h("se-block", null, h("se-loading", { loading: true }))))))));
  }
  get el() { return getElement(this); }
};
CommerceConnectorView.style = mainCss;

const noResultCss = ".cc-no-result__icon{width:64px;margin:0 auto 13px;color:rgba(51, 51, 51, 0.5)}.cc-no-result__label{font-size:12px;line-height:18px;font-weight:bold;text-align:center;color:#626469}";

const CommerceConnectorNoResult = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.label = undefined;
  }
  render() {
    return (h("div", { class: "cc-no-result" }, h("div", { class: "cc-no-result__icon" }, h("pes-icon", { size: pesIconSizes.XLARGE }, "action_ban")), h("div", { class: "cc-no-result__label" }, this.label)));
  }
};
CommerceConnectorNoResult.style = noResultCss;

function getInputValue(event) {
  if (event.target.id === 'ccSearchInput' && event.key === 'Enter') {
    return event.target.value;
  }
  if (event.target.id === 'ccSearchButton') {
    return event.target.previousSibling.value;
  }
}

const searchCss = ".cc-header__search{position:relative;display:flex}.cc-header__search pes-icon{position:absolute;top:50%;transform:translateY(-50%)}:host(:not([dir=\"rtl\"])) .cc-header__search pes-icon{margin-left:8px}:host([dir=\"rtl\"]) .cc-header__search pes-icon{margin-right:8px}.cc-header__search-wrapper{font-size:14px;line-height:20px;color:#626469}.cc-header__search-input{box-sizing:border-box;flex-grow:1;border-radius:0;border:1px solid #9fa0a4;color:#9fa0a4;outline:none}:host(:not([dir=\"rtl\"])) .cc-header__search-input{padding-left:30px}:host([dir=\"rtl\"]) .cc-header__search-input{padding-right:30px}.cc-header__search-input:focus{color:#333333}.cc-header__search-input--error{border-color:#b10043}.cc-header__search-input--error:focus{border-color:#9fa0a4}.cc-header__search-button{position:relative}:host(:not([dir=\"rtl\"])) .cc-header__search-button{left:-2px}:host([dir=\"rtl\"]) .cc-header__search-button{right:-2px}.cc-header__search-message{margin-top:4px;font-size:12px;line-height:15px;color:#b10043}";

const CommerceConnectorSearch = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.buyOnlineSearchClick = createEvent(this, "buyOnlineSearchClick", 7);
    this.buyOnlineSearchInputChanged = createEvent(this, "buyOnlineSearchInputChanged", 7);
    this.handleSubmit = (event) => {
      const value = getInputValue(event);
      this.buyOnlineSearchClick.emit(value);
    };
    this.handleInputValueChange = () => {
      this.buyOnlineSearchInputChanged.emit();
    };
    this.heading = undefined;
    this.placeholder = undefined;
    this.value = undefined;
    this.maxLength = undefined;
    this.buttonLabel = undefined;
    this.message = undefined;
    this.showValidateMessage = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "cc-header__search-wrapper" }, h("div", { class: "cc-header__search-heading" }, this.heading), h("div", { class: "cc-header__search" }, h("pes-icon", { size: "micro" }, "map_location"), h("input", { id: "ccSearchInput", type: "text", class: {
        'cc-header__search-input': true,
        'cc-header__search-input--error': this.showValidateMessage,
      }, placeholder: this.placeholder, maxLength: this.maxLength, value: this.value, onKeyUp: this.handleInputValueChange }), h("qds-button", { class: "cc-header__search-button", id: "ccSearchButton", size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.EMPHASIZED, onClick: this.handleSubmit, text: this.buttonLabel })), this.showValidateMessage && h("div", { class: "cc-header__search-message" }, this.message)));
  }
  get el() { return getElement(this); }
};
CommerceConnectorSearch.style = searchCss;

const chipsListCss = ".chips-list{display:flex;justify-content:center;flex-wrap:wrap}@media screen and (min-width: 980px){.chips-list{max-width:720px}}@media screen and (min-width: 980px){.chips-list--wide{max-width:none}}.chips-list__item{margin-bottom:4px}";

const MAX_CHIPS_COUNT = 10;
const ChipsList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didChipSelect = createEvent(this, "didChipSelect", 7);
    this.handleSelect = (value) => () => {
      this.didChipSelect.emit(value);
    };
    this.isChipSelected = (value) => {
      return this.selected === value;
    };
    this.data = undefined;
    this.selected = undefined;
  }
  render() {
    var _a;
    return (h("div", { class: classnames('chips-list', {
        'chips-list--wide': ((_a = this.data) === null || _a === void 0 ? void 0 : _a.length) > MAX_CHIPS_COUNT,
      }) }, this.data.map((chip) => (h("se-chip", { key: chip, class: "chips-list__item", value: chip, selected: this.isChipSelected(chip), onClick: this.handleSelect(chip) })))));
  }
};
ChipsList.style = chipsListCss;

const collapsibleContainerCss = ":host{display:block;padding:0 16px;background:#ffffff;background:var(--pes-collapsible-container-bgcolor, #ffffff)}@media screen and (max-width: 979px){:host{box-shadow:0 0 2px 0 rgba(51, 51, 51, 0.05), 0 2px 5px 0 rgba(51, 51, 51, 0.15);padding:0 16px;background:#ffffff}}:host(.collapsed) .content{display:none}@media screen and (min-width: 980px){:host(.collapsed) .content{display:block}}.content{padding-bottom:28px}@media screen and (min-width: 980px){.content{padding-bottom:25px}}.collapse-toggle{display:flex;align-items:center;background:none;border:none;padding:0;font:inherit;cursor:pointer;outline:inherit;max-width:36px;-webkit-tap-highlight-color:transparent}@media screen and (min-width: 980px){.collapse-toggle{display:none}}.collapse-toggle--color-default{color:#3dcd58}.collapse-toggle--color-inherit{color:inherit}.header{display:flex;flex-direction:row}.header .heading{flex:1 1}@media screen and (min-width: 980px){.header{padding-top:5px}}@media screen and (max-width: 979px){.header ::slotted(h2){margin:20px 0}}";

const CollapsibleContainer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.toggle = () => {
      this.isCollapsed = !this.isCollapsed;
    };
    this.toggleColor = 'default';
    this.isCollapsed = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, { class: classnames({ collapsed: this.isCollapsed }) }, h("div", { class: "header", onClick: this.toggle }, h("div", { class: "heading" }, h("slot", { name: "header" })), h("div", { class: `collapse-toggle collapse-toggle--color-${this.toggleColor}` }, h("pes-icon", { size: pesIconSizes.MICRO, mirror: !this.isCollapsed ? pesIconMirrorDirection.VERTICAL : undefined }, "arrow2_down"))), h("div", { class: "content" }, h("slot", null))));
  }
  get el() { return getElement(this); }
};
CollapsibleContainer.style = collapsibleContainerCss;

const comparisonBarCss = "@keyframes pulse{0%{transform:scale(1)}50%{transform:scale(1.03)}100%{transform:scale(1)}}:host{box-sizing:border-box;display:block;width:100%}:host *,:host *::before,:host *::after{box-sizing:inherit}.comparison-bar__container{background:#ffd100;height:0;overflow:hidden;transition:height 0.25s cubic-bezier(0, 0, 0.6, 1);font-size:0.875rem;color:#333333}@media screen and (min-width: 720px){.comparison-bar__container{margin-bottom:-12px;margin-top:12px}}.comparison-bar__container--hidden{height:0}@media screen and (max-width: 979px){.comparison-bar__container--visible{height:48px}}@media screen and (min-width: 980px){.comparison-bar__container--visible{height:56px}}.comparison-bar__container--is-animating{animation:pulse 0.25s;animation-iteration-count:1}.comparison__bar{position:relative;overflow:hidden;display:flex;flex-direction:row;align-items:center}@media screen and (max-width: 979px){.comparison__bar{height:48px}}@media screen and (min-width: 980px){.comparison__bar{height:56px;justify-content:space-between}:host(:not([dir=\"rtl\"])) .comparison__bar{padding-left:130px;padding-right:72px}:host([dir=\"rtl\"]) .comparison__bar{padding-right:130px;padding-left:72px}}.comparison__info{display:flex;align-items:center}.compare__info{display:inline-flex;flex-direction:row;align-items:center}:host(:not([dir=\"rtl\"])) .compare__info{margin-right:32px}:host([dir=\"rtl\"]) .compare__info{margin-left:32px}:host(:not([dir=\"rtl\"])) .compare__info-label{margin-right:4px}:host([dir=\"rtl\"]) .compare__info-label{margin-left:4px}.compare_qty{display:inline-flex}.compare__clear-btn{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;color:#333333;display:inline-flex;align-items:center;transition:color 0.25s}:host(:not([dir=\"rtl\"])) .compare__clear-btn{margin-right:32px}:host([dir=\"rtl\"]) .compare__clear-btn{margin-left:32px}.compare__clear-btn:hover{color:#0f0f0f}.compare__clear-btn:hover .compare__clear-label{text-decoration:underline}:host(:not([dir=\"rtl\"])) .compare__clear-icon{margin-right:10px}:host([dir=\"rtl\"]) .compare__clear-icon{margin-left:10px}.comparison__link--mobile{flex:1 1 auto;color:#333333;text-decoration:none;padding:16px 18px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.comparison__link--mobile:hover{background:#e6bc00}.compare__clear-label--mobile{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;color:#333333;padding:12px 14px;transition:all 0.25s}:host(:not([dir=\"rtl\"])) .compare__clear-label--mobile{border-left:1px solid rgba(51, 51, 51, 0.3)}:host([dir=\"rtl\"]) .compare__clear-label--mobile{border-right:1px solid rgba(51, 51, 51, 0.3)}.compare__clear-label--mobile:hover{color:#0f0f0f;background:#e6bc00}";

const COMPARATOR_URL = '/product-comparator';
const DESKTOP_WIDGET_HEIGHT = 56;
const MOBILE_WIDGET_HEIGHT = 48;
const ComparisonBar = class {
  handleCompareQuantityChange(newQty, oldQty) {
    if (oldQty === 0) {
      return;
    }
    if (newQty > 0) {
      this.animateQuantityChange();
    }
  }
  handleDocumentUpdate() {
    if (this.isShown()) {
      const paddingBottom = this.isMobile ? MOBILE_WIDGET_HEIGHT : DESKTOP_WIDGET_HEIGHT;
      document.body.style.paddingBottom = `${paddingBottom}px`;
    }
    else {
      document.body.style.paddingBottom = '';
    }
  }
  handleComparatorProductsChange() {
    this.compareQuantity = comparator.getStoredProductIds().length;
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.clearItems = () => {
      comparator.removeAll();
    };
    this.compareLabel = undefined;
    this.compareCta = undefined;
    this.clearListLabel = undefined;
    this.localeCode = undefined;
    this.isMobile = undefined;
    this.isPublic = false;
    this.isConfigured = false;
    this.compareQuantity = comparator.getStoredProductIds().length;
    this.compareLimit = MAX_COMPARATOR_ITEMS;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  animateQuantityChange() {
    if (this.comparisonBarEl) {
      const animationClassName = 'comparison-bar__container--is-animating';
      const removeAnimationHandler = () => {
        this.comparisonBarEl.classList.remove(animationClassName);
        this.comparisonBarEl.removeEventListener('animationend', removeAnimationHandler);
      };
      this.comparisonBarEl.classList.add(animationClassName);
      this.comparisonBarEl.addEventListener('animationend', removeAnimationHandler);
    }
  }
  comparisonUrl() {
    const url = `${this.localeCode}${isV3() && !this.isPublic ? REPLATFORMED_COMPARATOR_URL : COMPARATOR_URL}`;
    const productIds = comparator.getStoredProductIds().join('|');
    return `${url}/${getComparisonSessionId()}/${productIds}/`;
  }
  renderCompareQuantity() {
    return h("div", { class: "compare_qty" }, this.compareQuantity);
  }
  isShown() {
    return this.isConfigured && this.compareQuantity > 0;
  }
  renderDesktop() {
    return (h(Fragment, null, h("div", { class: "comparison__info" }, h("div", { class: "compare__info" }, h("div", { class: "compare__info-label" }, this.compareLabel), this.renderCompareQuantity()), h("button", { class: "compare__clear-btn", onClick: this.clearItems }, h("pes-icon", { class: "compare__clear-icon" }, "action_delete"), h("span", { class: "compare__clear-label" }, this.clearListLabel))), h("div", { class: "comparison__cta" }, h("qds-button", { importance: "standard", size: "standard", href: this.comparisonUrl(), text: this.compareCta }))));
  }
  renderMobile() {
    return (h(Fragment, null, h("a", { class: "comparison__link--mobile", href: this.comparisonUrl() }, this.compareLabel, " ", this.renderCompareQuantity()), h("button", { class: "compare__clear-label--mobile", onClick: this.clearItems }, h("pes-icon", null, "action_delete"))));
  }
  render() {
    return (h("div", { ref: (el) => (this.comparisonBarEl = el), class: classnames('comparison-bar__container', this.isShown()
        ? 'comparison-bar__container--visible'
        : 'comparison-bar__container--hidden') }, h("div", { class: "comparison__bar" }, this.isMobile ? this.renderMobile() : this.renderDesktop())));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "compareQuantity": ["handleCompareQuantityChange", "handleDocumentUpdate"],
    "isMobile": ["handleDocumentUpdate"],
    "isConfigured": ["handleDocumentUpdate"]
  }; }
};
ComparisonBar.style = comparisonBarCss;

const comparisonBarWrapperCss = ":host{box-sizing:border-box;display:block;width:100%;z-index:9900}:host *,:host *::before,:host *::after{box-sizing:inherit}";

const ComparisonBarWrapper = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.breakpointListener = () => {
      {
        this.isMobile = !this.mql.matches;
      }
    };
    this.configUrl = undefined;
    this.config = undefined;
    this.isPublic = 'false';
    this.isMobile = undefined;
  }
  async fetchComparisonBarConfigs() {
    try {
      if (!this.config) {
        this.config = await http.get(this.configUrl);
      }
    }
    catch (error) {
      console.error(error);
    }
  }
  setupResizeListeners() {
    {
      this.mql = window.matchMedia('(min-width: 980px)');
      this.isMobile = !this.mql.matches;
      this.mql.addListener(this.breakpointListener);
    }
  }
  componentDidLoad() {
    if (window.isAsco)
      return;
    this.fetchComparisonBarConfigs();
    this.setupResizeListeners();
  }
  disconnectedCallback() {
    if (window.isAsco)
      return;
    this.mql.removeListener(this.breakpointListener);
  }
  render() {
    var _a, _b, _c, _d;
    if (window.isAsco)
      return null;
    return (h("pes-comparison-bar", { localeCode: (_a = this.config) === null || _a === void 0 ? void 0 : _a.localeCode, compareCta: (_b = this.config) === null || _b === void 0 ? void 0 : _b.labels.compareCta, clearListLabel: (_c = this.config) === null || _c === void 0 ? void 0 : _c.labels.clearList, compareLabel: (_d = this.config) === null || _d === void 0 ? void 0 : _d.labels.compareLabel, isConfigured: Boolean(this.config), isMobile: this.isMobile, isPublic: this.isPublic === 'true' }));
  }
};
ComparisonBarWrapper.style = comparisonBarWrapperCss;

const pesCtaButtonCss = ":host{display:inline}.cta-button{width:100%}.cta-button.qds-customized-multiline-large-button{--qds-control-hero-border-radius:var(--qds-control-border-radius);--qds-control-hero-text:var(--qds-control-large-text);--qds-control-hero-gap-internal:var(--qds-control-large-gap-internal);--qds-control-hero-padding-auto-height:var(--qds-control-large-padding-auto-height);--qds-control-button-hero-padding-horizontal:var(--qds-control-button-large-padding-horizontal)}.cta-button.qds-customized-multiline-standard-button{--qds-control-hero-border-radius:var(--qds-control-border-radius);--qds-control-hero-text:var(--qds-control-standard-text);--qds-control-hero-gap-internal:var(--qds-control-standard-gap-internal);--qds-control-hero-padding-auto-height:var(--qds-control-standard-padding-auto-height);--qds-control-button-hero-padding-horizontal:var(--qds-control-button-standard-padding-horizontal)}";

const PesCtaButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didClick = createEvent(this, "didClick", 7);
    this.importance = EQdsButtonImportance.EMPHASIZED;
    this.size = EQdsButtonSize.LARGE;
    this.icon = undefined;
    this.extraClass = undefined;
    this.text = undefined;
    this.url = undefined;
    this.target = undefined;
    this.anchor = undefined;
    this.ctaProps = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    const ctaAttributes = {};
    if (!lodash.isEmpty(this.url)) {
      ctaAttributes.href = this.url;
      ctaAttributes.target = this.target;
    }
    if (!lodash.isEmpty(this.anchor)) {
      ctaAttributes.htmlFor = this.anchor;
    }
    this.ctaProps = ctaAttributes;
  }
  render() {
    return (h("qds-button", Object.assign({}, this.ctaProps, { block: true, importance: this.importance, padding: "none", size: this.size, iconName: this.icon, text: this.text, class: classnames('cta-button', this.extraClass, {
        'qds-customized-multiline-large-button': this.size === EQdsButtonSize.LARGE,
        'qds-customized-multiline-standard-button': this.size === EQdsButtonSize.STANDARD,
      }), onClick: (e) => this.didClick.emit(e), variant: "hero", iconLibrary: getQdsIconLibrary(this.icon) })));
  }
  get el() { return getElement(this); }
};
PesCtaButton.style = pesCtaButtonCss;

const VARIANT_RENDERED_PROPS = {
  stickyBar: ['priceHTML', 'tooltipHTML', 'priceFromLabel'],
};

const pesCtaPriceCss = ":host{display:block}.cta-price{display:flex;flex-direction:column;color:#333333}@media screen and (max-width: 979px){:host([variant=default]) .cta-price{justify-content:center;align-items:center}}.cta-price__in-stock-label{color:#3dcd58;font-weight:bold;font-size:0.875rem;line-height:20px;margin-bottom:4px}.cta-price__material-group{margin-bottom:16px;font-size:0.875rem;line-height:1rem;color:#626469}.cta-price__label{margin-bottom:4px;font-size:0.875rem;line-height:1rem;color:#626469}:host([variant=stickyBar]) .cta-price__label{margin-bottom:0;font-size:0.75rem;line-height:1.25rem}.cta-price__text-content{display:flex;align-items:flex-start;margin-bottom:12px}:host([variant=grid]) .cta-price__text-content{flex-direction:column}:host([variant=list]) .cta-price__text-content{flex-direction:column}:host([variant=stickyBar]) .cta-price__text-content{align-items:center}.cta-price__wrapper{display:flex;align-items:center}@media screen and (max-width: 979px){.cta-price__wrapper{align-items:flex-start;flex-direction:column}.cta-price__wrapper .cta-price__text{font-size:1.125rem;line-height:2rem}}.cta-price__bundle-label{color:#333333}@media screen and (min-width: 980px){.cta-price__bundle-label{font-size:0.75rem;line-height:1.25rem}:host(:not([dir=\"rtl\"])) .cta-price__bundle-label{margin-left:4px}:host([dir=\"rtl\"]) .cta-price__bundle-label{margin-right:4px}}@media screen and (max-width: 979px){.cta-price__bundle-label{font-size:0.875rem;line-height:1.25rem}}@media screen and (min-width: 980px){:host(.cta-area__price_filter) .cta-price__text,:host(.cta-area__price_filter) .cta-price__previous{width:100%}:host(:not([dir=\"rtl\"]).cta-area__price_filter) .cta-price__text,:host(:not([dir=\"rtl\"]).cta-area__price_filter) .cta-price__previous{text-align:right}:host([dir=\"rtl\"].cta-area__price_filter) .cta-price__text,:host([dir=\"rtl\"].cta-area__price_filter) .cta-price__previous{text-align:left}}:host(.cta-area__price_filter) .filter_pricearea{width:100%;display:flex}:host(.cta-area__price_filter) .cta-price__previous.beside{margin:0;line-height:2rem;font-size:16px;font-weight:400}@media screen and (min-width: 980px){:host(.cta-area__price_filter) .cta-price__previous.beside{flex-shrink:1}}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"]).cta-area__price_filter) .cta-price__previous.beside{margin-right:15px}:host([dir=\"rtl\"].cta-area__price_filter) .cta-price__previous.beside{margin-left:15px}}:host(.cta-area__price_filter) .cta-price__text{font-size:16px !important}:host(.cta-area__price_filter) .cta-price__vat-label{font-size:14px;font-weight:400}@media screen and (min-width: 980px){:host(.cta-area__price_filter) .cta-price__vat-label{width:100%}:host(:not([dir=\"rtl\"]).cta-area__price_filter) .cta-price__vat-label{text-align:right}:host([dir=\"rtl\"].cta-area__price_filter) .cta-price__vat-label{text-align:left}}@media screen and (max-width: 979px){:host(.cta-area__price_filter) .cta-price__vat-label{margin-top:0}}@media screen and (max-width: 979px){:host(.cta-area__price_filter) .cta-price{padding-bottom:18px}}@media screen and (min-width: 980px){:host(.cta-area__price_filter) .cta-price{padding-bottom:11px}}.cta-price__text{overflow:hidden;text-overflow:ellipsis;font-weight:bold}@media screen and (min-width: 980px){.cta-price__text{font-size:2.1875rem;line-height:2.5rem}:host([variant=grid]) .cta-price__text{font-size:1.125rem;line-height:2rem}:host([variant=list]) .cta-price__text{font-size:1.125rem;line-height:2rem}}@media screen and (max-width: 979px){.cta-price__text{font-size:1.5rem;line-height:1.625rem}:host([variant=grid]) .cta-price__text{font-size:1.125rem;line-height:2rem}:host([variant=list]) .cta-price__text{font-size:1.125rem;line-height:2rem}}:host([variant=stickyBar]) .cta-price__text{font-size:1rem;line-height:1.125rem}@media screen and (min-width: 980px){.cta-price__text-content--secondary .cta-price__text{font-size:1.5625rem;line-height:1.875rem}}@media screen and (max-width: 979px){.cta-price__text-content--secondary .cta-price__text{font-size:1.25rem;line-height:1.5625rem}}.cta-price__previous{color:#626469;font-size:0.75rem;line-height:1.125rem;font-weight:200}:host(:not([dir=\"rtl\"])) .cta-price__previous{margin-left:8px}:host([dir=\"rtl\"]) .cta-price__previous{margin-right:8px}@media screen and (min-width: 980px){.cta-price__previous{margin-top:2px}:host([variant=grid]) .cta-price__previous{font-size:0.75rem;line-height:1.125rem}:host(:not([dir=\"rtl\"])[variant=grid]) .cta-price__previous{margin-left:0}:host([dir=\"rtl\"][variant=grid]) .cta-price__previous{margin-right:0}:host([variant=list]) .cta-price__previous{font-size:0.75rem;line-height:1.125rem}:host(:not([dir=\"rtl\"])[variant=list]) .cta-price__previous{margin-left:0}:host([dir=\"rtl\"][variant=list]) .cta-price__previous{margin-right:0}}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"]).cta-area__price) .cta-price__previous{margin-left:0}:host([dir=\"rtl\"].cta-area__price) .cta-price__previous{margin-right:0}}.cta-price__vat-label{color:#626469;margin-top:4px}@media screen and (min-width: 980px){.cta-price__vat-label{font-size:0.75rem;line-height:1.25rem}}@media screen and (max-width: 979px){.cta-price__vat-label{font-size:0.75rem;line-height:1.25rem}}.cta-price__reseller-label{color:#3dcd58;margin-top:6px;font-weight:bold;font-size:0.875rem;line-height:1.25rem}:host(:not([dir=\"rtl\"])) .cta-price__tooltip-icon{margin-left:8px}:host([dir=\"rtl\"]) .cta-price__tooltip-icon{margin-right:8px}@media screen and (min-width: 980px){:host(:not([variant=stickyBar])) .cta-price__tooltip-icon{margin-top:2px}}";

const CtaPrice = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.priceHTML = undefined;
    this.secondaryPrice = undefined;
    this.previousPriceHTML = undefined;
    this.tooltipHTML = undefined;
    this.priceFromLabel = undefined;
    this.materialPriceGroup = undefined;
    this.inStockLabel = undefined;
    this.vatLabel = undefined;
    this.resellerLabel = undefined;
    this.isBundle = undefined;
    this.bundleLabel = undefined;
    this.qty = undefined;
    this.variant = 'default';
    this.previousPriceVariant = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getPropForCurrentVariant(propName) {
    var _a;
    if (this.variant === 'default' || !(this.variant in VARIANT_RENDERED_PROPS)) {
      return this[propName];
    }
    return ((_a = VARIANT_RENDERED_PROPS[this.variant]) === null || _a === void 0 ? void 0 : _a.includes(propName)) ? this[propName] : null;
  }
  getCurrentVariantProps() {
    return [
      'priceHTML',
      'previousPriceHTML',
      'tooltipHTML',
      'priceFromLabel',
      'materialPriceGroup',
      'inStockLabel',
      'vatLabel',
      'resellerLabel',
      'bundleLabel',
    ].reduce((acc, propName) => {
      acc[propName] = this.getPropForCurrentVariant(propName);
      return acc;
    }, {});
  }
  render() {
    if (!this.priceHTML) {
      return null;
    }
    const { inStockLabel, priceFromLabel, previousPriceHTML, tooltipHTML, vatLabel, resellerLabel, materialPriceGroup, bundleLabel, } = this.getCurrentVariantProps();
    return (h("div", { class: "cta-price" }, inStockLabel && h("span", { class: "cta-price__in-stock-label" }, inStockLabel), (materialPriceGroup === null || materialPriceGroup === void 0 ? void 0 : materialPriceGroup.label) && (materialPriceGroup === null || materialPriceGroup === void 0 ? void 0 : materialPriceGroup.price) && (h("div", { class: "cta-price__material-group" }, materialPriceGroup.label, ": ", materialPriceGroup.price)), priceFromLabel && h("div", { class: "cta-price__label" }, priceFromLabel, ":"), h("div", { class: "cta-price__text-content" }, this.isBundle ? (h("div", { class: "cta-price__wrapper" }, h("div", { class: {
        'cta-price__text': true,
        'cta-price__text--sticky-bar': this.variant === 'stickyBar',
      }, innerHTML: this.priceHTML }), h("div", { class: "cta-price__bundle-label", innerHTML: this.qty === 1 ? bundleLabel : bundleLabel.replace('#items qty#', `${this.qty}`) }))) : (h("div", { class: {
        filter_pricearea: this.previousPriceVariant === 'beside',
      } }, this.previousPriceVariant && previousPriceHTML && (h("div", { class: "cta-price__previous beside" }, h("strike", { innerHTML: previousPriceHTML }))), h("div", { class: {
        'cta-price__text': true,
        'cta-price__text--sticky-bar': this.variant === 'stickyBar',
      }, innerHTML: this.priceHTML }))), !this.previousPriceVariant && previousPriceHTML && (h("div", { class: "cta-price__previous" }, h("strike", { innerHTML: previousPriceHTML }))), tooltipHTML && (h("pdp-icon-tooltip", { class: "cta-price__tooltip-icon", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "bottom" }, tooltipHTML))), this.secondaryPrice && (h("div", { class: "cta-price__text-content cta-price__text-content--secondary" }, h("div", { class: "cta-price__text", innerHTML: this.secondaryPrice }))), vatLabel && h("div", { class: "cta-price__vat-label", innerHTML: vatLabel }), resellerLabel && h("div", { class: "cta-price__reseller-label", innerHTML: resellerLabel })));
  }
  get el() { return getElement(this); }
};
CtaPrice.style = pesCtaPriceCss;

const customQdsIconCss = ":host{display:inline-block}.pes-qds--icon{height:100%;width:100%}.qds-icon__wrapper{display:flex;pointer-events:none;width:24px;height:24px;font-size:24px;line-height:24px}";

const CustomQdsIconComponent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iconName = undefined;
    this.customStyles = undefined;
    this.customClasses = undefined;
  }
  render() {
    return (h("span", { class: classnames('qds-icon__wrapper', { [this.customClasses]: !!this.customClasses }), style: this.customStyles }, h("qds-icon", { name: this.iconName, class: 'pes-qds--icon' })));
  }
};
CustomQdsIconComponent.style = customQdsIconCss;

const descriptionCss = ".show-button{margin:2px 0}:host(.light) .show-button{margin:10px 0}@media screen and (min-width: 980px){.description-text{height:auto}:host(.light) .description-text{color:#ffffff}}.description-text--safari{overflow:hidden;text-overflow:ellipsis;font-size:1rem;line-height:1.5rem;margin:16px 0 0}:host(.category) .description-text--safari{margin:24px 0 0}.text-container.expanded{-webkit-line-clamp:unset}.text-container{display:block;margin:16px 0 0;font-size:1rem;line-height:1.5rem;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden}.text-container a{display:inline-block;border-radius:var(--qds-focus-border-radius);box-sizing:border-box;text-decoration:underline;color:var(--qds-theme-link-standard-default)}.text-container a:visited{color:var(--qds-theme-link-standard-visited)}.text-container a:hover{color:var(--qds-theme-link-standard-hover)}.text-container a:active{color:var(--qds-theme-link-standard-pressed)}.text-container a:visited:hover{color:var(--qds-theme-link-standard-visited-hover)}.text-container a:visited:active{color:var(--qds-theme-link-standard-visited-pressed)}.text-container a[rel~=external]>.qds-external{display:inline-block}.text-container a:focus-visible{outline:var(--qds-theme-focus-border) solid var(--qds-focus-border-width)}.text-container a[aria-disabled=true]{opacity:var(--qds-theme-disabled);pointer-events:none}.text-container p{margin:0}@media screen and (min-width: 980px){.text-container{display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;overflow:hidden}}:host(.category) .text-container{margin:24px 0 0}@media screen and (min-width: 980px){.text-container--banner{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}}.blurred-text{z-index:1;position:relative}:host(:not([dir=\"rtl\"])) .blurred-text{box-shadow:white 1px -3px 11px 8px}:host([dir=\"rtl\"]) .blurred-text{box-shadow:white -1px -3px 11px 8px}.font-m{font-size:14px;line-height:1.4285714286}.description__content{color:#626469}@media screen and (max-width: 979px){.description__content{margin-bottom:12px}}@media screen and (min-width: 980px){.description__content{width:780px}}.blurred-text{box-shadow:white 0px -19px 9px 11px;z-index:1;position:relative}.pdp-long-desc{text-align:justify;margin:unset}.pdp-long-desc>.pes-ellipsis{text-align:justify}";

const Description = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.getHeightLimit = () => {
      const { desktop, mobile } = this.numLinesToShow;
      const numLinesToShow = isMobile() ? mobile : desktop;
      const pStyle = window.getComputedStyle(this.paragraph, null);
      const lineHeight = (pStyle === null || pStyle === void 0 ? void 0 : pStyle.lineHeight) !== 'normal' ? pStyle.lineHeight : DEFAULT_LINE_HEIGHT;
      return numLinesToShow * parseInt(lineHeight, 10);
    };
    this.getShowReadMore = () => {
      var _a;
      if (this.isSafariBrowser() && this.isShowReadMore)
        return true;
      return (((_a = this.paragraph) === null || _a === void 0 ? void 0 : _a[this.isSafariBrowser() ? 'clientHeight' : 'scrollHeight']) > this.heightLimit);
    };
    this.handleResizeWindow = () => {
      this.heightLimit = this.getHeightLimit();
      this.isShowReadMore = this.getShowReadMore();
    };
    this.handleClick = () => {
      this.isExpanded = !this.isExpanded;
      if (!this.isSafariBrowser() && this.paragraph) {
        this.paragraph.classList.toggle('expanded');
      }
    };
    this.text = undefined;
    this.expandLabel = undefined;
    this.collapseLabel = undefined;
    this.numLinesToShow = { desktop: 5, mobile: 4 };
    this.isBanner = false;
    this.isPdp = false;
    this.variant = 'dark';
    this.isExpanded = false;
    this.isShowReadMore = false;
    this.heightLimit = undefined;
  }
  componentDidLoad() {
    this.heightLimit = this.getHeightLimit();
    this.isShowReadMore = this.getShowReadMore();
    window.addEventListener('resize', this.handleResizeWindow);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResizeWindow);
  }
  getWrapped(text) {
    return `<!--GEN_DESC_BEGIN-->${text}<!--GEN_DESC_END-->`;
  }
  renderSafariText() {
    return (h("p", { class: classnames('description-text description-text--safari', { 'pdp-long-desc': this.isPdp }), ref: (el) => (this.paragraph = el) }, this.isShowReadMore ? (h("pes-ellipsis", { maxHeight: this.isExpanded ? 'none' : `${this.heightLimit}px`, content: this.getWrapped(this.text), isPdpDesc: this.isPdp })) : (h("span", { innerHTML: this.getWrapped(this.text) }))));
  }
  renderText() {
    return (h("div", { class: classnames('text-container', { 'pdp-long-desc': this.isPdp }, {
        'text-container--banner': this.isBanner,
      }), ref: (el) => {
        this.paragraph = el;
      } }, h("span", { class: classnames({ 'description__content font-m': this.isPdp }, { 'description-text': !this.isPdp }), innerHTML: this.getWrapped(this.text) })));
  }
  isSafariBrowser() {
    return (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1);
  }
  render() {
    if (!this.text)
      return null;
    return (h(Host, { class: this.variant }, this.isSafariBrowser() ? this.renderSafariText() : this.renderText(), this.isPdp && this.isShowReadMore && this.getShowReadMore() && (h("div", { class: this.isExpanded ? '' : 'blurred-text' }, '')), this.isShowReadMore && this.getShowReadMore() && (h("qds-button", { size: "standard", importance: this.variant === 'light' ? 'emphasized' : 'subdued', class: classnames('show-button', { 'font-m': this.isPdp }), action: this.isExpanded ? 'dropdown-close' : 'dropdown', onClick: this.handleClick, text: this.isExpanded ? this.collapseLabel : this.expandLabel }))));
  }
};
Description.style = descriptionCss;

const DefaultIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#C6BCBC" d="M0 0h27l15 15v45H0z"/><path fill="#9B9B9C" d="m27 0 15 15H27z"/><path d="M35 47v3H7v-3h28zm0-9v3H7v-3h28zm0-9v3H7v-3h28zm-12-9v3H7v-3h16z" fill="#FFF"/></g></svg>`;

const Zip_7ZipIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#404040" d="M0 0h27l15 15v45H0z"/><path fill="#1C1C1C" d="m27 0 15 15H27z"/></g><path d="M25 45v3H5v-3h20zm-3-17v14H8V28h14zm9 14h6v3H25v-3h4.5V28H25v-3h12v3h-6v3h3v1.5h-3V34h3v1.5h-3V37h3v1.5h-3V42zm-6-20v3H5v-3h20z" fill="#FFF"/></g></svg>`;

const Avi_Audio_VideoIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#5D339F" d="M0 0h27l15 15v45H0z"/><path fill="#260741" d="m27 0 15 15H27z"/></g><path d="M7 23v23a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V23a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1zm18.838 11.733c.216.12.216.315 0 .434l-8.446 4.682c-.216.12-.392.022-.392-.217v-9.364c0-.239.176-.336.392-.217l8.446 4.682zM29 26h2.97l.03-4h-3v4zm0 7h2.97l.03-4h-3v4zm0 7h2.97l.03-4h-3v4zm0 7h2.97l.03-4h-3v4zM10 26h2.97l.03-4h-3v4zm0 7h2.97l.03-4h-3v4zm0 7h2.97l.03-4h-3v4zm0 7h2.97l.03-4h-3v4z" fill="#FFF"/></g></svg>`;

const BarcdIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#3DCD58" d="M0 0h27l15 15v45H0z"/><path fill="#009917" d="m27 0 15 15H27z"/><path d="M8 21v30H6V21h2zm14 0v30h-2V21h2zm5 0v30h-3V21h3zm-11 0v30h-5V21h5zm20 0v30h-7V21h7z" fill="#FFF"/></g></svg>`;

const CadIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#404040" d="M0 0h27l15 15v45H0z"/><path fill="#1C1C1C" d="m27 0 15 15H27z"/><path d="M20 44h-6.971v-7H7v-3.012h6.029V27h6.961v-6h3.055L23 27h7v7l5.996-.012V37H30v7h-7v6h-3v-6zm-4-3h11V30H16v11z" fill="#FFF"/></g></svg>`;

const CeIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#FFB033" d="M0 0h27l15 15v45H0z"/><path fill="#B87813" d="m27 0 15 15H27z"/></g><path d="M35 40v7.058c0 1.94-.913 2.874-2.788 2.938L32 50h-7v-3l5.39.045h.025a1.637 1.637 0 0 0 1.62-1.507l.004-.142L32 40h3zm-25 0-.04 5.396a1.636 1.636 0 0 0 1.625 1.649h.026L17 47v3h-7c-2.018 0-3-.93-3-2.942V40h3zm7-18v3l-5.39-.045h-.025a1.636 1.636 0 0 0-1.624 1.649L10 32H7v-7.058C7 22.93 7.982 22 10 22h7zm15 0 .212.004c1.875.064 2.788.999 2.788 2.938V32h-3l.04-5.396-.006-.142a1.637 1.637 0 0 0-1.62-1.507h-.025L25 25v-3h7z" fill="#FFF"/></g></svg>`;

const CrtfIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#1E4070" d="M0 0h26.992L42 15v45H0z"/><path fill="#0E1929" d="m27 0 15 15H27z"/><path d="M17.496 31.425c.373.233.689.55.922.925l.856 1.383a.804.804 0 0 0 .884.359l1.665-.43c1.497-.387 3.02.53 3.401 2.047.114.45.116.922.007 1.373l-.38 1.577a.824.824 0 0 0 .378.903l1.383.818c1.335.79 1.785 2.526 1.006 3.878a2.818 2.818 0 0 1-.946.983l-1.461.915a.825.825 0 0 0-.36.894l.387 1.585c.377 1.544-.553 3.106-2.076 3.488-.426.107-.87.113-1.298.017l-1.685-.378a.804.804 0 0 0-.864.371l-.902 1.492a2.82 2.82 0 0 1-3.909.95 2.861 2.861 0 0 1-.922-.925l-.856-1.383a.804.804 0 0 0-.884-.359l-1.665.43c-1.497.387-3.02-.53-3.401-2.047a2.873 2.873 0 0 1-.007-1.373l.38-1.577a.824.824 0 0 0-.378-.903l-1.383-.818c-1.335-.79-1.785-2.526-1.006-3.878.231-.402.556-.74.946-.983l1.461-.915a.825.825 0 0 0 .36-.894l-.387-1.585c-.377-1.544.553-3.106 2.076-3.488.426-.107.87-.113 1.298-.017l1.685.378a.804.804 0 0 0 .864-.371l.902-1.492a2.82 2.82 0 0 1 3.909-.95zm-2.09 3.19-.79 1.31a2.474 2.474 0 0 1-2.661 1.149l-1.476-.332a.696.696 0 0 0-.323.004.72.72 0 0 0-.516.87l.338 1.392a2.55 2.55 0 0 1-1.108 2.761l-1.28.804a.685.685 0 0 0 .014 1.164l1.212.718a2.548 2.548 0 0 1 1.163 2.787l-.333 1.385a.69.69 0 0 0 .002.329.667.667 0 0 0 .812.49l1.458-.378a2.472 2.472 0 0 1 2.725 1.108l.75 1.214a.7.7 0 0 0 1.202-.006l.79-1.31a2.474 2.474 0 0 1 2.66-1.148l1.476.332a.696.696 0 0 0 .323-.004.72.72 0 0 0 .516-.87l-.338-1.392a2.55 2.55 0 0 1 1.108-2.761l1.28-.804a.685.685 0 0 0-.014-1.164l-1.212-.718a2.548 2.548 0 0 1-1.163-2.787l.333-1.385a.69.69 0 0 0-.002-.329.667.667 0 0 0-.812-.49l-1.458.378a2.472 2.472 0 0 1-2.725-1.108l-.75-1.214a.7.7 0 0 0-1.202.006zM16 38.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm.089 2.323c-1.312 0-2.366 1.04-2.366 2.31 0 1.269 1.054 2.31 2.366 2.31s2.365-1.041 2.365-2.31c0-1.27-1.053-2.31-2.365-2.31zM31.08 18.307c.27.168.498.397.666.669l.41.662c.16.258.465.382.757.306l.814-.21a2.024 2.024 0 0 1 2.464 1.482c.082.326.083.667.005.994l-.18.747a.705.705 0 0 0 .323.772l.655.387a2.068 2.068 0 0 1 .043 3.52l-.715.447a.705.705 0 0 0-.308.765l.185.758c.273 1.116-.399 2.245-1.5 2.521a2.029 2.029 0 0 1-.938.012l-.832-.187a.688.688 0 0 0-.74.318l-.445.736a2.04 2.04 0 0 1-3.492.018l-.41-.662a.688.688 0 0 0-.757-.306l-.814.21a2.024 2.024 0 0 1-2.464-1.482 2.079 2.079 0 0 1-.005-.994l.18-.747a.705.705 0 0 0-.323-.772l-.655-.387a2.068 2.068 0 0 1-.043-3.52l.715-.447a.705.705 0 0 0 .308-.765l-.185-.758c-.273-1.116.399-2.245 1.5-2.521.308-.077.629-.081.938-.012l.832.187a.688.688 0 0 0 .74-.318l.445-.736a2.04 2.04 0 0 1 2.826-.687zm-1.342 1.609-.446.736a2.419 2.419 0 0 1-2.599 1.118l-.832-.187a.31.31 0 0 0-.143.002.319.319 0 0 0-.23.386l.185.758a2.478 2.478 0 0 1-1.083 2.688l-.715.448a.291.291 0 0 0 .006.496l.656.387a2.477 2.477 0 0 1 1.136 2.713l-.18.747a.293.293 0 0 0 0 .14.285.285 0 0 0 .348.21l.814-.211a2.418 2.418 0 0 1 2.661 1.078l.41.662a.312.312 0 0 0 .534-.003l.446-.736a2.419 2.419 0 0 1 2.599-1.118l.832.187a.31.31 0 0 0 .143-.002.319.319 0 0 0 .23-.386l-.185-.758a2.478 2.478 0 0 1 1.083-2.688l.715-.448a.291.291 0 0 0-.006-.496l-.656-.387a2.477 2.477 0 0 1-1.136-2.713l.18-.747a.293.293 0 0 0 0-.14.285.285 0 0 0-.348-.21l-.814.211a2.418 2.418 0 0 1-2.661-1.078l-.41-.662a.312.312 0 0 0-.534.003zm.319 3.12a3.058 3.058 0 0 1 3.066 3.05c0 1.69-1.378 3.05-3.066 3.05a3.058 3.058 0 0 1-3.066-3.05c0-1.69 1.377-3.05 3.066-3.05zm0 1.764c-.738 0-1.326.58-1.326 1.286 0 .705.588 1.286 1.326 1.286.737 0 1.325-.58 1.325-1.286 0-.705-.588-1.286-1.325-1.286z" fill="#FFF"/></g></svg>`;

const DatIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#FFD100" d="M0 0h27l15 15v45H0z"/><path fill="#E3A604" d="m27 0 15 15H27z"/><path d="M25.429 19 34 28.205V52H8V19h17.429zm-3.45 3H11v27h20V31.091h-9.02L21.978 22zM28 40v6h-6v-3h-9v-3h15zm-9-9v3h9v3H13v-6h6zm0-6v3h-6v-3h6zm5.979-2.187v5.143h4.657l-4.657-5.143z" fill="#FFF"/></g></svg>`;

const Doc_docxIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#2B5796" d="M0 0h27l15 15v45H0z"/><path fill="#18335B" d="m27 0 15 15H27z"/><path d="M36 47v3H6v-3h30zm0-7v3H6v-3h30zM23.68 26l1.712 6.462L27.48 26h2.038l1.944 6.462L33.325 26H36l-3.151 10h-2.616l-1.797-5.795L26.55 36h-2.608L21 26h2.68zM18 33v3H6v-3h12zm0-7v3H6v-3h12z" fill="#FFF"/></g></svg>`;

const DwfIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#6BA550" d="M0 0h27l15 15v45H0z"/><path fill="#305F1B" d="m27 0 15 15H27z"/></g><path d="M20.816 20.21c.266-.056.343-.037.406.003.02.013.045.027.055.05.551 1.619 2.732 7.361 8.557 13.733l.008.008-2.587 7.923 1.307.232a.346.346 0 0 1 .284.341v6a.344.344 0 0 1-.346.346h-15a.347.347 0 0 1-.347-.346v-6a.347.347 0 0 1 .285-.34l1.305-.234-2.586-7.923c5.86-6.41 8.035-12.177 8.468-13.443l.007-.022.004-.014c.041-.132.093-.245.179-.314zm6.497 22.606-13.75.452 1.124 4.916 13.75-.452-1.124-4.916zm-6.657-19.723c-1.024 2.233-3.363 6.423-7.988 11.018l2.881 8.043h10.903l2.88-8.043c-4.62-4.592-6.96-8.779-7.986-11.014L20.654 34.5l.002-11.407z" stroke="#FFF" stroke-width="2.308"/></g></svg>`;

const DwgIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#0E669F" d="M0 0h27l15 15v45H0z"/><path fill="#0D3C5A" d="m27 0 15 15H27z"/><path d="M18 0v18h5a1 1 0 0 1 1 1v5h18v3H24v5a1 1 0 0 1-1 1h-5v27h-3V33h-5a1 1 0 0 1-1-1v-5H0v-3h9v-5a1 1 0 0 1 1-1h5V0h3zm2.5 21h-8a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5zm-3 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2z" fill="#FFF"/></g></svg>`;

const DxfIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#FF5534" d="M0 0h27l15 15v45H0z"/><path fill="#8C1300" d="m27 0 15 15H27z"/><path d="M25 25a.5.5 0 0 1 .5.5V28h11a1.5 1.5 0 0 1 0 3h-6.239c2.633 1.993 4.385 4.821 4.691 8H37.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h2.433c-.436-3.225-2.955-5.937-6.433-7.215V33.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-1.715c-3.477 1.277-5.997 3.99-6.433 7.215H12.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h2.548c.306-3.179 2.058-6.007 4.69-8H5.5a1.5 1.5 0 0 1 0-3h11v-2.5a.5.5 0 0 1 .5-.5h8z" fill="#FFF"/></g></svg>`;

const EdsIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#3DCD58" d="M0 0h27l15 15v45H0z"/><path fill="#25943A" d="m27 0 15 15H27z"/><path d="M35 22a1 1 0 0 1 1 1v13.812a1.552 1.552 0 1 1-3.103 0V25H9.103v24h8.78a1.5 1.5 0 0 1 0 3H7a1 1 0 0 1-1-1V23a1 1 0 0 1 1-1zm-2.46 19.448a1.505 1.505 0 0 1 0 2.165l-5.371 5.245c-.4.39-1.049.39-1.449 0l-3.278-3.2a1.45 1.45 0 0 1 0-2.085 1.536 1.536 0 0 1 2.136 0l1.785 1.742 3.96-3.867a1.595 1.595 0 0 1 2.218 0zM19 41v3h-6v-3h6zm10-6v3H13v-3h16zm0-6v3H13v-3h16z" fill="#FFF"/></g></svg>`;

const ExeIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#3F5686" d="M0 0h27l15 15v45H0z"/><path fill="#1B2944" d="m27 0 15 15H27z"/></g><path d="m18.74 32.58-3.348.626c-.124-.757-.403-1.328-.839-1.71-.436-.384-1.002-.576-1.697-.576-.925 0-1.663.331-2.213.993-.55.661-.826 1.768-.826 3.32 0 1.724.28 2.943.84 3.655.558.712 1.31 1.068 2.251 1.068.705 0 1.282-.208 1.73-.623.45-.416.998-.975 1.183-1.988l3.415.489c-.379 1.734-1.106 3.043-2.18 3.929-1.074.885-2.514 1.328-4.32 1.328-2.051 0-3.687-.671-4.907-2.013C6.61 39.737 6 37.88 6 35.506c0-2.4.612-4.269 1.836-5.606 1.224-1.337 2.88-2.005 4.967-2.005 1.708 0 2.424.009 4.075 1.143 1.026.704 1.725 1.761 2.097 3.17a.3.3 0 0 1-.235.372zm4.561.89v-2.037a.5.5 0 0 1 .5-.5h2.053a.5.5 0 0 1 .5.5v2.038a.5.5 0 0 1-.5.5h-2.053a.5.5 0 0 1-.5-.5zm0 8.102v-2.038a.5.5 0 0 1 .5-.5h2.053a.5.5 0 0 1 .5.5v2.038a.5.5 0 0 1-.5.5h-2.053a.5.5 0 0 1-.5-.5zm6.668 2.64 3.004-16.952a1.527 1.527 0 0 1 1.767-1.237 1.521 1.521 0 0 1 1.235 1.764L32.971 44.74a1.527 1.527 0 0 1-1.767 1.237 1.521 1.521 0 0 1-1.235-1.764z" fill="#FFF"/></g></svg>`;

const FlvIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#D32A2A" d="M0 0h27l15 15v45H0z"/><path fill="#6E0403" d="m27 0 15 15H27z"/></g><path d="M24.97 21.764c-4.271 3.31-7.038 12.778-9.316 17.703C13.377 44.397 9 43.553 9 43.553v5.446s2.635.076 4.84-.876c2.213-.957 4.77-3.098 6.273-5.74.582-1.033 1.472-3.286 2.441-5.64h6.743v-5.447h-4.275c.263-1.027.831-2.335 1.704-3.923 1.517-2.761 6.229-2.886 6.229-2.886V19.04c.532 0-3.71-.587-7.985 2.724z" fill="#FFF"/></g></svg>`;

const Hmibu_Hmibp_Hmibw_HmipuIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#417505" d="M0 0h27l15 15v45H0z"/><path fill="#254006" d="m27 0 15 15H27z"/><path d="M24.286 27C25.785 27 27 28.075 27 29.4v19.2c0 1.325-1.215 2.4-2.714 2.4H10.714C9.215 51 8 49.925 8 48.6V29.4c0-1.325 1.215-2.4 2.714-2.4h13.572zm-1.637 3H12.35c-.746 0-1.351.605-1.351 1.351V46.65c0 .746.605 1.351 1.351 1.351h10.3c.746 0 1.351-.605 1.351-1.351v-15.3c0-.746-.605-1.351-1.351-1.351zm9.043-10A2.31 2.31 0 0 1 34 22.305v22.75C34 47 32.263 47 32 47c-.16 0-.317-.002-.472-.005a1.537 1.537 0 0 1-.634-2.922l.133-.056V24.35c0-.746-.605-1.351-1.35-1.351H18a1.518 1.518 0 0 1-2.932-.369L15 22c0-1.333.667-2 2-2h14.692z" fill="#FFF"/></g></svg>`;

const Html_HtmIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#9898A8" d="M0 0h27l15 15v45H0z"/><path fill="#62646A" d="m27 0 15 15H27z"/></g><path d="M21.28 27.319c.28-.958 1.324-1.519 2.332-1.253 1.008.266 1.598 1.258 1.318 2.216l-4.21 14.4c-.232.797-.994 1.318-1.824 1.318a1.98 1.98 0 0 1-.508-.066c-1.008-.266-1.598-1.258-1.318-2.216zm-10.597-.67a1.929 1.929 0 0 1 2.64-.233 1.75 1.75 0 0 1 .244 2.535l-5.251 6.062 5.248 6.033a1.75 1.75 0 0 1-.237 2.536c-.351.28-.777.418-1.2.418-.537 0-1.07-.22-1.441-.646l-6.25-7.185a1.745 1.745 0 0 1-.003-2.304zm20.634 0 6.25 7.216a1.745 1.745 0 0 1-.003 2.304l-6.25 7.185a1.904 1.904 0 0 1-1.44.646c-.424 0-.85-.137-1.2-.418a1.75 1.75 0 0 1-.238-2.536l5.248-6.033-5.25-6.062a1.75 1.75 0 0 1 .242-2.535c.796-.636 1.978-.531 2.64.233z" fill="#FFF"/></g></svg>`;

const IcdIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#167993" d="M0 0h27l15 15v45H0z"/><path fill="#114B5A" d="m27 0 15 15H27z"/></g><path d="m34.854 41.936.03.07a1.749 1.749 0 0 1-.904 2.218l-12.485 5.678a1.124 1.124 0 0 1-.916 0L8.002 44.23a1.711 1.711 0 0 1-.868-2.223 1.63 1.63 0 0 1 2-.925l.165.063 11.738 5.234 11.757-5.243a1.557 1.557 0 0 1 2.06.8zm0-8 .03.07a1.749 1.749 0 0 1-.904 2.218l-12.485 5.678a1.124 1.124 0 0 1-.916 0L8.002 36.23a1.711 1.711 0 0 1-.868-2.223 1.63 1.63 0 0 1 2-.925l.165.063 11.738 5.234 11.757-5.243a1.557 1.557 0 0 1 2.06.8zm-13.42-12.849 12.9 5.438c.405.17.666.562.666.994 0 .433-.263.824-.668.993L21.43 33.914a1.112 1.112 0 0 1-.862 0l-12.9-5.402a1.08 1.08 0 0 1-.669-.993c0-.432.261-.823.666-.994l12.9-5.438c.277-.116.59-.116.867 0zM21 24l-9 3.512L21 31l9-3.488L21 24z" fill="#FFF"/></g></svg>`;

const IcoIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#487AFD" d="M0 0h27l15 15v45H0z"/><path fill="#284AA5" d="m27 0 15 15H27z"/></g><path d="M30 20c2.75 0 5 2.25 5 5v18c0 2.75-2.25 5-5 5H12c-2.75 0-5-2.25-5-5V25c0-2.75 2.25-5 5-5h18zm-1.929 3H13.93a3.94 3.94 0 0 0-3.924 3.727L10 26.93v14.14a3.941 3.941 0 0 0 3.727 3.924l.202.005H28.07a3.942 3.942 0 0 0 3.924-3.727L32 41.07V26.93A3.94 3.94 0 0 0 28.071 23zm-2.075 4v3H23v8h2.996v3H17v-3h2.947v-7.954L17 30v-3h8.996z" fill="#FFF"/></g></svg>`;

const IduIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#3C47C7" d="M0 0h27l15 15v45H0z"/><path fill="#202777" d="m27 0 15 15H27z"/></g><path d="M8 49c-.14-.01-.768-.086-1.353-.719C6 47.581 6 46.783 6 46.44V24.561C6 22.504 6.647 22 8.21 22h6.068c.511 0 1.01.175 1.436.504l2.58 1.992c.424.329.924.504 1.435.504H29c2 0 2 .425 2 2v3.999L34 31c2 0 2.189 1.362 2 2-.126.425-1.506 5.44-4.14 15.045-.151.566-.626.955-1.165.955l-22.656-.001a.085.085 0 0 1-.016 0L8.001 49zm22.335-15H15.107c-.582 0-.939.367-1.071 1.102L12 44c-.365 1.333-.032 2 1 2h13.955c1.644 0 2.109 0 2.386-.973.228-.804 1.115-3.813 2.659-9.027.5-1.875-.06-1.992-1.665-2zM14 25h-4c-1 0-1 1-1 1v17.216c.511-2.425 1.26-5.93 2.245-10.518C11.377 32.103 11.568 31 13 31h14.626v-1.67c0-.653.146-1.312-.626-1.33-3.53.012-6.197.012-8 0-2.705-.018-3.877-3-5-3z" fill="#FFF"/></g></svg>`;

const IdxIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#6A56D7" d="M0 0h27l15 15v45H0z"/><path fill="#413292" d="m27 0 15 15H27z"/></g><path d="M29.594 24H12.077a2 2 0 0 0-1.897 1.367L6.005 37.873a.1.1 0 0 0-.005.032v8.323C6 49 7.868 49 8.727 49h24.546C34.132 49 36 49 36 46.228v-8.322a.1.1 0 0 0-.006-.034l-4.518-12.55A2 2 0 0 0 29.594 24zm-17.121 3.47a.663.663 0 0 1 .315-.337c.157-.088.328-.133.512-.133h15.401c.184 0 .354.045.512.133.157.089.262.2.314.336l2.387 7.269a.2.2 0 0 1-.19.262H10.276a.2.2 0 0 1-.19-.262l2.387-7.269zM33 45.333a.68.68 0 0 1-.179.469.546.546 0 0 1-.42.197H9.6a.549.549 0 0 1-.424-.197.682.682 0 0 1-.177-.469v-6.668c0-.18.06-.336.177-.468A.55.55 0 0 1 9.6 38h22.8c.163 0 .302.065.421.198.12.132.179.288.179.468v6.668z" fill="#FFF"/></g></svg>`;

const IgsIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#303C75" d="M0 0h27l15 15v45H0z"/><path fill="#121A40" d="m27 0 15 15H27z"/></g><path d="M21.5 19c1.103 0 2.172.324 3.092.937 1.406.939 4.223 2.594 7.282 3.137C33.685 23.396 35 24.95 35 26.768v7.544c0 2.493-.704 4.922-2.091 7.222-1.086 1.798-2.59 3.518-4.47 5.11-3.163 2.676-6.294 4.072-6.426 4.13l-.11.048a1 1 0 0 1-.806 0l-.11-.048c-.132-.058-3.263-1.454-6.426-4.13-1.88-1.592-3.384-3.312-4.47-5.11C8.704 39.234 8 36.804 8 34.312v-7.544c0-1.818 1.315-3.372 3.126-3.694 3.06-.543 5.876-2.198 7.283-3.137A5.554 5.554 0 0 1 21.5 19zm0 3.5c-.573 0-1.13.172-1.61.497-1.503 1.02-4.526 2.82-7.887 3.427A1.217 1.217 0 0 0 11 27.62v6.877c0 3.96 3.314 8.17 9.942 12.63a1 1 0 0 0 1.116 0l.402-.272c6.36-4.36 9.54-8.479 9.54-12.358V27.62c0-.589-.422-1.093-1.003-1.198-3.36-.606-6.384-2.407-7.888-3.426A2.858 2.858 0 0 0 21.5 22.5zm5.97 7.478c.555.52.684 1.405.341 2.09-3.138 4.353-5.303 7.062-6.493 8.127-1.191 1.065-3.134-.106-5.83-3.514-.569-.526-.653-1.473-.187-2.114l.102-.126c.608-.667 1.564-.709 2.215-.097l2.669 2.506 5.037-6.685c.553-.707 1.503-.79 2.146-.187z" fill="#FFF"/></g></svg>`;

const ImgIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#98D462" d="M0 0h27l15 15v45H0z"/><path fill="#78A84C" d="m27 0 15 15H27z"/><path d="m15.987 23.002 7.88 12.83 3.105-2.885L36 47.002H6l9.987-24zM16.363 30l-5.778 14h19.747l-3.892-6.398-3.568 2.524L16.363 30zM29.5 21a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 2.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" fill="#FFF"/></g></svg>`;

const IsoIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#6282A9" d="M0 0h27l15 15v45H0z"/><path fill="#3C5C83" d="m27 0 15 15H27z"/><path d="M21 20c8.271 0 15 6.729 15 15s-6.729 15-15 15S6 43.271 6 35s6.729-15 15-15zm0 3c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12zm0 7c2.758 0 5 2.242 5 5s-2.242 5-5 5-5-2.242-5-5 2.242-5 5-5zm0 2.801A2.202 2.202 0 0 0 18.801 35c0 1.212.987 2.199 2.199 2.199A2.202 2.202 0 0 0 23.199 35 2.202 2.202 0 0 0 21 32.801zM21.54 26c5.33 0 8.46 3.545 8.46 8.499V35h-1.968v-.501c0-3.7-2.729-6.488-6.493-6.488H21V26h.54z" fill="#FFF"/></g></svg>`;

const Lf24Icon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#E67840" d="M0 0h27l15 15v45H0z"/><path fill="#833A14" d="m27 0 15 15H27z"/><path d="M36 45v3H12v-3h24zM9 45v3H6v-3h3zm27-7v3H12v-3h24zM9 38v3H6v-3h3zm27-7v3H12v-3h24zM9 31v3H6v-3h3zm27-7v3H12v-3h24zM9 24v3H6v-3h3z" fill="#FFF"/></g></svg>`;

const MhtIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#626469" d="M0 0h27l15 15v45H0z"/><path fill="#333" d="m27 0 15 15H27z"/></g><path d="M21 21c8.27 0 15 6.729 15 15 0 8.27-6.729 15-15 15-8.272 0-15-6.73-15-15 0-8.271 6.728-15 15-15zm-5 16.5H9c.507 5.083 4.173 9.238 9 10.5-1.201-2.79-1.909-7.108-2-10.5zm7 0h-4c.136 6.322 1.352 10.157 2.032 10.5h.023c.601-.35 1.809-4.184 1.945-10.5zm10 0h-7c-.09 3.392-.799 7.71-2 10.5 4.826-1.262 8.494-5.417 9-10.5zM18 24c-4.827 1.262-8.493 5.417-9 10.5h7c.091-3.392.799-7.71 2-10.5zm3.055 0h-.023c-.68.343-1.896 4.178-2.032 10.5h4c-.136-6.316-1.344-10.15-1.945-10.5zM24 24c1.201 2.79 1.91 7.108 2 10.5h7c-.506-5.083-4.174-9.238-9-10.5z" fill="#FFF"/></g></svg>`;

const MovIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#20A0B0" d="M0 0h27l15 15v45H0z"/><path fill="#15626C" d="m27 0 15 15H27z"/></g><path d="M21 21c8.284 0 15 6.716 15 15-.002 5.03-1.819 9.255-6.013 12.03H36V51H21c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15zm0 3c-6.627 0-12 5.373-12 12 .007 6.624 5.376 11.993 12 12 6.627 0 12-5.373 12-12s-5.373-12-12-12zm-6.037 14.797a3 3 0 1 1 4.073 4.405 3 3 0 0 1-4.073-4.405zm8.272-.224a2.994 2.994 0 0 1 4.185.663 2.985 2.985 0 0 1-.663 4.192 2.994 2.994 0 0 1-4.185-.665 3.002 3.002 0 0 1 .663-4.19zM21 34.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-7.762-2.928a3 3 0 1 1 3.525 4.854 3 3 0 0 1-3.525-4.854zm12.835-.425a3 3 0 1 1 1.854 5.707 3 3 0 0 1-1.854-5.707zM21 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" fill="#FFF"/></g></svg>`;

const Mp4Icon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#FF8000" d="M0 0h27l15 15v45H0z"/><path fill="#A85501" d="m27 0 15 15H27z"/><path d="M31.607 25.393c5.857 5.858 5.857 15.356 0 21.214-5.858 5.857-15.356 5.857-21.214 0-5.857-5.858-5.857-15.356 0-21.214 5.858-5.857 15.356-5.857 21.214 0zM21 24c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2.468 7.052 7.279 4.604a.407.407 0 0 1 0 .688l-7.28 4.604a.331.331 0 0 1-.354 0 .38.38 0 0 1-.177-.322v-9.252a.38.38 0 0 1 .177-.322.331.331 0 0 1 .355 0z" fill="#FFF"/></g></svg>`;

const MpgIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#DA5499" d="M0 0h27l15 15v45H0z"/><path fill="#9E1259" d="m27 0 15 15H27z"/></g><path d="M34 23a2 2 0 0 1 2 2v23a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V25a2 2 0 0 1 2-2h26zm-1 21h-3v3h3v-3zm-21 0H9v3h3v-3zm15-5.997H15V47h12v-8.997zM33 38h-3v3h3v-3zm-21 0H9v3h3v-3zm15-11.997H15V35h12v-8.997zM33 32h-3v3h3v-3zm-21 0H9v3h3v-3zm21-6h-3v3h3v-3zm-21 0H9v3h3v-3z" fill="#FFF"/></g></svg>`;

const MsiIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#0177DB" d="M0 0h27l15 15v45H0z"/><path fill="#01447D" d="m27 0 15 15H27z"/></g><path d="M34 29a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2V31a2 2 0 0 1 2-2zm-2.005 3H15.963a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16.032a1 1 0 0 0 1-1V33a1 1 0 0 0-1-1zm-2.49-9a1.494 1.494 0 0 1 0 2.988H10a1 1 0 0 0-1 1V39.5a1.5 1.5 0 0 1-3 0V25a2 2 0 0 1 2-2h21.506z" fill="#FFF"/></g></svg>`;

const PdfIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#C22827" d="M0 0h27l15 15v45H0z"/><path fill="#680F11" d="m27 0 15 15H27z"/><path d="M37.45 36.943c.242.241.465.595.501.881.12.964.03 1.905-.414 2.589a1.775 1.775 0 0 1-1.035.722 4.062 4.062 0 0 1-1.042.117c-2.291 0-5.92-1.18-8.872-2.877-3.872.592-8.29 1.665-12.172 2.956C11.055 47.325 8.615 50 6.513 50c-.392 0-.775-.094-1.138-.28l-.837-.43c-.525-.307-.602-.97-.498-1.487.324-1.622 2.28-3.666 5.23-5.466.348-.215 1.831-1.016 1.894-1.05l.865-.468a106.852 106.852 0 0 0 2.782-5.232l.126-.252c.968-1.94 2.066-4.136 2.942-6.318l.313-.778c-1.223-4.776-1.898-8.463-1.244-10.927.215-.786 1.035-1.312 2.041-1.312h.015l.529.017c.902-.04 1.477.693 1.77 1.385l.094.246c.077.226.1.31.14.6.286 2.118-.793 8.38-.793 8.38a26.62 26.62 0 0 1-.172.723c.997 2.79 2.595 5.327 4.51 7.154.713.68 1.62 1.245 2.5 1.764 1.966-.281 3.834-.421 5.387-.404 2.294.031 3.801.394 4.48 1.078zM6.104 48.302c1.033-.478 2.604-2.002 4.95-5.825-.319.31-.666.642-.807.759-2.243 1.878-3.76 3.995-4.143 5.066zM19.39 17.075c-.31 0-.282 2.47-.282 2.47 0 1.293.185 3.27.569 4.525.463-.847.836-1.992.805-3.624-.032-1.631-.417-3.371-1.092-3.371zm-4.012 22.224c2.585-1.015 5.521-1.85 8.918-2.537-.232-.18-.453-.362-.661-.542-1.67-1.445-3.091-3.248-4.232-5.37a52.577 52.577 0 0 1-2.564 5.718c-.5.963-.99 1.87-1.46 2.731zm21.462-.117c.206-.132.191-.77-1.015-1.085-1.207-.315-1.573-.31-2.807-.31-.674 0-1.426.032-2.246.094 2.134.935 3.657 1.51 4.887 1.51.381 0 .974-.077 1.18-.209z" stroke="#FFF" stroke-width=".1" fill="#FFF"/></g></svg>`;

const Ppt_PptxIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#E64A19" d="M0 0h27l15 15v45H0z"/><path fill="#9F310E" d="m27 0 15 15H27z"/><path d="M36 49v3H6v-3h30zm0-7v3H6v-3h30zM20 20v9h9a9 9 0 1 1-9-9zm3-3a9 9 0 0 1 9 9h-9z" fill="#FFF"/></g></svg>`;

const PrsntIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#E03F0B" d="M0 0h27l15 15v45H0z"/><path fill="#96371E" d="m27 0 15 15H27z"/><path d="M36 24v26H6V24h30zm-3 3H9v20h24V27zm-4 4v3H13v-3h16z" fill="#FFF"/></g></svg>`;

const RarIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#914BB6" d="M0 0h27l15 15v45H0z"/><path fill="#47205B" d="m27 0 15 15H27z"/></g><path d="M13 33h-3v-3h3v-3h-3v-3h3v-3h-3v-3h3v-3h-3v-3h3V9h-3V6h3V0h3v3h3v3h-3v3h3v3h-3v3h3v3h-3v3h3v3h-3v3h3v3h-3v6h6v9c0 1.438-1.505 2.892-2.851 2.994L19 48h-9c-1.332 0-2.885-1.403-2.994-2.84L7 45v-9h6v-3zm6 6h-9v4.5a1.5 1.5 0 0 0 1.356 1.493L11.5 45h6a1.5 1.5 0 0 0 1.493-1.356L19 43.5V39z" fill="#FFF"/></g></svg>`;

const SecoIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#370317" d="M0 0h27l15 15v45H0z"/><path fill="#050505" d="m27 0 15 15H27z"/></g><path d="M36 21v29H7V21h29zm-3 3H10v23h23V24zm-4 13v6h-6v-6h6zm-9 0v6h-6v-6h6zm0-9v6h-6v-6h6zm9 0v6h-6v-6h6z" fill="#FFF"/></g></svg>`;

const Stp_StepIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#006E63" d="M0 0h27l15 15v45H0z"/><path fill="#013933" d="m27 0 15 15H27z"/></g><path d="m21.5 24 8.537 3.853a.5.5 0 0 1 .017.904l-8.332 4.132a.5.5 0 0 1-.444 0l-8.332-4.132a.5.5 0 0 1 .017-.904L21.5 24zM23 47.177V35.783a.5.5 0 0 1 .277-.448l8-3.977a.5.5 0 0 1 .723.448v11.23a.5.5 0 0 1-.27.443l-8 4.142a.5.5 0 0 1-.73-.444zM11.723 31.358l8 3.977a.5.5 0 0 1 .277.448v11.394a.5.5 0 0 1-.73.444l-8-4.142a.5.5 0 0 1-.27-.444V31.806a.5.5 0 0 1 .723-.448zm9.228 20.506a1.18 1.18 0 0 0 1.098 0l12.273-6.459A1.3 1.3 0 0 0 35 44.25V27.717c-.008-.545-.317-1-.752-1.191L21.975 21.1a1.17 1.17 0 0 0-.95 0L8.752 26.525A1.3 1.3 0 0 0 8 27.715V44.25c0 .49.263.937.678 1.155l12.273 6.459z" fill="#FFF"/></g></svg>`;

const TxtIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#489CE2" d="M0 0h27l15 15v45H0z"/><path fill="#286AA1" d="m27 0 15 15H27z"/><path d="M13 36v3H6v-3h7zm7-7v3H6v-3h14zm5-7v3H6v-3h19zM13.19 44.372l.097 4.785c.007.27.112.542.314.743.202.202.45.306.72.313l4.77.096a.94.94 0 0 0 .706-.277l16.06-16.025c.384-.382.368-1.02-.036-1.448l-4.842-4.879a1.04 1.04 0 0 0-1.45-.036l-3.211 3.23-12.85 12.794a1.04 1.04 0 0 0-.277.704zm16.673-13.56 2.83 2.824-1.414 1.41-2.83-2.824 1.414-1.41zM15.728 44.956l11.304-11.317 2.832 2.825-11.29 11.282-2.852.032.006-2.822z" fill="#FFF"/></g></svg>`;

const WmfIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#29AF91" d="M0 0h27l15 15v45H0z"/><path fill="#276E5E" d="m27 0 15 15H27z"/><path d="M30.5 48.5V53h-3v-4.5h3zm-16 0V53h-3v-4.5h3zm-6-6v3H4v-3h4.5zm29.5 0v3h-4.5v-3H38zm-7.5-16v19h-19v-19h19zm-16 3v13h5v-5h-5v-3h5v-5h-5zm12.999 8H22.5v5h5l-.001-5zM8.5 26.5v3H4v-3h4.5zm29.5 0v3h-4.5v-3H38zM30.5 19v4.5h-3V19h3zm-16 0v4.5h-3V19h3zm8 15.5h4.999l.001-5h-5v5z" fill="#FFF"/></g></svg>`;

const WmvIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#D874D9" d="M0 0h27l15 15v45H0z"/><path fill="#924A93" d="m27 0 15 15H27z"/></g><path d="M27 29c.957 0 1.91.97 1.994 1.872L29 31v5l6.303-2.701a.5.5 0 0 1 .689.37l.008.09v9.482a.5.5 0 0 1-.611.488l-.086-.028L29 40.998V46c0 .886-.588 1.894-1.506 1.992l-.148.008H7.731c-.952 0-1.657-.737-1.726-1.611L6 46.25V31.083c0-.892.91-1.98 1.863-2.076L8 29h19zm-2.154 3H10.154c-.595 0-1.085.45-1.147 1.028L9 33.154v10.692c0 .595.45 1.085 1.028 1.147l.126.007h14.692c.595 0 1.085-.45 1.147-1.028l.007-.126V33.154c0-.637-.517-1.154-1.154-1.154zM11.5 21a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm9-2a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm-9 4.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm9-1.75a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" fill="#FFF"/></g></svg>`;

const Xls_XlsxIcon = `<svg viewBox="0 0 42 60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path fill="#008F00" d="M0 0h27l15 15v45H0z"/><path fill="#015C01" d="m27 0 15 15H27z"/><path d="M36 24v24H6V24h30zM9 45l4.03-.001v-4.014H9V45zm24-4.015H16.02L16.018 45H33v-4.015zm0-3.045v-3.934H16.02v3.934H33zm-24 0h4.03v-3.934H9v3.934zm24-6.936V27H9v4.004h4.03V27h2.99v4.004H33z" fill="#FFF"/></g></svg>`;

const File_PlaceholderIcon = `<svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.04102 17.7818V20.1914H16.959V17.7818H3.04102ZM1.86524 17.7818V20.5059C1.86524 20.9816 2.25087 21.3672 2.72657 21.3672H17.2734C17.7491 21.3672 18.1348 20.9816 18.1348 20.5059V17.7818H18.1748H18.7764C19.4052 17.7818 19.9247 17.2704 19.9247 16.6244V10.8911C19.9521 10.2451 19.4052 9.73373 18.7764 9.73373H18.749H18.1748H18.1348V6.38642C18.1348 6.36559 18.134 6.3448 18.1325 6.32416C18.134 6.30726 18.1347 6.2902 18.1347 6.27295C18.1347 6.0919 18.0529 5.92994 17.9242 5.8221C17.9106 5.80646 17.8964 5.79126 17.8816 5.77652L12.9561 0.864707C12.7998 0.708821 12.5898 0.619105 12.3696 0.613555C12.3636 0.613363 12.3576 0.613281 12.3515 0.613281H12.3499H12.3479H2.72657C2.25087 0.613281 1.86524 0.99891 1.86524 1.47461V9.73373H1.85151H1.24998C1.09524 9.73259 0.941841 9.76173 0.798669 9.81951C0.655497 9.87726 0.525423 9.96246 0.41602 10.0702C0.306618 10.1779 0.220047 10.3059 0.161368 10.4469C0.102715 10.5878 0.0731025 10.7388 0.0742509 10.8911V16.6244C0.0731025 16.7767 0.102715 16.9277 0.161368 17.0686C0.220047 17.2096 0.306618 17.3376 0.41602 17.4453C0.525423 17.553 0.655497 17.6382 0.798669 17.696C0.941841 17.7538 1.09524 17.7829 1.24998 17.7818H1.82417H1.86524ZM3.04102 9.73373H16.959V6.86084H12.6249C12.1493 6.86084 11.7636 6.47521 11.7636 5.99951V1.78906H3.04102V9.73373ZM16.1248 5.68505L12.9394 2.50856V5.68505H16.1248Z" fill="#333333"/>
</svg>
`;

const knownTypes = {
  '7z': Zip_7ZipIcon,
  zip: Zip_7ZipIcon,
  avi: Avi_Audio_VideoIcon,
  audio: Avi_Audio_VideoIcon,
  video: Avi_Audio_VideoIcon,
  barcd: BarcdIcon,
  cad: CadIcon,
  ce: CeIcon,
  crtf: CrtfIcon,
  dat: DatIcon,
  dwf: DwfIcon,
  doc: Doc_docxIcon,
  docx: Doc_docxIcon,
  dwg: DwgIcon,
  dxf: DxfIcon,
  eds: EdsIcon,
  exe: ExeIcon,
  flv: FlvIcon,
  hmibu: Hmibu_Hmibp_Hmibw_HmipuIcon,
  hmibp: Hmibu_Hmibp_Hmibw_HmipuIcon,
  hmibw: Hmibu_Hmibp_Hmibw_HmipuIcon,
  hmipu: Hmibu_Hmibp_Hmibw_HmipuIcon,
  html: Html_HtmIcon,
  htm: Html_HtmIcon,
  icd: IcdIcon,
  ico: IcoIcon,
  idu: IduIcon,
  idx: IdxIcon,
  igs: IgsIcon,
  img: ImgIcon,
  iso: IsoIcon,
  lf24: Lf24Icon,
  mht: MhtIcon,
  mov: MovIcon,
  mp4: Mp4Icon,
  mpg: MpgIcon,
  msi: MsiIcon,
  pdf: PdfIcon,
  ppt: Ppt_PptxIcon,
  pptx: Ppt_PptxIcon,
  prsnt: PrsntIcon,
  rar: RarIcon,
  seco: SecoIcon,
  stp: Stp_StepIcon,
  step: Stp_StepIcon,
  txt: TxtIcon,
  wmf: WmfIcon,
  wmv: WmvIcon,
  xls: Xls_XlsxIcon,
  xlsx: Xls_XlsxIcon,
  placeholder: File_PlaceholderIcon,
};

const pesDocumentIconCss = ".pes-document-icon,.pes-document-icon svg{display:inline-block;width:14px;height:20px}@media screen and (max-width: 719px){.pes-document-icon,.pes-document-icon svg{width:10px;height:15px}}";

const PesDocumentIcon = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.getIconByType = (type) => {
      if (type.toLowerCase() in knownTypes) {
        return knownTypes[type.toLowerCase()];
      }
      return DefaultIcon;
    };
    this.type = undefined;
  }
  render() {
    return h("span", { class: "pes-document-icon", innerHTML: this.getIconByType(this.type) });
  }
};
PesDocumentIcon.style = pesDocumentIconCss;

const pesDocumentListingCss = ".pes-document-listing{font-size:0.8125rem;line-height:1.5rem;font-weight:300;margin:var(--document-listing-top-margin-mobile, 40px) auto auto}@media screen and (min-width: 980px){.pes-document-listing{margin-top:var(--document-listing-top-margin, 20px)}}";

const PesDocumentListing = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.documentListingReady = createEvent(this, "documentListingReady", 7);
    this.documentFavoriteCountChange = createEvent(this, "documentFavoriteCountChange", 7);
    this.onDocumentsReceived = (e) => {
      const { documentcount, statuscode } = e.detail;
      const hasDocuments = documentcount > 0 && statuscode === HttpStatusCodes.OK;
      this.documentListingReady.emit({ hasDocuments, name: this.name });
      window.removeEventListener(e.type, this.onDocumentsReceived);
    };
    this.onAddToDocuments = (event) => {
      this.documentFavoriteCountChange.emit(event.detail.count);
    };
    this.name = undefined;
    this.apiEndpoint = undefined;
    this.documentDetailsUrl = undefined;
    this.enableDocumentDetailsUrl = false;
    this.country = undefined;
    this.language = undefined;
    this.pageType = undefined;
    this.resourceId = undefined;
    this.software = undefined;
    this.applicationSource = 'PES_SE';
    this.view = 'grid';
    this.documentsCardOnly = false;
    this.myFavorites = false;
    this.idmsToken = '';
    this.keyword = '';
    this.userProfile = '';
  }
  get fetchSoftwares() {
    return this.software ? 'only' : 'none';
  }
  get configuration() {
    const conf = [
      this.apiEndpoint,
      this.country.toLocaleLowerCase(),
      this.language.toLocaleLowerCase(),
      this.applicationSource,
      `${this.pageType}=${this.resourceId}`,
      `view=${this.view}|fetchSoftwares=${this.fetchSoftwares}`,
      `documentscardonly=${this.documentsCardOnly}`,
    ];
    conf.push(`accessToken=${this.idmsToken}`);
    conf.push(`keyword=${this.keyword}`);
    return conf.join('::');
  }
  render() {
    return (h("div", { class: "pes-document-listing" }, this.software ? (h("document-listing-web-component-software", { ref: () => {
        window.addEventListener('documentsReceivedSoftware', this.onDocumentsReceived);
        window.addEventListener('myDocumentsCountUpdateSoftware', this.onAddToDocuments);
      }, configuration: this.configuration, myfavorites: this.myFavorites ? 'true' : 'false', user: this.userProfile })) : (h("document-listing-web-component", { ref: () => {
        window.addEventListener('documentsReceived', this.onDocumentsReceived);
        window.addEventListener('myDocumentsCountUpdate', this.onAddToDocuments);
      }, configuration: this.configuration, myfavorites: this.myFavorites ? 'true' : 'false', user: this.userProfile }))));
  }
};
PesDocumentListing.style = pesDocumentListingCss;

const ELLIPSIS_CHAR = '…';
const ELLIPSIS_LENGTH = 3;
const isContainerOverflowed = (container) => container.scrollHeight > container.clientHeight;
const addEllipsis = (lastNode, container) => {
  lastNode.textContent = `${lastNode.textContent.trimEnd()}${ELLIPSIS_CHAR}`;
  if (isContainerOverflowed(container)) {
    const sliceFromEnd = 2 * ELLIPSIS_LENGTH;
    lastNode.textContent = `${lastNode.textContent.slice(0, -sliceFromEnd)}${ELLIPSIS_CHAR}`;
  }
};
function getRangeLastNode(childNodes, containerBottom) {
  for (let i = childNodes.length - 1; i >= 0; i -= 1) {
    const child = childNodes[i];
    const range = document.createRange();
    range.selectNodeContents(child);
    const rangeRect = range.getBoundingClientRect();
    if (rangeRect.width && rangeRect.height) {
      const lastNodeHeight = containerBottom - Math.round(rangeRect.top);
      if (lastNodeHeight > 0) {
        const fontSize = child.nodeType === Node.TEXT_NODE
          ? parseFloat(getComputedStyle(child.parentNode).fontSize)
          : parseFloat(getComputedStyle(child).fontSize);
        if (lastNodeHeight < fontSize) {
          continue;
        }
        if (child.childNodes.length) {
          return getRangeLastNode(child.childNodes, containerBottom);
        }
        return range;
      }
    }
  }
}
function getStartOffset(range, containerBottom) {
  const elem = range.startContainer;
  for (let offset = range.endOffset; offset > 0; offset -= 1) {
    range.setEnd(elem, offset);
    if (Math.round(range.getBoundingClientRect().bottom) <= containerBottom) {
      return offset;
    }
  }
}
function getTextNodes(node) {
  const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
  const nodes = [];
  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }
  return nodes;
}
function getLastTextNodeInLengthWithOffset(textNodes, length) {
  let lastTextNode = null;
  let endOffset = 0;
  for (let i = 0; i < textNodes.length; i++) {
    lastTextNode = textNodes[i];
    endOffset += lastTextNode.textContent.length;
    if (endOffset > length) {
      break;
    }
  }
  return { lastTextNode, endOffset };
}
function trimOverflowedContent(commonContainer, node, offset) {
  const rangeToDelete = document.createRange();
  rangeToDelete.selectNodeContents(commonContainer);
  rangeToDelete.setStart(node, offset);
  rangeToDelete.deleteContents();
  rangeToDelete.detach();
}
const applyEllipsisByMaxHeight = (container, content) => {
  if (!container) {
    return;
  }
  container.innerHTML = content;
  const containerRect = container.getBoundingClientRect();
  const containerBottom = Math.round(containerRect.bottom);
  if (isContainerOverflowed(container)) {
    const lastNodeInRange = getRangeLastNode(container.childNodes, containerBottom);
    if (lastNodeInRange) {
      const lastNode = lastNodeInRange.startContainer;
      const startOffset = getStartOffset(lastNodeInRange, containerBottom);
      lastNodeInRange.detach();
      trimOverflowedContent(container, lastNode, startOffset);
      addEllipsis(lastNode, container);
    }
  }
};
const getTrimmedContentByLength = (content, maxLength) => {
  if (!maxLength) {
    return content;
  }
  const container = document.createElement('div');
  container.innerHTML = content;
  if (container.textContent.length <= maxLength) {
    return content;
  }
  const textNodes = getTextNodes(container);
  const { lastTextNode, endOffset } = getLastTextNodeInLengthWithOffset(textNodes, maxLength);
  const overflowedLength = endOffset - maxLength;
  if (overflowedLength <= 0) {
    return content;
  }
  const startOffsetToDelete = lastTextNode.textContent.length - overflowedLength;
  trimOverflowedContent(container, lastTextNode, startOffsetToDelete);
  addEllipsis(lastTextNode, container);
  return container.innerHTML;
};

const ellipsisCss = ":host{display:block;height:100%}:host .highlight-naming{font-weight:400}:host .highlight-naming .accent{font-weight:700}.pes-ellipsis{overflow:hidden;text-align:center}.pes-ellipsis a{display:inline-block;border-radius:var(--qds-focus-border-radius);box-sizing:border-box;text-decoration:underline;color:var(--qds-theme-link-standard-default)}.pes-ellipsis a:visited{color:var(--qds-theme-link-standard-visited)}.pes-ellipsis a:hover{color:var(--qds-theme-link-standard-hover)}.pes-ellipsis a:active{color:var(--qds-theme-link-standard-pressed)}.pes-ellipsis a:visited:hover{color:var(--qds-theme-link-standard-visited-hover)}.pes-ellipsis a:visited:active{color:var(--qds-theme-link-standard-visited-pressed)}.pes-ellipsis a[rel~=external]>.qds-external{display:inline-block}.pes-ellipsis a:focus-visible{outline:var(--qds-theme-focus-border) solid var(--qds-focus-border-width)}.pes-ellipsis a[aria-disabled=true]{opacity:var(--qds-theme-disabled);pointer-events:none}.pdp-long-desc a{display:inline-block;border-radius:var(--qds-focus-border-radius);box-sizing:border-box;text-decoration:underline;color:var(--qds-theme-link-standard-default)}.pdp-long-desc a:visited{color:var(--qds-theme-link-standard-visited)}.pdp-long-desc a:hover{color:var(--qds-theme-link-standard-hover)}.pdp-long-desc a:active{color:var(--qds-theme-link-standard-pressed)}.pdp-long-desc a:visited:hover{color:var(--qds-theme-link-standard-visited-hover)}.pdp-long-desc a:visited:active{color:var(--qds-theme-link-standard-visited-pressed)}.pdp-long-desc a[rel~=external]>.qds-external{display:inline-block}.pdp-long-desc a:focus-visible{outline:var(--qds-theme-focus-border) solid var(--qds-focus-border-width)}.pdp-long-desc a[aria-disabled=true]{opacity:var(--qds-theme-disabled);pointer-events:none}.tooltip-wrapper{display:flex;align-items:center}.tooltip-wrapper-centered{justify-content:center}@media screen and (max-width: 979px){.tooltip-wrapper{justify-content:center}}";

const Ellipsis = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.update = () => {
      return sleep().then(() => {
        var _a;
        applyEllipsisByMaxHeight(this.ref, this.trimmedContentByLength);
        this.isTruncated = ((_a = this.ref) === null || _a === void 0 ? void 0 : _a.innerHTML) !== this.content;
      });
    };
    this.debouncedUpdate = debounce_1(this.update, DEBOUNCED_HANDLER_DELAY);
    this.content = undefined;
    this.maxHeight = undefined;
    this.modifier = undefined;
    this.wrapperModifier = undefined;
    this.maxLength = undefined;
    this.hasTooltip = false;
    this.trimmedContentByLength = undefined;
    this.isTruncated = false;
    this.isPdpDesc = false;
  }
  contentOrMaxLengthDidChange() {
    this.updateTrimmedContentByLength();
  }
  triggerUpdate() {
    return this.update();
  }
  updateTrimmedContentByLength() {
    this.trimmedContentByLength = getTrimmedContentByLength(this.content, this.maxLength);
  }
  componentWillLoad() {
    this.updateTrimmedContentByLength();
  }
  componentDidLoad() {
    window.addEventListener('resize', this.debouncedUpdate);
    return this.update();
  }
  componentDidUpdate() {
    return this.update();
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedUpdate);
  }
  render() {
    var _a;
    return (h("pes-tooltip-wrapper", { showTooltip: this.hasTooltip && this.isTruncated, class: classnames('tooltip-wrapper', this.wrapperModifier && `tooltip-wrapper-${this.wrapperModifier}`) }, h("div", { slot: "tooltip-activator", ref: (el) => (this.ref = el), class: classnames(this.modifier && `pes-ellipsis-${this.modifier}`, { 'pes-ellipsis': !this.isPdpDesc }, {
        'pdp-long-desc': this.isPdpDesc,
      }), style: { maxHeight: (_a = this.maxHeight) !== null && _a !== void 0 ? _a : 'none' } }), this.hasTooltip && h("div", { slot: "tooltip-content", innerHTML: this.content })));
  }
  static get watchers() { return {
    "content": ["contentOrMaxLengthDidChange"],
    "maxLength": ["contentOrMaxLengthDidChange"]
  }; }
};
Ellipsis.style = ellipsisCss;

const FolderIcon = (props) => {
  return (h("svg", Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 768 768" }),
    h("path", { fill: "currentColor", d: "M325 638.5c12 0 21 10 21 22 0 11-9 21-21 21H21c-11 0-21-10-21-21v-555c5-35 27-89 79-89h171c39 0 62 44 73 69h330c12 0 21 10 21 22v82h73c6 0 13 3 17 8 4 6 5 13 3 19l-53 190c-3 11-15 18-26 15-12-4-18-15-15-27l45-162H164l-115 406zM79 59.5c-28 0-37 49-37 49l1 396 84-300c3-9 11-15 21-15h483v-61H308c-10 0-18-6-21-15-8-26-26-54-37-54zm669 571c13 14 20 31 20 50s-7 37-20 50c-14 14-33 21-51 21s-37-7-51-21l-113-113c-4-4-8-8-10-13-67 26-142 11-193-39-34-34-52-78-52-125s19-91 52-125c69-68 182-68 252 0 50 50 66 126 39 191 5 3 9 7 13 10zm-31 70c6-5 9-12 9-20 0-7-3-14-9-20l-113-113c-5-5-11-8-17-8-8-1-15-7-17-15-3-8 0-17 6-22l1-2c26-51 16-114-25-154-53-53-139-53-192 0-52 52-52 136 0 189 41 40 104 51 156 26l3-3c4-4 9-6 15-6 2 0 4 0 7 1 7 3 13 10 14 18 1 6 3 11 8 16l113 113c12 12 30 12 41 0z" })));
};

const pesFiltersNoResultsCss = ".filters-no-results{text-align:center;margin-top:30px;color:#626469}@media screen and (min-width: 980px){.filters-no-results{margin-top:80px}}.filters-no-results__search-icon{width:50px;height:50px;color:#cbcbcb;display:inline-block}@media screen and (min-width: 980px){.filters-no-results__search-icon{width:60px;height:60px}}.filters-no-results__header{font-size:18px;line-height:1.3888888889;font-weight:bold;margin:10px 0 0}@media screen and (min-width: 980px){.filters-no-results__header{font-size:22px;line-height:1.3636363636}}.filters-no-results__message{font-size:14px;line-height:1.4285714286;margin-top:10px;font-weight:400}@media screen and (min-width: 980px){.filters-no-results__message{font-size:16px;line-height:1.5625;margin-top:15px}}.filters-no-results__clear-link{font-size:14px;line-height:1.4285714286;margin-top:20px}@media screen and (min-width: 980px){.filters-no-results__clear-link{font-size:16px;line-height:1.5625;margin-top:30px}}";

const PesFiltersNoResults = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.resetAllClicked = createEvent(this, "resetAllClicked", 7);
    this.handleClick = () => {
      this.resetAllClicked.emit();
    };
    this.noResultsClearLink = undefined;
    this.noResultsHeader = undefined;
    this.noResultsMessage = undefined;
  }
  render() {
    return (h("div", { class: "filters-no-results" }, h(FolderIcon, { class: "filters-no-results__search-icon" }), h("h2", { class: "filters-no-results__header" }, this.noResultsHeader), h("div", { class: "filters-no-results__message" }, this.noResultsMessage), h("qds-button", { class: "filters-no-results__clear-link", onClick: this.handleClick, size: "standard", importance: "subdued", text: this.noResultsClearLink, iconName: "arrow-up-down-circle", iconLibrary: getQdsIconLibrary("arrow-up-down-circle") })));
  }
};
PesFiltersNoResults.style = pesFiltersNoResultsCss;

const hmcBannerCss = ":host{box-sizing:border-box;display:block;width:100%}:host *,:host *::before,:host *::after{box-sizing:inherit}.hmc-banner{flex:1;display:flex;padding:20px 30px 10px;justify-content:center;flex-direction:column}.hmc-banner.is-short{min-height:115px;height:100%;padding:0 28px}.hmc-banner.is-square{min-height:170px}.hmc-banner.is-extended{min-height:108px}@media screen and (min-width: 980px){.hmc-banner.is-extended{flex-direction:row;padding:0 60px;justify-content:space-between;align-items:center}}.hmc-banner__text-block.is-short{text-align:center}.hmc-banner__text-block.is-square{margin-bottom:12px}@media screen and (max-width: 979px){.hmc-banner__text-block.is-extended{margin-bottom:12px}}.hmc-banner__button.is-square,.hmc-banner__button.is-extended{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;height:40px;width:100%;background-color:#42b4e6;color:#ffffff;line-height:20px;border-radius:2px;margin:0}.hmc-banner__button.is-square:hover,.hmc-banner__button.is-extended:hover{cursor:pointer;background:linear-gradient(#59bde9, #42b4e6 50%)}@media screen and (max-width: 979px){.hmc-banner__button.is-square,.hmc-banner__button.is-extended{font-size:12px}}@media screen and (min-width: 980px){.hmc-banner__button.is-square,.hmc-banner__button.is-extended{font-size:16px}}@media screen and (max-width: 979px){.hmc-banner__button.is-extended{width:192px;margin:0 auto}}@media screen and (min-width: 980px){.hmc-banner__button.is-extended{flex:0 0 192px}}.hmc-banner__heading{line-height:25px;text-align:center}.hmc-banner__heading.is-short{margin:0 0 8px;max-width:100%;color:#333333;font-size:13px;line-height:15px}.hmc-banner__heading.is-square,.hmc-banner__heading.is-extended{margin:0 0 5px;color:#626469}@media screen and (max-width: 979px){.hmc-banner__heading.is-square,.hmc-banner__heading.is-extended{font-size:14px}}@media screen and (min-width: 980px){.hmc-banner__heading.is-square,.hmc-banner__heading.is-extended{font-size:16px}}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .hmc-banner__heading.is-extended{text-align:left;margin-right:20px}:host([dir=\"rtl\"]) .hmc-banner__heading.is-extended{text-align:right;margin-left:20px}}.hmc-banner__text{text-align:center}.hmc-banner__text.is-short{display:inline;font-size:13px;line-height:15px;text-transform:capitalize}.hmc-banner:hover .hmc-banner__text.is-short{text-decoration:underline}.hmc-banner__text.is-square,.hmc-banner__text.is-extended{font-size:12px;line-height:18px;font-weight:normal;color:#626469;text-align:center}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .hmc-banner__text.is-extended{text-align:left}:host([dir=\"rtl\"]) .hmc-banner__text.is-extended{text-align:right}}.hmc-banner__text-content.is-short{background:none;color:#42b4e6;border:none;padding:0;cursor:pointer;outline:inherit;font-family:inherit;font-size:15px;line-height:20px;font-weight:normal;text-align:center}.hmc-banner__text-content.is-short:hover{text-decoration:underline}.hmc-banner__text-content.is-short:hover{text-decoration:none}.hmc-banner__text-arrow-icon.is-short{display:inline-flex;align-items:center;vertical-align:middle;position:relative}:host(:not([dir=\"rtl\"])) .hmc-banner__text-arrow-icon.is-short{left:3px}:host([dir=\"rtl\"]) .hmc-banner__text-arrow-icon.is-short{right:3px;transform:scaleX(-1)}.banner-container--prerender{min-height:110px}";

const SQUARE_VARIANT_MAX_WIDTH = 300;
const HmcBanner = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.handleClick = (e) => {
      if (this.hasQuestionnaire) {
        e.preventDefault();
        this.modal = document.createElement('pes-hmc-modal-container');
        const analyticsData = { pageCategoryId: this.parentCategoryId };
        this.modal.host = this.hmcHost;
        this.modal.token = this.token;
        this.modal.channel = this.channel;
        this.modal.pageSource = this.pageSource;
        this.modal.closeModal = this.closeModal;
        document.body.appendChild(this.modal);
        if (isAnalyticsEnabled()) {
          send(hmcEvent, analyticsData);
        }
      }
    };
    this.closeModal = () => {
      var _a, _b;
      (_b = (_a = this.modal) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    this.buildClassName = (element) => {
      const block = 'hmc-banner';
      const fullClassName = element ? `${block}__${element}` : block;
      const variantClassName = `is-${this.variant}`;
      return classnames(fullClassName, variantClassName);
    };
    this.renderText = () => {
      var _a, _b;
      return this.variant === 'short' ? (h("span", { class: this.buildClassName('text-content') }, h("span", { class: this.buildClassName('text'), innerHTML: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcStartMessage }), h("pes-icon", { class: this.buildClassName('text-arrow-icon'), size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left"))) : (h("div", { class: this.buildClassName('text') }, (_b = this.labels) === null || _b === void 0 ? void 0 : _b.hmcStartMessage));
    };
    this.getVariant = () => {
      var _a;
      if (!((_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcStartBtn)) {
        return 'short';
      }
      const hostWidth = this.host.getBoundingClientRect().width;
      return hostWidth <= SQUARE_VARIANT_MAX_WIDTH ? 'square' : 'extended';
    };
    this.labels = undefined;
    this.categoryName = undefined;
    this.sourceId = undefined;
    this.pimId = null;
    this.parentCategoryId = null;
    this.categoryProductConfiguratorUrl = undefined;
    this.isExternalProductConfiguratorUrl = undefined;
    this.hasQuestionnaire = false;
    this.questionnaireUrl = undefined;
    this.rangeTooltipUrl = undefined;
    this.selectorConfigUrl = undefined;
    this.variant = 'short';
    this.hideHMCBanner = false;
    this.hmcBanner = undefined;
    this.hmcHost = undefined;
    this.token = undefined;
    this.pageSource = undefined;
    this.channel = undefined;
    this._labels = undefined;
    this._categoryName = undefined;
    this._pimId = undefined;
    this._sourceId = undefined;
    this._parentCategoryId = undefined;
    this._categoryProductConfiguratorUrl = undefined;
    this._isExternalProductConfiguratorUrl = undefined;
    this._hasQuestionnaire = undefined;
    this._questionnaireUrl = undefined;
    this._rangeTooltipUrl = undefined;
    this._selectorConfigUrl = undefined;
    this._hideHMCBanner = undefined;
    this._hmcBanner = undefined;
    this._variant = undefined;
    this._hmcHost = undefined;
    this._token = undefined;
    this._pageSource = undefined;
    this._channel = undefined;
    this.host.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    this.labels = (_a = tryParse(this._labels)) !== null && _a !== void 0 ? _a : this.labels;
    this.categoryName = (_b = tryParse(this._categoryName)) !== null && _b !== void 0 ? _b : this.categoryName;
    const pimId = (_c = tryParse(this._pimId)) !== null && _c !== void 0 ? _c : this.pimId;
    const sourceId = (_d = tryParse(this._sourceId)) !== null && _d !== void 0 ? _d : this.sourceId;
    this.sourceId = pimId === null ? sourceId : pimId;
    this.categoryProductConfiguratorUrl = (_e = tryParse(this._categoryProductConfiguratorUrl)) !== null && _e !== void 0 ? _e : this.categoryProductConfiguratorUrl;
    this.isExternalProductConfiguratorUrl = (_f = tryParse(this._isExternalProductConfiguratorUrl)) !== null && _f !== void 0 ? _f : this.isExternalProductConfiguratorUrl;
    this.hasQuestionnaire = (_g = tryParse(this._hasQuestionnaire)) !== null && _g !== void 0 ? _g : this.hasQuestionnaire;
    this.questionnaireUrl = (_h = tryParse(this._questionnaireUrl)) !== null && _h !== void 0 ? _h : this.questionnaireUrl;
    this.rangeTooltipUrl = (_j = tryParse(this._rangeTooltipUrl)) !== null && _j !== void 0 ? _j : this.rangeTooltipUrl;
    this.selectorConfigUrl = (_k = tryParse(this._selectorConfigUrl)) !== null && _k !== void 0 ? _k : this.selectorConfigUrl;
    this.variant = (_l = tryParse(this._variant)) !== null && _l !== void 0 ? _l : this.variant;
    this.parentCategoryId = (_m = tryParse(this._parentCategoryId)) !== null && _m !== void 0 ? _m : this.parentCategoryId;
    this.hideHMCBanner = (_o = tryParse(this._hideHMCBanner)) !== null && _o !== void 0 ? _o : this.hideHMCBanner;
    this.hmcBanner = (_p = tryParse(this._hmcBanner)) !== null && _p !== void 0 ? _p : this.hmcBanner;
    this.hmcHost = (_q = tryParse(this._hmcHost)) !== null && _q !== void 0 ? _q : this.hmcHost;
    this.channel = (_r = tryParse(this._channel)) !== null && _r !== void 0 ? _r : this.channel;
    this.pageSource = (_s = tryParse(this._pageSource)) !== null && _s !== void 0 ? _s : this.pageSource;
    this.token = (_t = tryParse(this._token)) !== null && _t !== void 0 ? _t : this.token;
  }
  getTargetForUrl() {
    return this.isExternalProductConfiguratorUrl ? '_blank' : '_self';
  }
  componentDidLoad() {
    this.variant = this.getVariant();
  }
  isHMCEnabled() {
    return !this.hideHMCBanner && !isEmpty_1(this.labels);
  }
  render() {
    var _a, _b, _c, _d;
    const heading = this.variant !== 'short' && this.categoryName
      ? (_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcHeader.replace('#CategoryName#', this.categoryName)
      : (_b = this.labels) === null || _b === void 0 ? void 0 : _b.hmcHeader;
    const urlProps = !this.hasQuestionnaire && this.categoryProductConfiguratorUrl
      ? {
        url: this.categoryProductConfiguratorUrl,
        target: this.getTargetForUrl(),
      }
      : {};
    if (!this.labels)
      return null;
    return (h("div", { class: classnames({
        'subcategories__banner-container--prerender': this.isHMCEnabled(),
      }) }, this.isHMCEnabled() && isBrowser() ? (h("pes-banner", Object.assign({}, urlProps, { icon: "action_search_stroke", onClick: this.handleClick }), h("div", { class: this.buildClassName() }, h("div", { class: this.buildClassName('text-block') }, h("h2", { class: this.buildClassName('heading'), innerHTML: heading }), this.renderText()), ((_c = this.labels) === null || _c === void 0 ? void 0 : _c.hmcStartBtn) && (h("button", { type: "button", class: this.buildClassName('button') }, (_d = this.labels) === null || _d === void 0 ? void 0 : _d.hmcStartBtn))))) : null));
  }
  get host() { return getElement(this); }
};
HmcBanner.style = hmcBannerCss;

const HmcModalContainer = class {
  componentWillLoad() {
    const { languageCode, countryCode } = getLocaleFromBody(isBrowser) || {};
    this.languageCode = languageCode;
    this.countryCode = countryCode;
    this.isloggedIn = Boolean(window.isPBS);
    this.isOpened = true;
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.host = undefined;
    this.token = undefined;
    this.channel = undefined;
    this.pageSource = undefined;
    this.closeModal = undefined;
    this.isOpened = false;
    this.languageCode = undefined;
    this.countryCode = undefined;
    this.isloggedIn = false;
    this.handleClose = this.handleClose.bind(this);
    window.addEventListener(HMC_CLOSE_EVENT, this.handleClose);
  }
  handleClose() {
    var _a;
    this.isOpened = false;
    (_a = this.closeModal) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  disconnectedCallback() {
    var _a;
    window.removeEventListener(HMC_CLOSE_EVENT, this.handleClose);
    (_a = this.closeModal) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    return (h("se-dialog", { open: this.isOpened }, h("wc-help-me-choose", { host: this.host, language: this.languageCode, country: this.countryCode, channel: this.channel, token: this.token, platform: this.isloggedIn ? HMCPlatform.MySchneider : HMCPlatform.SE, pageSource: this.pageSource, outputLinkClickEvent: this.isloggedIn ? MY_SCHNEIDER_CLICK_EVENT : '', addToCartEvent: 'scSelectorAddToCart', closeEvent: HMC_CLOSE_EVENT })));
  }
};

var fontfaceobserver_standalone = createCommonjsModule(function (module) {
/* Font Face Observer v2.3.0 - © Bram Stein. License: BSD-3-Clause */(function(){function p(a,c){document.addEventListener?a.addEventListener("scroll",c,!1):a.attachEvent("scroll",c);}function u(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function b(){document.removeEventListener("DOMContentLoaded",b);a();}):document.attachEvent("onreadystatechange",function g(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",g),a();});}function w(a){this.g=document.createElement("div");this.g.setAttribute("aria-hidden","true");this.g.appendChild(document.createTextNode(a));this.h=document.createElement("span");this.i=document.createElement("span");this.m=document.createElement("span");this.j=document.createElement("span");this.l=-1;this.h.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.i.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.j.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.m.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.h.appendChild(this.m);this.i.appendChild(this.j);this.g.appendChild(this.h);this.g.appendChild(this.i);}
function x(a,c){a.g.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+c+";";}function B(a){var c=a.g.offsetWidth,b=c+100;a.j.style.width=b+"px";a.i.scrollLeft=b;a.h.scrollLeft=a.h.scrollWidth+100;return a.l!==c?(a.l=c,!0):!1}function C(a,c){function b(){var e=g;B(e)&&null!==e.g.parentNode&&c(e.l);}var g=a;p(a.h,b);p(a.i,b);B(a);}function D(a,c,b){c=c||{};b=b||window;this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal";this.context=b;}var E=null,F=null,G=null,H=null;function I(a){null===F&&(M(a)&&/Apple/.test(window.navigator.vendor)?(a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent),F=!!a&&603>parseInt(a[1],10)):F=!1);return F}function M(a){null===H&&(H=!!a.document.fonts);return H}
function N(a,c){var b=a.style,g=a.weight;if(null===G){var e=document.createElement("div");try{e.style.font="condensed 100px sans-serif";}catch(q){}G=""!==e.style.font;}return [b,g,G?a.stretch:"","100px",c].join(" ")}
D.prototype.load=function(a,c){var b=this,g=a||"BESbswy",e=0,q=c||3E3,J=(new Date).getTime();return new Promise(function(K,L){if(M(b.context)&&!I(b.context)){var O=new Promise(function(r,t){function h(){(new Date).getTime()-J>=q?t(Error(""+q+"ms timeout exceeded")):b.context.document.fonts.load(N(b,'"'+b.family+'"'),g).then(function(n){1<=n.length?r():setTimeout(h,25);},t);}h();}),P=new Promise(function(r,t){e=setTimeout(function(){t(Error(""+q+"ms timeout exceeded"));},q);});Promise.race([P,O]).then(function(){clearTimeout(e);
K(b);},L);}else u(function(){function r(){var d;if(d=-1!=k&&-1!=l||-1!=k&&-1!=m||-1!=l&&-1!=m)(d=k!=l&&k!=m&&l!=m)||(null===E&&(d=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),E=!!d&&(536>parseInt(d[1],10)||536===parseInt(d[1],10)&&11>=parseInt(d[2],10))),d=E&&(k==y&&l==y&&m==y||k==z&&l==z&&m==z||k==A&&l==A&&m==A)),d=!d;d&&(null!==f.parentNode&&f.parentNode.removeChild(f),clearTimeout(e),K(b));}function t(){if((new Date).getTime()-J>=q)null!==f.parentNode&&f.parentNode.removeChild(f),
L(Error(""+q+"ms timeout exceeded"));else {var d=b.context.document.hidden;if(!0===d||void 0===d)k=h.g.offsetWidth,l=n.g.offsetWidth,m=v.g.offsetWidth,r();e=setTimeout(t,50);}}var h=new w(g),n=new w(g),v=new w(g),k=-1,l=-1,m=-1,y=-1,z=-1,A=-1,f=document.createElement("div");f.dir="ltr";x(h,N(b,"sans-serif"));x(n,N(b,"serif"));x(v,N(b,"monospace"));f.appendChild(h.g);f.appendChild(n.g);f.appendChild(v.g);b.context.document.body.appendChild(f);y=h.g.offsetWidth;z=n.g.offsetWidth;A=v.g.offsetWidth;t();
C(h,function(d){k=d;r();});x(h,N(b,'"'+b.family+'",sans-serif'));C(n,function(d){l=d;r();});x(n,N(b,'"'+b.family+'",serif'));C(v,function(d){m=d;r();});x(v,N(b,'"'+b.family+'",monospace'));});})};module.exports=D;}());
});

const iconCss = ":host{display:inline-block}.icon{display:flex;opacity:0;pointer-events:none}.icon--loaded{opacity:1}.icon__element{pointer-events:none}.icon--nano{width:14px;height:14px;font-size:14px;line-height:14px}.icon--micro{width:18px;height:18px;font-size:18px;line-height:18px}.icon--small{width:24px;height:24px;font-size:24px;line-height:24px}.icon--medium{width:32px;height:32px;font-size:32px;line-height:32px}.icon--large{width:52px;height:52px;font-size:52px;line-height:52px}.icon--xlarge{width:62px;height:62px;font-size:62px;line-height:62px}";

const IconComponent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.handleFontFaceLoaded = () => {
      this.fontLoaded = true;
    };
    this.option = undefined;
    this.size = pesIconSizes.SMALL;
    this.color = undefined;
    this.mirror = undefined;
    this.customStyle = undefined;
    this.fontLoaded = false;
  }
  componentWillLoad() {
    new fontfaceobserver_standalone(ICON_FONT_NAME)
      .load(null, LOAD_TIMEOUT)
      .then(this.handleFontFaceLoaded, this.handleFontFaceLoaded);
  }
  render() {
    const iconClass = classnames({
      icon: true,
      [`icon--${this.size}`]: true,
      'icon--loaded': this.fontLoaded,
    });
    return (h("span", { class: iconClass }, h("se-icon", { class: "icon__element", option: this.option, size: this.size, color: this.color, mirror: this.mirror, style: this.customStyle }, h("slot", null))));
  }
  get el() { return getElement(this); }
};
IconComponent.style = iconCss;

const lazyImgCss = ":host{display:block}.lazy-img{width:100%;height:auto;border:none;outline:none}";

const LazyImage = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onIntersection = async (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          if (this.observer) {
            this.observer.disconnect();
          }
          if (this.loaded) {
            entry.target.setAttribute('src', this.src);
          }
        }
      }
    };
    this.src = undefined;
    this.width = undefined;
    this.height = undefined;
    this.alt = undefined;
    this.class = '';
    this.useDefaultImage = true;
    this.loaded = false;
  }
  componentWillLoad() {
    this.loaded = true;
  }
  componentDidLoad() {
    var _a;
    if (this.image) {
      this.observer = new IntersectionObserver(this.onIntersection);
      (_a = this.observer) === null || _a === void 0 ? void 0 : _a.observe(this.image);
    }
  }
  componentDidUpdate() {
    var _a;
    (_a = this.observer) === null || _a === void 0 ? void 0 : _a.observe(this.image);
  }
  render() {
    return (h("img", { ref: (el) => (this.image = el), height: this.height, width: this.width, alt: this.alt, class: classnames('lazy-img', this.class), onError: this.useDefaultImage
        ? () => (this.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAEGWlDQ1BrQ0dDb2xvclNwYWNlR2Vu ZXJpY1JHQgAAOI2NVV1oHFUUPrtzZyMkzlNsNIV0qD8NJQ2TVjShtLp/3d02bpZJNtoi6GT27s6Y yc44M7v9oU9FUHwx6psUxL+3gCAo9Q/bPrQvlQol2tQgKD60+INQ6Ium65k7M5lpurHeZe58853v nnvuuWfvBei5qliWkRQBFpquLRcy4nOHj4g9K5CEh6AXBqFXUR0rXalMAjZPC3e1W99Dwntf2dXd /p+tt0YdFSBxH2Kz5qgLiI8B8KdVy3YBevqRHz/qWh72Yui3MUDEL3q44WPXw3M+fo1pZuQs4tOI BVVTaoiXEI/MxfhGDPsxsNZfoE1q66ro5aJim3XdoLFw72H+n23BaIXzbcOnz5mfPoTvYVz7KzUl 5+FRxEuqkp9G/Ajia219thzg25abkRE/BpDc3pqvphHvRFys2weqvp+krbWKIX7nhDbzLOItiM83 58pTwdirqpPFnMF2xLc1WvLyOwTAibpbmvHHcvttU57y5+XqNZrLe3lE/Pq8eUj2fXKfOe3pfOjz hJYtB/yll5SDFcSDiH+hRkH25+L+sdxKEAMZahrlSX8ukqMOWy/jXW2m6M9LDBc31B9LFuv6gVKg /0Szi3KAr1kGq1GMjU/aLbnq6/lRxc4XfJ98hTargX++DbMJBSiYMIe9Ck1YAxFkKEAG3xbYaKmD DgYyFK0UGYpfoWYXG+fAPPI6tJnNwb7ClP7IyF+D+bjOtCpkhz6CFrIa/I6sFtNl8auFXGMTP34s NwI/JhkgEtmDz14ySfaRcTIBInmKPE32kxyyE2Tv+thKbEVePDfW/byMM1Kmm0XdObS7oGD/MypM XFPXrCwOtoYjyyn7BV29/MZfsVzpLDdRtuIZnbpXzvlf+ev8MvYr/Gqk4H/kV/G3csdazLuyTMPs bFhzd1UabQbjFvDRmcWJxR3zcfHkVw9GfpbJmeev9F08WW8uDkaslwX6avlWGU6NRKz0g/SHtCy9 J30o/ca9zX3Kfc19zn3BXQKRO8ud477hLnAfc1/G9mrzGlrfexZ5GLdn6ZZrrEohI2wVHhZywjbh UWEy8icMCGNCUdiBlq3r+xafL549HQ5jH+an+1y+LlYBifuxAvRN/lVVVOlwlCkdVm9NOL5BE4wk Q2SMlDZU97hX86EilU/lUmkQUztTE6mx1EEPh7OmdqBtAvv8HdWpbrJS6tJj3n0CWdM6busNzRV3 S9KTYhqvNiqWmuroiKgYhshMjmhTh9ptWhsF7970j/SbMrsPE1suR5z7DMC+P/Hs+y7ijrQAlhyA gccjbhjPygfeBTjzhNqy28EdkUh8C+DU9+z2v/oyeH791OncxHOs5y2AtTc7nb/f73TWPkD/qwBn jX8BoJ98VQNcC+8AAAB0ZVhJZk1NACoAAAAIAAMBEgADAAAAAQABAAABMQACAAAAJAAAADKHaQAE AAAAAQAAAFYAAAAAQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkAAAKgAgAEAAAA AQAAAMigAwAEAAAAAQAAAMgAAAAAyZp7lQAABBdpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4 OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4w Ij4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJk Zi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAg ICAgICAgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iCiAgICAg ICAgICAgIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVz b3VyY2VSZWYjIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3Rp ZmYvMS4wLyIKICAgICAgICAgICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8x LjAvIj4KICAgICAgICAgPHhtcE1NOkluc3RhbmNlSUQ+eG1wLmlpZDo4MTAyQjU2NTM0QTcxMUU2 QkM0NUMwOUMwMDQ0NkQ5QjwveG1wTU06SW5zdGFuY2VJRD4KICAgICAgICAgPHhtcE1NOkRlcml2 ZWRGcm9tIHJkZjpwYXJzZVR5cGU9IlJlc291cmNlIj4KICAgICAgICAgICAgPHN0UmVmOmluc3Rh bmNlSUQ+eG1wLmlpZDo4MTAyQjU2MzM0QTcxMUU2QkM0NUMwOUMwMDQ0NkQ5Qjwvc3RSZWY6aW5z dGFuY2VJRD4KICAgICAgICAgICAgPHN0UmVmOmRvY3VtZW50SUQ+eG1wLmRpZDo4MTAyQjU2NDM0 QTcxMUU2QkM0NUMwOUMwMDQ0NkQ5Qjwvc3RSZWY6ZG9jdW1lbnRJRD4KICAgICAgICAgPC94bXBN TTpEZXJpdmVkRnJvbT4KICAgICAgICAgPHhtcE1NOkRvY3VtZW50SUQ+eG1wLmRpZDo4MTAyQjU2 NjM0QTcxMUU2QkM0NUMwOUMwMDQ0NkQ5QjwveG1wTU06RG9jdW1lbnRJRD4KICAgICAgICAgPHRp ZmY6T3JpZW50YXRpb24+MTwvdGlmZjpPcmllbnRhdGlvbj4KICAgICAgICAgPHhtcDpDcmVhdG9y VG9vbD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAxNSAoTWFjaW50b3NoKTwveG1wOkNyZWF0b3JUb29s PgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KhOqY 4wAAD0JJREFUeAHtnYl22zgSRZVYTuws02f6/7+xO1FiS4llZ3jZQZrhiBRJbAXg1Tk+lCUuwKu6 xMIS9OpwOPzYyaSAFLiowOuL7+pNKSAFegUEiAJBCswoIEBmxNFHUkCAKAakwIwCAmRGHH0kBQSI YkAKzCggQGbE0UdSYH9Ngr//+uvaLvpcChSrwH///HO27GpBZuXRh60rIEBajwDVf1YBATIrjz5s XQEB0noEqP6zCgiQWXn0YesKCJDWI0D1n1Xg6jTv3NH7/X63v73d3d/fz+2mz6RAFgWOx+Pu/PS0 O5/Pm6/v1YJ8+PixLwAFkUkBSwo4OIhRH/MC5NWrVztB4iO/jo2hwBAOYtTHvADhwoLER34dG1qB kHBQNm9AOIkgQQVZbgVCw0F9ggDCiQQJKshyKRADDuoSDBBOJkhQQZZagVhwUI+ggHBCQYIKslQK xISDOgQHhJMKElSQxVYgNhyUPwognFiQoIIslgIp4KDs0QDh5IIEFWShFUgFB+WOCggXECSoIAul QEo4KHN0QLiIIEEFma8CqeGgvEkA4UKCBBVkWxXIAQdlTQYIFxMkqCBbq0AuOChnUkC4oCBBBdlS BXLCQRmTA8JFBQkqyK4pkBsOypcFEC4sSFBBNqWABTgoWzZAuLggQQXZWAErcFCurIBQAEGCCjKn gCU4KFN2QCiEIEEFmTU48IgJQCiIIEGFds0iHHjDDCAURpCgQntmFQ48YQoQCiRIUKEdswwHXjAH CIUSJKhQv1mHAw+YBISCCRJUqNdKgAP1zQJC4QQJKtRnpcCB8qYBoYCCBBXqsZLgQHXzgFBIQYIK 5VtpcKB4EYBQUEGCCuVaiXCgdjGAUFhBggrlWalwoHRRgFBgQYIK5VjJcKBycYBQaEGCCvatdDhQ uEhAKLggQQW7VgMcqFssIBRekKCCPasFDpQtGhAqIEhQwY7VBAeqFg8IlRAkqJDfaoMDRasAhIoI ElTIZzXCgZrVAEJlBAkqpLda4UDJqgChQoIEFdJZzXCgYnWAUClBggrxrXY4ULBKQKiYIEGFeNYC HKhXLSBUTpCgQnhrBQ6UqxoQKihIUCGctQQHqlUPCJUUJKjgb63BgWJ7f9nKOIOD5OuXL7tjV+T7 +/syCm6klGvgeHl52T19/757Op93L93fc/f/Jbu9vd3d7Pe7/c3N7vbNm0u7ZH+vGUBQWpBsi7el cHz/9m33HTCenhZdiP3cvvgGSLhxvX5tp2PTFCCCZFHc/rbTEjgI8uPDw2RL8dsJJ/758ePHrges g+zN27e7d+/e9Te0id2TvW0H1WRV/rclOePYIx0u2SUFlsDBPnRbp7pRl8577T1A+fzp06/W5dr+ MT9vEhAEdd0tQXI5vK7BwR3/y+GwO0W6wXB+wAOWnNYsIIguSC6H3hI4CN5zNwCPbQ9d143y5LKm AUF0QfJ76FmCw5WMVipXS9I8IILEheGuv1PT5fzw8ePkAPl0OiVpOf4t1T+vaEmen5/Hb0f/X4D8 lLj1luRay4FMzFbFGnMsifTHDpLUJkAGircKyRI4kImp3JzGmCd1V0uAjDzeGiRL4SAwQ07ljmRf /G/qFkyAXHBNK5AshQOJvnfdKwsGpKSxpDIBMqF07ZCsgYNnEimDcsIlv95OCasA+SX7/7+oFZI1 cKAKM1uWLCWsAuSK52uDZC0cyPN8Tj+9OucWWjT+UpgAWaByLZBsgQN5zi+2AOnLlOApPtcRIKiw wEqHZCscvTSJ7tYL3JB8FwEykvz0eJzMIi0VEi84Rvq09q8AGXicfu3p22n3rUunmLLSIBEcU55c 9r4AGej07XjqB3+kVMw9sS0FklBw8LVYa5bqW4cC5Kfn+R41rYczntjOzZRYhyQUHOjxuvs6rDW7 6b7HnsIEyE+VCaghEDyxpUWZM6uQhISD+u+7xRUs2T5hiyZAOs/TelzqUtGi8NmcWYMkNBzUnbv1 jaGFFN4kXAFFgHQB8Pj4eJEBWhQC7ppZgSQGHK7ut91CClYs5RJBzQPCgHwudYGWhX2uWW5IYsJB 3d8aAYQVT1IN0Kl384DMTekiELZkH/bLBUlsOKgbQXlnYLG91Av+NQ1I33osaB2uTfsSQM5SQ5IC Dle3u7u7rGOR+7v0i8o1DciaL99cm/Z1QcQ2FSQp4XD1un//fljVZK+Zubp7l3652GYBYWyxZtma JdO+w2iJDUlqOFzdWE/3fWJIgIOFJHJYs4CsaT2cY5ZM+7p92caCJBccrm4MlFNB4uBAyxzWJCAM urd8v3rptO/QkaEhyQ2HqxuQfPjwYXJ5ILefz5bWam4JIp9zLz22OUC2BPlQzKXTvsNjQkFiBQ5X N55H/OePP3YEckhDLwbkueGgTs0B4hISfRy6dNp3eA1fSKzB4erG9C+BTGsSIgWElgnocgzIXZ2G W3tpmsPSBX5N6zFMSNx6ejftizPXmINk7Y/4WIVjWHdaE/56bfiNkO4PvZcYYJE+gp5oZMmaAoSU kqVOu+YkBvkExFqHroWkBDiGWtHd6rtc3UwXS4W+dH9T32m/ue1+XaqDY62Gw+vFft0MIFMJiVsF dtO+W7oCSyEpDY6xln2SY//zauNPyvm/mTEIwRba1k77Dq/vIJn6fZLS4RjWteTXTQBCU38pnd3X cb4zYlOQCA5fz4Q7voku1nEinT2EjIDHAHPrVKeDxA3cKdO1nyAIUW6dY5kC1bcgSxMSl8l1ea8t 077DMzlIOA9/Fub/h+Vr+XX1gPgG75LgcNO+S/ad2ocfpnGDWl7LbChQNSBbnnpvdcuabN/xNYZj DlqPqYH7+Dj9H1+BqgHZkpC4VXI37bv2+CEcdLVcd0uQrFUyzv7VAkLrsSUh0UfmtdO+YzjctQWJ UyL/tkpAmH6dWoghpuRrpn2n4HDlEyROibzbKgEJkZC41S1Lxj3X4HDXFiROiXzb6gDhLh4iIdHH JXMzZ0vhcNcXJE6JPNvqAMnZejgXTk37roXDnU+QOCXSb6sChITE4yl8ztUWt4ynfbfC4a4tSJwS abdVAUIQWrHhtK8vHK5OgsQpkW5bDSCh09lDuICx0MPDQ9DcKkESwjPLz1ENII9dIFozJgz4Zl3o 3CpBks7TVQCSIiFxq0uAZM36W0uvI0iWKuW3XxWAzE2r+skT5uhY5RMkYfwzd5biAbHcejjhp6Z9 3ec+W0Hio971Y4sH5Ghw7HFJ9vG076V9tr4nSLYqd/24ogHJkZB4XdLLewynfS/v4feuIPHTb+ro ogFJmc4+JeCa99dm+645N/sKkrWKXd+/WEBOj8fk6ezX5ZzfY0227/yZpj8VJNPabPmkSEAsJCRu EZtjlmT7bj23O84HEh5sfv361Z2q+W2RgFhISPSJnFjTvsMybYEEOHqAu4ebtNCyAhevJqUkdzq7 b+DEnPYdlm0NJA4OdzxJn3M/bur2q31bXAtC4h9drNIt5rTvUJslkIzhcMfzPjeklq0oQCwmJG4N ntjTvsNyzUEyBQfHcyN66MYjNdyQhnqseV0UIJbS2deIPLVv7Gnf4XUvQTIHhzuWPLIc3+9318+9 LQaQVP32lA7hzpwS+iEkh8Nh8XrFDNxTTCyk1H7ptYoBpFYHpZj2HQYDkPCrUM9dy7DGaEW4SbVm RQCCY2p2Tkr4+25VN427xRiPtDZoLwKQ0lJK1gZfqu7jkjHHXNlbHLSbB4QuSIwvHM0FQo7PYt8E fOFwmrQ2aDcPSOzAcY7PvWXaN9bT61BwOI24afHXgpkGhL45gdOKMe0b+plDaDicLzgvv9xVu5kF JPUUqAVHU+eQzxxiweG0+tJNFYcG2p3bytYsIKUnJG51MF2XEHfm2HBQP+Dgp+NqNpOAIHzpCYk+ QeP7m4op4HD1Y9DO9Wo1k4DwE2S1N91zAdU/99nwrMLd0VMPoGsetJsDpE9nN7SE6Fwgx/xsbSvi 4Mj1QJVWJETXMKamW85tDpCUuUlbBEt1zJppXwdH7udFD914pLaW3xQg3IFSdw9SBfyW6yyZ9rUC B/UDatJRajJTgKztVtTkiEt1Ifjnpn0tweHKTxevpl6AGUD6gWmD2aIusKa2U9O+FuFwdSD7oZae gBlAUma0OkeWsh23rJbhcJrS8tUwaDcBCIsD5Jp9cQ61vO1b15/TviXAgZaUs4ZBuwlAxndIy8Ga q2xoVAocTqMaBu3ZAen72A0lJLrgWbsl2D5/+lRc6j+tX6ws5bUabtk/KyDcEVtJZ9/inPEx6FWi lbzGVlZASEjkziirX4FSn7RnA6RvPbrvP8jaUAB/8zuSpbWC2QBpNZ29DRwu17LEzN8sgJCQSL9U 1p4CTOmXNGjPAkhNqQjthbh/jUsatCcHpKb1df1Dpd0zMGgvYY2t5IDMJd+1Gy7t1ZzBegkLYycF ZJgy0V5IqMZjBUpYYyspIEpIHIeI/ieTwnJcJAOkbz2Uzi4iLihAt5v4sGjJADlWvPKFRceWViar C2MnAUQJiaWFa/ryWh20JwFECYnpA67EK1octEcHhKemSkgsMVzzlJneBn9WLCogNJstr5Boxcml lcNS5m9UQJSQWFpo2imvlYWxowGi1sNOsJVYEuLHwsLY0QBhbptKyqTAVgUspMdHAUQJiVtDQseN Fcg9aI8CiNLZx27W/z4K5By0BweElAFL03Q+jtGxdhTItcZWcEAsJ57ZcbdKslaBXGtsBQVECYlr 3a791yhAfKXuvgcFRK3HGndr3y0KpF4YOxggjDuspixvcYSOsatAyoWxgwGihES7AVVbyXi+lmrQ HgQQWg8lJNYWhrbr0w/aE3zHyBsQaNZCDLaDqdbSpVhjyxsQJSTWGn5l1Cv2GltegNB6KJ29jECq uZQxn7R7AXI6nZSQWHPkFVK3vpsfaWFsP0C6H2uUSQELCsTK/PUCxIIwKoMUcArEGLQLEKeutlUo 0A/aA66xJUCqCAtVYqgA30QMtTC2ABkqq9fVKHD4/DnIBJIAqSYkVJGhAsxsfelaEl8TIL4K6niz Cjyfz96QCBCz7lXBQihw9hywC5AQXtA5qlVAgFTrWlUshAICJISKOke1CgiQal2rioVQQICEUFHn qFYBAVKta1WxEAoIkBAq6hzVKvDqcDhohelq3auK+SqgFsRXQR1ftQICpGr3qnK+CggQXwV1fNUK CJCq3avK+SogQHwV1PFVKyBAqnavKuergADxVVDHV63A/wCERSvjpMUolAAAAABJRU5ErkJggg==')
        : () => { } }));
  }
};
LazyImage.style = lazyImgCss;

const pesLogoCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.logo__container{width:100%;height:32px;display:flex;align-items:center;gap:8px}@media screen and (min-width: 980px){.logo__container{height:32px;margin-bottom:24px}:host(:not([dir=\"rtl\"])) .logo__container{float:left;margin-right:12px}:host([dir=\"rtl\"]) .logo__container{float:right;margin-left:12px}}@media screen and (max-width: 979px){.logo__container{margin-top:10px;margin-bottom:16px;max-height:-moz-fit-content;max-height:fit-content}}.pes__logo{width:32px;height:32px}@media screen and (max-width: 719px){.pes__logo{width:24px;height:24px}}.pes__title{font-weight:700;font-size:22px;line-height:30px;color:#3dcd58}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .pes__title{float:left}:host([dir=\"rtl\"]) .pes__title{float:right}}@media screen and (max-width: 719px){.pes__title{font-size:16px;line-height:20px}}";

const PesLogo = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.logo = undefined;
    this.title = undefined;
    this.containerClassName = undefined;
    this.logoClassName = undefined;
    this.titleClassName = undefined;
  }
  render() {
    var _a, _b;
    return (h("div", { class: classnames('logo__container', this.containerClassName) }, h("img", { src: (_a = this.logo) === null || _a === void 0 ? void 0 : _a.url, alt: (_b = this.logo) === null || _b === void 0 ? void 0 : _b.alt, class: classnames('pes__logo', this.logoClassName) }), this.title && h("h3", { class: `pes__title ${this.titleClassName}` }, this.title)));
  }
};
PesLogo.style = pesLogoCss;

const mobileFiltersCategoriesCss = ".mobile-filters-categories{color:#333333;background-color:#ffffff;border:1px solid #e7e6e6;list-style:none;margin:15px 13px 10px;padding:0}@media screen and (min-width: 980px){.mobile-filters-categories{display:none}}.mobile-filters-categories__item{margin:0;padding:0 15px}.mobile-filters-categories__button{border-bottom:1px solid #e7e6e6;display:block;font-weight:400;font-size:16px;line-height:20px;margin:0;padding:15px 0 14px;position:relative;text-transform:capitalize;width:100%}:host(:not([dir=\"rtl\"])) .mobile-filters-categories__button{text-align:left}:host([dir=\"rtl\"]) .mobile-filters-categories__button{text-align:right}.mobile-filters-categories__button::after{border-bottom:2px solid #9fa0a4;border-top-color:#9fa0a4;content:\"\";height:8px;opacity:0.7;position:absolute;top:35%;width:8px}:host(:not([dir=\"rtl\"])) .mobile-filters-categories__button::after{border-left-color:#9fa0a4;border-right:2px solid #9fa0a4;right:2px;transform:rotate(-45deg)}:host([dir=\"rtl\"]) .mobile-filters-categories__button::after{border-right-color:#9fa0a4;border-left:2px solid #9fa0a4;left:2px;transform:rotate(45deg)}";

const MobileFiltersCategories = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.selectCategory = createEvent(this, "selectCategory", 7);
    this.categories = undefined;
  }
  render() {
    var _a, _b;
    if (((_a = this.categories) === null || _a === void 0 ? void 0 : _a.length) === 0)
      return;
    return (h("ul", { class: "mobile-filters-categories" }, (_b = this.categories) === null || _b === void 0 ? void 0 : _b.map((i) => (h("li", { class: "mobile-filters-categories__item" }, h("a", { class: "mobile-filters-categories__button", onClick: () => {
        this.selectCategory.emit(i.navigationState);
      } }, h("span", null, i.label)))))));
  }
};
MobileFiltersCategories.style = mobileFiltersCategoriesCss;

const HIDE_TIMEOUT = 5000;

async function getMyProducts(host) {
  try {
    const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
    const response = await fetchers.getMyProducts({
      contextRoot,
      countryCode,
      languageCode,
    });
    if (response.lists.length === 0) {
      throw new Error('[FAVORITES] No favorites received');
    }
    return response.lists.map((productGroupShort) => (Object.assign(Object.assign({}, productGroupShort), { products: productGroupShort.products
        .map(Object.entries)
        .map(([[productId, quantity]]) => ({ productId, quantity })) })));
  }
  catch (error) {
    console.warn(error);
    return [];
  }
}
function scAddToCart(host, configurationEvent) {
  const payload = scConfigurationToPostData(configurationEvent);
  const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
  return fetchers.postMyProducts({
    contextRoot,
    countryCode,
    languageCode,
    payload,
  });
}
function addToMyProducts(host, productsParams) {
  const payload = productsParamsToPostData(productsParams);
  const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
  return fetchers.postMyProducts({
    contextRoot,
    countryCode,
    languageCode,
    payload,
  });
}
function deleteMyProducts(host, productsParams) {
  const { repositoryId, id } = productsParams;
  const idToDelete = repositoryId || (Array.isArray(id) ? id[0] : id);
  const params = { id: idToDelete };
  const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
  return fetchers.deleteMyProducts({
    contextRoot,
    countryCode,
    languageCode,
    params,
  });
}

const pesMyProductsConnectorCss = ":host{display:none}";

const PesMyProductsConnector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pesGetMyProductsSucceeded = createEvent(this, "pesGetMyProductsSucceeded", 7);
    this.promiseRequest = null;
    this.myProductsGroupsCache = null;
    this.notificationElement = null;
    this.notificationController = new NotificationBannerController(HIDE_TIMEOUT);
    this.handleGetMyProducts = debounce_1(async () => {
      this.pesGetMyProductsSucceeded.emit(await this.getMyProducts());
    }, 200);
    this.handleScSelectorAddToCart = async (event) => {
      try {
        await this.handleScAddToCart(event.detail);
      }
      catch (error) {
        console.log('Error handling SC selector add to cart:', error);
      }
    };
    this.handleScAddToCart = async (configurationEvent) => {
      const response = await scAddToCart(this.localeCode, configurationEvent);
      const { status } = response;
      this.myProductsGroupsCache = null;
      if (isAnalyticsEnabled() && status === myProductsResponseStatus.SUCCESS) {
        this.sendScAnalytics(configurationEvent, response);
      }
      return this.showBanner("ADDED_TO_CART", 'body');
    };
    this.handleButtonClick = () => {
      window.open(this.myProductsURL, '_self');
    };
    this.localeCode = undefined;
    this.myProductsURL = undefined;
    this.labels = undefined;
    this.isExternalConsumer = undefined;
    this.externalMyProducts = undefined;
    this._localeCode = undefined;
    this._myProductsURL = undefined;
    this._labels = undefined;
    this._externalMyProducts = undefined;
  }
  async handleCtaDidClick(event) {
    const { type, product, bannerContext, onFinish, inList } = event.detail;
    let request;
    let notificationType;
    if (['favorites', 'cart'].includes(type)) {
      if (type === 'favorites' && inList) {
        request = this.handleRemoveFromList(product, onFinish);
        notificationType = "REMOVED_FROM_MY_PRODUCTS";
      }
      else {
        request = this.handleAddToList(product, onFinish);
        notificationType = type === 'favorites'
          ? "ADDED_TO_MY_PRODUCTS"
          : "ADDED_TO_CART";
      }
      const response = await request;
      if ((response === null || response === void 0 ? void 0 : response.status) === myProductsResponseStatus.SUCCESS) {
        this.showBanner(notificationType, bannerContext);
      }
    }
  }
  async handleSelectorAddToCart(event) {
    await this.handleScAddToCart(event.detail);
  }
  componentWillLoad() {
    var _a, _b, _c, _d;
    this.localeCode = (_a = tryParse(this._localeCode)) !== null && _a !== void 0 ? _a : this.localeCode;
    this.myProductsURL = (_b = tryParse(this._myProductsURL)) !== null && _b !== void 0 ? _b : this.myProductsURL;
    this.labels = (_c = tryParse(this._labels)) !== null && _c !== void 0 ? _c : this.labels;
    this.externalMyProducts = (_d = tryParse(this._externalMyProducts)) !== null && _d !== void 0 ? _d : this.externalMyProducts;
  }
  connectedCallback() {
    document.addEventListener('pesGetMyProducts', this.handleGetMyProducts);
    window.addEventListener('scSelectorAddToCart', this.handleScSelectorAddToCart);
  }
  disconnectedCallback() {
    document.removeEventListener('pesGetMyProducts', this.handleGetMyProducts);
    window.removeEventListener('scSelectorAddToCart', this.handleScSelectorAddToCart);
  }
  attachListeners(el) {
    el === null || el === void 0 ? void 0 : el.addEventListener('actionDidClick', this.handleButtonClick);
  }
  async handleRemoveFromList(productData, onFinish) {
    const response = await timeLimitedRequest(deleteMyProducts)(this.localeCode, productData);
    if (typeof onFinish === 'function') {
      onFinish(response);
    }
    this.myProductsGroupsCache = null;
    return response;
  }
  async handleAddToList(productData, onFinish) {
    const response = await timeLimitedRequest(addToMyProducts)(this.localeCode, productData);
    if (typeof onFinish === 'function') {
      onFinish(response);
      this.myProductsGroupsCache = null;
    }
    return response;
  }
  sendScAnalytics(configurationEvent, response) {
    var _a, _b;
    const { productsUpdated, infoForGa } = response;
    const { products } = configurationEvent;
    const quantities = products.reduce((acc, product) => {
      const { productId, quantity } = product;
      acc[productId] = quantity;
      return acc;
    }, {});
    const mappedProducts = productsUpdated.map((id) => {
      const { description: name, brand = '', price = null } = infoForGa[id];
      return {
        id,
        brand,
        name,
        price,
        category: '',
        variant: '',
        quantity: quantities[id],
      };
    });
    const currencyCode = (_b = (_a = Object.values(infoForGa).find((product) => product.currency)) === null || _a === void 0 ? void 0 : _a.currency) !== null && _b !== void 0 ? _b : '';
    send(productSelectorAddToCartEvent, {
      currencyCode,
      distributor: '',
      products: mappedProducts,
    });
  }
  async showBanner(type, target) {
    const notificationElement = await this.notificationController.show({
      target,
      componentProps: this.getAllProps(type),
    });
    this.attachListeners(notificationElement);
  }
  getBannerContent(type) {
    switch (type) {
      case "ADDED_TO_CART":
        return {
          message: this.labels.addedToCart,
          btnMessage: this.labels.viewCart,
        };
      case "ADDED_TO_MY_PRODUCTS":
        return {
          message: this.labels.addedToMyProducts,
          btnMessage: this.labels.viewMyProducts,
          type,
        };
      case "REMOVED_FROM_MY_PRODUCTS":
        return {
          message: this.labels.removedFromMyProducts,
          type,
        };
      default:
        return {};
    }
  }
  getAllProps(type) {
    const actions = {};
    const bannerContent = this.getBannerContent(type);
    if (bannerContent === null || bannerContent === void 0 ? void 0 : bannerContent.btnMessage) {
      actions.primary = {
        label: bannerContent.btnMessage,
      };
    }
    return {
      active: true,
      status: "warning",
      actions,
      innerHTML: bannerContent.message,
    };
  }
  async getMyProducts() {
    var _a;
    if (this.isExternalConsumer && this.externalMyProducts) {
      this.myProductsGroupsCache = this.externalMyProducts || [];
      this.promiseRequest = null;
      return this.myProductsGroupsCache;
    }
    if (!this.myProductsGroupsCache && !window.isAsco) {
      this.promiseRequest = (_a = this.promiseRequest) !== null && _a !== void 0 ? _a : getMyProducts(this.localeCode);
      this.myProductsGroupsCache = await this.promiseRequest;
    }
    this.promiseRequest = null;
    return this.myProductsGroupsCache;
  }
  componentDidLoad() {
    {
      this.getMyProducts();
    }
  }
  render() {
    return h(Host, null);
  }
};
PesMyProductsConnector.style = pesMyProductsConnectorCss;

const pesNotificationBannerCss = ":host{--pes-nb-content-color:#ffffff;--pes-nb-background-color:#42b4e6;--pes-nb-close-background-color:#ffffff;--pes-nb-btn-primary-background-color:#ffffff;--pes-nb-btn-primary-color:#42b4e6;--pes-nb-btn-primary-hover:#e6e6e6;--pes-nb-btn-primary-selected:#e6e6e6;--pes-nb-btn-secondary-color:#ffffff;display:block}:host([status=warning]){--pes-nb-background-color:#ffd100;--pes-nb-content-color:#333333;--pes-nb-btn-primary-color:#333333;--pes-nb-btn-primary-background-color:#ffffff;--pes-nb-btn-secondary-color:#333333;--pes-nb-close-background-color:rgba(51, 51, 51, 0.5)}:host([status=error]){--pes-nb-background-color:#b10043;--pes-nb-content-color:#ffffff;--pes-nb-btn-primary-background-color:#ffffff;--pes-nb-btn-primary-color:#b10043;--pes-nb-btn-secondary-color:#ffffff}.notification-banner{display:flex;flex:1;color:var(--pes-nb-content-color);background-color:var(--pes-nb-background-color)}.notification-banner__inner{box-sizing:border-box;position:relative;width:100%;max-width:1200px;margin:0 auto;display:flex}.notification-banner__inner *,.notification-banner__inner *::before,.notification-banner__inner *::after{box-sizing:inherit}@media screen and (min-width: 980px){.notification-banner__inner{padding:20px 10px}}@media screen and (max-width: 979px){.notification-banner__inner{padding:20px}}.notification-banner__content{display:flex;width:100%}@media screen and (min-width: 980px){.notification-banner__content{align-items:center;max-width:1130px}}@media screen and (max-width: 979px){.notification-banner__content{flex-direction:column;max-width:100%}}.notification-banner__content-group{display:flex;max-width:680px}@media screen and (max-width: 719px){.notification-banner__content-group{max-width:calc(100% - 40px)}}.notification-banner__actions{display:flex;flex-wrap:nowrap}@media screen and (min-width: 980px){.notification-banner__actions{padding:0 40px}:host(:not([dir=\"rtl\"])) .notification-banner__actions{margin-left:auto}:host([dir=\"rtl\"]) .notification-banner__actions{margin-right:auto}}@media screen and (max-width: 979px){.notification-banner__actions{margin-top:20px}}@media screen and (max-width: 719px){.notification-banner__actions{flex-direction:column;flex-wrap:wrap}}.notification-banner__text-content{font-size:0.875rem;line-height:1.25rem;display:flex;flex-direction:column;align-self:center}.notification-banner__title{font-weight:bold}:host(:not([dir=\"rtl\"])) .notification-banner__icon{margin-right:14px}:host([dir=\"rtl\"]) .notification-banner__icon{margin-left:14px}@media screen and (max-width: 719px){:host(:not([dir=\"rtl\"])) .notification-banner__icon{margin-right:8px}:host([dir=\"rtl\"]) .notification-banner__icon{margin-left:8px}}.notification-banner__icon--position_top{align-self:flex-start}.notification-banner__icon--position_center{align-self:center}.notification-banner__slot-wrapper{display:block}::slotted(a){color:inherit;text-decoration:underline}::slotted(a:hover){text-decoration:none}.notification-banner__close{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;position:absolute;background-color:var(--pes-nb-close-background-color);color:var(--pes-nb-background-color);display:flex;justify-content:center;align-items:center;align-self:center;flex:0 0 20px;width:20px;height:20px;font-size:18px;border-radius:50%}:host(:not([dir=\"rtl\"])) .notification-banner__close{margin-left:auto}:host([dir=\"rtl\"]) .notification-banner__close{margin-right:auto}@media screen and (min-width: 980px){.notification-banner__close{bottom:50%;transform:translateY(50%)}:host(:not([dir=\"rtl\"])) .notification-banner__close{right:10px}:host([dir=\"rtl\"]) .notification-banner__close{left:10px}}@media screen and (max-width: 979px){.notification-banner__close{top:20px}:host(:not([dir=\"rtl\"])) .notification-banner__close{right:20px}:host([dir=\"rtl\"]) .notification-banner__close{left:20px}}@media screen and (max-width: 719px){.notification-banner__button{width:100%}}@media screen and (min-width: 720px){:host(:not([dir=\"rtl\"])) .notification-banner__button+.notification-banner__button{margin-left:20px}:host([dir=\"rtl\"]) .notification-banner__button+.notification-banner__button{margin-right:20px}}@media screen and (max-width: 719px){.notification-banner__button+.notification-banner__button{margin-top:14px}}";

const NotificationBanner = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.actionDidClick = createEvent(this, "actionDidClick", 7);
    this.closeDidClick = createEvent(this, "closeDidClick", 7);
    this.didClose = createEvent(this, "didClose", 7);
    this.didOpen = createEvent(this, "didOpen", 7);
    this.handleTransitionEnd = () => {
      if (this.active) {
        this.didOpen.emit();
      }
      else {
        this.didClose.emit();
      }
    };
    this.handleButtonClick = (detail) => () => {
      this.actionDidClick.emit(detail);
    };
    this.handleClose = () => {
      this.closeDidClick.emit();
    };
    this.active = false;
    this.status = "informational";
    this.heading = undefined;
    this.icon = undefined;
    this.iconSize = undefined;
    this.iconPosition = 'top';
    this.hideCloseIcon = undefined;
    this.actions = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderButton(button, type) {
    return (h("qds-button", { size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.STANDARD, class: classnames('notification-banner__button', `notification-banner__button--${type}`), onClick: this.handleButtonClick(button.eventDetail), text: button.label }));
  }
  renderActions() {
    var _a, _b;
    if (isEmpty_1(this.actions)) {
      return null;
    }
    return (h("div", { class: "notification-banner__actions" }, ((_a = this.actions) === null || _a === void 0 ? void 0 : _a.primary) && this.renderButton(this.actions.primary, 'primary'), ((_b = this.actions) === null || _b === void 0 ? void 0 : _b.secondary) && this.renderButton(this.actions.secondary, 'secondary')));
  }
  renderIcon() {
    return (this.icon && (h("pes-icon", { class: classnames('notification-banner__icon', {
        [`notification-banner__icon--position_${this.iconPosition}`]: !!this.iconPosition,
      }), size: this.iconSize }, this.icon)));
  }
  render() {
    return (h("pes-slide-down-container", { onTransitionEnd: this.handleTransitionEnd, active: this.active }, h("div", { class: classnames('notification-banner', `notification-banner--${this.status}`) }, h("div", { class: "notification-banner__inner" }, h("div", { class: "notification-banner__content" }, h("div", { class: "notification-banner__content-group" }, this.renderIcon(), h("div", { class: "notification-banner__text-content" }, this.heading && h("div", { class: "notification-banner__title" }, this.heading), h("div", { class: "notification-banner__slot-wrapper" }, h("slot", null)))), this.renderActions()), !this.hideCloseIcon && (h("button", { class: "notification-banner__close", onClick: this.handleClose }, h("pes-icon", { size: pesIconSizes.NANO, class: "notification-banner__close-icon" }, "action_close")))))));
  }
  get el() { return getElement(this); }
};
NotificationBanner.style = pesNotificationBannerCss;

const pesNotificationSubtleCss = "@charset \"UTF-8\";.notification{background-color:#ffede5;color:#333333;font-size:14px;line-height:20px;padding:16px;transition:all 0.25s ease-in}@media screen and (min-width: 980px){.notification{padding:20px 24px}}.notification a{background:none;color:#42b4e6;border:none;padding:0;cursor:pointer;outline:inherit;font-family:inherit;text-decoration:none}.notification a:hover{text-decoration:underline}.notification--error{--pes-nb-background-color:#ffede5;--pes-nb-close-background-color:#333333;--pes-nb-content-color:#333333;--pes-nb-close-background-color:#9fa0a4}.notification--error-padding{padding:16px 0}.notification--one-string-error{--pes-nb-background-color:#ffede5;--pes-nb-close-background-color:#333333;--pes-nb-content-color:#333333;--pes-nb-close-background-color:#9fa0a4}.notification--warning{--pes-nb-background-color:#ffd100;--pes-nb-close-background-color:#333333;--pes-nb-content-color:#333333;--pes-nb-close-background-color:#9fa0a4}.notification--warning a{color:#333333;text-decoration:underline}.notification--informational{--pes-nb-background-color:#42b4e6;--pes-nb-close-background-color:#ffffff;--pes-nb-content-color:#ffffff;--pes-nb-close-background-color:#ffffff}.notification--informational a{color:#ffffff;text-decoration:underline}.notification--hidden{height:0;padding-top:0;padding-bottom:0;transform:translateY(-100%);transition:all 0.25s ease-out}.notification__head-row{display:flex;align-items:center}.notification__inner{width:100%;margin:auto}@media screen and (min-width: 980px){.notification__inner{min-width:980px;max-width:1180px}}.notification__label-wrapper{flex-grow:1;display:flex;align-items:center}:host(:not([dir=\"rtl\"])) .notification__label{margin-right:12px}:host([dir=\"rtl\"]) .notification__label{margin-left:12px}.notification__reload{color:#42b4e6;text-decoration:none}.notification__reload-icon{font-size:18px}:host(:not([dir=\"rtl\"])) .notification__reload-icon{margin-right:6px}:host([dir=\"rtl\"]) .notification__reload-icon{margin-left:6px}.notification__list{padding:0;list-style-type:none}:host(:not([dir=\"rtl\"])) .notification__list{margin:0 0 0 36px}:host([dir=\"rtl\"]) .notification__list{margin:0 36px 0 0}.notification__list-item{display:flex;margin-top:8px;align-items:center}.notification__list-item::before{content:\"•\";color:#626469}:host(:not([dir=\"rtl\"])) .notification__list-item::before{margin-right:8px}:host([dir=\"rtl\"]) .notification__list-item::before{margin-left:8px}.notification__product{display:flex;align-items:center}.notification__counter{padding:1px 8px;background-color:#ffffff;border-radius:12px;font-size:12px;line-height:18px}:host(:not([dir=\"rtl\"])) .notification__counter{margin-right:8px}:host([dir=\"rtl\"]) .notification__counter{margin-left:8px}.notification__link{background:none;color:#42b4e6;border:none;padding:0;cursor:pointer;outline:inherit;font-family:inherit;text-decoration:none}:host(:not([dir=\"rtl\"])) .notification__link{margin-right:8px}:host([dir=\"rtl\"]) .notification__link{margin-left:8px}.notification__link:hover{text-decoration:underline}:host(:not([dir=\"rtl\"])) .notification__product-title{margin-right:8px}:host([dir=\"rtl\"]) .notification__product-title{margin-left:8px}.notification__plus{color:#626469}:host(:not([dir=\"rtl\"])) .notification__plus{margin-right:8px}:host([dir=\"rtl\"]) .notification__plus{margin-left:8px}.warning-icon-wrapper{color:#b10043}:host(:not([dir=\"rtl\"])) .warning-icon-wrapper{margin-right:14px}:host([dir=\"rtl\"]) .warning-icon-wrapper{margin-left:14px}.close-button__wrapper{border-radius:50%;width:18px;height:18px;border:none;background-color:#9fa0a4;cursor:pointer;display:flex;justify-content:center;align-items:center;position:relative;z-index:2}:host(:not([dir=\"rtl\"])) .close-button__wrapper{margin-left:16px}:host([dir=\"rtl\"]) .close-button__wrapper{margin-right:16px}.close-button__icon{font-size:11px;font-weight:bold}";

const PesNotificationSubtle = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.closeClick = createEvent(this, "closeClick", 7);
    this.timeoutId = null;
    this.bannerRef = null;
    this.timeout = 5000;
    this.languageCode = 'en';
    this.countryCode = 'US';
    this.isShown = false;
    this.buttonText = undefined;
    this.pageType = undefined;
    this.status = EStatus.ERROR;
    this.content = '';
    this.type = ENotificationType.WITH_HTML;
    this.productsList = undefined;
    this.eventDetails = undefined;
  }
  initNotificationHandler(event) {
    this.isShown = true;
    const { status, content, type, productsList, countryCode, languageCode, buttonText, pageType, } = event.detail;
    this.status = status;
    this.content = content;
    this.type = type !== null && type !== void 0 ? type : this.type;
    this.productsList = productsList !== null && productsList !== void 0 ? productsList : this.productsList;
    this.countryCode = countryCode !== null && countryCode !== void 0 ? countryCode : this.countryCode;
    this.languageCode = languageCode !== null && languageCode !== void 0 ? languageCode : this.languageCode;
    this.buttonText = buttonText !== null && buttonText !== void 0 ? buttonText : this.buttonText;
    this.pageType = pageType !== null && pageType !== void 0 ? pageType : this.pageType;
  }
  closeDidClickHandler() {
    this.isShown = false;
  }
  actionDidClickHandler() {
    const urlBuilderPayload = {
      languageCode: this.languageCode,
      countryCode: this.countryCode,
      isPublic: isPublicEnvironment(),
    };
    const baseComparatorUrl = getBaseNavigationUrl(Object.assign({ path: 'product-comparator' }, urlBuilderPayload));
    const baseProductCartUrl = getBaseNavigationUrl(Object.assign({ path: 'product-cart' }, urlBuilderPayload));
    switch (this.pageType) {
      case ENotificationPageType.COMPARATOR: {
        window.open(getComparatorUrl(baseComparatorUrl), '_self');
        break;
      }
      case ENotificationPageType.PRODUCT_CART: {
        window.open(baseProductCartUrl, '_self');
        break;
      }
    }
  }
  activeDidChange() {
    if (this.isShown && this.status === EStatus.WARNING) {
      this.startTimeoutClose();
    }
    else {
      this.killTimeout();
    }
  }
  startTimeoutClose() {
    if (this.timeout > 0) {
      this.timeoutId = window.setTimeout(() => {
        this.isShown = false;
      }, this.timeout);
    }
  }
  killTimeout() {
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }
  componentDidLoad() {
    this.activeDidChange();
  }
  renderProduct(product, index = 0, length = 0) {
    return (h("span", { class: "notification__product" }, product && product.amount && h("span", { class: "notification__counter" }, `${product.amount}x`), (product === null || product === void 0 ? void 0 : product.title) && product.url && (h("qds-standalone-link", { size: EQdsButtonSize.SMALL, importance: EQdsButtonImportance.STANDARD, href: product.url, class: "notification__link" }, product.title)), (product === null || product === void 0 ? void 0 : product.title) && !product.url && h("span", { class: "notification__product-title" }, product.title), length > 1 && index < length - 1 && h("span", { class: "notification__plus" }, "+")));
  }
  renderNotificationItem(item) {
    return (h("li", { class: "notification__list-item" }, item.products.map((product, index) => this.renderProduct(product, index, item.products.length))));
  }
  render() {
    return (h("pes-notification-banner", { status: this.status.toLowerCase(), active: this.isShown, class: classnames(this.status === EStatus.ERROR && Array.isArray(this.productsList) && 'notification--error', this.status === EStatus.ERROR && !Array.isArray(this.productsList) && 'notification--one-string-error', this.status === EStatus.WARNING && 'notification--warning', this.status === EStatus.INFORMATIONAL && 'notification--informational'), actions: this.buttonText && this.pageType && {
        primary: {
          label: this.buttonText,
        },
      } }, this.isShown && (h("div", { class: classnames('notification__inner', EStatus.ERROR && Array.isArray(this.productsList) && 'notification--error-padding') }, h("div", { class: "notification__head-row" }, h("span", { class: "warning-icon-wrapper" }, this.status === EStatus.ERROR && (h("se-icon", { size: "micro", class: "warning-icon" }, "general_danger_full"))), h("div", { class: "notification__label-wrapper" }, (this.type === ENotificationType.WITH_HTML
      || this.type === ENotificationType.PRODUCTS_LIST)
      && (h("div", { class: "notification__label", innerHTML: this.content })))), this.type === ENotificationType.PRODUCTS_LIST && Array.isArray(this.productsList) && (h("ul", { class: "notification__list" }, this.productsList.map((item) => this.renderNotificationItem(item))))))));
  }
  static get watchers() { return {
    "isShown": ["activeDidChange"],
    "status": ["activeDidChange"]
  }; }
};
PesNotificationSubtle.style = pesNotificationSubtleCss;

const pesPartnerPriceCss = ".pes-partner-price-label{margin-top:5px;margin-bottom:0;color:#626469}.product-card.list-view .pes-partner-price-label{margin-top:0;margin-bottom:10px;line-height:17px}@media screen and (min-width: 980px){.pes-partner-price-label{font-size:12px;line-height:15px}.product-card.list-view .pes-partner-price-label{line-height:17px}}.pes-partner-price-value{display:block;margin-top:5px;font-size:22px;line-height:30px;color:#333333}.pes-partner-price-value--mobile{font-size:1.125rem;line-height:32px}.product-card.list-view .pes-partner-price-value{margin-top:0;font-size:20px;line-height:1}@media screen and (min-width: 980px){.pes-partner-price-value{font-size:18px}.product-card.list-view .pes-partner-price-value{font-size:20px}}";

const PartnerPrice = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.price = undefined;
    this.priceLabel = undefined;
    this.isMobile = false;
  }
  render() {
    return (h(Host, { class: "pes-partner-price" }, this.priceLabel && h("p", { class: "pes-partner-price-label" }, this.priceLabel), h("span", { class: classnames('pes-partner-price-value', this.isMobile && 'pes-partner-price-value--mobile') }, this.price)));
  }
};
PartnerPrice.style = pesPartnerPriceCss;

const productCardIdCss = ":host{display:block}.card{display:flex;flex-direction:column;width:100%;text-decoration:none;color:#333333;padding:10px;box-sizing:border-box;background:var(--pes-product-card-bgcolor, inherit)}@media screen and (min-width: 980px){.card{flex-direction:row;padding:16px}}.card__img{width:150px;height:100%}@media screen and (min-width: 980px){.card__img{width:70px;flex-shrink:0}}.card__info{display:flex;flex-direction:column;overflow:hidden}@media screen and (min-width: 980px){.card__info{flex:1 1}:host(:not([dir=\"rtl\"])) .card__info{margin-left:10px}:host([dir=\"rtl\"]) .card__info{margin-right:10px}}.card__name{color:#626469;font-size:10px}.card__description{margin:7px 0;font-size:14px}@media screen and (min-width: 980px){.card__description{margin:8px 0}}";

const ProductCardId = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onClickHandler = (event) => {
      var _a;
      (_a = this.onRecentlyViewedItemClick) === null || _a === void 0 ? void 0 : _a.call(this, {
        event,
        id: this.name,
        name: this.name,
        url: this.productUrl,
      });
      if (isAppRoutingEnabled()) {
        navigateWithRouter(this.route, event.currentTarget);
      }
    };
    this.name = undefined;
    this.productUrl = undefined;
    this.description = undefined;
    this.imageUrl = undefined;
    this.imageTitle = undefined;
    this.onRecentlyViewedItemClick = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.productUrl);
      this.route = new PesRoute({ page: pageType, pageId });
      this.productUrl = this.route.url;
    }
  }
  render() {
    return (h("a", { href: this.productUrl, class: "card", onClick: this.onClickHandler }, h("pes-lazy-img", { class: "card__img", src: this.imageUrl, alt: this.imageTitle }), h("section", { class: "card__info" }, h("span", { class: "card__name" }, this.name), h("p", { class: "card__description" }, this.description ? h("pes-ellipsis", { maxHeight: "50px", content: this.description }) : ''))));
  }
  get el() { return getElement(this); }
};
ProductCardId.style = productCardIdCss;

const productCardIdSoftwareCss = ":host{display:block}.card{display:flex;flex-direction:column;width:100%;text-decoration:none;color:#333333;padding:10px;box-sizing:border-box;background:var(--pes-product-card-bgcolor, inherit)}@media screen and (min-width: 980px){.card{flex-direction:row;padding:16px}}:host(.mode--desktop-only) .card{flex-direction:row;padding:16px}.card__img{width:150px;height:100%}@media screen and (min-width: 980px){.card__img{width:70px;flex-shrink:0}}:host(.mode--desktop-only) .card__img{width:70px;flex-shrink:0}.card__info{display:flex;flex-direction:column;overflow:hidden}@media screen and (min-width: 980px){.card__info{flex:1 1}:host(:not([dir=\"rtl\"])) .card__info{margin-left:10px}:host([dir=\"rtl\"]) .card__info{margin-right:10px}}:host(.mode--desktop-only) .card__info{flex:1 1}:host(:not([dir=\"rtl\"]).mode--desktop-only) .card__info{margin-left:10px}:host([dir=\"rtl\"].mode--desktop-only) .card__info{margin-right:10px}.card__name{color:#626469;font-size:10px}.card__description{margin:7px 0;font-size:14px}@media screen and (min-width: 980px){.card__description{margin:8px 0}}:host(.mode--desktop-only) .card__description{margin:8px 0}.card__version{margin:0;font-size:12px;color:#626469}";

const ProductCardIdSoftware = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onClickHandler = (event) => {
      var _a;
      (_a = this.onRecentlyViewedItemClick) === null || _a === void 0 ? void 0 : _a.call(this, {
        event,
        id: this.name,
        name: this.name,
        url: this.productUrl,
      });
      if (!isAppRoutingEnabled())
        return;
      navigateWithRouter(this.route, event.currentTarget);
    };
    this.name = undefined;
    this.productUrl = undefined;
    this.description = undefined;
    this.imageUrl = undefined;
    this.imageTitle = undefined;
    this.version = undefined;
    this.versionLabel = undefined;
    this.noMobileView = false;
    this.onRecentlyViewedItemClick = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    if (!isAppRoutingEnabled())
      return;
    const { pageType, pageId } = parseCommonURLToRouterParts(this.productUrl);
    this.route = new PesRoute({ page: pageType, pageId });
    this.productUrl = this.route.url;
  }
  render() {
    return (h(Host, { class: classnames({ 'mode--desktop-only': this.noMobileView }) }, h("a", { href: this.productUrl, class: "card", onClick: this.onClickHandler }, h("pes-lazy-img", { class: "card__img", src: this.imageUrl, alt: this.imageTitle }), h("div", { class: "card__info" }, h("span", { class: "card__name" }, this.name), h("p", { class: "card__description" }, this.description ? h("pes-ellipsis", { maxHeight: "50px", content: this.description }) : ''), this.version && (h("p", { class: "card__version" }, this.versionLabel, " ", this.version))))));
  }
  get el() { return getElement(this); }
};
ProductCardIdSoftware.style = productCardIdSoftwareCss;

const ProductInfoChatEvent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.dispatchChatEvent = () => {
      if (document.getElementById('chatHandler')) {
        this.sendProductInfo();
        clearInterval(this.chatInterval);
      }
    };
    this.productCategory = undefined;
    this.productSubCategory = undefined;
    this.productRange = undefined;
    this.productName = undefined;
    this.sendProductInfoUsingInterval = false;
    this.intervalInMs = 500;
  }
  sendProductInfo() {
    document.getElementById('chatHandler').dispatchEvent(new CustomEvent('addProductInfo', {
      detail: {
        productCategory: this.productCategory,
        productSubCategory: this.productSubCategory,
        productRange: this.productRange,
        productName: this.productName,
      },
    }));
  }
  connectedCallback() {
    if (this.sendProductInfoUsingInterval)
      return;
    if (sessionStorage.getItem('embedded_chat_loaded')) {
      this.sendProductInfo();
    }
    else {
      document.addEventListener('chatLoaded', this.sendProductInfo);
    }
  }
  disconnectedCallback() {
    window.removeEventListener('chatLoaded', this.sendProductInfo);
  }
  componentDidLoad() {
    if (this.sendProductInfoUsingInterval) {
      this.chatInterval = setInterval(this.dispatchChatEvent, this.intervalInMs);
    }
  }
};

const pesProductPriceCss = ".price{margin:0;font-size:1.125rem;line-height:30px;display:inline-flex;color:#333333}@media screen and (max-width: 979px){.price{font-size:1rem;font-style:normal;font-weight:700;line-height:20px}}.price--mobile{font-size:1.125rem}@media screen and (min-width: 980px){.product-card.grid-view .price{font-size:18px}.product-card.list-view .price{font-size:20px}}:host(:not([dir=\"rtl\"])) .currency{margin-left:6px;margin-right:9px}:host([dir=\"rtl\"]) .currency{margin-right:6px;margin-left:9px}";

const ProductPrice = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.price = undefined;
    this.currency = undefined;
    this.info = undefined;
    this.isMobile = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    var _a;
    return (h("p", { class: classnames('price', this.isMobile && 'price--mobile') }, h("span", null, this.price), h("span", { class: "currency" }, this.currency), ((_a = this.info) === null || _a === void 0 ? void 0 : _a.weeePrices) && !isEmpty(this.info.weeePrices) && h("slot", { name: "modal-tooltip" })));
  }
  get el() { return getElement(this); }
};
ProductPrice.style = pesProductPriceCss;

const productSelectorCss = ".product-selector-link{cursor:pointer;display:flex;align-items:center;font-weight:400;font-size:14px;color:#42b4e6;padding-top:0;margin-top:15px}:host(:not([dir=\"rtl\"])) .product-selector-link{padding-left:75px}:host([dir=\"rtl\"]) .product-selector-link{padding-right:75px}.product-selector-link pes-icon{position:relative}.product-selector-link pes-icon:hover{text-decoration:none}@media screen and (min-width: 980px){.product-selector-link pes-icon{text-decoration:none}}@media screen and (min-width: 980px){.product-selector-link{margin-top:10px}:host(:not([dir=\"rtl\"])) .product-selector-link{padding-left:0;margin-left:0}:host([dir=\"rtl\"]) .product-selector-link{padding-right:0;margin-right:0}}.product-selector-btn{box-sizing:border-box;width:100%;margin-top:16px;background-color:#42b4e6;border:none;padding:10px 20px;color:#ffffff;font-size:16px;line-height:20px;outline:none;cursor:pointer;font-weight:400}.product-selector-btn *,.product-selector-btn *::before,.product-selector-btn *::after{box-sizing:inherit}:host(:not([dir=\"rtl\"])) .product-selector-btn:hover{background:linear-gradient(180deg, #55d1fe, #42b4e6)}:host([dir=\"rtl\"]) .product-selector-btn:hover{background:linear-gradient(-180deg, #55d1fe, #42b4e6)}.product-selector-btn:active{background:#3a738c}@media screen and (min-width: 980px){.product-selector-btn{width:auto}}:host(:not([dir=\"rtl\"]).sub) .product-selector-link{padding-left:0}:host([dir=\"rtl\"].sub) .product-selector-link{padding-right:0}";

const ProductSelector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.openingProductSelector = createEvent(this, "openingProductSelector", 7);
    this.config = undefined;
    this.renderFunction = undefined;
    this.selector = undefined;
  }
  openPesProductSelector(config) {
    if (this.selector) {
      this.openingProductSelector.emit(config);
      this.selector.open(config);
    }
    else {
      console.error("Selector wasn't inited");
    }
  }
  componentWillLoad() {
    if (this.config) {
      const productSelector = switchProductSelector(this.config);
      if (productSelector) {
        productSelector.then((selector) => {
          this.selector = selector;
        });
      }
    }
  }
  render() {
    if (isEmpty(this.config)) {
      return null;
    }
    return this.renderFunction(this.selector);
  }
};
ProductSelector.style = productSelectorCss;

const productsCarouselCss = ":host{display:block}*{box-sizing:border-box}.header{color:#3dcd58;font-size:16px;margin:20px 0;font-weight:bold;line-height:1.5625rem}@media screen and (min-width: 980px){.header{font-size:28px;margin:40px auto 20px;max-width:1200px;padding:0 10px}}.header--crossSellLife{color:#b10043}.content{max-width:1200px;margin:0 -16px}@media screen and (min-width: 980px){.content{padding-bottom:45px}}@media screen and (min-width: 1230px){.content{margin:0 auto}}.collapsible-container{background-color:#f7f7f7}.product__white{background-color:white}:host(:not([dir=\"rtl\"])) .product{margin-right:10px}:host([dir=\"rtl\"]) .product{margin-left:10px}@media screen and (max-width: 719px){.product{--se-carousel-item-width:calc(\n        (100% - 10px) / 2\n      )}}@media screen and (min-width: 720px) and (max-width: 980px){.product{--se-carousel-item-width:calc(\n        (100% - 20px) / 3\n      )}}@media screen and (min-width: 980px){.product{--se-carousel-item-width:calc(\n        (100% - 60px) / 4\n      )}}@media screen and (max-width: 1229px){:host(:not([dir=\"rtl\"])) .product:first-child{padding-left:16px}:host([dir=\"rtl\"]) .product:first-child{padding-right:16px}:host(:not([dir=\"rtl\"])) .product:last-child{padding-right:16px}:host([dir=\"rtl\"]) .product:last-child{padding-left:16px}}:host(:not([dir=\"rtl\"])) .product:last-child{margin-right:0}:host([dir=\"rtl\"]) .product:last-child{margin-left:0}@media screen and (min-width: 980px){.product{height:140px}:host(:not([dir=\"rtl\"])) .product{margin-right:20px}:host([dir=\"rtl\"]) .product{margin-left:20px}}";

const ProductsCarousel = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.setTabActive = createEvent(this, "setTabActive", 7);
    this.ref = null;
    this.screenSizeHandler = () => {
      this.arrowsOverlay = !this.mql.matches;
    };
    this.onRecentlyViewedItemClick = async ({ event, id, name, url }) => {
      event.preventDefault();
      const { consumer, storageName } = getConsumerSpecificData(isPBS(), this.hostWithLocale);
      const currentPageStorageKey = `${this.pageType}/${this.pageId}`;
      indexDBBreadcrumbs.setChannel(consumer);
      try {
        const currentBreadcrumbs = await indexDBBreadcrumbs.getValidatedBreadcrumbs({
          storageName,
          key: currentPageStorageKey,
        });
        const breadcrumbsToStore = this.pageType === PRODUCT ? [] : [...currentBreadcrumbs];
        await storeBreadcrumbs({
          url,
          id,
          name,
          breadcrumbs: breadcrumbsToStore,
          storageName,
          pageName: PageNames.PRODUCT,
        });
      }
      catch (e) {
        console.error(`[PES]:${this.pageType} page breadcrumbs can not be fetched from ${storageName} storage`, e);
      }
    };
    this.sectionTitle = undefined;
    this._sectionTitle = undefined;
    this.data = undefined;
    this._data = undefined;
    this.versionLabel = undefined;
    this._versionLabel = undefined;
    this.relationType = undefined;
    this._relationType = undefined;
    this.isBackgroundGrey = false;
    this.pageId = undefined;
    this.pageType = undefined;
    this.hostWithLocale = undefined;
    this.arrowsOverlay = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  setupTabbar() {
    const tabtype = getStickyBarMapping(this.relationType);
    if (!tabtype || !this.sectionTitle)
      return;
    setStickyBarTab(tabtype, [this.sectionTitle]);
    this.observe();
  }
  handleTabClicked(event) {
    if (this.ref && event.detail.title === this.sectionTitle) {
      scrollToComponent(this.ref);
    }
  }
  observe() {
    observeIntersectionWithHeader(this.ref, (entries) => {
      var _a;
      if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
        const tabtype = getStickyBarMapping(this.relationType);
        setTabActive({ type: tabtype, title: this.sectionTitle });
        this.setTabActive.emit();
      }
    });
  }
  componentWillLoad() {
    var _a, _b, _c, _d;
    this.sectionTitle = (_a = tryParse(this._sectionTitle)) !== null && _a !== void 0 ? _a : this.sectionTitle;
    this.data = (_b = tryParse(this._data)) !== null && _b !== void 0 ? _b : this.data;
    this.versionLabel = (_c = tryParse(this._versionLabel)) !== null && _c !== void 0 ? _c : this.versionLabel;
    this.relationType = (_d = tryParse(this._relationType)) !== null && _d !== void 0 ? _d : this.relationType;
    if (!this.relationType)
      return;
    const relationTypeKey = this.relationType;
    store.dispatch(setLinearProductData({ [relationTypeKey]: {
        sectionTitle: this.sectionTitle,
        data: this.data,
        versionLabel: this.versionLabel,
        relationType: this.relationType,
      } }));
    this.unsubscribe = store.subscribe(() => {
      const { data, activeProductTab, lastActionType } = store.getState().product;
      if (lastActionType !== ACTION_TYPES.SET_ACTIVE_PRODUCT_TAB)
        return;
      if (!data[activeProductTab][relationTypeKey])
        return;
      const { sectionTitle, data: carouselData, versionLabel, relationType, } = data[activeProductTab][relationTypeKey];
      this.data = carouselData;
      this.sectionTitle = sectionTitle;
      this.versionLabel = versionLabel;
      this.relationType = relationType;
      if (!(carouselData === null || carouselData === void 0 ? void 0 : carouselData.length))
        return;
      this.setupTabbar();
    });
  }
  componentDidLoad() {
    const screenSize = DESKTOP_MAX_CONTENT_WIDTH + 100;
    this.mql = window.matchMedia(`screen and (min-width: ${screenSize}px)`);
    this.arrowsOverlay = !this.mql.matches;
    {
      this.mql.addListener(this.screenSizeHandler);
    }
    this.setupTabbar();
  }
  disconnectedCallback() {
    var _a;
    this.mql.removeListener(this.screenSizeHandler);
    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    var _a;
    if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.length)) {
      return null;
    }
    const onRecentlyViewedItemClick = isIndexDBEnabled() && this.onRecentlyViewedItemClick;
    return (h("pes-collapsible-container", { class: this.isBackgroundGrey && 'collapsible-container', ref: (el) => (this.ref = el) }, h("h2", { slot: "header", class: Object.assign({ header: true }, (this.relationType && { [`header--${this.relationType}`]: true })) }, this.sectionTitle), h("div", { class: "content" }, h("se-carousel", { "item-min-width": 0, hintWidth: 0, arrowsOverlay: this.arrowsOverlay, pagination: true }, this.data.map((product) => (h("se-carousel-item", { class: "product" }, h("div", { class: {
        product__card: true,
        product__white: this.isBackgroundGrey,
      } }, product.softwareType ? (h("pes-product-card-id-software", Object.assign({}, product, { versionLabel: this.versionLabel, key: product.name, onRecentlyViewedItemClick: onRecentlyViewedItemClick }))) : (h("pes-product-card-id", Object.assign({}, product, { key: product.name, onRecentlyViewedItemClick: onRecentlyViewedItemClick })))))))))));
  }
  get el() { return getElement(this); }
};
ProductsCarousel.style = productsCarouselCss;

const productsPaginationCss = "@media screen and (max-width: 719px){:host{padding:0 16px}}.products-pagination__desktop{width:100%;text-align:center;margin-top:36px}.products-pagination__load-prev-btn{display:block;width:100%;margin-bottom:20px}.products-pagination__load-more-btn{display:block;width:100%;margin-top:20px}.products-pagination__total-count{color:#626469;font-size:14px;line-height:20px;margin-bottom:12px}";

const ProductsPagination = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.scrollToProduct = createEvent(this, "scrollToProduct", 7);
    this.pageSelected = createEvent(this, "pageSelected", 7);
    this.resizeWindow = () => {
      if (isMobile())
        this.updateLoadedRecNum();
    };
    this.debouncedHandleResize = debounce_1(this.resizeWindow, DEBOUNCED_HANDLER_DELAY);
    this.updateLoadedRecNum = () => {
      if (this.firstLoadedRecNumSaved > this.firstLoadedRecNum) {
        this.firstLoadedRecNumSaved = this.firstLoadedRecNum;
      }
      if (this.lastLoadedRecNumSaved < this.lastLoadedRecNum) {
        this.lastLoadedRecNumSaved = this.lastLoadedRecNum;
      }
    };
    this.loadPrevious = () => {
      const previousPageNumber = Math.floor(this.firstLoadedRecNum / this.productsPerPage);
      if (isAnalyticsEnabled()) {
        send(paginationClickEvent, { articleTitle: previousPageNumber });
      }
      this.pageSelected.emit(previousPageNumber);
      this.scrollToProduct.emit(this.productsPerPage);
    };
    this.loadMore = () => {
      const nextPageNumber = Math.floor(this.lastLoadedRecNum / this.productsPerPage) + 1;
      if (isAnalyticsEnabled()) {
        send(paginationClickEvent, { articleTitle: nextPageNumber });
      }
      this.pageSelected.emit(nextPageNumber);
      this.scrollToProduct.emit(this.lastLoadedRecNum - this.firstLoadedRecNum + 1);
    };
    this.onPaginationChange = (event) => {
      const { value: pageNumber, perPage: pageNoParam } = event.detail;
      if (isAnalyticsEnabled()) {
        send(paginationClickEvent, {
          articleTitle: pageNumber,
          pageNoParam: pageNumber * pageNoParam - pageNoParam,
        });
      }
      this.pageSelected.emit(pageNumber);
      scrollToTop(this.el);
    };
    this.loadMoreLabel = undefined;
    this.loadPreviousLabel = undefined;
    this.previousLabel = undefined;
    this.nextLabel = undefined;
    this.labelValue = undefined;
    this.firstLoadedRecNum = undefined;
    this.lastLoadedRecNum = undefined;
    this.showMobilePagination = undefined;
    this.showDesktopPagination = undefined;
    this.totalNumRecs = undefined;
    this.productsPerPage = undefined;
    this.selectedPage = undefined;
    this.productsCountLabel = undefined;
    this.firstLoadedRecNumSaved = 9999;
    this.lastLoadedRecNumSaved = 0;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillRender() {
    if (isMobile())
      this.updateLoadedRecNum();
  }
  connectedCallback() {
    window.addEventListener('resize', this.debouncedHandleResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedHandleResize);
  }
  getTotalPages() {
    return Math.ceil(this.totalNumRecs / this.productsPerPage);
  }
  render() {
    return (h(Host, null, this.showMobilePagination && this.productsCountLabel && (h("div", { class: "products-pagination__total-count" }, this.productsCountLabel, ": ", this.totalNumRecs)), this.showMobilePagination
      && !!this.totalNumRecs
      && this.firstLoadedRecNumSaved > 1
      && this.lastLoadedRecNumSaved < this.totalNumRecs && (h("qds-button", { class: "products-pagination__load-prev-btn", size: "large", importance: "standard", onClick: this.loadPrevious, text: this.loadPreviousLabel })), h("slot", null), this.showDesktopPagination && this.totalNumRecs > this.productsPerPage && (h("se-pagination", { class: "products-pagination__desktop", hideEdge: true, perPage: this.productsPerPage, total: this.getTotalPages(), value: this.selectedPage, labelValue: this.labelValue, labelPrev: this.previousLabel, labelNext: this.nextLabel, onDidChange: this.onPaginationChange })), this.showMobilePagination && this.lastLoadedRecNum < this.totalNumRecs && (h("qds-button", { class: "products-pagination__load-more-btn", size: "large", importance: "standard", text: this.loadMoreLabel, onClick: this.loadMore }))));
  }
  get el() { return getElement(this); }
};
ProductsPagination.style = productsPaginationCss;

const pesRangeFilterPillsCss = ":host{display:block}.pills{line-height:44px;min-height:44px;display:none}@media screen and (min-width: 980px){.pills{display:block;margin:-6px 0 12px}}.pills__tooltip{font-size:14px;line-height:1.4285714286;font-weight:bold}:host(:not([dir=\"rtl\"])) .pill:not(:first-child){margin-left:8px}:host([dir=\"rtl\"]) .pill:not(:first-child){margin-right:8px}";

const RangePills = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.removePill = createEvent(this, "removePill", 7);
    this.handleClickClose = (navigationState, value, unCheckedURL) => {
      this.pillsEl.dispatchEvent(new CustomEvent(GLOBAL_ANALYTICS_EVENT_NAME, {
        detail: {
          event: FILTER_STATE_CHANGED_EVENT_NAME,
          isChecked: false,
          refinementId: `${value}_${navigationState}`,
        },
        bubbles: true,
        composed: true,
      }));
      this.removePill.emit(unCheckedURL);
    };
    this.pills = [];
  }
  render() {
    var _a;
    if (!((_a = this.pills) === null || _a === void 0 ? void 0 : _a.length))
      return null;
    return (h("div", { class: "pills", ref: (el) => {
        this.pillsEl = el;
      } }, this.pills.map((item) => (h("pes-tooltip-wrapper", { class: "pill", position: "top", key: `${item === null || item === void 0 ? void 0 : item.charValueId}_${item === null || item === void 0 ? void 0 : item.navigationState}` }, h("qds-chip", { slot: "tooltip-activator", type: "closable", text: html2plain(item.label), onQdsClose: () => this.handleClickClose(item === null || item === void 0 ? void 0 : item.navigationState, item === null || item === void 0 ? void 0 : item.charValueId, item === null || item === void 0 ? void 0 : item.unCheckedURL) }), h("div", { slot: "tooltip-content", class: "pills__tooltip" }, item.characteristicName))))));
  }
};
RangePills.style = pesRangeFilterPillsCss;

const ProductCtasUpdater = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.buttonsChange = createEvent(this, "buttonsChange", 7);
    this.fillFavoritesList = (result) => {
      if (!this.isFavoritesExist)
        return;
      this.mergeAndEmitChange({
        favorites: {
          list: getSingleProductList(result).map((p) => p.productId),
        },
      });
    };
    this.buttons = undefined;
    this.myProductsGetter = undefined;
  }
  onCcGetOptionsSucceeded(event) {
    if (!this.buttons)
      return;
    if (!this.buttons.favorites && !this.buttons.cart)
      return;
    this.mergeAndEmitChange({
      favorites: this.buttons.favorites && {
        isShown: !event.detail.enableChannelSightOnCart,
      },
      cart: this.buttons.cart && {
        isShown: event.detail.enableChannelSightOnCart,
      },
    });
  }
  onPesProductAddedToFavorites(e) {
    if (!this.isFavoritesExist)
      return;
    const favoritesList = this.buttons.favorites.list || [];
    if (!favoritesList.includes(e.detail)) {
      this.mergeAndEmitChange({
        favorites: {
          list: [...favoritesList, e.detail],
        },
      });
    }
  }
  onPesProductRemovedFromFavorites(e) {
    if (!this.isFavoritesExist)
      return;
    const favoritesList = this.buttons.favorites.list;
    if (favoritesList === null || favoritesList === void 0 ? void 0 : favoritesList.length) {
      this.mergeAndEmitChange({
        favorites: {
          list: favoritesList.filter((i) => i !== e.detail),
        },
      });
    }
  }
  componentDidLoad() {
    var _a;
    (_a = this.myProductsGetter) === null || _a === void 0 ? void 0 : _a.call(this).then(this.fillFavoritesList);
  }
  get isFavoritesExist() {
    var _a;
    return Boolean((_a = this.buttons) === null || _a === void 0 ? void 0 : _a.favorites);
  }
  mergeAndEmitChange(partialButtons) {
    const merged = this.mergeWithExistingButtons(partialButtons);
    this.buttonsChange.emit(merged);
  }
  mergeWithExistingButtons(partialButtons) {
    const updatedButtons = Object.keys(partialButtons).reduce((merged, buttonKey) => {
      if (partialButtons[buttonKey]) {
        merged[buttonKey] = Object.assign(Object.assign({}, this.buttons[buttonKey]), partialButtons[buttonKey]);
      }
      return merged;
    }, {});
    return Object.assign(Object.assign({}, this.buttons), updatedButtons);
  }
};

const recentlyViewedContainerCss = ":host{display:block}@media screen and (max-width: 979px){:host{margin-bottom:44px}}@media screen and (min-width: 980px){:host(.subcategory) .recently-viewed-container{margin-bottom:72px}}@media screen and (max-width: 979px){:host(.subcategory) .recently-viewed-container{margin-bottom:48px}}";

const RecentlyViewedContainer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.url = undefined;
    this._url = undefined;
    this.result = undefined;
  }
  componentWillLoad() {
    var _a;
    this.url = (_a = tryParse(this._url)) !== null && _a !== void 0 ? _a : this.url;
    this.fetchData();
  }
  fetchData() {
    if (!this.url || window.isAsco)
      return;
    const urlParamSymbol = this.url.includes('?') ? '&' : '/?';
    fetch(`${this.url}${urlParamSymbol}ts=${Date.now()}`, {
      credentials: 'include',
    })
      .then((response) => {
      return response.json();
    })
      .then((data) => {
      this.result = data;
    })
      .catch(() => {
    });
  }
  render() {
    if (this.result && this.result.data.length) {
      return h("pes-products-carousel", Object.assign({ class: "recently-viewed-container" }, this.result));
    }
  }
  static get watchers() { return {
    "url": ["fetchData"]
  }; }
};
RecentlyViewedContainer.style = recentlyViewedContainerCss;

const responsiveFiltersCss = "@media screen and (min-width: 980px){:host{flex:0 0 280px}}.responsive-filters__mobile{margin-top:24px;min-height:50px}@media screen and (min-width: 980px){.responsive-filters__mobile{display:none}}@media screen and (max-width: 979px){.responsive-filters__desktop:not(.responsive-filters__desktop--visible){display:none}}.responsive-filters{--se-primary:#3dcd58;--se-primary-rgb:61, 205, 88;--se-secondary:#42b4e6;--se-secondary-rgb:66, 180, 230;--se-standard:#626469;--se-standard-rgb:98, 100, 105;--se-alternative:#ffffff;--se-alternative-rgb:255, 255, 255;--se-success:#3dcd58;--se-success-rgb:61, 205, 88;--se-information:#0087cd;--se-information-rgb:0, 135, 205;--se-warning:#e47f00;--se-warning-rgb:228, 127, 0;--se-error:#dc0a0a;--se-error-rgb:220, 10, 10;--se-border:#9fa0a4;--se-border-rgb:159, 160, 164;--se-disabled:#9fa0a4;--se-disabled-rgb:159, 160, 164;--se-border-focus:#333333;--se-border-focus-rgb:51, 51, 51;--se-divider:#e6e6e6;--se-divider-rgb:230, 230, 230;--se-link-color:#0087CD;--se-link-color-rgb:0, 135, 205;--se-link-visited:#3a738c;--se-link-visited-rgb:58, 115, 140;--se-primary-contrast:#ffffff;--se-primary-contrast-rgb:255, 255, 255;--se-secondary-contrast:#ffffff;--se-secondary-contrast-rgb:255, 255, 255;--se-standard-contrast:#ffffff;--se-standard-contrast-rgb:255, 255, 255;--se-alternative-contrast:#333333;--se-alternative-contrast-rgb:51, 51, 51;--se-success-contrast:#ffffff;--se-success-contrast-rgb:255, 255, 255;--se-information-contrast:#ffffff;--se-information-contrast-rgb:255, 255, 255;--se-warning-contrast:#333333;--se-warning-contrast-rgb:51, 51, 51;--se-error-contrast:#ffffff;--se-error-contrast-rgb:255, 255, 255;--se-primary-hover:#32ad3c;--se-primary-hover-rgb:50, 173, 60;--se-secondary-hover:#0087cd;--se-secondary-hover-rgb:0, 135, 205;--se-standard-hover:#494b50;--se-standard-hover-rgb:73, 75, 80;--se-alternative-hover:#e6e6e6;--se-alternative-hover-rgb:230, 230, 230;--se-primary-selected:#0a9a25;--se-primary-selected-rgb:10, 154, 37;--se-secondary-selected:#0f81b3;--se-secondary-selected-rgb:15, 129, 179;--se-standard-selected:#2f3136;--se-standard-selected-rgb:47, 49, 54;--se-alternative-selected:#cccccc;--se-alternative-selected-rgb:204, 204, 204;--se-button-focus:#007acd;--se-button-focus-rgb:0, 122, 205;--se-background-standard:#f7f7f7;--se-background-standard-rgb:247, 247, 247;--se-background-standard-contrast:#333333;--se-background-standard-contrast-rgb:51, 51, 51;--se-background-alternative:#ffffff;--se-background-alternative-rgb:255, 255, 255;--se-background-alternative-contrast:#333333;--se-background-alternative-contrast-rgb:51, 51, 51;--se-background-footer:#e7e6e6;--se-background-footer-rgb:231, 230, 230;--se-background-footer-contrast:#333333;--se-background-footer-contrast-rgb:51, 51, 51;--se-overlay:rgba(15, 15, 15, 0.4);--se-overlay-rgb:15, 15, 15;--se-overlay-loading:rgba(255, 255, 255, 0.4);--se-overlay-loading-rgb:255, 255, 255;--se-shadow:rgba(15, 15, 15, 0.2);--se-shadow-rgb:15, 15, 15}";

const PesResponsiveFilter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.showMobileFilter = createEvent(this, "showMobileFilter", 7);
    this.facetContentMaxHeight = 32 * 10 + 9 * 4 + 2 * 16;
    this.showFilterMobileView = () => {
      this.showMobileFilter.emit();
      send(filtersVirtualPageEvent);
    };
    this.filtrationSmartData = undefined;
    this.resetButtonLabel = undefined;
    this.viewMoreFacetsLabel = undefined;
    this.viewLessFacetsLabel = undefined;
    this.visibleFacetsCount = 5;
    this.visibleRefinementsPerFacetCount = 5;
    this.headerLabelDesktop = undefined;
    this.headerLabelMobile = undefined;
    this.viewProductsLabel = undefined;
    this.viewMoreRefinementsLabel = undefined;
    this.viewLessRefinementsLabel = undefined;
    this.noProductsFoundLabel = undefined;
    this.isMobileViewVisible = undefined;
    this.isMobileCategorySelected = undefined;
    this.productsCount = undefined;
    this.selectedSectionsCount = undefined;
    this.categories = [];
  }
  get showProductsLabel() {
    const label = this.productsCount > 0 ? this.viewProductsLabel : this.noProductsFoundLabel;
    return `${label} (${this.productsCount})`;
  }
  renderMobileFilters() {
    return (h("div", { class: "responsive-filters__mobile" }, this.isMobileCategorySelected && (h("se-filtration-smart-mobile-view-trigger", { label: this.headerLabelMobile, count: this.selectedSectionsCount, onClick: this.showFilterMobileView })), !this.isMobileCategorySelected && (h("pes-mobile-filters-categories", { categories: this.categories }))));
  }
  renderDesktopFilters() {
    return (h("div", { class: {
        'responsive-filters__desktop': true,
        'responsive-filters__desktop--visible': this.isMobileViewVisible,
      } }, h("se-filtration-smart", { filters: this.filtrationSmartData, resetButtonLabel: this.resetButtonLabel, viewMoreFacetsLabel: this.viewMoreFacetsLabel, viewLessFacetsLabel: this.viewLessFacetsLabel, visibleFacetsCount: this.visibleFacetsCount, visibleRefinementsPerFacetCount: this.visibleRefinementsPerFacetCount, headerLabelDesktop: this.headerLabelDesktop, headerLabelMobile: this.headerLabelMobile, isMobileViewVisible: this.isMobileViewVisible, showProductsLabel: this.showProductsLabel, maxFacetContentHeight: this.facetContentMaxHeight, viewMoreRefinementsLabel: this.viewMoreRefinementsLabel, viewLessRefinementsLabel: this.viewLessRefinementsLabel })));
  }
  render() {
    return (h("div", { class: "responsive-filters" }, this.renderMobileFilters(), this.renderDesktopFilters()));
  }
};
PesResponsiveFilter.style = responsiveFiltersCss;

const richTextInformationCss = ":host{display:block}.product-information{font-weight:normal}@media screen and (min-width: 980px){.product-information{font-size:14px;line-height:1.4285714286;border:0}:host(:not([dir=\"rtl\"])) .product-information{margin:26px 0 0 20px}:host([dir=\"rtl\"]) .product-information{margin:26px 20px 0 0}}.product-information a{display:inline-block;border-radius:var(--qds-focus-border-radius);box-sizing:border-box;text-decoration:underline;color:var(--qds-theme-link-standard-default)}.product-information a:visited{color:var(--qds-theme-link-standard-visited)}.product-information a:hover{color:var(--qds-theme-link-standard-hover)}.product-information a:active{color:var(--qds-theme-link-standard-pressed)}.product-information a:visited:hover{color:var(--qds-theme-link-standard-visited-hover)}.product-information a:visited:active{color:var(--qds-theme-link-standard-visited-pressed)}.product-information a[rel~=external]>.qds-external{display:inline-block}.product-information a:focus-visible{outline:var(--qds-theme-focus-border) solid var(--qds-focus-border-width)}.product-information a[aria-disabled=true]{opacity:var(--qds-theme-disabled);pointer-events:none}@media screen and (max-width: 979px){.product-information>*:first-child{border-top:1px solid #9fa0a4}}.product-information .text{display:inline-block;width:100%;margin:20px 0 0;padding-top:1px}.product-information .text:last-child{margin-bottom:20px}.product-information h3{font-size:30px;margin-bottom:15px}.product-information span{font-size:15px;line-height:1.3333333333;display:block;color:#000000;font-weight:bold}.richText span{font-weight:normal}.product-information table{width:100%}.product-information table tr{border-bottom:1px solid #e7e6e6;border-bottom:0}.product-information table tr:last-child{border-bottom:none}.product-information table tr td{vertical-align:top;color:#333333}:host(:not([dir=\"rtl\"])) .product-information table tr td{padding:10px 10px 10px 0}:host([dir=\"rtl\"]) .product-information table tr td{padding:10px 0 10px 10px}.product-information table tr td:first-child{font-weight:bold}@media screen and (min-width: 980px){.product-information table tr td:first-child{width:35%}}@media screen and (max-width: 979px){.product-information table tr td,.product-information table tr td:first-child{padding:0}}";

const PesRichTextInformation = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.richText = undefined;
  }
  render() {
    var _a;
    return (((_a = this.richText) === null || _a === void 0 ? void 0 : _a.length) > 0 && (h("div", { class: "product-information" }, this.richText.map((text) => (h("p", { class: "text", innerHTML: text }))))));
  }
};
PesRichTextInformation.style = richTextInformationCss;

const pesRouterLinkCss = "";

const PesRouterLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onLinkClick = (e) => {
      var _a;
      if (!store$1.get('bypass')) {
        e.preventDefault();
      }
      (_a = this.saveInIndexDB) === null || _a === void 0 ? void 0 : _a.call(this, e);
      navigateWithRouter(this.route, e.currentTarget);
    };
    this.page = undefined;
    this.pageId = undefined;
    this.tabId = undefined;
    this.url = undefined;
    this.target = undefined;
    this.urlSearchParams = undefined;
    this.saveInIndexDB = undefined;
  }
  connectedCallback() {
    const firstChild = this.pesLinkElement.children[0];
    if (firstChild) {
      this.child = firstChild;
      if (!this.url) {
        this.child.addEventListener('click', this.onLinkClick);
      }
    }
  }
  componentWillLoad() {
    const firstChild = this.pesLinkElement.children[0];
    if (firstChild) {
      this.child = firstChild;
      if (this.url) {
        this.child.href = this.url;
      }
      else {
        this.route = new PesRoute({
          page: this.page,
          pageId: this.pageId,
          tabId: this.tabId,
          searchParams: this.urlSearchParams,
        });
        this.child.href = this.route.url;
      }
      if (this.target) {
        this.child.target = this.target;
      }
    }
  }
  disconnectedCallback() {
    this.child.removeEventListener('click', this.onLinkClick);
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
  get pesLinkElement() { return getElement(this); }
};
PesRouterLink.style = pesRouterLinkCss;

const selectCss = ".pes-select{width:100%;min-width:250px;max-width:100%}@media screen and (min-width: 980px){.pes-select--fixed-width{width:250px}}";

const PesSelect = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.selectedValue = createEvent(this, "selectedValue", 7);
    this.setSelectedValue = () => {
      var _a;
      this.selected = (_a = this.items.find((item) => {
        return item.selected === true;
      })) === null || _a === void 0 ? void 0 : _a.value;
    };
    this.items = [];
    this.hasFixedWidth = true;
    this.selected = undefined;
    this.updateCount = 0;
  }
  handleSelect(event) {
    this.selectedValue.emit({ selectedValue: event.target.value });
  }
  handleItemsUpdate(newValue, previousValue) {
    if (lodash.isEqual(newValue, previousValue))
      return;
    this.updateCount++;
    this.setSelectedValue();
  }
  componentWillLoad() {
    this.setSelectedValue();
  }
  render() {
    return (h("qds-select", { key: this.updateCount, class: classnames('pes-select', { 'pes-select--fixed-width': this.hasFixedWidth }), value: this.selected, onQdsChange: (event) => this.handleSelect(event) }, this.items.map(({ value, label, selected }) => {
      return (h("option", { value: value, key: value, selected: selected }, html2plain(label)));
    })));
  }
  static get watchers() { return {
    "items": ["handleItemsUpdate"]
  }; }
};
PesSelect.style = selectCss;

const pesSlideDownContainerCss = ":host{display:flex;transform:scaleY(0);transform-origin:100% 0;transition:transform 0.25s}:host(.active){transform:scaleY(1)}";

const PesSlideDownContainer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.active = undefined;
  }
  render() {
    return (h(Host, { class: { active: this.active } }, h("slot", null)));
  }
};
PesSlideDownContainer.style = pesSlideDownContainerCss;

const getSplitText = (div, maxHeight) => {
  const range = document.createRange();
  const dFragment = document.createDocumentFragment();
  const lineHeight = Math.max(0, parseFloat(getComputedStyle(div).lineHeight));
  const text = div.textContent.trim();
  div.firstChild.textContent = div.firstChild.textContent.trim();
  const node = div.firstChild;
  let lastHeight = 0;
  let indexStart = 0;
  let txtOffset = 0;
  range.setStart(node, 0);
  maxHeight += range.getBoundingClientRect().height - lineHeight;
  for (; txtOffset < text.length; txtOffset += 1) {
    range.setEnd(node, txtOffset);
    const curHeight = Math.round(range.getBoundingClientRect().height);
    if (curHeight !== lastHeight) {
      if (lastHeight) {
        const span = document.createElement('span');
        span.textContent = curHeight > maxHeight
          ? text.substring(indexStart)
          : text.substring(indexStart, txtOffset - 1);
        span.classList.add('smart-ellipsis__row');
        dFragment.appendChild(span);
        if (curHeight > maxHeight) {
          indexStart = -1;
          break;
        }
      }
      indexStart = txtOffset - 1;
      lastHeight = curHeight;
    }
  }
  if (indexStart !== -1 || txtOffset === text.length) {
    const span = document.createElement('span');
    span.textContent = text.substring(indexStart);
    span.classList.add('smart-ellipsis__row');
    dFragment.appendChild(span);
  }
  return dFragment;
};
const smartEllipsis = (container, content, label) => {
  container.innerHTML = content;
  const containerRect = container.getBoundingClientRect();
  const maxHeight = containerRect.height;
  const dFragment = getSplitText(container, maxHeight);
  container.textContent = '';
  container.appendChild(dFragment);
  const { length } = container.childNodes;
  const truncatedText = document.createElement('div');
  truncatedText.classList.add('truncated-text');
  truncatedText.appendChild(container.childNodes[length - 1]);
  if (label) {
    const languageLabel = document.createElement('span');
    languageLabel.classList.add('label');
    languageLabel.textContent = label;
    truncatedText.appendChild(languageLabel);
  }
  container.appendChild(truncatedText);
};

const pesSmartEllipsisCss = ".pes-smart-ellipsis{height:100%;display:block}.pes-smart-ellipsis .smart-ellipsis__row{display:block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.pes-smart-ellipsis .truncated-text{display:flex;align-items:center}.pes-smart-ellipsis .label{font-size:12px;line-height:20px;display:inline;height:20px;padding:0 5px;font-weight:normal;color:#626469;background-color:rgba(98, 100, 105, 0.1);text-transform:capitalize;margin:0 5px;border-radius:2px}";

const SmartEllipsis = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.update = () => {
      setTimeout(() => {
        smartEllipsis(this.ref, this.content, this.label);
      });
    };
    this.content = undefined;
    this.maxHeight = undefined;
    this.modifier = undefined;
    this.label = undefined;
  }
  componentDidLoad() {
    window.addEventListener('resize', this.update);
    this.update();
  }
  componentDidUpdate() {
    this.update();
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.update);
  }
  render() {
    return (h(Host, null, h("div", { ref: (el) => (this.ref = el), class: `pes-smart-ellipsis pes-smart-ellipsis-${this.modifier}`, style: { maxHeight: this.maxHeight } })));
  }
};
SmartEllipsis.style = pesSmartEllipsisCss;

const softwareModalCss = ".dialog-header-title{font-size:18px;line-height:24px;font-weight:bold;color:#ffffff}@media screen and (min-width: 980px){.dialog-header-title{font-size:22px;line-height:32px}:host(:not([dir=\"rtl\"])) .dialog-header-title{padding-left:25px}:host([dir=\"rtl\"]) .dialog-header-title{padding-right:25px}}";

const SoftwareModal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didSoftwareModalClose = createEvent(this, "didSoftwareModalClose", 7);
    this.isOpen = false;
    this.headerLabel = undefined;
  }
  didModalClose() {
    this.didSoftwareModalClose.emit();
    this.isOpen = false;
  }
  getSize() {
    if (isMobile()) {
      return 'fill';
    }
    return 'xlarge';
  }
  render() {
    return (h("se-dialog", { open: this.isOpen, size: this.getSize(), "can-backdrop": true }, h("se-dialog-header", { "close-icon": "true", option: "indent" }, h("h2", { class: "dialog-header-title" }, this.headerLabel)), h("se-dialog-content", null, h("slot", null))));
  }
};
SoftwareModal.style = softwareModalCss;

const pesSoftwareModalCellCss = "@media screen and (min-width: 980px){.pes-software-modal-cell{font-size:14px;line-height:1.4285714286;padding:15px}}.pes-software-modal-cell--versions{font-size:14px;line-height:1.4285714286}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .pes-software-modal-cell--versions{padding:20px 65px 15px 30px}:host([dir=\"rtl\"]) .pes-software-modal-cell--versions{padding:20px 30px 15px 65px}}.pes-software-modal-cell--format{text-transform:uppercase}.pes-software-modal-cell--size{text-transform:capitalize}";

const PesSoftwareModalCell = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.type = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: classnames('pes-software-modal-cell', this.type && `pes-software-modal-cell--${this.type}`) }, h("slot", null)));
  }
  get el() { return getElement(this); }
};
PesSoftwareModalCell.style = pesSoftwareModalCellCss;

const pesSoftwareModalContentCss = ".pes-software-modal{padding:15px 20px 10px;color:#333333}@media screen and (min-width: 980px){.pes-software-modal{padding:6px 12px 48px}}@media screen and (max-width: 719px){.pes-software-modal{padding:0 2px 24px}}.pes-software-modal__row{display:block;border-bottom:1px solid #e7e6e6;margin-bottom:15px}@media screen and (min-width: 980px){.pes-software-modal__row{margin:0}}.pes-software-modal__row:last-child{border-bottom:0}";

const PesSoftwareModal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.columns = [];
    this.data = [];
    this.viewDownloadCellEnabled = false;
    this.labels = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    if (this.viewDownloadCellEnabled) {
      this.columns.push({ label: '', type: 'onlineLink' }, { label: '', type: 'link' });
    }
    return (h("div", { class: "pes-software-modal" }, this.columns.length > 0 && h("pes-software-modal-header-row", { columns: this.columns }), Array.isArray(this.data) && this.data.map(({ cells, fileType, link, documentReference, documentName, documentType, downloadAll, files, }) => {
      if (this.viewDownloadCellEnabled) {
        cells.push({ text: '', type: 'onlineLink' }, { text: '', type: 'link' });
      }
      return (h("pes-software-modal-row", { cells: cells, fileType: fileType, link: link, documentReference: documentReference, documentName: documentName, documentType: documentType, class: "pes-software-modal__row", labels: this.labels, downloadAll: downloadAll, files: files }));
    })));
  }
  get el() { return getElement(this); }
};
PesSoftwareModal.style = pesSoftwareModalContentCss;

const pesSoftwareModalHeaderCellCss = ".pes-software-modal-header-cell{font-size:14px;line-height:1.7142857143;font-weight:bold;color:#333333}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .pes-software-modal-header-cell{padding-left:17px}:host([dir=\"rtl\"]) .pes-software-modal-header-cell{padding-right:17px}}@media screen and (max-width: 719px){.pes-software-modal-header-cell:not(.pes-software-modal-header-cell--first){display:none}}";

const PesSoftwareModalHeaderCell = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.label = undefined;
    this.index = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: classnames('pes-software-modal-header-cell', this.index === 0 && 'pes-software-modal-header-cell--first') }, this.label));
  }
  get el() { return getElement(this); }
};
PesSoftwareModalHeaderCell.style = pesSoftwareModalHeaderCellCss;

const pesSoftwareModalHeaderRowCss = ".pes-software-modal-header-row{border-bottom:1px solid #e7e6e6;margin-bottom:14px;padding-bottom:10px}@media screen and (min-width: 980px){.pes-software-modal-header-row{display:grid;grid-template-columns:3fr 2fr 1fr 1fr 1fr 1fr 0.5fr 0.5fr;margin-bottom:0}}";

const PesSoftwareModalHeaderRow = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.columns = [];
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "pes-software-modal-header-row" }, this.columns.map(({ type, label }, index) => (h("pes-software-modal-header-cell", { label: label, index: index, class: classnames('pes-software-modal-header-row__cell', type && `pes-software-modal-header-row__cell--${type}`) })))));
  }
  get el() { return getElement(this); }
};
PesSoftwareModalHeaderRow.style = pesSoftwareModalHeaderRowCss;

const pesSoftwareModalRowCss = ".pes-software-modal-row{font-size:12px;line-height:1.25;padding-bottom:3px}:host(:not([dir=\"rtl\"])) .pes-software-modal-row{padding-left:34px}:host([dir=\"rtl\"]) .pes-software-modal-row{padding-right:34px}@media screen and (min-width: 980px){.pes-software-modal-row{display:grid;grid-template-columns:3fr 2fr 1fr 1fr 1fr 1fr 0.5fr 0.5fr;padding-bottom:0}:host(:not([dir=\"rtl\"])) .pes-software-modal-row{padding-left:17px}:host([dir=\"rtl\"]) .pes-software-modal-row{padding-right:17px}}.pes-software-modal-row__cell{display:block;margin-bottom:10px;box-sizing:border-box}@media screen and (min-width: 980px){.pes-software-modal-row__cell{margin-bottom:0}}.pes-software-modal-row__cell--versions{margin-bottom:11px}@media screen and (min-width: 980px){.pes-software-modal-row__cell--versions{margin:0}}@media screen and (max-width: 719px){.pes-software-modal-row__cell--format,.pes-software-modal-row__cell--size,.pes-software-modal-row__cell--date{display:inline-block}:host(:not([dir=\"rtl\"])) .pes-software-modal-row__cell--format,:host(:not([dir=\"rtl\"])) .pes-software-modal-row__cell--size,:host(:not([dir=\"rtl\"])) .pes-software-modal-row__cell--date{margin-right:15px}:host([dir=\"rtl\"]) .pes-software-modal-row__cell--format,:host([dir=\"rtl\"]) .pes-software-modal-row__cell--size,:host([dir=\"rtl\"]) .pes-software-modal-row__cell--date{margin-left:15px}}.pes-software-modal-row__icon{position:absolute;top:-3px}:host(:not([dir=\"rtl\"])) .pes-software-modal-row__icon{left:-26px}:host([dir=\"rtl\"]) .pes-software-modal-row__icon{right:-26px}.pes-software-modal-row__link{text-decoration:none;outline:none;position:relative;color:inherit}.pes-software-modal-row__link:hover{text-decoration:underline}.pes-software-modal-row__download-link{background:none;color:#42b4e6;border:none;padding:0;cursor:pointer;outline:inherit;font-family:inherit;display:flex;align-items:center;text-decoration:none}:host(:not([dir=\"rtl\"])) .pes-software-modal-row__download-link{padding-left:0}:host([dir=\"rtl\"]) .pes-software-modal-row__download-link{padding-right:0}.pes-software-modal-row__download-link:hover{text-decoration:underline}.pes-software-modal-row__download-link:hover{text-decoration:none}:host(:not([dir=\"rtl\"])) .pes-software-modal-row__download-text{margin-left:5px}:host([dir=\"rtl\"]) .pes-software-modal-row__download-text{margin-right:5px}.pes-software-modal-row__download-text:hover{text-decoration:underline}.pes-software-modal-row__label{font-weight:bold}:host(:not([dir=\"rtl\"])) .pes-software-modal-row__label{float:left;margin-right:3px}:host([dir=\"rtl\"]) .pes-software-modal-row__label{float:right;margin-left:3px}@media screen and (min-width: 980px){.pes-software-modal-row__label{display:none}}";

const PesSoftwareModalRow = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.getDownloadLink = () => {
      var _a, _b, _c;
      if (!isViewOnline(this.documentName)) {
        return this.link;
      }
      if (((_a = this.downloadAll) === null || _a === void 0 ? void 0 : _a.length) && ((_b = this.files) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        return this.downloadAll;
      }
      if (((_c = this.files) === null || _c === void 0 ? void 0 : _c.length) === 1) {
        return this.files[0].link;
      }
      return null;
    };
    this.cells = undefined;
    this.fileType = undefined;
    this.link = undefined;
    this.documentReference = undefined;
    this.documentName = undefined;
    this.documentType = undefined;
    this.downloadAll = undefined;
    this.files = undefined;
    this.labels = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getCellByType(cell) {
    var _a;
    const { type, text, mobileLabel } = cell;
    if (type === columnTypes.VERSIONS) {
      return (h("pes-software-modal-cell", { class: classnames('pes-software-modal-row__cell', type && `pes-software-modal-row__cell--${type}`), type: type }, h("a", { class: "pes-software-modal-row__link", target: isViewOnline(this.documentName) ? '_blank' : '_self', href: this.link, onClick: () => this.onLinkClick(this.documentReference, this.documentName, this.documentType) }, h("pes-document-icon", { class: "pes-software-modal-row__icon", type: this.fileType }), text)));
    }
    if (type === columnTypes.LINK) {
      if (isViewOnline(this.documentName) && ((_a = this.files) === null || _a === void 0 ? void 0 : _a.length) === 1) {
        const { documentReference, documentName, documentType } = this.files[0];
        return this.buildLink(type, false, this.getDownloadLink(), documentReference, documentName, documentType);
      }
      return this.buildLink(type, false, this.getDownloadLink(), this.documentReference, this.documentName, this.documentType);
    }
    if (type === columnTypes.ONLINELINK) {
      return this.buildLink(type, isViewOnline(this.documentName), isViewOnline(this.documentName) ? this.link : '', this.documentReference, this.documentName, this.documentType);
    }
    return (h("pes-software-modal-cell", { class: classnames('pes-software-modal-row__cell', type && `pes-software-modal-row__cell--${type}`), type: type }, Boolean(text) && Boolean(mobileLabel) && (h("span", { class: "pes-software-modal-row__label" }, mobileLabel, ": ")), text));
  }
  buildLink(type, isLinkExternal, link, documentReference, documentName, documentType) {
    return (h("pes-software-modal-cell", { class: classnames('pes-software-modal-row__cell', type && `pes-software-modal-row__cell--${type}`), type: type }, h("a", { class: "pes-software-modal-row__download-link", target: isLinkExternal ? '_blank' : '_self', href: link, onClick: () => this.onLinkClick(documentReference, documentName, documentType) }, link && (h("se-icon", { class: "pes-software-modal-row__download-icon", size: "micro" }, isLinkExternal ? 'body_eye' : 'action_download_stroke')))));
  }
  onLinkClick(documentReference, documentName, documentType) {
    send(downloadDocumentEvent, {
      documentReference,
      documentName,
      documentType,
    });
  }
  render() {
    return (h("div", { class: "pes-software-modal-row" }, this.cells.map(this.getCellByType.bind(this))));
  }
  get el() { return getElement(this); }
};
PesSoftwareModalRow.style = pesSoftwareModalRowCss;

const pesSprykerCategorySubcategoryListingCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}:host{display:block;box-sizing:border-box;width:100%}:host *,:host *::before,:host *::after{box-sizing:inherit}.category-subcategory-listing{position:relative;display:block;margin:0 auto;box-sizing:border-box;max-width:1200px;overflow:visible;color:#626469;padding-bottom:0;display:flex;flex-direction:column}.category-subcategory-listing *,.category-subcategory-listing *::before,.category-subcategory-listing *::after{box-sizing:inherit}@media screen and (min-width: 980px){.category-subcategory-listing{flex-direction:row}}.category-subcategory-listing__filters{display:flex;flex-direction:column-reverse}@media screen and (min-width: 980px){.category-subcategory-listing__filters{flex-direction:column;flex:0 0 280px}:host(:not([dir=\"rtl\"])) .category-subcategory-listing__filters{margin-right:20px;margin-left:10px}:host([dir=\"rtl\"]) .category-subcategory-listing__filters{margin-left:20px;margin-right:10px}}@media screen and (min-width: 980px){.category-subcategory-listing__content{padding:0;flex:1 1 auto}}@media screen and (min-width: 980px){.category-subcategory-listing__content.category-subcategory-listing__content--with-subcategory{margin-top:40px}}.category-subcategory-listing__products--hidden{display:none}@media screen and (max-width: 719px){.category-subcategory-listing__products{padding-left:16px;padding-right:16px}}.category-subcategory-listing__hmc-banner{margin-bottom:16px}@media screen and (max-width: 719px){.category-subcategory-listing__hmc-banner{padding-left:16px;padding-right:16px}}@media screen and (min-width: 980px){.category-subcategory-listing__hmc-banner{margin-top:12px}.category-subcategory-listing__hmc-banner--top{margin-top:0}}.hidden-subcategories{display:none}.category-subcategory-listing__overlay{z-index:2;top:0;right:0;bottom:0;left:0;background:#fafafa;opacity:0.4}.category-subcategory-listing__overlay:not(.category-subcategory-listing__overlay--visible){display:none}@media screen and (max-width: 979px){.category-subcategory-listing__overlay{position:fixed}}@media screen and (min-width: 980px){.category-subcategory-listing__overlay{position:absolute}}";

const PesSprykerCategorySubcategoryListing = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.renderHMC = () => {
      if (this.hideHMCBanner || !this.hmcBanner) {
        return;
      }
      return (h("pes-hmc-banner", { class: {
          'category-subcategory-listing__hmc-banner': true,
          'category-subcategory-listing__hmc-banner--top': this.showHMConTop,
        }, categoryName: this.hmcBanner.categoryName, labels: this.hmcBanner.labels, sourceId: this.hmcBanner.pimId, parentCategoryId: this.hmcBanner.parentCategoryId, categoryProductConfiguratorUrl: this.hmcBanner.categoryProductConfiguratorUrl, hasQuestionnaire: this.hmcBanner.hasQuestionnaire, questionnaireUrl: this.hmcBanner.questionnaireUrl, rangeTooltipUrl: this.hmcBanner.rangeTooltipUrl, selectorConfigUrl: this.hmcBanner.selectorConfigUrl, isExternalProductConfiguratorUrl: this.hmcBanner.isExternalProductConfiguratorUrl, variant: "square", hmcHost: this.hmcBanner.host, token: this.hmcBanner.token, channel: this.hmcBanner.channel, pageSource: this.hmcBanner.pageSource }));
    };
    this.localeCode = undefined;
    this.host = '';
    this.subcategorySection = undefined;
    this.productsSection = undefined;
    this.filtersSection = undefined;
    this.hmcBanner = undefined;
    this.hideHMCBanner = false;
    this.navigationState = '';
    this.filtersUrl = undefined;
    this.productsUrl = undefined;
    this.rangesUrl = undefined;
    this.numberOfProducts = undefined;
    this.showDocuments = undefined;
    this.showBuyOnline = true;
    this.enableCommerceConnector = true;
    this.avoidAccents = false;
    this.hiddenSubcategoriesInfo = undefined;
    this.pageParam = undefined;
    this.isBrowser = isBrowser();
    this.showCompare = true;
    this.searchParams = {};
    this.isSubcategoryPage = false;
    this.isPBS = false;
    this.storageName = undefined;
    this.currentPageStorageKey = undefined;
    this.productCtas = DEFAULT_CATEGORY_PRODUCT_CTAS;
    this.filtersNormalized = undefined;
    this.filtrationSmartData = undefined;
    this.pills = undefined;
    this.isMobileView = isMobile();
    this.isFilterInMobileViewVisible = false;
    this.isMobileCategorySelected = Boolean(this.navigationState);
    this.filtersCategories = undefined;
    this.productsCount = undefined;
    this.selectedSectionsCount = undefined;
    this.isProductsLoading = false;
    this.sprykerParsedProducts = null;
    this.selectedPage = undefined;
    this.initialNavState = '';
    this.currentNavState = this.navigationState;
    this.initialFilterUrl = undefined;
    this.subCategoryProductListingParams = undefined;
    this.selectedFilterUrl = undefined;
    this.isLoadingFilters = false;
    this.PBSoffset = 0;
    this.breadcrumbs = [];
    this.analyticsPageData = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  async componentWillLoad() {
    const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
    this.selectedPage = Math.floor(offset / productsPerPage) + 1;
    this.initialFilterUrl = this.initialBaseFiltersUrl;
    this.subCategoryProductListingParams = {
      pageParam: this.pageParam,
      subCategoryId: this.navigationState,
    };
    const filter = this.getSearchParam() || '';
    this.selectedFilterUrl = getCategoryOrSubCatFilterUrl(this.filtersUrl, this.localeCode, this.subCategoryProductListingParams, filter);
    if (this.isBrowser) {
      await this.loadData(this.selectedFilterUrl, true);
    }
  }
  windowSizeDidChange() {
    this.isMobileView = isMobile();
    if (!this.isMobileView && this.isFilterInMobileViewVisible) {
      this.isFilterInMobileViewVisible = false;
    }
  }
  choosePage(event) {
    this.selectedPage = event.detail;
    const { productsPerPage } = this.getPaginationParamsWithDefaults;
    if (!this.isPBS) {
      setPaginationParams(productsPerPage * (this.selectedPage - 1), productsPerPage, true);
    }
    this.PBSoffset = productsPerPage * (this.selectedPage - 1);
    this.loadProducts(this.selectedFilterUrl);
  }
  onToggleFilterMobileViewVisibility() {
    this.isFilterInMobileViewVisible = !this.isFilterInMobileViewVisible;
  }
  onSelectCategoryHandler(event) {
    console.log('event.detail', event.detail);
    this.loadData(event.detail);
    this.isMobileCategorySelected = true;
  }
  mobileCategoryReset() {
    this.isMobileCategorySelected = false;
  }
  onFilterStateChanged(event) {
    const { lastChangedFilterId: filterId } = event.detail;
    if (filterId) {
      const { checkedURL, unCheckedURL } = this.filtersNormalized.entities.filter[filterId];
      const changedFilterUrl = unCheckedURL !== '' ? unCheckedURL : checkedURL;
      this.changeFilter(changedFilterUrl, filterReset(changedFilterUrl, this.initialFilterUrl), '');
    }
  }
  removePillHandler(event) {
    const unCheckedURL = event.detail;
    this.changeFilter(unCheckedURL, filterReset(unCheckedURL, this.initialFilterUrl));
  }
  resetAllFiltersHandler() {
    this.changeFilter(this.initialFilterUrl, true);
  }
  handlePopState() {
    if (!this.isPBS) {
      const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
      this.selectedPage = Math.floor(offset / productsPerPage) + 1;
      this.loadData(getCategoryOrSubCatFilterUrl(this.filtersUrl, this.localeCode, this.subCategoryProductListingParams));
    }
  }
  trackAnalyticsEventListener(e) {
    const { event } = e.detail;
    if (!event)
      return;
    if (event === FILTER_STATE_CHANGED_EVENT_NAME)
      trackFilterAnalytics(e, this.filtersNormalized);
  }
  changeFilter(changedFilterUrl, isReset, seoUrl) {
    if (!this.isPBS) {
      setNavigationFilterPath(changedFilterUrl, this.navigationState, isReset, seoUrl);
    }
    this.PBSoffset = 0;
    this.selectedPage = 1;
    this.selectedFilterUrl = changedFilterUrl;
    this.loadData(changedFilterUrl);
  }
  buildSearchParam(param) {
    return param in this.searchParams ? this.searchParams[param] : '';
  }
  getSearchParam(param = 'filter') {
    return this.isPBS ? this.buildSearchParam(param) : getQueryParam(param);
  }
  get hasProducts() {
    var _a;
    return !((_a = this.subcategorySection) === null || _a === void 0 ? void 0 : _a.hideProducts);
  }
  get showHMConTop() {
    return !this.hasProducts && !this.isMobileView;
  }
  get initialBaseFiltersUrl() {
    const categoriesFiltersBaseUrl = getBaseUrl(this.filtersUrl, this.localeCode);
    const subCategoriesBaseUrl = `${getBaseUrl(this.filtersUrl, this.localeCode)}&subcategory-id=${this.navigationState}&pageParam=${pageParam.SUBCATEGORY_LISTING}`;
    return this.pageParam === listingTypes.SUBCATEGORY_LISTING
      ? subCategoriesBaseUrl
      : categoriesFiltersBaseUrl;
  }
  get hasSubcategory() {
    var _a;
    return !!((_a = this.subcategorySection) === null || _a === void 0 ? void 0 : _a.subcategory);
  }
  get getPaginationParamsWithDefaults() {
    return getPaginationParams({
      offset: 0,
      productsPerPage: Number(this.numberOfProducts),
    });
  }
  async loadData(filterUrl, isInitialLoad = false) {
    const searchParams = new URLSearchParams(window.location.search);
    this.loadFilters(`${this.host}${filterUrl}`);
    if (!isInitialLoad || searchParams.has(NAVIGATION_STATE_PARAM_NAME)) {
      await this.loadRanges(filterUrl);
    }
    if (this.hasProducts) {
      this.loadProducts(filterUrl);
    }
  }
  async loadFilters(filterUrl) {
    try {
      this.isLoadingFilters = true;
      const { filtersNormalized, filtrationSmartData, pills, filtersCategories, selectedSectionsCount, } = await fetchSprykerFilters(filterUrl);
      this.filtersNormalized = filtersNormalized;
      this.filtrationSmartData = filtrationSmartData;
      this.pills = pills !== null && pills !== void 0 ? pills : [];
      this.filtersCategories = filtersCategories;
      this.selectedSectionsCount = selectedSectionsCount > 0 ? selectedSectionsCount : 0;
    }
    catch (error) {
      console.error(error);
    }
    finally {
      this.isLoadingFilters = false;
    }
  }
  loadProducts(filtersUrl) {
    this.isProductsLoading = true;
    const PPWProductFiltersUrl = getFilterProductsUrl(this.productsUrl, this.numberOfProducts, this.localeCode, '', this.subCategoryProductListingParams);
    const PBSProductFiltersUrl = getPbsFilterProductsUrl({
      host: this.host,
      ProductsPath: this.productsUrl,
      CheckedFiltersUrl: filtersUrl,
      pbsOffset: this.PBSoffset,
      Nrpp: this.numberOfProducts,
    });
    const url = !this.isPBS ? PPWProductFiltersUrl : PBSProductFiltersUrl;
    getData(false, url)
      .then((response) => {
      const { totalNumRecs } = response;
      this.sprykerParsedProducts = response;
      this.productsCount = totalNumRecs;
    })
      .finally(() => {
      this.isProductsLoading = false;
    });
  }
  async loadRanges(filtersUrl) {
    const PPWRangesFiltersUrl = getCategoryRangesFilterUrl(this.rangesUrl, this.localeCode, this.subCategoryProductListingParams);
    const PBSRangesFiltersUrl = getPbsRangesfiltersUrl({
      host: this.host,
      rangesPath: this.rangesUrl,
      CheckedFiltersUrl: filtersUrl,
    });
    const url = !this.isPBS ? PPWRangesFiltersUrl : PBSRangesFiltersUrl;
    const response = await getData(false, url);
    if (this.pageParam === listingTypes.SUBCATEGORY_LISTING && response.subcategory) {
      response.subcategory.name = null;
      response.subcategory.description = null;
    }
    this.subcategorySection = response;
  }
  renderFilters() {
    if (!this.filtrationSmartData) {
      return;
    }
    return (h("pes-responsive-filters", { filtrationSmartData: this.filtrationSmartData, resetButtonLabel: this.filtersSection.labels.facetButtonResetAll, viewMoreFacetsLabel: this.filtersSection.labels.facetButtonViewMoreFilters, viewLessFacetsLabel: this.filtersSection.labels.facetButtonViewLessFilters, headerLabelDesktop: this.filtersSection.labels.commonFiltersFilterBy, headerLabelMobile: this.filtersSection.labels.rangeProductsFilters, viewProductsLabel: this.filtersSection.labels.viewProducts, viewMoreRefinementsLabel: this.filtersSection.labels.viewMore, viewLessRefinementsLabel: this.filtersSection.labels.viewLess, noProductsFoundLabel: this.filtersSection.labels.noProductsFound, isMobileViewVisible: this.isFilterInMobileViewVisible, isMobileCategorySelected: this.isMobileCategorySelected, selectedSectionsCount: this.selectedSectionsCount, productsCount: this.productsCount, categories: this.filtersCategories, onShowMobileFilter: () => (this.isFilterInMobileViewVisible = true) }));
  }
  renderSubcategoryBlock() {
    const { labels, subcategory, sdlPromoBlocks, productTypeFilterSelected, } = this.subcategorySection;
    if (sdlPromoBlocks) {
      return h("pes-subcategory-promo-blocks", { subcategoryPromoBlocksData: sdlPromoBlocks });
    }
    if (this.hasSubcategory) {
      return (h("pes-subcategory-list", null, h("pes-subcategory-block", { slot: "pes-subcategory-block", subCategory: subcategory, rangePartofLabel: labels.rangePartofLabel, viewOnLabel: labels.viewOnLabel, productRelationsViewProdLabel: labels.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: labels.rangeProductsViewDetailsLabel, readMoreLabel: labels.readMoreLabel, readLessLabel: labels.readLessLabel, rangesSectionTitleLabel: labels.rangesSectionTitle, viewMoreLabel: labels.viewMore, viewLessLabel: labels.viewLess, rangeBlockCollapsible: this.hasProducts, showDescriptionBlock: !this.isSubcategoryPage && productTypeFilterSelected, avoidAccents: this.avoidAccents, navState: this.currentNavState, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName, shouldHaveSubcategory: this.isSubcategoryPage })));
    }
    return null;
  }
  getHiddenSubcategories() {
    var _a;
    const { subcategory, sdlPromoBlocks } = this.subcategorySection;
    if (!((_a = this.hiddenSubcategoriesInfo) === null || _a === void 0 ? void 0 : _a.length)) {
      return [];
    }
    if (sdlPromoBlocks || !subcategory) {
      return this.hiddenSubcategoriesInfo;
    }
    const { sdlCategoryPromo } = subcategory;
    const visibleRanges = subcategory.ranges.slice(0, sdlCategoryPromo ? MAX_RANGES_BEFORE_SDL_PROMO_BANNER : MAX_VISIBLE_CARDS_WHILE_COLLAPSED);
    const visibleRangesIDs = visibleRanges.map((range) => range.id);
    return this.hiddenSubcategoriesInfo.reduce((accCategories, subCategories) => {
      const category = Object.assign(Object.assign({}, subCategories), { ranges: subCategories.ranges.filter((range) => {
          return !visibleRangesIDs.includes(range.id);
        }) });
      if (category.ranges.length > 0) {
        accCategories.push(category);
      }
      return accCategories;
    }, []);
  }
  renderHiddenSubcategories() {
    const subCategories = this.getHiddenSubcategories();
    if (!subCategories.length) {
      return null;
    }
    const { labels } = this.subcategorySection;
    return (h("pes-subcategory-list", { class: "hidden-subcategories" }, subCategories.map((subCategory) => (h("pes-subcategory-block", { slot: "pes-subcategory-block", subCategory: subCategory, rangePartofLabel: labels.rangePartofLabel, viewOnLabel: labels.viewOnLabel, productRelationsViewProdLabel: labels.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: labels.rangeProductsViewDetailsLabel, readMoreLabel: labels.readMoreLabel, readLessLabel: labels.readLessLabel, rangesSectionTitleLabel: labels.rangesSectionTitle, viewMoreLabel: labels.viewMore, viewLessLabel: labels.viewLess, avoidAccents: this.avoidAccents, navState: this.currentNavState, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName, shouldHaveSubcategory: this.isSubcategoryPage, rangeBlockCollapsible: this.hasProducts })))));
  }
  renderProducts() {
    var _a;
    if (!this.hasProducts) {
      return null;
    }
    const { productsPerPage } = this.getPaginationParamsWithDefaults;
    const areProductsHidden = this.isMobileView
      && (this.isFilterInMobileViewVisible
        || (!this.isMobileCategorySelected && ((_a = this.filtersCategories) === null || _a === void 0 ? void 0 : _a.length) > 0));
    return (h("pes-category-subcategory-products-list", { class: classnames('category-subcategory-listing__products', {
        'category-subcategory-listing__products--hidden': areProductsHidden,
      }), hostWithLocale: this.isPBS ? this.host : this.localeCode, storageName: this.storageName, navigationState: this.navigationState, isProductsLoading: this.isProductsLoading, parsedProducts: this.sprykerParsedProducts, selectedPage: this.selectedPage, productsPerPage: productsPerPage, pills: this.pills, isMobileView: this.isMobileView, isMobileCategorySelected: this.isMobileCategorySelected, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, enableCommerceConnector: this.enableCommerceConnector, numberProductsOfAllProductsLabel: this.productsSection.labels.numberProductsOfAllProducts, appProductsLabel: this.productsSection.labels.appProducts, loadMoreLabel: this.productsSection.labels.loadMore, loadPreviousLabel: this.productsSection.labels.loadPrevious, previousLabel: this.productsSection.labels.previous, labelValue: this.productsSection.labels.pageLabel, nextLabel: this.productsSection.labels.next, productsSectionTitleLabel: this.productsSection.labels.title, noResultsClearLinkLabel: this.productsSection.labels.noResultsClearLink, noResultsHeaderLabel: this.productsSection.labels.noResultsHeader, noResultsMessageLabel: this.productsSection.labels.noResultsMessage, enableAppRouting: this.isPBS, localeCode: this.localeCode, isPBS: this.isPBS, productCtas: this.productCtas, showCompare: this.showCompare, analyticsPageData: this.analyticsPageData, currentPageStorageKey: this.currentPageStorageKey }));
  }
  render() {
    return (h("main", { class: "category-subcategory-listing" }, h("div", { class: {
        'category-subcategory-listing__overlay': true,
        'category-subcategory-listing__overlay--visible': this.isLoadingFilters,
      } }), h("aside", { class: "category-subcategory-listing__filters" }, this.renderFilters(), !this.showHMConTop && this.renderHMC()), h("section", { class: {
        'category-subcategory-listing__content': true,
        'category-subcategory-listing__content--with-subcategory': this.hasSubcategory,
      } }, this.showHMConTop && this.renderHMC(), this.renderSubcategoryBlock(), this.renderHiddenSubcategories(), this.renderProducts())));
  }
  get el() { return getElement(this); }
};
PesSprykerCategorySubcategoryListing.style = pesSprykerCategorySubcategoryListingCss;

const StarRatingItem = (props) => {
  const { gProps, svgProps, size } = props;
  return (h("div", { class: "star__wrapper", style: { width: `${size}px`, height: `${size}px` } },
    h("svg", Object.assign({}, svgProps, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50", preserveAspectRatio: "xMidYMid meet" }),
      h("g", Object.assign({}, gProps),
        h("path", { d: "M3 19.664c0-.669.482-1.084 1.447-1.247L17.42 16.44l5.815-12.328C23.56 3.37 23.984 3 24.5 3c.517 0 .939.37 1.266 1.11l5.815 12.33 12.972 1.977c.965.163 1.447.578 1.447 1.247 0 .379-.215.812-.646 1.3l-9.406 9.592 2.222 13.547c.035.253.052.434.052.542 0 .38-.09.7-.272.962-.18.262-.452.393-.814.393-.31 0-.654-.108-1.033-.325L24.5 39.28l-11.603 6.395c-.362.217-.706.325-1.033.325-.345 0-.608-.131-.789-.393-.18-.262-.27-.582-.27-.962 0-.235.008-.415.025-.542l2.222-13.547-9.38-9.592c-.448-.47-.672-.903-.672-1.3z" })))));
};

const starRatingCss = ".star__wrapper{line-height:1}.star__color-filled{fill:#ffd100}.star__color-empty{fill:#cbcbcb}.product-rating{display:flex;align-items:center;font-size:0;text-decoration:none}.product-rating:hover,.product-rating:focus,.product-rating:active{text-decoration:none}.product-rating__wrapper{position:relative;bottom:1px;line-height:1}:host(:not([dir=\"rtl\"])) .product-rating__wrapper{margin-right:5px}:host([dir=\"rtl\"]) .product-rating__wrapper{margin-left:5px}.product-rating__inner-wrapper{display:flex;align-items:center;width:100%}.product-rating__rating-count,.product-rating__review-count{line-height:1.25rem;font-size:0.75rem;color:#42b4e6;white-space:nowrap}:host(:not([dir=\"rtl\"])) .product-rating__rating-count{margin-right:5px}:host([dir=\"rtl\"]) .product-rating__rating-count{margin-left:5px}";

const StarRating = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.generateId = () => (~~(Math.random() * 1e8)).toString(16);
    this.renderStarWrapper = (rate) => {
      const defsProps = null;
      const svgProps = { width: '0', height: '0', style: { position: 'absolute' } };
      const gradientProps = { id: `partialFilling_${this.partialId}` };
      return (h("svg", Object.assign({}, svgProps), h("defs", Object.assign({}, defsProps), h("linearGradient", Object.assign({}, gradientProps), h("stop", { "stop-opacity": "1", offset: `${(rate - parseInt(rate || 0, 10)) * 100}%`, "stop-color": this.starColor }), h("stop", { "stop-opacity": "1", offset: "0%", "stop-color": this.starBackground })))));
    };
    this.bazaarVoiceEnabled = undefined;
    this.ratingData = undefined;
    this.url = undefined;
    this.partialId = undefined;
    this.starSize = 15;
    this.starColor = '#ffd100';
    this.starBackground = '#cbcbcb';
  }
  renderItems() {
    const { rate, range } = this.ratingData || { rate: 0, range: 5 };
    const starClass = { class: 'star__color-filled' };
    const emptyStarClass = { class: 'star__color-empty' };
    const partialFilling = { fill: `url(#partialFilling_${this.partialId})` };
    const starsArray = [...new Array(range)];
    let integerPart = true;
    return starsArray.map((_, index) => {
      const filledStars = Math.floor(rate);
      if (index < filledStars && integerPart) {
        return StarRatingItem({ gProps: starClass, size: this.starSize });
      }
      if (integerPart) {
        integerPart = false;
        return StarRatingItem({ gProps: partialFilling, size: this.starSize });
      }
      return StarRatingItem({ gProps: emptyStarClass, size: this.starSize });
    });
  }
  componentWillLoad() {
    this.partialId = this.generateId();
  }
  render() {
    const { rate, totalQty } = this.ratingData || { rate: 0, totalQty: 0 };
    const rating = Number(rate).toFixed(1);
    return (this.bazaarVoiceEnabled && (h("a", { href: this.url, target: "_blank", rel: "noopener noreferrer", class: "product-rating" }, h("div", { class: "product-rating__wrapper" }, this.renderStarWrapper(rate), h("div", { class: "product-rating__inner-wrapper" }, this.renderItems())), h("span", { class: "product-rating__rating-count" }, rating), h("span", { class: "product-rating__review-count" }, "(", totalQty, ")"))));
  }
};
StarRating.style = starRatingCss;

const ViewMore = ({ hiddenElementsCount, rangeBlockCollapsed, viewMoreLabel, viewLessLabel, toggleRangeBlock, allCardsRenderers, }) => {
  if (allCardsRenderers.length <= MAX_VISIBLE_CARDS_WHILE_COLLAPSED)
    return null;
  const text = rangeBlockCollapsed
    ? viewMoreLabel.replace('#number of values hidden#', hiddenElementsCount.toString())
    : viewLessLabel;
  return (h("div", { class: "subcategory-block__collapser-wrapper" },
    h("qds-button", { size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.SUBDUED, onClick: toggleRangeBlock, action: !rangeBlockCollapsed ? 'dropdown-close' : 'dropdown', text: text })));
};

const SubcategoryBlockUI = ({ shouldDescriptionBeVisible, subCategory, readMoreLabel, readLessLabel, rangesSectionTitleLabel, visibleCardsRenderers, rangeBlockCollapsible, allCardsRenderers, rangeBlockCollapsed, viewMoreLabel, viewLessLabel, toggleRangeBlock, currentPageStorageKey, storageName, }) => {
  return (h(Fragment, null,
    h("div", { class: "subcategory-block__main" },
      shouldDescriptionBeVisible && (h("pes-subcategory-description", { name: subCategory.name, currentPageStorageKey: currentPageStorageKey, storageName: storageName, id: subCategory.id, description: subCategory.description, badge: subCategory.badge, url: subCategory.url, readMoreLabel: readMoreLabel, readLessLabel: readLessLabel, class: "subcategory-block__description" })),
      rangesSectionTitleLabel && (h("h2", { class: "subcategory-block__ranges-title" },
        rangesSectionTitleLabel,
        ' ',
        h("span", { class: "subcategory-block__ranges-count" },
          "(",
          subCategory.ranges.length,
          ")"))),
      h("div", { class: "subcategory-block__ranges" }, visibleCardsRenderers.map((renderCard) => renderCard()))),
    rangeBlockCollapsible && (h(ViewMore, { rangeBlockCollapsed: rangeBlockCollapsed, hiddenElementsCount: allCardsRenderers.length - visibleCardsRenderers.length, allCardsRenderers: allCardsRenderers, viewMoreLabel: viewMoreLabel, viewLessLabel: viewLessLabel, toggleRangeBlock: toggleRangeBlock }))));
};

const subcategoryBlockCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.subcategory-block__main{padding:15px}@media screen and (min-width: 980px){.subcategory-block__main{padding:30px 40px}}.subcategory-block__collapser-wrapper{display:flex;justify-content:center;border-top:1px solid #e6e6e6}@media screen and (min-width: 980px){.subcategory-block__collapser-wrapper{padding:4px 40px}}.subcategory-block__ranges{display:flex;flex-wrap:wrap;flex-direction:column}@media screen and (min-width: 980px){.subcategory-block__ranges{flex-direction:row;max-width:100%}}.subcategory-block__range-card{padding:20px 5px}@media screen and (min-width: 980px){.subcategory-block__range-card{width:calc(33.33% - 16.66px)}:host(:not([dir=\"rtl\"])) .subcategory-block__range-card{margin-right:25px}:host([dir=\"rtl\"]) .subcategory-block__range-card{margin-left:25px}:host(:not([dir=\"rtl\"])) .subcategory-block__range-card:nth-child(3n){margin-right:0}:host([dir=\"rtl\"]) .subcategory-block__range-card:nth-child(3n){margin-left:0}}.subcategory-block__promo-banner{padding:20px 5px;flex:1 0 auto}.subcategory-block__description{display:block;margin-bottom:16px}.subcategory-block__ranges-title{margin:0;color:#333333;font-weight:400;font-size:1.125rem;line-height:1.5625rem}@media screen and (min-width: 980px){.subcategory-block__ranges-title{font-size:1.375rem;line-height:1.875rem}}.subcategory-block__ranges-count{color:#9fa0a6;cursor:default}";

const SubcategoryBlock = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.toggleRangeBlock = (e) => {
      e === null || e === void 0 ? void 0 : e.preventDefault();
      this.rangeBlockCollapsed = !this.rangeBlockCollapsed;
    };
    this.getRangeRenderer = (range, idx) => () => (h("pes-category-range-card", { key: range.id, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName, subCategory: !this.shouldHaveSubcategory && this.subCategory, class: "subcategory-block__range-card", data: range, productRelationsViewProdLabel: this.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: this.rangeProductsViewDetailsLabel, viewOnLabel: this.viewOnLabel, rangePartofLabel: this.rangePartofLabel, avoidAccents: this.avoidAccents, withImageLazy: this.isFirstBlock ? idx > 2 : true }));
    this.promoBannerRenderer = () => (h("pes-banner-promo-block", { key: "subcategory-promo-banner", class: "subcategory-block__promo-banner", sdlCategoryPromo: this.subCategory.sdlCategoryPromo }));
    this.subCategory = undefined;
    this.rangePartofLabel = undefined;
    this.viewOnLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.rangeProductsViewDetailsLabel = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.rangesSectionTitleLabel = undefined;
    this.viewMoreLabel = undefined;
    this.viewLessLabel = undefined;
    this.rangeBlockCollapsible = undefined;
    this.showDescriptionBlock = true;
    this.avoidAccents = undefined;
    this.navState = undefined;
    this.rangeBlockCollapsed = undefined;
    this.isFirstBlock = false;
    this.currentPageStorageKey = undefined;
    this.storageName = undefined;
    this.shouldHaveSubcategory = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    this.rangeBlockCollapsed = this.rangeBlockCollapsible;
  }
  watchRangeBlockCollapsible(newValue) {
    if (newValue === this.rangeBlockCollapsed)
      return;
    this.rangeBlockCollapsed = newValue;
  }
  render() {
    var _a, _b;
    if (!((_b = (_a = this.subCategory) === null || _a === void 0 ? void 0 : _a.ranges) === null || _b === void 0 ? void 0 : _b.length))
      return;
    const allCardsRenderers = this.subCategory.ranges.map(this.getRangeRenderer);
    if (!isPBS() && this.subCategory.sdlCategoryPromo) {
      allCardsRenderers.splice(MAX_RANGES_BEFORE_SDL_PROMO_BANNER, 0, this.promoBannerRenderer);
    }
    const visibleCardsRenderers = this.rangeBlockCollapsed
      ? allCardsRenderers.slice(0, MAX_VISIBLE_CARDS_WHILE_COLLAPSED)
      : allCardsRenderers;
    const shouldDescriptionBeVisible = this.showDescriptionBlock
      && (this.subCategory.name || this.subCategory.description);
    return (h(SubcategoryBlockUI, { shouldDescriptionBeVisible: Boolean(shouldDescriptionBeVisible), visibleCardsRenderers: visibleCardsRenderers, subCategory: this.subCategory, readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, rangesSectionTitleLabel: this.rangesSectionTitleLabel, rangeBlockCollapsible: this.rangeBlockCollapsible, allCardsRenderers: allCardsRenderers, rangeBlockCollapsed: this.rangeBlockCollapsed, viewMoreLabel: this.viewMoreLabel, viewLessLabel: this.viewLessLabel, toggleRangeBlock: this.toggleRangeBlock, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName }));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "rangeBlockCollapsible": ["watchRangeBlockCollapsible"]
  }; }
};
SubcategoryBlock.style = subcategoryBlockCss;

const subcategoryDescriptionCss = ":host{display:block}.subcategory-description{display:flex;align-items:center;flex-wrap:wrap}@media screen and (max-width: 979px){.subcategory-description{flex-direction:column;align-items:flex-start;margin:0 0 15px}}:host(:not([dir=\"rtl\"])) .subcategory-description__header{margin:0 15px 0 0}:host([dir=\"rtl\"]) .subcategory-description__header{margin:0 0 0 15px}.subcategory-description__link{font-size:1.5625rem;line-height:2.1875rem;color:#3dcd58;font-weight:400;text-decoration:none}@media screen and (min-width: 980px){.subcategory-description__link{font-size:1.875rem;line-height:2.25rem}}.subcategory-description__badge{display:flex}@media screen and (max-width: 979px){.subcategory-description__badge{margin-top:10px}}";

const SubcategoryDescription = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.handleLinkClick = async (event) => {
      if (!isAppRoutingEnabled())
        return;
      const target = event.currentTarget;
      event.preventDefault();
      if (!isIndexDBEnabled()) {
        navigateWithRouter(this.route, target);
        return;
      }
      const { consumer, storageName } = getConsumerSpecificData(true, this.storageName);
      indexDBBreadcrumbs.setChannel(consumer);
      const breadcrumbs = await indexDBBreadcrumbs.getValidatedBreadcrumbs({
        storageName,
        key: this.currentPageStorageKey,
      });
      await storeBreadcrumbs({
        pageName: PageNames.SUBCATEGORY,
        url: this.url,
        id: this.id,
        name: this.name,
        breadcrumbs,
        storageName,
      });
      navigateWithRouter(this.route, target);
    };
    this.id = undefined;
    this.name = undefined;
    this.description = undefined;
    this.badge = undefined;
    this.url = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.currentPageStorageKey = undefined;
    this.storageName = undefined;
    this.route = new PesRoute({ page: 'subcategory', pageId: this.id });
    this.el.dir = document.documentElement.dir || 'auto';
  }
  urlChanged(newValue) {
    if (!isAppRoutingEnabled())
      return;
    const { pageType, pageId } = parseCommonURLToRouterParts(newValue);
    this.route = new PesRoute({ page: pageType, pageId });
    this.url = this.route.url;
  }
  getWrapped(text) {
    return `<!--L2_BEGIN-->${text}<!--L2_END-->`;
  }
  getLink() {
    if (this.url) {
      return (h("a", { href: this.url, class: "subcategory-description__link", innerHTML: this.getWrapped(this.name), onClick: this.handleLinkClick }));
    }
    return (h("pes-router-link", { page: "subcategory", pageId: this.id, saveInIndexDB: (e) => isIndexDBEnabled() && this.handleLinkClick(e) }, h("a", { href: "#", class: "subcategory-description__link" }, this.name)));
  }
  render() {
    if (!this.name && !this.description) {
      return null;
    }
    return (h(Host, null, this.name && (h("div", { class: "subcategory-description" }, h("h2", { class: "subcategory-description__header" }, this.getLink()), this.badge && (h("div", { class: "subcategory-description__badge" }, h("pes-badge-wrapper", { type: this.badge.type, label: this.badge.label }))))), this.description && (h("pes-description", { text: this.description, expandLabel: this.readMoreLabel, collapseLabel: this.readLessLabel, numLinesToShow: { desktop: 2, mobile: 4 }, isBanner: true }))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "url": ["urlChanged"]
  }; }
};
SubcategoryDescription.style = subcategoryDescriptionCss;

const subcategoryListCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.subcategory-list{display:flex;flex-direction:column;margin-bottom:32px;background-color:#ffffff;box-shadow:0 1px 3px 0 rgba(51, 51, 51, 0.15)}@media screen and (min-width: 980px){.subcategory-list{max-width:900px;min-width:650px;min-height:300px;box-sizing:border-box;border:1px solid #e6e6e6;box-shadow:none}}";

const SubcategoryList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("section", { class: "subcategory-list" }, h("slot", { name: "pes-subcategory-block" })));
  }
  get el() { return getElement(this); }
};
SubcategoryList.style = subcategoryListCss;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


const applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


const arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


const computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


const eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


const flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


const hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


const offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


const popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


const preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

const tooltipCss = ":host{display:none}:host([active]){display:block}.tooltip__arrow{position:absolute;width:28px;height:12px;overflow:hidden}.tooltip__arrow::before{content:\"\";position:absolute;display:block;background-color:#ffffff;visibility:visible;width:12px;height:12px;top:0}:host(:not([dir=\"rtl\"])) .tooltip__arrow::before{transform:translateX(-50%) translateY(-50%) rotate(45deg);left:50%;box-shadow:2px 2px 4px 0 rgba(51, 51, 51, 0.15)}:host([dir=\"rtl\"]) .tooltip__arrow::before{transform:translateX(50%) translateY(-50%) rotate(-45deg);right:50%;box-shadow:-2px 2px 4px 0 rgba(51, 51, 51, 0.15)}:host([data-popper-placement^=top]) .tooltip__arrow{bottom:-12px}:host([data-popper-placement^=bottom]) .tooltip__arrow{top:-12px}:host([data-popper-placement^=bottom]) .tooltip__arrow::before{top:auto;bottom:-12px}:host(:not([dir=\"rtl\"])[data-popper-placement^=bottom]) .tooltip__arrow::before{transform:translateX(-50%) translateY(-50%) rotate(315deg)}:host([dir=\"rtl\"][data-popper-placement^=bottom]) .tooltip__arrow::before{transform:translateX(50%) translateY(-50%) rotate(-315deg)}.tooltip__content{display:block;margin:0;background-color:#ffffff;border-radius:4px;box-shadow:0 0 5px 0 rgba(51, 51, 51, 0.05), 0 5px 5px 0 rgba(51, 51, 51, 0.15)}.tooltip__content--option-fill{padding-top:16px;padding-bottom:16px}.tooltip__content--option-indent{padding:16px}";

const FALLBACK_PLACEMENTS = {
  top: 'bottom',
  bottom: 'top',
};
const PesTooltip = class {
  async activeDidChange() {
    var _a;
    await ((_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.setOptions(this.getOptions()));
    this.updateWhenActive();
  }
  async referenceDidChange() {
    var _a;
    (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.destroy();
    this.popperInstance = createPopper(this.reference, this.host, this.getOptions());
    this.updateWhenActive();
  }
  triggerUpdate() {
    var _a;
    return (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.forceUpdate();
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.createArrowRef = (el) => {
      this.arrowRef = el;
    };
    this.reference = undefined;
    this.arrow = false;
    this.placement = 'top';
    this.active = false;
    this.option = 'indent';
    this.host.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    if (this.reference) {
      this.popperInstance = createPopper(this.reference, this.host, this.getOptions());
    }
    this.updateWhenActive();
  }
  componentWillUnload() {
    var _a;
    (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.destroy();
  }
  updateWhenActive() {
    var _a;
    if (this.active) {
      (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.forceUpdate();
    }
  }
  getOptions() {
    const modifiers = [
      {
        name: 'flip',
        enabled: true,
        options: {
          fallbackPlacements: [FALLBACK_PLACEMENTS[this.placement]],
        },
      },
      {
        name: 'offset',
        enabled: true,
        options: {
          offset: [0, 12],
        },
      },
      {
        name: 'eventListeners',
        enabled: this.active,
      },
    ];
    if (this.arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: this.arrowRef,
        },
      });
    }
    return {
      strategy: 'fixed',
      placement: this.placement,
      modifiers,
    };
  }
  render() {
    return (h(Host, null, this.arrow && h("div", { ref: this.createArrowRef, class: "tooltip__arrow" }), h("div", { class: {
        tooltip__content: true,
        [`tooltip__content--option-${this.option}`]: true,
      } }, h("slot", null))));
  }
  get host() { return getElement(this); }
  static get watchers() { return {
    "active": ["activeDidChange"],
    "reference": ["referenceDidChange"]
  }; }
};
PesTooltip.style = tooltipCss;

const DEFAULT_LEAVE_DELAY = 100;

const tooltipWrapperCss = ":host{display:inline-block}:host>div:hover .tooltip,:host>div:active .tooltip{visibility:visible;z-index:10}:host([hidden]){display:none}.tooltip-wrapper{cursor:default;max-width:520px;z-index:10}.tooltip-wrapper-inner-content{display:block;font-size:12px;line-height:14px}.tooltip-wrapper-container{display:flex}.tooltip-wrapper-container--pointer{cursor:pointer}.tooltip-wrapper-container .tooltip-wrapper-text{color:#9fa0a4;line-height:16px}:host(:not([dir=\"rtl\"])) .tooltip-wrapper-container .tooltip-wrapper-text{margin-left:5px}:host([dir=\"rtl\"]) .tooltip-wrapper-container .tooltip-wrapper-text{margin-right:5px}.tooltip-wrapper-container .tooltip-wrapper-text:hover,.tooltip-wrapper-container .tooltip-wrapper-text:active{color:#626469;cursor:pointer}@media screen and (max-width: 979px){.tooltip-wrapper-container{padding:1em;margin:-1em}}.tooltip-wrapper-modal-content{color:#626469;font-size:14px;position:relative;display:flex;justify-content:center;flex-direction:column;padding:32px 30px}.tooltip-wrapper-modal-close-button{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg viewBox='0 0 19 19' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath fill='%239FA0A4' fill-rule='evenodd' d='M13.1 13.1c-.28.28-.74.28-1.02 0l-2.7-2.68-2.8 2.8c-.28.3-.74.3-1.02 0a.7.7 0 0 1 0-1l2.8-2.83L5.7 6.7c-.3-.27-.3-.73 0-1 .27-.3.73-.3 1 0l2.7 2.67 2.55-2.55c.28-.3.74-.3 1.02 0 .28.28.28.73 0 1.02L10.42 9.4l2.68 2.68c.28.28.28.74 0 1.02m2.94-10.35c-3.66-3.67-9.63-3.67-13.3 0-3.66 3.66-3.66 9.62 0 13.3 3.67 3.65 9.63 3.65 13.3 0 3.66-3.68 3.66-9.64 0-13.3'%3E%3C/path%3E%3C/svg%3E\");height:20px;width:20px;position:absolute;top:11px}:host(:not([dir=\"rtl\"])) .tooltip-wrapper-modal-close-button{right:11px}:host([dir=\"rtl\"]) .tooltip-wrapper-modal-close-button{left:11px}.tooltip-wrapper-modal-close-button::before{content:\"\";display:block;top:-10px;position:absolute;height:40px;width:40px}:host(:not([dir=\"rtl\"])) .tooltip-wrapper-modal-close-button::before{right:-10px}:host([dir=\"rtl\"]) .tooltip-wrapper-modal-close-button::before{left:-10px}@media screen and (min-width: 980px){:host{position:relative}}";

const TooltipWrapperComponent = class {
  onShowModalChange(newValue) {
    if (newValue === false && this.sustainabilityPortal) {
      this.sustainabilityPortal.isOpen = newValue;
    }
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didOpen = createEvent(this, "didOpen", 7);
    this.didClose = createEvent(this, "didClose", 7);
    this.open = () => {
      this.active = true;
      clearTimeout(this.leaveTimer);
      this.didOpen.emit();
    };
    this.close = () => {
      if ((this.isBrowser && !this.isMobile) || (this.isMobile && !this.isSustainabilityPortal)) {
        this.active = false;
        clearTimeout(this.leaveTimer);
        this.didClose.emit();
      }
      if (this.isBrowser && this.isMobile && this.isSustainabilityPortal) {
        this.sustainabilityPortal.isOpen = false;
      }
    };
    this.handleResizeWindow = () => {
      this.isMobile = isMobile();
    };
    this.handleMouseEnter = () => {
      if (!this.isMobile) {
        this.open();
      }
    };
    this.handleMouseLeave = () => {
      var _a;
      if (!this.isMobile) {
        this.leaveTimer = window.setTimeout(this.close, (_a = this.leaveDelay) !== null && _a !== void 0 ? _a : 0);
      }
    };
    this.handleKeydown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.active ? this.close() : this.open();
      }
    };
    this.handleClick = () => {
      this.open();
      if (this.isBrowser && this.isMobile && this.isSustainabilityPortal) {
        this.sustainabilityPortal.isOpen = true;
      }
    };
    this.handleDialogClose = this.close;
    this.renderPortalMobileContent = () => {
      if (!this.sustainabilityPortal) {
        this.sustainabilityPortal = document.createElement('pes-sustainability-portal');
        if (!this.sustainabilityPortalTooltipContent) {
          this.sustainabilityPortalTooltipContent = this.sustainabilityPortal.querySelector('[slot="tooltip-content"]')
            || this.host.querySelector('[slot="tooltip-content"]');
        }
        this.sustainabilityPortal.appendChild(this.sustainabilityPortalTooltipContent);
        document.body.append(this.sustainabilityPortal);
      }
    };
    this.renderMobileContent = () => {
      return (h("se-dialog", { size: "small", open: this.active, noBackdrop: true, pageScroll: false }, h("div", { class: "tooltip-wrapper-modal-content" }, h("button", { class: "tooltip-wrapper-modal-close-button", onClick: this.handleDialogClose }), h("slot", { name: "tooltip-content" }))));
    };
    this.renderDesktopContent = (interactiveListeners) => {
      return (h("pes-tooltip", Object.assign({}, interactiveListeners, { ref: (el) => (this.tooltipRef = el), class: "tooltip-wrapper", placement: this.position, arrow: true, active: this.active, reference: this.tooltipContainerRef }), h("div", { class: "tooltip-wrapper-inner-content" }, h("slot", { name: "tooltip-content" }))));
    };
    this.renderContent = (interactiveListeners) => {
      if (this.isBrowser && this.isMobile) {
        if (this.isSustainabilityPortal) {
          return this.renderPortalMobileContent();
        }
        return this.renderMobileContent();
      }
      return this.renderDesktopContent(interactiveListeners);
    };
    this.position = 'bottom';
    this.disableInteractive = false;
    this.leaveDelay = DEFAULT_LEAVE_DELAY;
    this.showTooltip = true;
    this.showModal = false;
    this.isSustainabilityPortal = false;
    this.active = false;
    this.isBrowser = isBrowser();
    this.isMobile = isMobile();
    this.host.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    forceUpdate(this.host);
    if (this.isBrowser && this.isMobile && this.isSustainabilityPortal) {
      this.renderPortalMobileContent();
    }
  }
  connectedCallback() {
    window.addEventListener('resize', this.handleResizeWindow);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResizeWindow);
  }
  render() {
    const interactiveListeners = {};
    if (!this.disableInteractive) {
      interactiveListeners.onMouseEnter = this.handleMouseEnter;
      interactiveListeners.onMouseLeave = this.handleMouseLeave;
    }
    return (h(Host, null, h("div", { ref: (el) => (this.tooltipContainerRef = el), onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, onClick: this.handleClick, onKeyDown: this.handleKeydown, onFocusout: this.handleDialogClose, tabIndex: 0, role: "button", class: {
        'tooltip-wrapper-container': true,
        'tooltip-wrapper-container--pointer': this.showTooltip,
      } }, h("slot", { name: "tooltip-activator" })), this.showTooltip && this.renderContent(interactiveListeners)));
  }
  get host() { return getElement(this); }
  static get watchers() { return {
    "showModal": ["onShowModalChange"]
  }; }
};
TooltipWrapperComponent.style = tooltipWrapperCss;

const uscCss = ":host{display:block;box-sizing:border-box;z-index:10}:host *,:host *::before,:host *::after{box-sizing:inherit}:host ::slotted(*){margin-bottom:12px;pointer-events:all}:host ::slotted(*:last-child:not(pes-back-to-top)){margin-bottom:0}.usc-wrapper{display:flex;flex-direction:column;justify-content:flex-end;align-items:flex-end;pointer-events:none;width:100%;position:fixed;right:0;bottom:0;left:0;z-index:9;margin-bottom:12px}@media screen and (max-width: 719px){.usc-wrapper{padding:0;margin-bottom:0}}@media screen and (min-width: 720px){.usc-wrapper{margin-bottom:12px}}";

const Usc = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: "usc-wrapper" }, h("slot", null)));
  }
};
Usc.style = uscCss;

const COMMERCIAL_STATUS_MAX_LENGTH = 30;
const LINE_HEIGHT = '28px';
const ProductCardAdditionalContent = ({ badge, commercialInfo, circularAvailability }) => {
  if (!badge && !commercialInfo && !circularAvailability)
    return null;
  return (h("div", { class: "badge-wrapper" },
    badge && (h("pes-badge-wrapper", { class: "badge", type: badge.type, label: badge.label, size: "large", lineHeight: LINE_HEIGHT })),
    commercialInfo && (h(ProductCommercialLabel, { statusMaxLength: COMMERCIAL_STATUS_MAX_LENGTH, lineHeight: LINE_HEIGHT, message: commercialInfo.commercialMessage, backgroundColor: commercialInfo.commercialColor, color: commercialInfo.commercialTextColor })),
    circularAvailability && (h("qds-tag", { text: circularAvailability, status: "success", size: QdsSize.SMALL }))));
};

const mainInfoCss = ".main-info{position:relative;margin:10px 0}@media screen and (max-width: 979px){.main-info{margin:8px;position:unset}}@media screen and (min-width: 980px){.main-info.list{position:unset;margin-top:0;display:flex;flex-wrap:wrap}}.main-info__product-links{margin-bottom:3px;height:-moz-fit-content;height:fit-content;width:100%;display:flex;align-items:center}@media screen and (min-width: 980px){.list .main-info__product-links{margin-bottom:10px}}.logo{position:absolute;bottom:calc(100% + 16px);display:flex;flex-direction:column;gap:8px;align-items:flex-start}@media screen and (max-width: 979px){.logo{bottom:8px}:host(:not([dir=\"rtl\"])) .logo{left:0;margin-left:8px}:host([dir=\"rtl\"]) .logo{right:0;margin-right:8px}.logo .green-premium,.logo .brand{display:none}}@media screen and (min-width: 980px){.list .logo{bottom:28px}:host(:not([dir=\"rtl\"])) .list .logo{left:0;margin-left:20px}:host([dir=\"rtl\"]) .list .logo{right:0;margin-right:20px}}.logo .made-in-america{overflow:hidden}@media screen and (min-width: 980px){.list .logo .made-in-america{margin-top:0}}.logo .brand{width:60px;overflow:hidden}@media screen and (min-width: 980px){.list .logo .brand{vertical-align:middle}}.logo .green-premium{width:54px;height:20px;overflow:hidden}.commercial{display:inline-block;width:auto;margin:0;padding:0 5px;color:#ffffff;font-size:14px;font-weight:700;line-height:20px;background-color:#b10043;border-radius:4px}a{color:inherit;display:inline-flex}a,a:hover{text-decoration:none}.enumber{display:inline-block;color:#626469;font-weight:normal;font-size:12px;line-height:15px}:host(:not([dir=\"rtl\"])) .enumber{margin-right:10px;padding-right:10px;border-right:1px solid #f3f2f2}:host([dir=\"rtl\"]) .enumber{margin-left:10px;padding-left:10px;border-left:1px solid #f3f2f2}@media screen and (max-width: 979px){.enumber{font-size:10px}:host(:not([dir=\"rtl\"])) .enumber{margin-right:0px;padding-right:5px}:host([dir=\"rtl\"]) .enumber{margin-left:0px;padding-left:5px}}.enumber .enumber-link{visibility:visible}:host(:not([dir=\"rtl\"])) .enumber .enumber-link span{margin-right:5px}:host([dir=\"rtl\"]) .enumber .enumber-link span{margin-left:5px}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .enumber .enumber-link span{margin-right:5px}:host([dir=\"rtl\"]) .enumber .enumber-link span{margin-left:5px}}@media screen and (min-width: 980px){.list .enumber{order:1;height:20px;font-size:14px;line-height:20px}:host(:not([dir=\"rtl\"])) .list .enumber{padding-right:10px;margin-right:10px;border-right:1px solid #f3f2f2}:host([dir=\"rtl\"]) .list .enumber{padding-left:10px;margin-left:10px;border-left:1px solid #f3f2f2}.grid .enumber{font-size:12px;line-height:15px}}.commercial-reference,.commercial-reference__bundle{color:#626469;font-size:0.75rem}@media screen and (max-width: 979px){.commercial-reference,.commercial-reference__bundle{font-size:0.875rem;font-weight:400}}.commercial-reference-link,.commercial-reference__bundle-link{visibility:visible;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden}@media screen and (min-width: 980px){.commercial-reference,.commercial-reference__bundle{display:inline-block}.list .commercial-reference,.list .commercial-reference__bundle{order:2;height:20px;font-size:14px;line-height:20px}.grid .commercial-reference,.grid .commercial-reference__bundle{font-size:12px;line-height:18px}}.description{overflow:hidden;display:block;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;font-weight:bold;color:#333333;font-size:0.875rem;line-height:25px;max-height:100px}.description:hover,.description:focus{text-decoration:underline}.description-mobile{font-size:0.875rem;line-height:20px}.description-link{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}@media screen and (min-width: 980px){.description{-webkit-line-clamp:3;max-height:60px}.list .description{order:4;width:100%}.grid .description{font-size:14px;line-height:20px}}.description-link__content{margin:0;font-size:inherit;font-weight:inherit;line-height:inherit}@media screen and (max-width: 979px){.description-link__content{line-height:20px}}.bundle-description{overflow:hidden;display:block;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;font-weight:bold;color:#626469;font-size:0.875rem;line-height:1.25rem;max-height:100px;margin-bottom:16px}.bundle-description a:hover,.bundle-description a:focus{color:#3dcd58}@media screen and (max-width: 719px){.bundle-description{-webkit-line-clamp:10;max-height:200px}}.main-product-link,.bundle-product-link{display:inline;color:#333333}.count-ellips{cursor:default;font-size:0.625rem;line-height:1rem;position:relative;display:inline-block;width:22px;height:16px;flex-shrink:0;border-radius:10px;vertical-align:middle;text-align:center;background-color:#e7e6e6;color:#0f0f0f}:host(:not([dir=\"rtl\"])) .count-ellips{margin-right:5px}:host([dir=\"rtl\"]) .count-ellips{margin-left:5px}.tooltip-content{max-width:263px;max-height:160px}.tooltip-content .tooltip-title{font-size:0.75rem;font-weight:700;color:#9fa0a4;margin-bottom:9px}:host(:not([dir=\"rtl\"])) .tooltip-content .count-ellips{margin-right:8px}:host([dir=\"rtl\"]) .tooltip-content .count-ellips{margin-left:8px}.tooltip-content .main-product-link,.tooltip-content .bundle-product-link{color:#42b4e6;line-height:1rem;margin-bottom:6px}.tooltip-content .tooltip-main-product,.tooltip-content .tooltip-bundle-product{display:flex}.tooltip-content .commercial-reference__bundle{display:block}:host(:not([dir=\"rtl\"])) .tooltip-content .commercial-reference__bundle{margin-left:30px}:host([dir=\"rtl\"]) .tooltip-content .commercial-reference__bundle{margin-right:30px}.tooltip-content .tooltip-bundle-rating{display:flex;align-items:center;justify-content:flex-start;gap:12px;margin-bottom:6px}.badge-wrapper{display:flex;margin:10px 0 5px;flex-wrap:wrap;gap:4px}@media screen and (min-width: 980px){.list .badge-wrapper{margin:12px 0 8px 0;min-height:20px;width:100%;order:3}}@media screen and (max-width: 979px){.main-info__qds-tag{--qds-control-small-height:1.75rem}}";

const ProductCardMainInfo = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.miaLogo = null;
    this.logosUrls = null;
    this.enumber = undefined;
    this.pdpUrl = undefined;
    this.description = undefined;
    this.bundledProduct = false;
    this.bundleQty = undefined;
    this.bundleUrl = undefined;
    this.bundleDescription = undefined;
    this.bundleDetailsLabel = undefined;
    this.bundleItemsLabel = undefined;
    this.commercialReference = undefined;
    this.bundleCommercialReferenceBundle = undefined;
    this.layout = 'grid';
    this.repositoryId = undefined;
    this.bundleRepositoryId = undefined;
    this.enableAppRouting = undefined;
    this.hostWithoutLocaleCodes = undefined;
    this.greenPremiumLogo = undefined;
    this.pdsLogo = undefined;
    this.commercialInfo = undefined;
    this.isMobile = false;
    this.bazaarVoiceEnabled = false;
    this.productsRatings = undefined;
    this.badge = undefined;
    this.isExternalConsumer = false;
    this.viewDetailUrl = undefined;
    this.handleProductClick = undefined;
    this.extraBadges = undefined;
    this.circularAvailability = undefined;
    this.isMobileView = isMobile();
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getLogoUrl(name) {
    if (!this[name])
      return null;
    if (this[name].absoluteUrl) {
      return this[name].absoluteUrl;
    }
    return this.hostWithoutLocaleCodes + this[name].url;
  }
  urlWithAnchorToReview(href) {
    const url = new URL(href);
    url.hash = REVIEW_SECTION_ANCHOR;
    return url.href;
  }
  renderLogos() {
    if (!this.greenPremiumLogo && !this.pdsLogo && !this.miaLogo) {
      return null;
    }
    return (h("div", { class: "logo" }, this.miaLogo && (h("img", { class: "made-in-america", src: this.logosUrls.miaLogoUrl, alt: this.miaLogo.alt, width: "40", height: "40" })), this.pdsLogo && (h("img", { class: "brand", src: this.logosUrls.pdsLogoUrl, alt: this.pdsLogo.alt, width: "60" })), this.greenPremiumLogo && (h("img", { class: "green-premium", src: this.logosUrls.greenPremiumLogoUrl, alt: this.greenPremiumLogo.alt, width: "54" }))));
  }
  renderDescription() {
    return (h(PesProductLink, { className: classnames('description', this.isMobile && 'description-mobile'), url: this.isExternalConsumer ? this.viewDetailUrl : this.pdpUrl, id: this.repositoryId, enableAppRouting: this.enableAppRouting }, h("a", { href: this.pdpUrl, onClick: this.handleProductClick, class: "description-link", title: this.description && this.description.replace(/&nbsp;/g, String.fromCharCode(160)) }, h("h3", { class: "description-link__content", innerHTML: isWebkitLineClampSupports() ? this.description : '', "data-da-element-id": "p_tile_sub" }, !isWebkitLineClampSupports() && (h("pes-ellipsis", { maxHeight: "80px", modifier: this.layout, content: this.description }))))));
  }
  renderCommercialReference(reference, url, repositoryId) {
    if (this.isMobileView && this.enumber)
      return null;
    return (h(PesProductLink, { className: this.bundledProduct ? 'commercial-reference__bundle' : 'commercial-reference', url: this.isExternalConsumer ? this.viewDetailUrl : url, id: repositoryId, enableAppRouting: this.enableAppRouting }, h("a", { href: this.isExternalConsumer ? this.viewDetailUrl : url, class: "commercial-reference-link", "data-da-element-id": "p_tile_t", title: reference, onClick: this.handleProductClick }, reference)));
  }
  renderBundleDescriptionItem(description, url, isMain) {
    const productTitle = description && description.replace(/&nbsp;/g, String.fromCharCode(160));
    const id = isMain ? 'p_tile_sub_main' : 'p_tile_sub_bundle';
    const linkClassName = isMain ? 'main-product-link' : 'bundle-product-link';
    return (h("a", { href: url, class: linkClassName, "data-da-element-id": id, title: productTitle, innerHTML: isWebkitLineClampSupports() ? description : '' }, !isWebkitLineClampSupports() && (h("pes-ellipsis", { maxHeight: "50px", modifier: this.layout, content: description }))));
  }
  renderBundleDescription() {
    return (h(PesProductLink, { className: classnames('bundle-description', this.isMobile && 'bundle-description-mobile'), url: this.pdpUrl, id: this.repositoryId, enableAppRouting: this.enableAppRouting }, h("div", { class: "count-ellips" }, "x1"), this.renderBundleDescriptionItem(this.description, this.pdpUrl, true), IconPlus(), h("div", { class: "count-ellips" }, "x", this.bundleQty), this.renderBundleDescriptionItem(this.bundleDescription, this.bundleUrl)));
  }
  renderBundledTooltip() {
    var _a, _b;
    const commonQuantity = 1 + this.bundleQty;
    return (h("pdp-icon-tooltip", { class: "toggle-icon-info m-hidden", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "top", text: this.bundleDetailsLabel || 'UPS Solution details' }, h("div", { class: "tooltip-content" }, h("div", { class: "tooltip-title" }, h("span", null, `${this.bundleItemsLabel || 'Items:'} ${commonQuantity}`)), h("div", { class: "tooltip-main-product" }, h("div", { class: "count-ellips" }, "x1"), this.renderBundleDescriptionItem(this.description, this.pdpUrl, true)), h("div", { class: "tooltip-bundle-rating" }, this.renderCommercialReference(this.commercialReference, this.pdpUrl, this.repositoryId), h("pes-star-rating", { bazaarVoiceEnabled: this.bazaarVoiceEnabled, ratingData: (_a = this.productsRatings) === null || _a === void 0 ? void 0 : _a[this.repositoryId], url: this.urlWithAnchorToReview(this.pdpUrl) })), h("div", { class: "tooltip-bundle-product" }, h("div", { class: "count-ellips" }, "x", this.bundleQty), this.renderBundleDescriptionItem(this.bundleDescription, this.bundleUrl)), h("div", { class: "tooltip-bundle-rating" }, this.renderCommercialReference(this.bundleCommercialReferenceBundle, this.bundleUrl, this.bundleRepositoryId), h("pes-star-rating", { bazaarVoiceEnabled: this.bazaarVoiceEnabled, ratingData: (_b = this.productsRatings) === null || _b === void 0 ? void 0 : _b[this.bundleRepositoryId], url: this.urlWithAnchorToReview(this.bundleUrl) })))));
  }
  componentWillLoad() {
    var _a, _b;
    this.miaLogo = (_b = (_a = this.extraBadges) === null || _a === void 0 ? void 0 : _a.find(({ charId }) => charId === ExtraBadgesCharId.ATS_MADE_IN_AMERICA)) === null || _b === void 0 ? void 0 : _b.url;
    if (!this.greenPremiumLogo && !this.pdsLogo && !this.miaLogo) {
      return null;
    }
    this.logosUrls = {
      miaLogoUrl: this.getLogoUrl('miaLogo'),
      greenPremiumLogoUrl: this.getLogoUrl('greenPremiumLogo'),
      pdsLogoUrl: this.getLogoUrl('pdsLogo'),
    };
  }
  render() {
    return (h("div", { class: `main-info ${this.layout}` }, !this.isMobileView && (h(ProductCardAdditionalContent, { badge: this.badge, commercialInfo: this.commercialInfo, circularAvailability: this.circularAvailability })), this.isMobileView && this.circularAvailability && (h("div", { class: "main-info__qds-tag" }, h("qds-tag", { text: this.circularAvailability, status: "success", size: QdsSize.SMALL }))), h("div", { class: "main-info__product-links" }, this.renderLogos(), this.enumber && (h(PesProductLink, { className: "enumber", url: this.pdpUrl, id: this.repositoryId, enableAppRouting: this.enableAppRouting }, h("a", { href: this.pdpUrl, class: "enumber-link" }, h("span", null, this.enumber.code, ":"), this.enumber.value))), !this.bundledProduct
      && this.renderCommercialReference(this.commercialReference, this.pdpUrl, this.repositoryId)), this.bundledProduct ? this.renderBundleDescription() : this.renderDescription(), this.bundledProduct && this.renderBundledTooltip()));
  }
  get el() { return getElement(this); }
};
ProductCardMainInfo.style = mainInfoCss;

const productCardsWrapperCss = "::slotted([slot=title]){margin:0 0 20px !important;flex:1 1 auto}.cards-wrapper{box-sizing:border-box;margin:auto}.cards-wrapper *,.cards-wrapper *::before,.cards-wrapper *::after{box-sizing:inherit}@media screen and (min-width: 980px){.cards-wrapper__header{display:flex;justify-content:flex-end;align-items:flex-end}}@media screen and (max-width: 979px){.switch-view{display:none}}@media screen and (min-width: 980px){.switch-view{display:flex;justify-content:flex-end;align-items:baseline;margin-bottom:20px}}:host(:not([dir=\"rtl\"])) slot[name=title]+.switch-view{margin-left:20px}:host([dir=\"rtl\"]) slot[name=title]+.switch-view{margin-right:20px}.cards-list{margin:0;padding:0;list-style:none}.cards-item:not(:last-child){margin-bottom:20px}@media screen and (max-width: 719px){.cards-item:not(:last-child){margin-bottom:20px}}@media screen and (min-width: 980px){.cards-wrapper{max-width:100%;margin:auto}.cards-wrapper.grid-view .cards-list{display:flex;flex-wrap:wrap;max-width:880px;margin-left:auto;margin-right:auto}.cards-wrapper.grid-view .cards-item{min-height:100%;width:33.3%;min-width:292px}.cards-wrapper.grid-view .cards-item:not(:last-child){margin-bottom:0px}.cards-wrapper.list-view .cards-list{border-top:1px solid transparent;max-width:880px;margin-left:auto;margin-right:auto}.cards-wrapper.list-view .cards-item{margin:0}}@media only screen and (max-height: 430px){.cards-item{width:400px;margin:0 auto}}";

const ProductCardWrapper = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    var _a;
    this.notificationController = new NotificationBannerController();
    this.gridStateStorageKey = 'pes-uiaas-gridState';
    this.unifiedCheckoutFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.unifiedCheckout;
    this.isUnifiedCheckoutEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.unifiedCheckoutFlag || {});
    this.productPropDefault = 'repositoryId';
    this.productsForCC = [];
    this.additionalDistributors = null;
    this.splitBundlePartNumbers = (partNumber) => {
      if (partNumber.includes(':')) {
        const [basePartNumber, auxPartNumberFull] = partNumber.split(':');
        const [, auxPartNumber] = auxPartNumberFull.split(')');
        return [basePartNumber, auxPartNumber];
      }
      return [partNumber];
    };
    this.handleProductCtasChange = (event) => {
      if (!this.productCtas)
        return;
      this.productCtas = Object.assign(Object.assign({}, this.productCtas), { buttons: event.detail });
    };
    this.host = undefined;
    this.hostWithLocale = undefined;
    this.endpoint = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.productIds = undefined;
    this.productOfProductsLabel = undefined;
    this.productsLabel = undefined;
    this.firstRecNum = undefined;
    this.lastRecNum = undefined;
    this.totalNumRecs = undefined;
    this.showHighlightedChar = undefined;
    this.showPrice = undefined;
    this.showDocuments = undefined;
    this.showViewToggle = true;
    this.enableGridViewByDefault = true;
    this.showDownload = undefined;
    this.showViewDetails = undefined;
    this.showBuyOnline = true;
    this.showCompare = false;
    this.enableCartRemove = false;
    this.labels = undefined;
    this.areListGridLabelsShown = true;
    this.products = undefined;
    this.additionalInfos = {};
    this.comparator = {
      list: [],
      isFull: false,
      productProp: 'repositoryId',
    };
    this.buyOnline = {
      list: [],
      productProp: 'repositoryId',
    };
    this.partnerPrices = undefined;
    this.productUrlParams = undefined;
    this.additionalMainQueryParams = undefined;
    this.pdpLinkQueryParams = {};
    this.enableAppRouting = false;
    this.page = '';
    this.pageId = undefined;
    this.enableCommerceConnector = false;
    this.bazaarVoiceEnabled = false;
    this.productsRatings = {};
    this.productCtas = productCtas;
    this.scrollToProduct = undefined;
    this.isAPCSite = false;
    this.agentChatCscId = undefined;
    this.apcCtaUrl = undefined;
    this.apcCta = undefined;
    this.productsAvailabilityInfo = undefined;
    this.siteType = undefined;
    this.localeCode = undefined;
    this.isExternalConsumer = undefined;
    this.externalUrlConfig = undefined;
    this.externalFavoriteConfig = undefined;
    this.showAddToFavorite = undefined;
    this._externalUrlConfig = undefined;
    this._externalFavoriteConfig = undefined;
    this.currentPageStorageKey = undefined;
    this.storageName = undefined;
    this.isProductListing = false;
    this.analyticsPageData = undefined;
    this.productsInfoMap = {};
    this.isGridView = this.showViewToggle
      && sessionStorage.getItem(this.gridStateStorageKey) !== null
      ? sessionStorage.getItem(this.gridStateStorageKey) === 'true'
      : this.enableGridViewByDefault;
    this.ccProductIdToShow = undefined;
    this.ccPricesMap = {};
    this.ccBuyOnlineAvailability = {};
    this.isLoading = true;
  }
  productIdsDidChange() {
    this.loadData();
  }
  optionDidChanged() {
    this.loadData();
  }
  onToggleCardView(event) {
    this.isGridView = event.detail;
    sessionStorage.setItem(this.gridStateStorageKey, event.detail);
  }
  onProductBuyOnlineClick(e) {
    if (this.enableCommerceConnector) {
      const ccProductToShow = this.products.find((product) => product.commercialReference === e.detail.commercialReference);
      this.ccProductIdToShow = ccProductToShow.commercialReference;
    }
  }
  onCCDialogClosed() {
    this.ccProductIdToShow = undefined;
  }
  onCCPricesReceived(e) {
    this.ccPricesMap = e.detail.prices;
    if (e.detail.priceFromLabel) {
      this.labels.partnerPriceLabel = e.detail.priceFromLabel;
    }
  }
  onCCBtnBuyOnlineAvailability(e) {
    this.ccBuyOnlineAvailability = e.detail;
  }
  onApcCtaButtonDidClick(event) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let gaObj = {};
    const productDetail = this.products.find((item) => item.repositoryId === event.detail.productId);
    if (isAnalyticsEnabled()) {
      const product = {
        brand: 'APC Brand',
        price: (_b = (_a = this.productsAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b[event.detail.productId].activePriceValue,
        category: '',
        id: event.detail.productId,
        name: productDetail.description,
        quantity: 1,
      };
      gaObj = {
        currencyCode: ((_d = (_c = this.productsAvailabilityInfo) === null || _c === void 0 ? void 0 : _c.prices) === null || _d === void 0 ? void 0 : _d[event.detail.productId].activePriceValue)
          ? productDetail.currency
          : 'EUR',
        distributor: '',
        products: [Object.assign(Object.assign({}, product), { variant: '' })],
        isGridView: (_e = this.isGridView) !== null && _e !== void 0 ? _e : false,
      };
    }
    addToCart(this.notificationController, event.detail.productId, this.getLocaleCodes(), (_g = (_f = this.apcCta) === null || _f === void 0 ? void 0 : _f.urls) === null || _g === void 0 ? void 0 : _g.apcHost, (_j = (_h = this.apcCta) === null || _h === void 0 ? void 0 : _h.labels) === null || _j === void 0 ? void 0 : _j.failedResponse, this.agentChatCscId, gaObj, 'addToCartProductCardEvent');
  }
  onCcGetOptionsSucceeded(event) {
    if (event.detail.isApcSite && event.detail.apcCtaUrl) {
      const { isApcSite, apcCtaUrl, agentChatCscId } = event.detail;
      this.isAPCSite = isApcSite;
      this.apcCtaUrl = apcCtaUrl;
      this.agentChatCscId = agentChatCscId;
      if (this.isAPCSite && this.apcCtaUrl) {
        this.requestApcCta(this.apcCtaUrl);
      }
    }
  }
  async requestApcCta(apcCtaUrl) {
    if (isV3()) {
      const countryCode = getCountry(this.localeCode);
      const languageCode = getLanguage(this.localeCode);
      const params = {
        countryCode,
        languageCode,
      };
      this.apcCta = await getApcCta(formCtaUrl(apcCtaUrl, params));
    }
    else {
      this.apcCta = await getApcCta(this.host + apcCtaUrl);
    }
    this.requestProductAvailabilityInfo();
  }
  async requestProductAvailabilityInfo() {
    var _a, _b, _c;
    if ((_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls.apcHost) {
      const requestUrl = availabilityUrl((_c = (_b = this.apcCta) === null || _b === void 0 ? void 0 : _b.urls) === null || _c === void 0 ? void 0 : _c.apcHost, this.getLocaleCodes(), this.productIds.replace(/,/g, '%7C'));
      this.productsAvailabilityInfo = await getAvailabilityInfo(requestUrl);
    }
  }
  async updateProductCtasList(obj) {
    const newProductCtas = Object.assign({}, this.productCtas);
    Object.keys(obj).forEach((type) => {
      newProductCtas.buttons[type].list = obj[type];
    });
    this.productCtas = Object.assign({}, newProductCtas);
  }
  async updateProductCtasButtons(obj) {
    const newProductCtas = Object.assign({}, this.productCtas);
    Object.keys(obj).forEach((type) => {
      deepMerge(newProductCtas.buttons[type], obj[type]);
    });
    this.productCtas = Object.assign({}, newProductCtas);
  }
  getLocaleCodes() {
    const { languageCode, countryCode } = getLocaleFromBody(isBrowser) || {};
    return countryCode && languageCode ? join('/', countryCode, languageCode) : '';
  }
  getComparatorProp() {
    var _a;
    return ((_a = this.comparator) === null || _a === void 0 ? void 0 : _a.productProp) || this.productPropDefault;
  }
  getDataUrl(lastPathFragment, ids, additionalQueryParams) {
    const urlFragments = [];
    if (this.endpoint) {
      urlFragments.push(this.endpoint);
    }
    else {
      urlFragments.push('product');
    }
    urlFragments.push('api');
    urlFragments.push('productCard');
    urlFragments.push(lastPathFragment);
    const parsedHost = url.parse(this.host);
    const urlFormated = url.format({
      protocol: parsedHost.protocol,
      host: parsedHost.host,
      pathname: join(parsedHost.pathname || '', ...urlFragments),
      query: Object.assign({ ids }, additionalQueryParams),
    });
    return urlFormated;
  }
  getProductSecondaryInfoUrl(id) {
    if (isV3()) {
      return `${validateHost(this.host)}${SPRYKER_PRODUCT_CARD_SECONDARY_PATH}?brand=${getBrandName$1()}&country-code=${getCountry(this.localeCode)}&language-code=${getLanguage(this.localeCode)}&ids=${id}`;
    }
    return this.getDataUrl('addition', id);
  }
  updateProductByInfo(info) {
    const product = this.products.find((prd) => prd.repositoryId === (info === null || info === void 0 ? void 0 : info.productId));
    if (product) {
      this.productsInfoMap[product.repositoryId] = info;
    }
  }
  getReviewsInfo() {
    const partNumbers = this.productIds
      .split(',')
      .reduce((acc, item) => [...acc, ...this.splitBundlePartNumbers(item)], [])
      .join(',');
    const params = qs.stringify({
      apiversion: '5.4',
      passkey: window.bvKey,
      filter: `productid:${partNumbers}`,
      stats: 'Reviews',
    });
    return fetch(`${BAZAAR_VOICE_URL}?${params}`)
      .then((resp) => resp.json())
      .then((data) => this.processBazaarVoiceResponse(data))
      .catch((err) => {
      console.error(err);
    });
  }
  processBazaarVoiceResponse(ratingsData) {
    ratingsData.Results.forEach(({ ProductStatistics }) => {
      const { ProductId, ReviewStatistics: { TotalReviewCount, AverageOverallRating, OverallRatingRange }, } = ProductStatistics;
      this.productsRatings[ProductId] = {
        totalQty: TotalReviewCount,
        rate: AverageOverallRating,
        range: OverallRatingRange,
      };
    });
  }
  getInfoForProducts() {
    let additionalInfos = {};
    Promise.all(this.productIds.split(',').map((id) => getData(false, this.getProductSecondaryInfoUrl(id))
      .then((res) => {
      const { productAdditionalInfos } = res, rest = __rest(res, ["productAdditionalInfos"]);
      this.updateProductByInfo(productAdditionalInfos[0]);
      additionalInfos = Object.assign(Object.assign({}, additionalInfos), { [id]: rest });
      if (productAdditionalInfos[0].apcURL) {
        if (!this.additionalDistributors) {
          this.additionalDistributors = {};
        }
        this.additionalDistributors[id] = [
          getAPCDistributor(productAdditionalInfos[0].apcURL, res.purchaseOnAPCLabel),
        ];
      }
    })
      .catch((error) => console.error(error)))).then(() => {
      this.additionalInfos = additionalInfos;
    });
  }
  getProductCardMainUrl(ids) {
    const { nodeOrSubCatId, isCategoryListing } = this.additionalMainQueryParams || {};
    if (isV3()) {
      return `${validateHost(this.host)}${SPRYKER_PRODUCT_CARD_MAIN_PATH}?brand=${getBrandName$1()}&country-code=${getCountry(this.localeCode)}&language-code=${getLanguage(this.localeCode)}&ids=${ids}&nodeOrSubCatId=${nodeOrSubCatId}&isCategoryListing=${isCategoryListing}`;
    }
    return this.getDataUrl('main', ids, this.additionalMainQueryParams);
  }
  async getProductCardContent() {
    if (this.unifiedCheckoutFlag) {
      const { languageCode, countryCode } = getLocaleFromBody(isBrowser) || {};
      const { result, error } = await SprykerProductCardMain.getProductCardMain({
        productIdList: this.productIds,
        countryCode,
        languageCode,
      });
      if (error) {
        throw error;
      }
      return result;
    }
    return getData(false, this.getProductCardMainUrl(this.productIds));
  }
  async loadData() {
    var _a;
    if (!this.productIds || !this.productIds.length) {
      return;
    }
    this.isLoading = true;
    try {
      const result = await this.getProductCardContent();
      if (result.selectedNodeId) {
        this.pdpLinkQueryParams.selectedNodeId = result.selectedNodeId;
      }
      if (result.parentSubCategoryId) {
        this.pdpLinkQueryParams.parentSubCategoryId = result.parentSubCategoryId;
      }
      this.labels = result.labels;
      if (!this.enableCartRemove) {
        this.labels.removeFromCartLabel = this.labels.addToCartLabel;
      }
      if ((_a = this.partnerPrices) === null || _a === void 0 ? void 0 : _a.label) {
        this.labels.partnerPriceLabel = this.partnerPrices.label;
      }
      this.products = result.products;
      this.productsForCC = this.products.map(({ commercialReference, description, pictureUrl: imgUrl, pictureAltText: imgAlt, }) => ({
        commercialReference,
        description,
        imgUrl,
        imgAlt,
      }));
      const isRatingRequest = this.products.find((product) => product.bazaarVoiceEnabled);
      if (this.bazaarVoiceEnabled && isRatingRequest) {
        this.getReviewsInfo();
      }
      this.getInfoForProducts();
    }
    catch (error) {
      console.error(`[PES]: Error fetching products card data:\n${error.message}`);
    }
    finally {
      this.isLoading = false;
    }
  }
  componentWillLoad() {
    var _a, _b;
    this.externalUrlConfig = (_a = tryParse(this._externalUrlConfig)) !== null && _a !== void 0 ? _a : this.externalUrlConfig;
    this.externalFavoriteConfig = (_b = tryParse(this._externalFavoriteConfig)) !== null && _b !== void 0 ? _b : this.externalFavoriteConfig;
    this.loadData();
    this.selfRef.addEventListener('pesLinkClick', ({ detail }) => {
      this.pageId = detail.pageId;
      this.page = detail.page;
    });
  }
  componentDidRender() {
    if (this.productToScrollTo && this.productToScrollTo !== this.lastScrolledToProduct) {
      scrollToTop(this.productToScrollTo);
      this.lastScrolledToProduct = this.productToScrollTo;
    }
  }
  isInCompareList(product) {
    const prop = this.getComparatorProp();
    return this.comparator.list.includes(product[prop]);
  }
  isShowBuyOnline(product) {
    var _a, _b, _c;
    const productIdPropName = ((_a = this.buyOnline) === null || _a === void 0 ? void 0 : _a.productProp) || this.productPropDefault;
    const productId = product[productIdPropName];
    const showBuyOnlineFromOldPesCC = (_c = (_b = this.buyOnline) === null || _b === void 0 ? void 0 : _b.list) === null || _c === void 0 ? void 0 : _c.includes(productId);
    const showBuyOnlineFromNewCC = this.ccBuyOnlineAvailability[productId]
      || (!this.isAPCSite && this.additionalDistributors && !!this.additionalDistributors[productId]);
    return this.enableCommerceConnector ? showBuyOnlineFromNewCC : showBuyOnlineFromOldPesCC;
  }
  getPartnerPrice(product) {
    var _a, _b;
    const idProp = ((_a = this.partnerPrices) === null || _a === void 0 ? void 0 : _a.productProp) || this.productPropDefault;
    const productId = product[idProp];
    if (this.enableCommerceConnector && productId in this.ccPricesMap) {
      return this.ccPricesMap[productId];
    }
    const partnerPrices = ((_b = this.partnerPrices) === null || _b === void 0 ? void 0 : _b.list) || [];
    const partnerPrice = partnerPrices.find((partnerPrice) => partnerPrice.productId === productId);
    return partnerPrice === null || partnerPrice === void 0 ? void 0 : partnerPrice.price;
  }
  render() {
    var _a, _b, _c, _d, _e;
    if (this.isLoading)
      return h("pdp-skeleton", null);
    return (h("div", { class: `cards-wrapper ${this.isGridView ? 'grid-view' : 'list-view'}` }, this.isExternalConsumer && this.showAddToFavorite && (h("pes-range-product-ctas-updater", { buttons: (_a = this.productCtas) === null || _a === void 0 ? void 0 : _a.buttons, myProductsGetter: getMyProductsFromConnector, onChange: this.handleProductCtasChange })), h("div", { class: "cards-wrapper__header" }, !!this.selfRef.querySelector('[slot="title"]') && h("slot", { name: "title" }), this.showViewToggle && (h("pdp-switch-card-view", { isGridView: this.isGridView, productOfProductsLabel: this.productOfProductsLabel, productsLabel: this.productsLabel, firstRecNum: this.firstRecNum, lastRecNum: this.lastRecNum, totalNumRecs: this.totalNumRecs, listViewLabel: (_b = this.labels) === null || _b === void 0 ? void 0 : _b.listViewLabel, gridViewLabel: (_c = this.labels) === null || _c === void 0 ? void 0 : _c.gridViewLabel, areLabelsShown: this.areListGridLabelsShown }))), !!this.selfRef.querySelector('[slot="pills"]') && h("slot", { name: "pills" }), h("ul", { class: "cards-list" }, this.products
      && Array.isArray(this.products)
      && this.products.map((product, index) => {
        const { substitutionLabelRecommendedReplacement, groupOfProductsLabel, pdpViewAllLabel, documentsLabel, downloadButtonLabel, viewOnlineButtonLabel, seeSoftwareButtonLabel, operatingSystemsLabel, sizeLabel, formatLabel, dateLabel, languageLabel, versionLabel, detailsLabel, availableVersionsLabel, } = this.additionalInfos[product.repositoryId] || {};
        const showBazaarVoiceForProduct = (product === null || product === void 0 ? void 0 : product.bazaarVoiceEnabled) || false;
        return (h("li", { class: "cards-item" }, h("product-card", { ref: (el) => {
            if (index === this.scrollToProduct)
              this.productToScrollTo = el;
          }, host: this.host, hostWithLocale: this.hostWithLocale, productUrlParams: this.productUrlParams, pdpLinkQueryParams: this.pdpLinkQueryParams, isInCompareList: this.isInCompareList(product), isCompareDisabled: this.comparator.isFull && !this.isInCompareList(product), isGridView: this.isGridView, enableAppRouting: this.enableAppRouting, labels: this.labels, product: product, info: this.productsInfoMap[product.repositoryId], substitutionLabelRecommendedReplacement: substitutionLabelRecommendedReplacement, groupOfProductsLabel: groupOfProductsLabel, pdpViewAllLabel: pdpViewAllLabel, documentsLabel: documentsLabel, showPrice: this.showPrice, showHighlightedChar: this.showHighlightedChar, showDocuments: this.showDocuments, showDownload: this.showDownload, showViewDetails: this.showViewDetails, showBuyOnline: this.showBuyOnline && this.isShowBuyOnline(product), singleDistributor: !this.ccBuyOnlineAvailability[product.repositoryId]
            ? getSingleDistributor(this.additionalDistributors, product.repositoryId)
            : null, showCompare: this.showCompare, partnerPrice: this.getPartnerPrice(product), downloadButtonLabel: downloadButtonLabel, viewOnlineButtonLabel: viewOnlineButtonLabel, seeSoftwareButtonLabel: seeSoftwareButtonLabel, operatingSystemsLabel: operatingSystemsLabel, sizeLabel: sizeLabel, formatLabel: formatLabel, dateLabel: dateLabel, languageLabel: languageLabel, versionLabel: versionLabel, detailsLabel: detailsLabel, availableVersionsLabel: availableVersionsLabel, productCtas: this.productCtas, isAPCSite: this.isAPCSite, apcCta: this.apcCta, productId: product.repositoryId, availabilityInfo: this.productsAvailabilityInfo, bazaarVoiceEnabled: this.bazaarVoiceEnabled && showBazaarVoiceForProduct, productsRatings: this.productsRatings, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig, currentPageStorageKey: this.currentPageStorageKey, cardMetaData: {
            selectedCardIndex: index,
            currentPageFirstRecNum: this.firstRecNum,
            isListingProducts: this.isProductListing,
          }, analyticsPageData: this.analyticsPageData, localeCode: this.localeCode })));
      })), this.enableCommerceConnector && ((_d = this.productsForCC) === null || _d === void 0 ? void 0 : _d.length) && (h("pes-cc-main", { host: isV3() || this.isExternalConsumer ? this.host : this.hostWithLocale, products: this.productsForCC, productIdToShow: this.ccProductIdToShow, additionalDistributors: !this.isAPCSite && this.additionalDistributors, siteType: this.siteType, localeCode: this.isExternalConsumer && ((_e = this.externalFavoriteConfig) === null || _e === void 0 ? void 0 : _e.localeCode)
        ? this.externalFavoriteConfig.localeCode
        : this.localeCode }))));
  }
  get selfRef() { return getElement(this); }
  static get watchers() { return {
    "productIds": ["productIdsDidChange"],
    "host": ["optionDidChanged"]
  }; }
};
ProductCardWrapper.style = productCardsWrapperCss;

export { AddToCartButton as add_to_cart_button, AddToFavoriteButton as add_to_favorite_button, DocumentsList as pdp_documents_list, IconTooltipComponent as pdp_icon_tooltip, ModalSymply as pdp_modal_symply, SkeletonComponent as pdp_skeleton, Slider as pdp_slider, SwitchCardView as pdp_switch_card_view, CopyLinkButton as pes_agent_link, BackToTop as pes_back_to_top, Badge$1 as pes_badge, Badge as pes_badge_wrapper, Banner as pes_banner, BannerPromoBlock as pes_banner_promo_block, Breadcrumbs as pes_breadcrumbs, CategoryDescription as pes_category_description, CategoryRangeCard as pes_category_range_card, PesCategorySubcategoryProductsList as pes_category_subcategory_products_list, CommerceConnectorItems as pes_cc_items, CommerceConnectorMain as pes_cc_main, CommerceConnectorView as pes_cc_main_view, CommerceConnectorNoResult as pes_cc_no_result, CommerceConnectorSearch as pes_cc_search, ChipsList as pes_chips_list, CollapsibleContainer as pes_collapsible_container, ComparisonBar as pes_comparison_bar, ComparisonBarWrapper as pes_comparison_bar_wrapper, PesCtaButton as pes_cta_button, CtaPrice as pes_cta_price, CustomQdsIconComponent as pes_custom_qds_icon, Description as pes_description, PesDocumentIcon as pes_document_icon, PesDocumentListing as pes_document_listing, Ellipsis as pes_ellipsis, PesFiltersNoResults as pes_filters_no_results, HmcBanner as pes_hmc_banner, HmcModalContainer as pes_hmc_modal_container, IconComponent as pes_icon, LazyImage as pes_lazy_img, PesLogo as pes_logo, MobileFiltersCategories as pes_mobile_filters_categories, PesMyProductsConnector as pes_my_products_connector, NotificationBanner as pes_notification_banner, PesNotificationSubtle as pes_notification_subtle, PartnerPrice as pes_partner_price, ProductCardId as pes_product_card_id, ProductCardIdSoftware as pes_product_card_id_software, ProductInfoChatEvent as pes_product_info_chat_event, ProductPrice as pes_product_price, ProductSelector as pes_product_selector, ProductsCarousel as pes_products_carousel, ProductsPagination as pes_products_pagination, RangePills as pes_range_filter_pills, ProductCtasUpdater as pes_range_product_ctas_updater, RecentlyViewedContainer as pes_recently_viewed_container, PesResponsiveFilter as pes_responsive_filters, PesRichTextInformation as pes_rich_text_information, PesRouterLink as pes_router_link, PesSelect as pes_select, PesSlideDownContainer as pes_slide_down_container, SmartEllipsis as pes_smart_ellipsis, SoftwareModal as pes_software_modal, PesSoftwareModalCell as pes_software_modal_cell, PesSoftwareModal as pes_software_modal_content, PesSoftwareModalHeaderCell as pes_software_modal_header_cell, PesSoftwareModalHeaderRow as pes_software_modal_header_row, PesSoftwareModalRow as pes_software_modal_row, PesSprykerCategorySubcategoryListing as pes_spryker_category_subcategory_listing, StarRating as pes_star_rating, SubcategoryBlock as pes_subcategory_block, SubcategoryDescription as pes_subcategory_description, SubcategoryList as pes_subcategory_list, PesTooltip as pes_tooltip, TooltipWrapperComponent as pes_tooltip_wrapper, Usc as pes_usc, ProductCardMainInfo as product_card_main_info, ProductCardWrapper as product_cards_wrapper };
